import * as React from 'react';
import React__default, { forwardRef, Component, useCallback } from 'react';
import * as ReactDOM from 'react-dom';
import ReactDOM__default from 'react-dom';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$2 = ".storybook-button {\n  font-family: 'Nunito Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  font-weight: 700;\n  border: 0;\n  border-radius: 3em;\n  cursor: pointer;\n  display: inline-block;\n  line-height: 1;\n}\n.storybook-button--primary {\n  color: white;\n  background-color: #1ea7fd;\n}\n.storybook-button--secondary {\n  color: #333;\n  background-color: transparent;\n  box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 0px 1px inset;\n}\n.storybook-button--small {\n  font-size: 12px;\n  padding: 10px 16px;\n}\n.storybook-button--medium {\n  font-size: 14px;\n  padding: 11px 20px;\n}\n.storybook-button--large {\n  font-size: 16px;\n  padding: 12px 24px;\n}\n";
styleInject(css_248z$2);

/**
 * Primary UI component for user interaction
 */
var Button$1 = function (_a) {
    var _b = _a.primary, primary = _b === void 0 ? true : _b, backgroundColor = _a.backgroundColor, _c = _a.size, size = _c === void 0 ? "medium" : _c, onClick = _a.onClick, label = _a.label;
    var mode = primary
        ? "storybook-button--primary"
        : "storybook-button--secondary";
    return (React__default.createElement("button", { type: "button", className: ["storybook-button", "storybook-button--".concat(size), mode].join(" "), style: backgroundColor ? { backgroundColor: backgroundColor } : {}, onClick: onClick }, label));
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

function commonjsRequire (target) {
	throw new Error('Could not dynamically require "' + target + '". Please configure the dynamicRequireTargets option of @rollup/plugin-commonjs appropriately for this require call to behave properly.');
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element$2=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal$2=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement$1=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element$2,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal$2,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement$1,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$2;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;

var has$1 = has$2;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$2 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = ReactPropTypesSecret$1;
  var loggedTypeFailures = {};
  var has = has$1;

  printWarning$2 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$2(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$2(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

var checkPropTypes = checkPropTypes_1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */








var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has$1(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has$1(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret$1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var require$$1 = factoryWithTypeCheckers;

var require$$2 = factoryWithThrowingShims;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var propTypes = createCommonjsModule(function (module) {
if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require$$1(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = require$$2();
}
});

var PropTypes = propTypes;

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

var classnames = createCommonjsModule(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var ManagerReferenceNodeContext = React.createContext();
var ManagerReferenceNodeSetterContext = React.createContext();
function Manager(_ref) {
  var children = _ref.children;

  var _React$useState = React.useState(null),
      referenceNode = _React$useState[0],
      setReferenceNode = _React$useState[1];

  var hasUnmounted = React.useRef(false);
  React.useEffect(function () {
    return function () {
      hasUnmounted.current = true;
    };
  }, []);
  var handleSetReferenceNode = React.useCallback(function (node) {
    if (!hasUnmounted.current) {
      setReferenceNode(node);
    }
  }, []);
  return /*#__PURE__*/React.createElement(ManagerReferenceNodeContext.Provider, {
    value: referenceNode
  }, /*#__PURE__*/React.createElement(ManagerReferenceNodeSetterContext.Provider, {
    value: handleSetReferenceNode
  }, children));
}

/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === 'function') {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};
/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (process.env.NODE_ENV !== "production") {
    if (!isHTMLElement(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
    }

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (process.env.NODE_ENV !== "production") {
    var transitionProperty = getComputedStyle(state.elements.popper).transitionProperty || '';

    if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
    }
  }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;

    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
    }
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    [].concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
    .filter(function (value, index, self) {
      return self.indexOf(value) === index;
    }).forEach(function (key) {
      switch (key) {
        case 'name':
          if (typeof modifier.name !== 'string') {
            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
          }

          break;

        case 'enabled':
          if (typeof modifier.enabled !== 'boolean') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
          }

          break;

        case 'phase':
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
          }

          break;

        case 'fn':
          if (typeof modifier.fn !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'effect':
          if (modifier.effect != null && typeof modifier.effect !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'requires':
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
          }

          break;

        case 'requiresIfExists':
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
          }

          break;

        case 'options':
        case 'data':
          break;

        default:
          console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
            return "\"" + s + "\"";
          }).join(', ') + "; but \"" + key + "\" was provided.");
      }

      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

function uniqueBy(arr, fn) {
  var identifiers = new Set();
  return arr.filter(function (item) {
    var identifier = fn(item);

    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (process.env.NODE_ENV !== "production") {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);

          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === 'flip';
            });

            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
            }
          }

          var _getComputedStyle = getComputedStyle(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
          // cause bugs with positioning, so we'll warn the consumer


          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
          }
        }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (process.env.NODE_ENV !== "production") {
            console.error(INVALID_ELEMENT_ERROR);
          }

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (process.env.NODE_ENV !== "production") {
            __debug_loops__ += 1;

            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(INVALID_ELEMENT_ERROR);
      }

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */
var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

var EMPTY_MODIFIERS$1 = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = React.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS$1
  };

  var _React$useState = React.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = React.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        ReactDOM.flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = React.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (reactFastCompare(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

var NOOP = function NOOP() {
  return void 0;
};

var NOOP_PROMISE = function NOOP_PROMISE() {
  return Promise.resolve(null);
};

var EMPTY_MODIFIERS = [];
function Popper(_ref) {
  var _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      _ref$strategy = _ref.strategy,
      strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy,
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS : _ref$modifiers,
      referenceElement = _ref.referenceElement,
      onFirstUpdate = _ref.onFirstUpdate,
      innerRef = _ref.innerRef,
      children = _ref.children;
  var referenceNode = React.useContext(ManagerReferenceNodeContext);

  var _React$useState = React.useState(null),
      popperElement = _React$useState[0],
      setPopperElement = _React$useState[1];

  var _React$useState2 = React.useState(null),
      arrowElement = _React$useState2[0],
      setArrowElement = _React$useState2[1];

  React.useEffect(function () {
    setRef(innerRef, popperElement);
  }, [innerRef, popperElement]);
  var options = React.useMemo(function () {
    return {
      placement: placement,
      strategy: strategy,
      onFirstUpdate: onFirstUpdate,
      modifiers: [].concat(modifiers, [{
        name: 'arrow',
        enabled: arrowElement != null,
        options: {
          element: arrowElement
        }
      }])
    };
  }, [placement, strategy, onFirstUpdate, modifiers, arrowElement]);

  var _usePopper = usePopper(referenceElement || referenceNode, popperElement, options),
      state = _usePopper.state,
      styles = _usePopper.styles,
      forceUpdate = _usePopper.forceUpdate,
      update = _usePopper.update;

  var childrenProps = React.useMemo(function () {
    return {
      ref: setPopperElement,
      style: styles.popper,
      placement: state ? state.placement : placement,
      hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: styles.arrow,
        ref: setArrowElement
      },
      forceUpdate: forceUpdate || NOOP,
      update: update || NOOP_PROMISE
    };
  }, [setPopperElement, setArrowElement, placement, state, styles, update, forceUpdate]);
  return unwrapArray(children)(childrenProps);
}

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning;

function Reference(_ref) {
  var children = _ref.children,
      innerRef = _ref.innerRef;
  var setReferenceNode = React.useContext(ManagerReferenceNodeSetterContext);
  var refHandler = React.useCallback(function (node) {
    setRef(innerRef, node);
    safeInvoke(setReferenceNode, node);
  }, [innerRef, setReferenceNode]); // ran on unmount
  // eslint-disable-next-line react-hooks/exhaustive-deps

  React.useEffect(function () {
    return function () {
      return setRef(innerRef, null);
    };
  }, []);
  React.useEffect(function () {
    warning_1(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
  }, [setReferenceNode]);
  return unwrapArray(children)({
    ref: refHandler
  });
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

var TransitionGroupContext = React__default.createContext(null);

var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM__default.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children;
        _this$props.in;
        _this$props.mountOnEnter;
        _this$props.unmountOnExit;
        _this$props.appear;
        _this$props.enter;
        _this$props.exit;
        _this$props.timeout;
        _this$props.addEndListener;
        _this$props.onEnter;
        _this$props.onEntering;
        _this$props.onEntered;
        _this$props.onExit;
        _this$props.onExiting;
        _this$props.onExited;
        _this$props.nodeRef;
        var childProps = _objectWithoutPropertiesLoose$1(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };

  return Transition;
}(React__default.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop$3() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$3,
  onEntering: noop$3,
  onEntered: noop$3,
  onExit: noop$3,
  onExiting: noop$3,
  onExited: noop$3
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var Transition$1 = Transition;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function getScrollbarWidth() {
  let scrollDiv = document.createElement('div'); // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113

  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.width = '50px';
  scrollDiv.style.height = '50px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}
function setScrollbarWidth(padding) {
  document.body.style.paddingRight = padding > 0 ? `${padding}px` : null;
}
function isBodyOverflowing() {
  return document.body.clientWidth < window.innerWidth;
}
function getOriginalBodyPadding() {
  const style = window.getComputedStyle(document.body, null);
  return parseInt(style && style.getPropertyValue('padding-right') || 0, 10);
}
function conditionallyUpdateScrollbar() {
  const scrollbarWidth = getScrollbarWidth(); // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433

  const fixedContent = document.querySelectorAll('.fixed-top, .fixed-bottom, .is-fixed, .sticky-top')[0];
  const bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;

  if (isBodyOverflowing()) {
    setScrollbarWidth(bodyPadding + scrollbarWidth);
  }
}
let globalCssModule;
function mapToCssModules(className = '', cssModule = globalCssModule) {
  if (!cssModule) return className;
  return className.split(' ').map(c => cssModule[c] || c).join(' ');
}
/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */

function omit(obj, omitKeys) {
  const result = {};
  Object.keys(obj).forEach(key => {
    if (omitKeys.indexOf(key) === -1) {
      result[key] = obj[key];
    }
  });
  return result;
}
/**
 * Returns a filtered copy of an object with only the specified keys.
 */

function pick(obj, keys) {
  const pickKeys = Array.isArray(keys) ? keys : [keys];
  let {
    length
  } = pickKeys;
  let key;
  const result = {};

  while (length > 0) {
    length -= 1;
    key = pickKeys[length];
    result[key] = obj[key];
  }

  return result;
}
let warned = {};
function warnOnce(message) {
  if (!warned[message]) {
    /* istanbul ignore else */
    if (typeof console !== 'undefined') {
      console.error(message); // eslint-disable-line no-console
    }

    warned[message] = true;
  }
}
function deprecated(propType, explanation) {
  return function validate(props, propName, componentName, ...rest) {
    if (props[propName] !== null && typeof props[propName] !== 'undefined') {
      warnOnce(`"${propName}" property of "${componentName}" has been deprecated.\n${explanation}`);
    }

    return propType(props, propName, componentName, ...rest);
  };
} // Shim Element if needed (e.g. in Node environment)

const Element$1 = typeof window === 'object' && window.Element || function () {};

function DOMElement(props, propName, componentName) {
  if (!(props[propName] instanceof Element$1)) {
    return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Expected prop to be an instance of Element. Validation failed.');
  }
}
const targetPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, DOMElement, PropTypes.shape({
  current: PropTypes.any
})]);
const tagPropType = PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.shape({
  $$typeof: PropTypes.symbol,
  render: PropTypes.func
}), PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.shape({
  $$typeof: PropTypes.symbol,
  render: PropTypes.func
})]))]); // These are all setup to match what is in the bootstrap _variables.scss
// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss

const TransitionTimeouts = {
  Fade: 150,
  // $transition-fade
  Collapse: 350,
  // $transition-collapse
  Modal: 300,
  // $modal-transition
  Carousel: 600,
  // $carousel-transition
  Offcanvas: 300 // $offcanvas-transition

}; // Duplicated Transition.propType keys to ensure that Reactstrap builds
// for distribution properly exclude these keys for nested child HTML attributes
// since `react-transition-group` removes propTypes in production builds.

const TransitionPropTypeKeys = ['in', 'mountOnEnter', 'unmountOnExit', 'appear', 'enter', 'exit', 'timeout', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'];
const TransitionStatuses = {
  ENTERING: 'entering',
  ENTERED: 'entered',
  EXITING: 'exiting',
  EXITED: 'exited'
};
const keyCodes = {
  esc: 27,
  space: 32,
  enter: 13,
  tab: 9,
  up: 38,
  down: 40,
  home: 36,
  end: 35,
  n: 78,
  p: 80
};
const PopperPlacements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
const canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function isReactRefObj(target) {
  if (target && typeof target === 'object') {
    return 'current' in target;
  }

  return false;
}

function getTag(value) {
  if (value == null) {
    return value === undefined ? '[object Undefined]' : '[object Null]';
  }

  return Object.prototype.toString.call(value);
}

function isObject(value) {
  const type = typeof value;
  return value != null && (type === 'object' || type === 'function');
}
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }

  const tag = getTag(value);
  return tag === '[object Function]' || tag === '[object AsyncFunction]' || tag === '[object GeneratorFunction]' || tag === '[object Proxy]';
}
function findDOMElements(target) {
  if (isReactRefObj(target)) {
    return target.current;
  }

  if (isFunction(target)) {
    return target();
  }

  if (typeof target === 'string' && canUseDOM) {
    let selection = document.querySelectorAll(target);

    if (!selection.length) {
      selection = document.querySelectorAll(`#${target}`);
    }

    if (!selection.length) {
      throw new Error(`The target '${target}' could not be identified in the dom, tip: check spelling`);
    }

    return selection;
  }

  return target;
}
function isArrayOrNodeList(els) {
  if (els === null) {
    return false;
  }

  return Array.isArray(els) || canUseDOM && typeof els.length === 'number';
}
function getTarget(target, allElements) {
  const els = findDOMElements(target);

  if (allElements) {
    if (isArrayOrNodeList(els)) {
      return els;
    }

    if (els === null) {
      return [];
    }

    return [els];
  }

  if (isArrayOrNodeList(els)) {
    return els[0];
  }

  return els;
}
const defaultToggleEvents = ['touchstart', 'click'];
function addMultipleEventListeners(_els, handler, _events, useCapture) {
  let els = _els;

  if (!isArrayOrNodeList(els)) {
    els = [els];
  }

  let events = _events;

  if (typeof events === 'string') {
    events = events.split(/\s+/);
  }

  if (!isArrayOrNodeList(els) || typeof handler !== 'function' || !Array.isArray(events)) {
    throw new Error(`
      The first argument of this function must be DOM node or an array on DOM nodes or NodeList.
      The second must be a function.
      The third is a string or an array of strings that represents DOM events
    `);
  }

  Array.prototype.forEach.call(events, event => {
    Array.prototype.forEach.call(els, el => {
      el.addEventListener(event, handler, useCapture);
    });
  });
  return function removeEvents() {
    Array.prototype.forEach.call(events, event => {
      Array.prototype.forEach.call(els, el => {
        el.removeEventListener(event, handler, useCapture);
      });
    });
  };
}
const focusableElements = ['a[href]', 'area[href]', 'input:not([disabled]):not([type=hidden])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'object', 'embed', '[tabindex]:not(.modal)', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'];
({
  tag: tagPropType,
  fluid: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  className: PropTypes.string,
  cssModule: PropTypes.object
});
const rowColsPropType = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
({
  tag: tagPropType,
  noGutters: deprecated(PropTypes.bool, 'Please use Bootstrap 5 gutter utility classes. https://getbootstrap.com/docs/5.0/layout/gutters/'),
  className: PropTypes.string,
  cssModule: PropTypes.object,
  xs: rowColsPropType,
  sm: rowColsPropType,
  md: rowColsPropType,
  lg: rowColsPropType,
  xl: rowColsPropType,
  xxl: rowColsPropType,
  widths: PropTypes.array
});

const _excluded$1f = ["className", "cssModule", "widths", "tag"];
const colWidths$1 = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
const stringOrNumberProp$1 = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
const columnProps$1 = PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string, PropTypes.shape({
  size: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
  order: stringOrNumberProp$1,
  offset: stringOrNumberProp$1
})]);
const propTypes$1k = {
  tag: tagPropType,
  xs: columnProps$1,
  sm: columnProps$1,
  md: columnProps$1,
  lg: columnProps$1,
  xl: columnProps$1,
  xxl: columnProps$1,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  widths: PropTypes.array
};
const defaultProps$1i = {
  tag: 'div',
  widths: colWidths$1
};

const getColumnSizeClass$1 = (isXs, colWidth, colSize) => {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : `col-${colWidth}`;
  }

  if (colSize === 'auto') {
    return isXs ? 'col-auto' : `col-${colWidth}-auto`;
  }

  return isXs ? `col-${colSize}` : `col-${colWidth}-${colSize}`;
};

const getColumnClasses = (attributes, cssModule, widths = colWidths$1) => {
  const modifiedAttributes = attributes;
  const colClasses = [];
  widths.forEach((colWidth, i) => {
    let columnProp = modifiedAttributes[colWidth];
    delete modifiedAttributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    const isXs = !i;

    if (isObject(columnProp)) {
      const colSizeInterfix = isXs ? '-' : `-${colWidth}-`;
      const colClass = getColumnSizeClass$1(isXs, colWidth, columnProp.size);
      colClasses.push(mapToCssModules(classnames({
        [colClass]: columnProp.size || columnProp.size === '',
        [`order${colSizeInterfix}${columnProp.order}`]: columnProp.order || columnProp.order === 0,
        [`offset${colSizeInterfix}${columnProp.offset}`]: columnProp.offset || columnProp.offset === 0
      }), cssModule));
    } else {
      const colClass = getColumnSizeClass$1(isXs, colWidth, columnProp);
      colClasses.push(colClass);
    }
  });
  return {
    colClasses,
    modifiedAttributes
  };
};

function Col(props) {
  const {
    className,
    cssModule,
    widths,
    tag: Tag
  } = props,
        attributes = _objectWithoutProperties(props, _excluded$1f);

  let {
    modifiedAttributes,
    colClasses
  } = getColumnClasses(attributes, cssModule, widths);

  if (!colClasses.length) {
    colClasses.push('col');
  }

  const classes = mapToCssModules(classnames(className, colClasses), cssModule);
  return /*#__PURE__*/React__default.createElement(Tag, _extends({}, modifiedAttributes, {
    className: classes
  }));
}

Col.propTypes = propTypes$1k;
Col.defaultProps = defaultProps$1i;
({
  children: PropTypes.node,

  /** Add custom class */
  className: PropTypes.string,

  /** Theme the navbar by adding a background color  */
  color: PropTypes.string,

  /** Use any of the responsive containers to change how wide the content in your navbar is presented. */
  container: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** This prop is passed if the background is dark, to make the text lighter */
  dark: PropTypes.bool,

  /** Determine if to show toggler button */
  expand: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),

  /** Make the navbar fixed at the top */
  fixed: PropTypes.string,
  full: PropTypes.bool,

  /** Add `.navbar-light` class */
  light: PropTypes.bool,
  role: PropTypes.string,

  /** Use `position: sticky` which isn't fully supported in every browser */
  sticky: PropTypes.string,

  /** Set a custom element for this component */
  tag: tagPropType
});
({
  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Set a custom element for this component */
  tag: tagPropType
});
({
  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Set a custom element for this component */
  tag: tagPropType,
  active: PropTypes.bool
});
({
  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Set a custom element for this component */
  tag: tagPropType,
  type: PropTypes.string,

  /** Pass children so this component can wrap the child elements */
  children: PropTypes.node
});
({
  /** Adding card prop adds `.card-header-tabs` or `.card-header-pills` class */
  card: PropTypes.bool,

  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** fills the nav to extend to full available width */
  fill: PropTypes.bool,

  /** Change the horizontal alignment of your nav */
  horizontal: PropTypes.oneOf(['center', 'end']),

  /**  All horizontal space will be occupied by nav links, but unlike the `fill` above, every nav item will be the same width. */
  justified: PropTypes.bool,

  /** Add navbar for a full-height and lightweight navigation */
  navbar: PropTypes.bool,

  /** Make NavItems look like pills */
  pills: PropTypes.bool,

  /** Make NavItems look like tabs */
  tabs: PropTypes.bool,

  /** Set a custom element for this component */
  tag: tagPropType,

  /** Stack your navigation by changing the flex item direction */
  vertical: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
});
({
  /** Add active class to element */
  active: PropTypes.bool,

  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Set a custom element for this component */
  tag: tagPropType
});

const _excluded$18 = ["className", "cssModule", "active", "tag", "innerRef"];
const propTypes$1d = {
  /** Add active class to NavLink */
  active: PropTypes.bool,

  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Disable the link */
  disabled: PropTypes.bool,
  href: PropTypes.any,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),

  /** Function to be triggered on click */
  onClick: PropTypes.func,

  /** Set a custom element for this component */
  tag: tagPropType
};
const defaultProps$1b = {
  tag: 'a'
};

class NavLink extends React__default.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.href === '#') {
      e.preventDefault();
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }
  }

  render() {
    let _this$props = this.props,
        {
      className,
      cssModule,
      active,
      tag: Tag,
      innerRef
    } = _this$props,
        attributes = _objectWithoutProperties(_this$props, _excluded$18);

    const classes = mapToCssModules(classnames(className, 'nav-link', {
      disabled: attributes.disabled,
      active: active
    }), cssModule);
    return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
      ref: innerRef,
      onClick: this.onClick,
      className: classes
    }));
  }

}

NavLink.propTypes = propTypes$1d;
NavLink.defaultProps = defaultProps$1b;
({
  /** Aria label */
  'aria-label': PropTypes.string,

  /** Pass children so this component can wrap them */
  children: PropTypes.node,

  /** Add custom class */
  className: PropTypes.string,

  /** Change existing className with a new className */
  cssModule: PropTypes.object,

  /** Add custom class to list tag */
  listClassName: PropTypes.string,

  /** Set a custom element for list tag */
  listTag: tagPropType,

  /** Set a custom element for this component */
  tag: tagPropType
});
({
  /** Adds a visual "active" state to a Breadcrumb Item */
  active: PropTypes.bool,

  /** Add custom class to the element */
  className: PropTypes.string,

  /** Change existing className with a new className */
  cssModule: PropTypes.object,

  /** Set a custom element for this component */
  tag: tagPropType
});

const _excluded$15 = ["className", "cssModule", "variant", "innerRef"];
const propTypes$1a = {
  /** Disable the button if needed */
  active: PropTypes.bool,

  /** Aria label */
  'aria-label': PropTypes.string,

  /** Function to be triggered on click */
  onClick: PropTypes.func,

  /** Change the variant to white */
  variant: PropTypes.oneOf(['white']),
  className: PropTypes.string,
  cssModule: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func])
};
const defaultProps$18 = {
  'aria-label': 'close'
};

function CloseButton(props) {
  const {
    className,
    cssModule,
    variant,
    innerRef
  } = props,
        attributes = _objectWithoutProperties(props, _excluded$15);

  const classes = mapToCssModules(classnames(className, 'btn-close', variant && `btn-close-${variant}`));
  return /*#__PURE__*/React__default.createElement("button", _extends({
    ref: innerRef,
    type: "button",
    className: classes
  }, attributes));
}

CloseButton.propTypes = propTypes$1a;
CloseButton.defaultProps = defaultProps$18;

const _excluded$14 = ["active", "aria-label", "block", "className", "close", "cssModule", "color", "outline", "size", "tag", "innerRef"];
const propTypes$19 = {
  /** Manually set the visual state of the button to active */
  active: PropTypes.bool,

  /** Aria label */
  'aria-label': PropTypes.string,
  block: PropTypes.bool,

  /** Pass children so this component can wrap them */
  children: PropTypes.node,

  /** Add custom class */
  className: PropTypes.string,

  /** Change existing className with a new className */
  cssModule: PropTypes.object,

  /** Use the button as a close button */
  close: PropTypes.bool,

  /** Change color of Button to one of the available colors */
  color: PropTypes.string,

  /** Disables the button */
  disabled: PropTypes.bool,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),

  /** Function to be triggered on click */
  onClick: PropTypes.func,

  /** Adds outline to the button */
  outline: PropTypes.bool,

  /** Make the button bigger or smaller */
  size: PropTypes.string,

  /** Set a custom element for this component */
  tag: tagPropType
};
const defaultProps$17 = {
  color: 'secondary',
  tag: 'button'
};

function Button(props) {
  const onClick = useCallback(e => {
    if (props.disabled) {
      e.preventDefault();
      return;
    }

    if (props.onClick) {
      return props.onClick(e);
    }
  }, [props.onClick, props.disabled]);

  let {
    active,
    'aria-label': ariaLabel,
    block,
    className,
    close,
    cssModule,
    color,
    outline,
    size,
    tag: Tag,
    innerRef
  } = props,
      attributes = _objectWithoutProperties(props, _excluded$14);

  if (close) {
    return /*#__PURE__*/React__default.createElement(CloseButton, attributes);
  }

  const btnOutlineColor = `btn${outline ? '-outline' : ''}-${color}`;
  const classes = mapToCssModules(classnames(className, 'btn', btnOutlineColor, size ? `btn-${size}` : false, block ? 'd-block w-100' : false, {
    active,
    disabled: props.disabled
  }), cssModule);

  if (attributes.href && Tag === 'button') {
    Tag = 'a';
  }

  return /*#__PURE__*/React__default.createElement(Tag, _extends({
    type: Tag === 'button' && attributes.onClick ? 'button' : undefined
  }, attributes, {
    className: classes,
    ref: innerRef,
    onClick: onClick,
    "aria-label": ariaLabel
  }));
}

Button.propTypes = propTypes$19;
Button.defaultProps = defaultProps$17;
({
  onClick: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  defaultValue: PropTypes.bool,
  className: PropTypes.string,
  cssModule: PropTypes.object
});

/**
 * DropdownContext
 * {
 *  toggle: PropTypes.func.isRequired,
 *  isOpen: PropTypes.bool.isRequired,
 *  direction: PropTypes.oneOf(['up', 'down', 'start', 'end']).isRequired,
 *  inNavbar: PropTypes.bool.isRequired,
 *  disabled: PropTypes.bool
 * }
 */

const DropdownContext = React__default.createContext({});

const InputGroupContext = React__default.createContext({});

const _excluded$12 = ["className", "cssModule", "direction", "isOpen", "group", "size", "nav", "setActiveFromChild", "active", "tag", "menuRole"];
const propTypes$17 = {
  a11y: PropTypes.bool,
  disabled: PropTypes.bool,
  direction: PropTypes.oneOf(['up', 'down', 'start', 'end', 'left', 'right']),
  group: PropTypes.bool,
  isOpen: PropTypes.bool,
  nav: PropTypes.bool,
  active: PropTypes.bool,
  size: PropTypes.string,
  tag: tagPropType,
  toggle: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  dropup: PropTypes.bool,
  inNavbar: PropTypes.bool,
  setActiveFromChild: PropTypes.bool,
  menuRole: PropTypes.oneOf(['listbox', 'menu'])
};
const defaultProps$15 = {
  a11y: true,
  isOpen: false,
  direction: 'down',
  nav: false,
  active: false,
  inNavbar: false,
  setActiveFromChild: false
};
const preventDefaultKeys = [keyCodes.space, keyCodes.enter, keyCodes.up, keyCodes.down, keyCodes.end, keyCodes.home];

class Dropdown extends React__default.Component {
  constructor(props) {
    super(props);
    this.addEvents = this.addEvents.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.removeEvents = this.removeEvents.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleMenuRef = this.handleMenuRef.bind(this);
    this.handleToggleRef = this.handleToggleRef.bind(this);
    this.containerRef = React__default.createRef();
    this.menuRef = React__default.createRef();
    this.toggleRef = React__default.createRef(); // ref for DropdownToggle
  }

  componentDidMount() {
    this.handleProps();
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen !== prevProps.isOpen) {
      this.handleProps();
    }
  }

  componentWillUnmount() {
    this.removeEvents();
  }

  handleMenuRef(menuRef) {
    this.menuRef.current = menuRef;
  }

  handleToggleRef(toggleRef) {
    this.toggleRef.current = toggleRef;
  }

  handleDocumentClick(e) {
    if (e && (e.which === 3 || e.type === 'keyup' && e.which !== keyCodes.tab)) return;
    const container = this.getContainer();
    const menu = this.getMenu();
    const toggle = this.getToggle();
    const targetIsToggle = e.target === toggle;
    const clickIsInMenu = menu && menu.contains(e.target) && menu !== e.target;
    let clickIsInInput = false;

    if (container) {
      // this is only for InputGroup with type dropdown
      clickIsInInput = container.classList.contains('input-group') && container.classList.contains('dropdown') && e.target.tagName === 'INPUT';
    }

    if ((targetIsToggle && !clickIsInInput || clickIsInMenu) && (e.type !== 'keyup' || e.which === keyCodes.tab)) {
      return;
    }

    this.toggle(e);
  }

  handleKeyDown(e) {
    const isTargetMenuItem = e.target.getAttribute('role') === 'menuitem' || e.target.getAttribute('role') === 'option';
    const isTargetMenuCtrl = this.getMenuCtrl() === e.target;
    const isTab = keyCodes.tab === e.which;

    if (/input|textarea/i.test(e.target.tagName) || isTab && !this.props.a11y || isTab && !(isTargetMenuItem || isTargetMenuCtrl)) {
      return;
    }

    if (preventDefaultKeys.indexOf(e.which) !== -1 || e.which >= 48 && e.which <= 90) {
      e.preventDefault();
    }

    if (this.props.disabled) return;

    if (isTargetMenuCtrl) {
      if ([keyCodes.space, keyCodes.enter, keyCodes.up, keyCodes.down].indexOf(e.which) > -1) {
        // Open the menu (if not open) and focus the first menu item
        if (!this.props.isOpen) {
          this.toggle(e);
        }

        setTimeout(() => this.getMenuItems()[0].focus());
      } else if (this.props.isOpen && isTab) {
        // Focus the first menu item if tabbing from an open menu. We need this
        // for cases where the DropdownMenu sets a custom container, which may
        // not be the natural next item to tab to from the DropdownToggle.
        e.preventDefault();
        this.getMenuItems()[0].focus();
      } else if (this.props.isOpen && e.which === keyCodes.esc) {
        this.toggle(e);
      }
    }

    if (this.props.isOpen && isTargetMenuItem) {
      if ([keyCodes.tab, keyCodes.esc].indexOf(e.which) > -1) {
        this.toggle(e);
        this.getMenuCtrl().focus();
      } else if ([keyCodes.space, keyCodes.enter].indexOf(e.which) > -1) {
        e.target.click();
        this.getMenuCtrl().focus();
      } else if ([keyCodes.down, keyCodes.up].indexOf(e.which) > -1 || [keyCodes.n, keyCodes.p].indexOf(e.which) > -1 && e.ctrlKey) {
        const $menuitems = this.getMenuItems();
        let index = $menuitems.indexOf(e.target);

        if (keyCodes.up === e.which || keyCodes.p === e.which && e.ctrlKey) {
          index = index !== 0 ? index - 1 : $menuitems.length - 1;
        } else if (keyCodes.down === e.which || keyCodes.n === e.which && e.ctrlKey) {
          index = index === $menuitems.length - 1 ? 0 : index + 1;
        }

        $menuitems[index].focus();
      } else if (keyCodes.end === e.which) {
        const $menuitems = this.getMenuItems();
        $menuitems[$menuitems.length - 1].focus();
      } else if (keyCodes.home === e.which) {
        const $menuitems = this.getMenuItems();
        $menuitems[0].focus();
      } else if (e.which >= 48 && e.which <= 90) {
        const $menuitems = this.getMenuItems();
        const charPressed = String.fromCharCode(e.which).toLowerCase();

        for (let i = 0; i < $menuitems.length; i += 1) {
          const firstLetter = $menuitems[i].textContent && $menuitems[i].textContent[0].toLowerCase();

          if (firstLetter === charPressed) {
            $menuitems[i].focus();
            break;
          }
        }
      }
    }
  }

  handleProps() {
    if (this.props.isOpen) {
      this.addEvents();
    } else {
      this.removeEvents();
    }
  }

  getContextValue() {
    return {
      toggle: this.toggle,
      isOpen: this.props.isOpen,
      direction: this.props.direction === 'down' && this.props.dropup ? 'up' : this.props.direction,
      inNavbar: this.props.inNavbar,
      disabled: this.props.disabled,
      // Callback that should be called by DropdownMenu to provide a ref to
      // a HTML tag that's used for the DropdownMenu
      onMenuRef: this.handleMenuRef,
      onToggleRef: this.handleToggleRef,
      menuRole: this.props.menuRole
    };
  }

  getContainer() {
    return this.containerRef.current;
  }

  getMenu() {
    return this.menuRef.current;
  }

  getToggle() {
    return this.toggleRef.current;
  }

  getMenuCtrl() {
    if (this._$menuCtrl) return this._$menuCtrl;
    this._$menuCtrl = this.getToggle();
    return this._$menuCtrl;
  }

  getItemType() {
    if (this.props.menuRole === 'listbox') {
      return 'option';
    }

    return 'menuitem';
  }

  getMenuItems() {
    // In a real menu with a child DropdownMenu, `this.getMenu()` should never
    // be null, but it is sometimes null in tests. To mitigate that, we just
    // use `this.getContainer()` as the fallback `menuContainer`.
    const menuContainer = this.getMenu() || this.getContainer();
    return [].slice.call(menuContainer.querySelectorAll(`[role="${this.getItemType()}"]`));
  }

  addEvents() {
    ['click', 'touchstart', 'keyup'].forEach(event => document.addEventListener(event, this.handleDocumentClick, true));
  }

  removeEvents() {
    ['click', 'touchstart', 'keyup'].forEach(event => document.removeEventListener(event, this.handleDocumentClick, true));
  }

  toggle(e) {
    if (this.props.disabled) {
      return e && e.preventDefault();
    }

    return this.props.toggle(e);
  }

  render() {
    const _omit = omit(this.props, ['toggle', 'disabled', 'inNavbar', 'a11y']),
          {
      className,
      cssModule,
      direction,
      isOpen,
      group,
      size,
      nav,
      setActiveFromChild,
      active,
      tag,
      menuRole
    } = _omit,
          attrs = _objectWithoutProperties(_omit, _excluded$12);

    const Tag = tag || (nav ? 'li' : 'div');
    let subItemIsActive = false;

    if (setActiveFromChild) {
      React__default.Children.map(this.props.children[1].props.children, dropdownItem => {
        if (dropdownItem && dropdownItem.props.active) subItemIsActive = true;
      });
    }

    const classes = mapToCssModules(classnames(className, nav && active ? 'active' : false, setActiveFromChild && subItemIsActive ? 'active' : false, {
      'btn-group': group,
      [`btn-group-${size}`]: !!size,
      dropdown: !group,
      dropup: direction === 'up',
      dropstart: direction === 'start' || direction === 'left',
      dropend: direction === 'end' || direction === 'right',
      show: isOpen,
      'nav-item': nav
    }), cssModule);

    if (this.context.insideInputGroup) {
      return /*#__PURE__*/React__default.createElement(DropdownContext.Provider, {
        value: this.getContextValue()
      }, /*#__PURE__*/React__default.createElement(Manager, null, React__default.Children.map(this.props.children, child => React__default.cloneElement(child, {
        onKeyDown: this.handleKeyDown
      }))));
    }

    return /*#__PURE__*/React__default.createElement(DropdownContext.Provider, {
      value: this.getContextValue()
    }, /*#__PURE__*/React__default.createElement(Manager, null, /*#__PURE__*/React__default.createElement(Tag, _extends({}, attrs, {
      [typeof Tag === 'string' ? 'ref' : 'innerRef']: this.containerRef,
      onKeyDown: this.handleKeyDown,
      className: classes
    }))));
  }

}

Dropdown.propTypes = propTypes$17;
Dropdown.defaultProps = defaultProps$15;
Dropdown.contextType = InputGroupContext;
var Dropdown$1 = Dropdown;

const propTypes$16 = {
  children: PropTypes.node
};

function ButtonDropdown(props) {
  return /*#__PURE__*/React__default.createElement(Dropdown$1, _extends({
    group: true
  }, props));
}

ButtonDropdown.propTypes = propTypes$16;
({
  /** Aria label */
  'aria-label': PropTypes.string,

  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** In order for assistive technologies (such as screen readers) to convey that a series of buttons is grouped, an appropriate role attribute needs to be provided. For button groups, this would be role="group", while toolbars should have a role="toolbar". */
  role: PropTypes.string,

  /** Make the button bigger or smaller */
  size: PropTypes.string,

  /** Set a custom element for this component */
  tag: tagPropType,

  /** Make button group vertical */
  vertical: PropTypes.bool
});
({
  /** Aria label */
  'aria-label': PropTypes.string,

  /** Add custom class */
  className: PropTypes.string,

  /** Change existing className with a new className */
  cssModule: PropTypes.object,

  /** In order for assistive technologies (such as screen readers) to convey that a series of buttons is grouped, an appropriate role attribute needs to be provided. For button groups, this would be role="group", while toolbars should have a role="toolbar". */
  role: PropTypes.string,

  /** Set a custom element for this component */
  tag: tagPropType
});

const _excluded$$ = ["className", "cssModule", "divider", "tag", "header", "active", "text"];
const propTypes$13 = {
  children: PropTypes.node,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  divider: PropTypes.bool,
  tag: tagPropType,
  header: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  toggle: PropTypes.bool,
  text: PropTypes.bool
};
const defaultProps$12 = {
  tag: 'button',
  toggle: true
};

class DropdownItem extends React__default.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.getTabIndex = this.getTabIndex.bind(this);
  }

  onClick(e) {
    const {
      disabled,
      header,
      divider,
      text
    } = this.props;

    if (disabled || header || divider || text) {
      e.preventDefault();
      return;
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }

    if (this.props.toggle) {
      this.context.toggle(e);
    }
  }

  getRole() {
    if (this.context.menuRole === 'listbox') {
      return 'option';
    }

    return 'menuitem';
  }

  getTabIndex() {
    const {
      disabled,
      header,
      divider,
      text
    } = this.props;

    if (disabled || header || divider || text) {
      return '-1';
    }

    return '0';
  }

  render() {
    const tabIndex = this.getTabIndex();
    const role = tabIndex > -1 ? this.getRole() : undefined;

    let _omit = omit(this.props, ['toggle']),
        {
      className,
      cssModule,
      divider,
      tag: Tag,
      header,
      active,
      text
    } = _omit,
        props = _objectWithoutProperties(_omit, _excluded$$);

    const classes = mapToCssModules(classnames(className, {
      disabled: props.disabled,
      'dropdown-item': !divider && !header && !text,
      active: active,
      'dropdown-header': header,
      'dropdown-divider': divider,
      'dropdown-item-text': text
    }), cssModule);

    if (Tag === 'button') {
      if (header) {
        Tag = 'h6';
      } else if (divider) {
        Tag = 'div';
      } else if (props.href) {
        Tag = 'a';
      } else if (text) {
        Tag = 'span';
      }
    }

    return /*#__PURE__*/React__default.createElement(Tag, _extends({
      type: Tag === 'button' && (props.onClick || this.props.toggle) ? 'button' : undefined
    }, props, {
      tabIndex: tabIndex,
      role: role,
      className: classes,
      onClick: this.onClick
    }));
  }

}

DropdownItem.propTypes = propTypes$13;
DropdownItem.defaultProps = defaultProps$12;
DropdownItem.contextType = DropdownContext;

const _excluded$_ = ["className", "cssModule", "dark", "end", "right", "tag", "flip", "modifiers", "persist", "strategy", "container", "updateOnSelect"];
const propTypes$12 = {
  tag: tagPropType,
  children: PropTypes.node.isRequired,
  dark: PropTypes.bool,
  end: PropTypes.bool,

  /** Flips the menu to the opposite side if there is not enough space to fit */
  flip: PropTypes.bool,
  modifiers: PropTypes.array,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  style: PropTypes.object,
  persist: PropTypes.bool,
  strategy: PropTypes.string,
  container: targetPropType,

  /** Update popper layout when a click event comes up. This leverages event bubbling. */
  updateOnSelect: PropTypes.bool,
  right: deprecated(PropTypes.bool, 'Please use "end" instead.')
};
const defaultProps$11 = {
  tag: 'div',
  flip: true,
  modifiers: []
};
const directionPositionMap = {
  up: 'top',
  left: 'left',
  right: 'right',
  start: 'left',
  end: 'right',
  down: 'bottom'
};

class DropdownMenu extends React__default.Component {
  getRole() {
    if (this.context.menuRole === 'listbox') {
      return 'listbox';
    }

    return 'menu';
  }

  render() {
    const _this$props = this.props,
          {
      className,
      cssModule,
      dark,
      end,
      right,
      tag,
      flip,
      modifiers,
      persist,
      strategy,
      container,
      updateOnSelect
    } = _this$props,
          attrs = _objectWithoutProperties(_this$props, _excluded$_);

    const classes = mapToCssModules(classnames(className, 'dropdown-menu', {
      'dropdown-menu-dark': dark,
      'dropdown-menu-end': end || right,
      show: this.context.isOpen
    }), cssModule);
    const Tag = tag;

    if (persist || this.context.isOpen && !this.context.inNavbar) {
      const position1 = directionPositionMap[this.context.direction] || 'bottom';
      const position2 = end || right ? 'end' : 'start';
      const poperPlacement = `${position1}-${position2}`;
      const poperModifiers = [...modifiers, {
        name: 'flip',
        enabled: !!flip
      }];
      const popper = /*#__PURE__*/React__default.createElement(Popper, {
        placement: poperPlacement,
        modifiers: poperModifiers,
        strategy: strategy
      }, ({
        ref,
        style,
        placement,
        update
      }) => {
        let combinedStyle = _objectSpread2(_objectSpread2({}, this.props.style), style);

        const handleRef = tagRef => {
          // Send the ref to `react-popper`
          ref(tagRef); // Send the ref to the parent Dropdown so that clicks outside
          // it will cause it to close

          const {
            onMenuRef
          } = this.context;
          if (onMenuRef) onMenuRef(tagRef);
        };

        return /*#__PURE__*/React__default.createElement(Tag, _extends({
          tabIndex: "-1",
          role: this.getRole(),
          ref: handleRef
        }, attrs, {
          style: combinedStyle,
          "aria-hidden": !this.context.isOpen,
          className: classes,
          "data-popper-placement": placement,
          onClick: () => updateOnSelect && update()
        }));
      });

      if (container) {
        return ReactDOM__default.createPortal(popper, getTarget(container));
      }

      return popper;
    }

    const {
      onMenuRef
    } = this.context;
    return /*#__PURE__*/React__default.createElement(Tag, _extends({
      tabIndex: "-1",
      role: this.getRole()
    }, attrs, {
      ref: onMenuRef,
      "aria-hidden": !this.context.isOpen,
      className: classes,
      "data-popper-placement": attrs.placement
    }));
  }

}

DropdownMenu.propTypes = propTypes$12;
DropdownMenu.defaultProps = defaultProps$11;
DropdownMenu.contextType = DropdownContext;

const _excluded$Z = ["className", "color", "cssModule", "caret", "split", "nav", "tag", "innerRef"];
const propTypes$11 = {
  caret: PropTypes.bool,
  color: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  'aria-haspopup': PropTypes.bool,
  split: PropTypes.bool,
  tag: tagPropType,
  nav: PropTypes.bool,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func])
};
const defaultProps$10 = {
  color: 'secondary',
  'aria-haspopup': true
};

class DropdownToggle extends React__default.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    if (this.props.disabled || this.context.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.nav && !this.props.tag) {
      e.preventDefault();
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }

    this.context.toggle(e);
  }

  getRole() {
    return this.context.menuRole || this.props['aria-haspopup'];
  }

  render() {
    const _this$props = this.props,
          {
      className,
      color,
      cssModule,
      caret,
      split,
      nav,
      tag,
      innerRef
    } = _this$props,
          props = _objectWithoutProperties(_this$props, _excluded$Z);

    const ariaLabel = props['aria-label'] || 'Toggle Dropdown';
    const classes = mapToCssModules(classnames(className, {
      'dropdown-toggle': caret || split,
      'dropdown-toggle-split': split,
      'nav-link': nav
    }), cssModule);
    const children = typeof props.children !== 'undefined' ? props.children : /*#__PURE__*/React__default.createElement("span", {
      className: "visually-hidden"
    }, ariaLabel);
    let Tag;

    if (nav && !tag) {
      Tag = 'a';
      props.href = '#';
    } else if (!tag) {
      Tag = Button;
      props.color = color;
      props.cssModule = cssModule;
    } else {
      Tag = tag;
    }

    if (this.context.inNavbar) {
      return /*#__PURE__*/React__default.createElement(Tag, _extends({}, props, {
        className: classes,
        onClick: this.onClick,
        ref: this.context.onToggleRef,
        "aria-expanded": this.context.isOpen,
        "aria-haspopup": this.getRole(),
        children: children
      }));
    }

    return /*#__PURE__*/React__default.createElement(Reference, {
      innerRef: innerRef
    }, ({
      ref
    }) => {
      const handleRef = tagRef => {
        ref(tagRef);
        const {
          onToggleRef
        } = this.context;
        if (onToggleRef) onToggleRef(tagRef);
      };

      return /*#__PURE__*/React__default.createElement(Tag, _extends({}, props, {
        [typeof Tag === 'string' ? 'ref' : 'innerRef']: handleRef,
        className: classes,
        onClick: this.onClick,
        "aria-expanded": this.context.isOpen,
        "aria-haspopup": this.getRole(),
        children: children
      }));
    });
  }

}

DropdownToggle.propTypes = propTypes$11;
DropdownToggle.defaultProps = defaultProps$10;
DropdownToggle.contextType = DropdownContext;

const _excluded$Y = ["tag", "baseClass", "baseClassActive", "className", "cssModule", "children", "innerRef"];

const propTypes$10 = _objectSpread2(_objectSpread2({}, Transition$1.propTypes), {}, {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  tag: tagPropType,
  baseClass: PropTypes.string,
  baseClassActive: PropTypes.string,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func])
});

const defaultProps$$ = _objectSpread2(_objectSpread2({}, Transition$1.defaultProps), {}, {
  tag: 'div',
  baseClass: 'fade',
  baseClassActive: 'show',
  timeout: TransitionTimeouts.Fade,
  appear: true,
  enter: true,
  exit: true,
  in: true
});

function Fade(props) {
  const {
    tag: Tag,
    baseClass,
    baseClassActive,
    className,
    cssModule,
    children,
    innerRef
  } = props,
        otherProps = _objectWithoutProperties(props, _excluded$Y);

  const transitionProps = pick(otherProps, TransitionPropTypeKeys);
  const childProps = omit(otherProps, TransitionPropTypeKeys);
  return /*#__PURE__*/React__default.createElement(Transition$1, transitionProps, status => {
    const isActive = status === 'entered';
    const classes = mapToCssModules(classnames(className, baseClass, isActive && baseClassActive), cssModule);
    return /*#__PURE__*/React__default.createElement(Tag, _extends({
      className: classes
    }, childProps, {
      ref: innerRef
    }), children);
  });
}

Fade.propTypes = propTypes$10;
Fade.defaultProps = defaultProps$$;

/**
 * AccordionContext
 * {
 *  toggle: PropTypes.func.isRequired,
 *  openId: PropTypes.string,
 * }
 */

React__default.createContext({});
({
  children: PropTypes.node,

  /** Add custom class */
  className: PropTypes.string,

  /** Change existing className with a new className */
  cssModule: PropTypes.object,

  /** Render accordions edge-to-edge with their parent container */
  flush: PropTypes.bool,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),

  /** The current active key that corresponds to the currently expanded card */
  open: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,

  /** Set a custom element for this component */
  tag: tagPropType,

  /** Function that's triggered on clicking `AccordionHeader` */
  toggle: PropTypes.func.isRequired
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),
  children: PropTypes.node,
  defaultOpen: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  stayOpen: PropTypes.bool
});
({
  children: PropTypes.node,

  /** Add custom class */
  className: PropTypes.string,

  /** Change existing base class name with a new class name */
  cssModule: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),

  /** Set a custom element for this component */
  tag: tagPropType,

  /** Unique key used to control item's collapse/expand */
  targetId: PropTypes.string.isRequired
});
({
  children: PropTypes.node,

  /** To add custom class */
  className: PropTypes.string,

  /** Change existing base class name with a new class name */
  cssModule: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),

  /** Set a custom element for this component */
  tag: tagPropType
});

const _excluded$T = ["tag", "horizontal", "isOpen", "className", "navbar", "cssModule", "children", "innerRef"];

const propTypes$X = _objectSpread2(_objectSpread2({}, Transition$1.propTypes), {}, {
  /** Make content animation appear horizontally */
  horizontal: PropTypes.bool,

  /** Set if Collapse is open or closed */
  isOpen: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

  /** Set a custom element for this component */
  tag: tagPropType,

  /** Add custom class */
  className: PropTypes.node,
  navbar: PropTypes.bool,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,
  innerRef: PropTypes.shape({
    current: PropTypes.object
  })
});

const defaultProps$W = _objectSpread2(_objectSpread2({}, Transition$1.defaultProps), {}, {
  horizontal: false,
  isOpen: false,
  appear: false,
  enter: true,
  exit: true,
  tag: 'div',
  timeout: TransitionTimeouts.Collapse
});

const transitionStatusToClassHash = {
  [TransitionStatuses.ENTERING]: 'collapsing',
  [TransitionStatuses.ENTERED]: 'collapse show',
  [TransitionStatuses.EXITING]: 'collapsing',
  [TransitionStatuses.EXITED]: 'collapse'
};

function getTransitionClass(status) {
  return transitionStatusToClassHash[status] || 'collapse';
}

class Collapse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dimension: null
    };
    this.nodeRef = props.innerRef || React__default.createRef();
    ['onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'].forEach(name => {
      this[name] = this[name].bind(this);
    });
  }

  onEntering(_, isAppearing) {
    const node = this.getNode();
    this.setState({
      dimension: this.getDimension(node)
    });
    this.props.onEntering(node, isAppearing);
  }

  onEntered(_, isAppearing) {
    const node = this.getNode();
    this.setState({
      dimension: null
    });
    this.props.onEntered(node, isAppearing);
  }

  onExit() {
    const node = this.getNode();
    this.setState({
      dimension: this.getDimension(node)
    });
    this.props.onExit(node);
  }

  onExiting() {
    const node = this.getNode(); // getting this variable triggers a reflow

    this.getDimension(node); // eslint-disable-line no-unused-vars


    this.setState({
      dimension: 0
    });
    this.props.onExiting(node);
  }

  onExited() {
    const node = this.getNode();
    this.setState({
      dimension: null
    });
    this.props.onExited(node);
  }

  getNode() {
    return this.nodeRef.current;
  }

  getDimension(node) {
    return this.props.horizontal ? node.scrollWidth : node.scrollHeight;
  }

  render() {
    const _this$props = this.props,
          {
      tag: Tag,
      horizontal,
      isOpen,
      className,
      navbar,
      cssModule,
      children,
      innerRef
    } = _this$props,
          otherProps = _objectWithoutProperties(_this$props, _excluded$T);

    const {
      dimension
    } = this.state;
    const transitionProps = pick(otherProps, TransitionPropTypeKeys);
    const childProps = omit(otherProps, TransitionPropTypeKeys);
    return /*#__PURE__*/React__default.createElement(Transition$1, _extends({}, transitionProps, {
      in: isOpen,
      nodeRef: this.nodeRef,
      onEntering: this.onEntering,
      onEntered: this.onEntered,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }), status => {
      let collapseClass = getTransitionClass(status);
      const classes = mapToCssModules(classnames(className, horizontal && 'collapse-horizontal', collapseClass, navbar && 'navbar-collapse'), cssModule);
      const style = dimension === null ? null : {
        [horizontal ? 'width' : 'height']: dimension
      };
      return /*#__PURE__*/React__default.createElement(Tag, _extends({}, childProps, {
        style: _objectSpread2(_objectSpread2({}, childProps.style), style),
        className: classes,
        ref: this.nodeRef
      }), children);
    });
  }

}

Collapse.propTypes = propTypes$X;
Collapse.defaultProps = defaultProps$W;
var Collapse$1 = Collapse;
({
  /** Unique key used to control item's collapse/expand */
  accordionId: PropTypes.string.isRequired,

  /** To add custom class */
  className: PropTypes.string,
  children: PropTypes.node,

  /** Change existing base class name with a new class name */
  cssModule: PropTypes.object,

  /** Pass ref to the component */
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),

  /** Set a custom element for this component */
  tag: tagPropType
});
({
  /** Pass children so this component can wrap the child elements */
  children: PropTypes.node,

  /** Add custom class */
  className: PropTypes.string,

  /** Change background color of Badge */
  color: PropTypes.string,

  /** Change existing className with a new className */
  cssModule: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),

  /** Add rounded corners to the Badge */
  pill: PropTypes.bool,

  /** Set a custom element for this component */
  tag: tagPropType
});
({
  /** Toggles card padding using `.card-body` */
  body: PropTypes.bool,

  /** Add custom class */
  className: PropTypes.string,

  /** Change background color of component */
  color: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),

  /** Inverts the color */
  inverse: PropTypes.bool,

  /** Changes the card to have only outline */
  outline: PropTypes.bool,

  /** Set a custom element for this component */
  tag: tagPropType
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),

  /** Set a custom element for this component */
  tag: tagPropType
});
({
  tag: tagPropType,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Set a custom element for this component */
  tag: tagPropType
});
({
  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Set a custom element for this component */
  tag: tagPropType
});
({
  /** Add `bottom` prop if image is at bottom of card */
  bottom: PropTypes.bool,

  /** Add custom class */
  className: PropTypes.string,

  /** Change existing className with a new className */
  cssModule: PropTypes.object,

  /** Set a custom element for this component */
  tag: tagPropType,

  /** Add `top` prop if image is at top of card */
  top: PropTypes.bool
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});

/**
 * CarouselContext
 * {
 *  direction: PropTypes.oneOf(['start', 'end']).isRequired,
 * }
 */

const CarouselContext = React__default.createContext({});

const _excluded$G = ["in", "children", "cssModule", "slide", "tag", "className"];

class CarouselItem extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = {
      startAnimation: false
    };
    this.onEnter = this.onEnter.bind(this);
    this.onEntering = this.onEntering.bind(this);
    this.onExit = this.onExit.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
  }

  onEnter(node, isAppearing) {
    this.setState({
      startAnimation: false
    });
    this.props.onEnter(node, isAppearing);
  }

  onEntering(node, isAppearing) {
    // getting this variable triggers a reflow
    const {
      offsetHeight
    } = node;
    this.setState({
      startAnimation: true
    });
    this.props.onEntering(node, isAppearing);
    return offsetHeight;
  }

  onExit(node) {
    this.setState({
      startAnimation: false
    });
    this.props.onExit(node);
  }

  onExiting(node) {
    this.setState({
      startAnimation: true
    });
    node.dispatchEvent(new CustomEvent('slide.bs.carousel'));
    this.props.onExiting(node);
  }

  onExited(node) {
    node.dispatchEvent(new CustomEvent('slid.bs.carousel'));
    this.props.onExited(node);
  }

  render() {
    const _this$props = this.props,
          {
      in: isIn,
      children,
      cssModule,
      slide,
      tag: Tag,
      className
    } = _this$props,
          transitionProps = _objectWithoutProperties(_this$props, _excluded$G);

    return /*#__PURE__*/React__default.createElement(Transition$1, _extends({}, transitionProps, {
      enter: slide,
      exit: slide,
      in: isIn,
      onEnter: this.onEnter,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }), status => {
      const {
        direction
      } = this.context;
      const isActive = status === TransitionStatuses.ENTERED || status === TransitionStatuses.EXITING;
      const directionClassName = (status === TransitionStatuses.ENTERING || status === TransitionStatuses.EXITING) && this.state.startAnimation && (direction === 'end' ? 'carousel-item-start' : 'carousel-item-end');
      const orderClassName = status === TransitionStatuses.ENTERING && (direction === 'end' ? 'carousel-item-next' : 'carousel-item-prev');
      const itemClasses = mapToCssModules(classnames(className, 'carousel-item', isActive && 'active', directionClassName, orderClassName), cssModule);
      return /*#__PURE__*/React__default.createElement(Tag, {
        className: itemClasses
      }, children);
    });
  }

}

CarouselItem.propTypes = _objectSpread2(_objectSpread2({}, Transition$1.propTypes), {}, {
  /** Set a custom element for this component */
  tag: tagPropType,
  in: PropTypes.bool,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,
  children: PropTypes.node,

  /** Enable/disable animation */
  slide: PropTypes.bool,

  /** Add custom class */
  className: PropTypes.string
});
CarouselItem.defaultProps = _objectSpread2(_objectSpread2({}, Transition$1.defaultProps), {}, {
  tag: 'div',
  timeout: TransitionTimeouts.Carousel,
  slide: true
});
CarouselItem.contextType = CarouselContext;
var CarouselItem$1 = CarouselItem;

const SWIPE_THRESHOLD = 40;
const propTypes$K = {
  /** the current active slide of the carousel */
  activeIndex: PropTypes.number,

  /** a function which should advance the carousel to the next slide (via activeIndex) */
  next: PropTypes.func.isRequired,

  /** a function which should advance the carousel to the previous slide (via activeIndex) */
  previous: PropTypes.func.isRequired,

  /** controls if the left and right arrow keys should control the carousel */
  keyboard: PropTypes.bool,

  /** If set to "hover", pauses the cycling of the carousel on mouseenter and resumes the cycling of the carousel on
   * mouseleave. If set to false, hovering over the carousel won't pause it.
   */
  pause: PropTypes.oneOf(['hover', false]),

  /** Autoplays the carousel after the user manually cycles the first item. If "carousel", autoplays the carousel on load. */
  ride: PropTypes.oneOf(['carousel']),

  /** the interval at which the carousel automatically cycles */
  interval: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
  children: PropTypes.array,

  /** called when the mouse enters the Carousel */
  mouseEnter: PropTypes.func,

  /** called when the mouse exits the Carousel */
  mouseLeave: PropTypes.func,

  /** controls whether the slide animation on the Carousel works or not */
  slide: PropTypes.bool,

  /** make the controls, indicators and captions dark on the Carousel */
  dark: PropTypes.bool,
  fade: PropTypes.bool,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Add custom class */
  className: PropTypes.string,

  /** Enable touch support */
  enableTouch: PropTypes.bool
};
const propsToOmit$2 = Object.keys(propTypes$K);
const defaultProps$J = {
  interval: 5000,
  pause: 'hover',
  keyboard: true,
  slide: true,
  enableTouch: true,
  fade: false
};

class Carousel extends React__default.Component {
  constructor(props) {
    super(props);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.renderItems = this.renderItems.bind(this);
    this.hoverStart = this.hoverStart.bind(this);
    this.hoverEnd = this.hoverEnd.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.state = {
      activeIndex: this.props.activeIndex,
      direction: 'end',
      indicatorClicked: false
    };
  }

  componentDidMount() {
    // Set up the cycle
    if (this.props.ride === 'carousel') {
      this.setInterval();
    } // TODO: move this to the specific carousel like bootstrap. Currently it will trigger ALL carousels on the page.


    document.addEventListener('keyup', this.handleKeyPress);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let newState = null;
    let {
      activeIndex,
      direction,
      indicatorClicked
    } = prevState;

    if (nextProps.activeIndex !== activeIndex) {
      // Calculate the direction to turn
      if (nextProps.activeIndex === activeIndex + 1) {
        direction = 'end';
      } else if (nextProps.activeIndex === activeIndex - 1) {
        direction = 'start';
      } else if (nextProps.activeIndex < activeIndex) {
        direction = indicatorClicked ? 'start' : 'end';
      } else if (nextProps.activeIndex !== activeIndex) {
        direction = indicatorClicked ? 'end' : 'start';
      }

      newState = {
        activeIndex: nextProps.activeIndex,
        direction,
        indicatorClicked: false
      };
    }

    return newState;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.activeIndex === this.state.activeIndex) return;
    this.setInterval();
  }

  componentWillUnmount() {
    this.clearInterval();
    document.removeEventListener('keyup', this.handleKeyPress);
  }

  handleKeyPress(evt) {
    if (this.props.keyboard) {
      if (evt.keyCode === 37) {
        this.props.previous();
      } else if (evt.keyCode === 39) {
        this.props.next();
      }
    }
  }

  handleTouchStart(e) {
    if (!this.props.enableTouch) {
      return;
    }

    this.touchStartX = e.changedTouches[0].screenX;
    this.touchStartY = e.changedTouches[0].screenY;
  }

  handleTouchEnd(e) {
    if (!this.props.enableTouch) {
      return;
    }

    const currentX = e.changedTouches[0].screenX;
    const currentY = e.changedTouches[0].screenY;
    const diffX = Math.abs(this.touchStartX - currentX);
    const diffY = Math.abs(this.touchStartY - currentY); // Don't swipe if Y-movement is bigger than X-movement

    if (diffX < diffY) {
      return;
    }

    if (diffX < SWIPE_THRESHOLD) {
      return;
    }

    if (currentX < this.touchStartX) {
      this.props.next();
    } else {
      this.props.previous();
    }
  }

  getContextValue() {
    return {
      direction: this.state.direction
    };
  }

  setInterval() {
    // make sure not to have multiple intervals going...
    this.clearInterval();

    if (this.props.interval) {
      this.cycleInterval = setInterval(() => {
        this.props.next();
      }, parseInt(this.props.interval, 10));
    }
  }

  clearInterval() {
    clearInterval(this.cycleInterval);
  }

  hoverStart(...args) {
    if (this.props.pause === 'hover') {
      this.clearInterval();
    }

    if (this.props.mouseEnter) {
      this.props.mouseEnter(...args);
    }
  }

  hoverEnd(...args) {
    if (this.props.pause === 'hover') {
      this.setInterval();
    }

    if (this.props.mouseLeave) {
      this.props.mouseLeave(...args);
    }
  }

  renderItems(carouselItems, className) {
    const {
      slide
    } = this.props;
    return /*#__PURE__*/React__default.createElement("div", {
      className: className
    }, carouselItems.map((item, index) => {
      const isIn = index === this.state.activeIndex;
      return React__default.cloneElement(item, {
        in: isIn,
        slide: slide
      });
    }));
  }

  render() {
    const {
      cssModule,
      slide,
      className,
      dark,
      fade
    } = this.props;
    const attributes = omit(this.props, propsToOmit$2);
    const outerClasses = mapToCssModules(classnames(className, 'carousel', fade && 'carousel-fade', slide && 'slide', dark && 'carousel-dark'), cssModule);
    const innerClasses = mapToCssModules(classnames('carousel-inner'), cssModule); // filter out booleans, null, or undefined

    const children = this.props.children.filter(child => child !== null && child !== undefined && typeof child !== 'boolean');
    const slidesOnly = children.every(child => child.type === CarouselItem$1); // Rendering only slides

    if (slidesOnly) {
      return /*#__PURE__*/React__default.createElement("div", _extends({}, attributes, {
        className: outerClasses,
        onMouseEnter: this.hoverStart,
        onMouseLeave: this.hoverEnd
      }), /*#__PURE__*/React__default.createElement(CarouselContext.Provider, {
        value: this.getContextValue()
      }, this.renderItems(children, innerClasses)));
    } // Rendering slides and controls


    if (children[0] instanceof Array) {
      const _carouselItems = children[0];
      const _controlLeft = children[1];
      const _controlRight = children[2];
      return /*#__PURE__*/React__default.createElement("div", _extends({}, attributes, {
        className: outerClasses,
        onMouseEnter: this.hoverStart,
        onMouseLeave: this.hoverEnd
      }), /*#__PURE__*/React__default.createElement(CarouselContext.Provider, {
        value: this.getContextValue()
      }, this.renderItems(_carouselItems, innerClasses), _controlLeft, _controlRight));
    } // Rendering indicators, slides and controls


    const indicators = children[0];

    const wrappedOnClick = e => {
      if (typeof indicators.props.onClickHandler === 'function') {
        this.setState({
          indicatorClicked: true
        }, () => indicators.props.onClickHandler(e));
      }
    };

    const wrappedIndicators = React__default.cloneElement(indicators, {
      onClickHandler: wrappedOnClick
    });
    const carouselItems = children[1];
    const controlLeft = children[2];
    const controlRight = children[3];
    return /*#__PURE__*/React__default.createElement("div", _extends({}, attributes, {
      className: outerClasses,
      onMouseEnter: this.hoverStart,
      onMouseLeave: this.hoverEnd,
      onTouchStart: this.handleTouchStart,
      onTouchEnd: this.handleTouchEnd
    }), /*#__PURE__*/React__default.createElement(CarouselContext.Provider, {
      value: this.getContextValue()
    }, wrappedIndicators, this.renderItems(carouselItems, innerClasses), controlLeft, controlRight));
  }

}

Carousel.propTypes = propTypes$K;
Carousel.defaultProps = defaultProps$J;
var Carousel$1 = Carousel;

const _excluded$F = ["direction", "onClickHandler", "cssModule", "directionText", "className"];

function CarouselControl(props) {
  const {
    direction,
    onClickHandler,
    cssModule,
    directionText,
    className
  } = props,
        attributes = _objectWithoutProperties(props, _excluded$F);

  const anchorClasses = mapToCssModules(classnames(className, `carousel-control-${direction}`), cssModule);
  const iconClasses = mapToCssModules(classnames(`carousel-control-${direction}-icon`), cssModule);
  const screenReaderClasses = mapToCssModules(classnames('visually-hidden'), cssModule);
  return (
    /*#__PURE__*/
    // We need to disable this linting rule to use an `<a>` instead of
    // `<button>` because that's what the Bootstrap examples require:
    // https://getbootstrap.com/docs/4.5/components/carousel/#with-controls
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    React__default.createElement("a", _extends({}, attributes, {
      className: anchorClasses,
      style: {
        cursor: 'pointer'
      },
      role: "button",
      tabIndex: "0",
      onClick: e => {
        e.preventDefault();
        onClickHandler();
      }
    }), /*#__PURE__*/React__default.createElement("span", {
      className: iconClasses,
      "aria-hidden": "true"
    }), /*#__PURE__*/React__default.createElement("span", {
      className: screenReaderClasses
    }, directionText || direction))
  );
}

CarouselControl.propTypes = {
  /** Set the direction of control button */
  direction: PropTypes.oneOf(['prev', 'next']).isRequired,

  /** Function to be triggered on click */
  onClickHandler: PropTypes.func.isRequired,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Screen reader text */
  directionText: PropTypes.string,

  /** Add custom class */
  className: PropTypes.string
};

const _excluded$E = ["items", "activeIndex", "cssModule", "onClickHandler", "className"];

function CarouselIndicators(props) {
  const {
    items,
    activeIndex,
    cssModule,
    onClickHandler,
    className
  } = props,
        attributes = _objectWithoutProperties(props, _excluded$E);

  const listClasses = mapToCssModules(classnames(className, 'carousel-indicators'), cssModule);
  const indicators = items.map((item, idx) => {
    const indicatorClasses = mapToCssModules(classnames({
      active: activeIndex === idx
    }), cssModule);
    return /*#__PURE__*/React__default.createElement("button", {
      "aria-label": item.caption,
      "data-bs-target": true,
      type: "button",
      key: `${item.key || Object.values(item).join('')}`,
      onClick: e => {
        e.preventDefault();
        onClickHandler(idx);
      },
      className: indicatorClasses
    });
  });
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: listClasses
  }, attributes), indicators);
}

CarouselIndicators.propTypes = {
  /** The current active index */
  activeIndex: PropTypes.number.isRequired,

  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Array of items to show */
  items: PropTypes.array.isRequired,

  /** Function to be triggered on click */
  onClickHandler: PropTypes.func.isRequired
};

function CarouselCaption(props) {
  const {
    captionHeader,
    captionText,
    cssModule,
    className
  } = props;
  const classes = mapToCssModules(classnames(className, 'carousel-caption', 'd-none', 'd-md-block'), cssModule);
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes
  }, /*#__PURE__*/React__default.createElement("h3", null, captionHeader), /*#__PURE__*/React__default.createElement("p", null, captionText));
}

CarouselCaption.propTypes = {
  /** Heading for the caption */
  captionHeader: PropTypes.node,

  /** Text for caption */
  captionText: PropTypes.node.isRequired,

  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object
};

const _excluded$D = ["defaultActiveIndex", "autoPlay", "indicators", "controls", "items", "goToIndex"];
const propTypes$J = {
  items: PropTypes.array.isRequired,
  indicators: PropTypes.bool,
  controls: PropTypes.bool,
  autoPlay: PropTypes.bool,
  defaultActiveIndex: PropTypes.number,
  activeIndex: PropTypes.number,
  next: PropTypes.func,
  previous: PropTypes.func,
  goToIndex: PropTypes.func
};

class UncontrolledCarousel extends Component {
  constructor(props) {
    super(props);
    this.animating = false;
    this.state = {
      activeIndex: props.defaultActiveIndex || 0
    };
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.goToIndex = this.goToIndex.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
  }

  onExiting() {
    this.animating = true;
  }

  onExited() {
    this.animating = false;
  }

  next() {
    if (this.animating) return;
    this.setState(prevState => {
      const nextIndex = prevState.activeIndex === this.props.items.length - 1 ? 0 : prevState.activeIndex + 1;
      return {
        activeIndex: nextIndex
      };
    });
  }

  previous() {
    if (this.animating) return;
    this.setState(prevState => {
      const nextIndex = prevState.activeIndex === 0 ? this.props.items.length - 1 : prevState.activeIndex - 1;
      return {
        activeIndex: nextIndex
      };
    });
  }

  goToIndex(newIndex) {
    if (this.animating) return;
    this.setState({
      activeIndex: newIndex
    });
  }

  render() {
    const _this$props = this.props,
          {
      defaultActiveIndex,
      autoPlay,
      indicators,
      controls,
      items,
      goToIndex
    } = _this$props,
          props = _objectWithoutProperties(_this$props, _excluded$D);

    const {
      activeIndex
    } = this.state;
    const slides = items.map(item => {
      const key = item.key || item.src;
      return /*#__PURE__*/React__default.createElement(CarouselItem$1, {
        onExiting: this.onExiting,
        onExited: this.onExited,
        key: key
      }, /*#__PURE__*/React__default.createElement("img", {
        className: "d-block w-100",
        src: item.src,
        alt: item.altText
      }), /*#__PURE__*/React__default.createElement(CarouselCaption, {
        captionText: item.caption,
        captionHeader: item.header || item.caption
      }));
    });
    return /*#__PURE__*/React__default.createElement(Carousel$1, _extends({
      activeIndex: activeIndex,
      next: this.next,
      previous: this.previous,
      ride: autoPlay ? 'carousel' : undefined
    }, props), indicators && /*#__PURE__*/React__default.createElement(CarouselIndicators, {
      items: items,
      activeIndex: props.activeIndex || activeIndex,
      onClickHandler: goToIndex || this.goToIndex
    }), slides, controls && /*#__PURE__*/React__default.createElement(CarouselControl, {
      direction: "prev",
      directionText: "Previous",
      onClickHandler: props.previous || this.previous
    }), controls && /*#__PURE__*/React__default.createElement(CarouselControl, {
      direction: "next",
      directionText: "Next",
      onClickHandler: props.next || this.next
    }));
  }

}

UncontrolledCarousel.propTypes = propTypes$J;
UncontrolledCarousel.defaultProps = {
  controls: true,
  indicators: true,
  autoPlay: true
};
({
  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Set a custom element for this component */
  tag: tagPropType
});
({
  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Set a custom element for this component */
  tag: tagPropType
});
({
  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Set a custom element for this component */
  tag: tagPropType
});

const _excluded$z = ["cssModule", "children", "isOpen", "flip", "target", "offset", "fallbackPlacements", "placementPrefix", "arrowClassName", "hideArrow", "popperClassName", "tag", "container", "modifiers", "strategy", "boundariesElement", "onClosed", "fade", "transition", "placement"];

function noop$2() {}

const propTypes$F = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  popperClassName: PropTypes.string,
  placement: PropTypes.string,
  placementPrefix: PropTypes.string,
  arrowClassName: PropTypes.string,
  hideArrow: PropTypes.bool,
  tag: tagPropType,
  isOpen: PropTypes.bool,
  cssModule: PropTypes.object,
  offset: PropTypes.arrayOf(PropTypes.number),
  fallbackPlacements: PropTypes.array,
  flip: PropTypes.bool,
  container: targetPropType,
  target: targetPropType.isRequired,
  modifiers: PropTypes.array,
  strategy: PropTypes.string,
  boundariesElement: PropTypes.oneOfType([PropTypes.string, DOMElement]),
  onClosed: PropTypes.func,
  fade: PropTypes.bool,
  transition: PropTypes.shape(Fade.propTypes)
};
const defaultProps$F = {
  boundariesElement: 'scrollParent',
  placement: 'auto',
  hideArrow: false,
  isOpen: false,
  offset: [0, 0],
  flip: true,
  container: 'body',
  modifiers: [],
  onClosed: noop$2,
  fade: true,
  transition: _objectSpread2({}, Fade.defaultProps)
};

class PopperContent extends React__default.Component {
  constructor(props) {
    super(props);
    this.setTargetNode = this.setTargetNode.bind(this);
    this.getTargetNode = this.getTargetNode.bind(this);
    this.getRef = this.getRef.bind(this);
    this.onClosed = this.onClosed.bind(this);
    this.state = {
      isOpen: props.isOpen
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.isOpen && !state.isOpen) {
      return {
        isOpen: props.isOpen
      };
    }

    return null;
  }

  componentDidUpdate() {
    if (this._element && this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) {
      this._element.childNodes[0].focus();
    }
  }

  onClosed() {
    this.props.onClosed();
    this.setState({
      isOpen: false
    });
  }

  getTargetNode() {
    return this.targetNode;
  }

  getContainerNode() {
    return getTarget(this.props.container);
  }

  getRef(ref) {
    this._element = ref;
  }

  setTargetNode(node) {
    this.targetNode = typeof node === 'string' ? getTarget(node) : node;
  }

  renderChildren() {
    const _this$props = this.props,
          {
      cssModule,
      children,
      isOpen,
      flip,
      target,
      offset,
      fallbackPlacements,
      placementPrefix,
      arrowClassName: _arrowClassName,
      hideArrow,
      popperClassName: _popperClassName,
      tag,
      container,
      modifiers,
      strategy,
      boundariesElement,
      onClosed,
      fade,
      transition,
      placement
    } = _this$props,
          attrs = _objectWithoutProperties(_this$props, _excluded$z);

    const arrowClassName = mapToCssModules(classnames('arrow', _arrowClassName), cssModule);
    const popperClassName = mapToCssModules(classnames(_popperClassName, placementPrefix ? `${placementPrefix}-auto` : ''), this.props.cssModule);
    const modifierNames = modifiers.map(m => m.name);
    const baseModifiers = [{
      name: 'offset',
      options: {
        offset
      }
    }, {
      name: 'flip',
      enabled: flip,
      options: {
        fallbackPlacements
      }
    }, {
      name: 'preventOverflow',
      options: {
        boundary: boundariesElement
      }
    }].filter(m => !modifierNames.includes(m.name));
    const extendedModifiers = [...baseModifiers, ...modifiers];

    const popperTransition = _objectSpread2(_objectSpread2(_objectSpread2({}, Fade.defaultProps), transition), {}, {
      baseClass: fade ? transition.baseClass : '',
      timeout: fade ? transition.timeout : 0
    });

    return /*#__PURE__*/React__default.createElement(Fade, _extends({}, popperTransition, attrs, {
      in: isOpen,
      onExited: this.onClosed,
      tag: tag
    }), /*#__PURE__*/React__default.createElement(Popper, {
      referenceElement: this.targetNode,
      modifiers: extendedModifiers,
      placement: placement,
      strategy: strategy
    }, ({
      ref,
      style,
      placement: popperPlacement,
      isReferenceHidden,
      arrowProps,
      update
    }) => /*#__PURE__*/React__default.createElement("div", {
      ref: ref,
      style: style,
      className: popperClassName,
      "data-popper-placement": popperPlacement,
      "data-popper-reference-hidden": isReferenceHidden ? 'true' : undefined
    }, typeof children === 'function' ? children({
      update
    }) : children, !hideArrow && /*#__PURE__*/React__default.createElement("span", {
      ref: arrowProps.ref,
      className: arrowClassName,
      style: arrowProps.style
    }))));
  }

  render() {
    this.setTargetNode(this.props.target);

    if (this.state.isOpen) {
      return this.props.container === 'inline' ? this.renderChildren() : ReactDOM__default.createPortal( /*#__PURE__*/React__default.createElement("div", {
        ref: this.getRef
      }, this.renderChildren()), this.getContainerNode());
    }

    return null;
  }

}

PopperContent.propTypes = propTypes$F;
PopperContent.defaultProps = defaultProps$F;
var PopperContent$1 = PopperContent;

({
  popperManager: PropTypes.object.isRequired
});
({
  target: targetPropType.isRequired
});

const propTypes$E = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  placement: PropTypes.oneOf(PopperPlacements),
  target: targetPropType.isRequired,
  container: targetPropType,
  isOpen: PropTypes.bool,
  disabled: PropTypes.bool,
  hideArrow: PropTypes.bool,
  boundariesElement: PropTypes.oneOfType([PropTypes.string, DOMElement]),
  className: PropTypes.string,
  innerClassName: PropTypes.string,
  arrowClassName: PropTypes.string,
  popperClassName: PropTypes.string,
  cssModule: PropTypes.object,
  toggle: PropTypes.func,
  autohide: PropTypes.bool,
  placementPrefix: PropTypes.string,
  delay: PropTypes.oneOfType([PropTypes.shape({
    show: PropTypes.number,
    hide: PropTypes.number
  }), PropTypes.number]),
  modifiers: PropTypes.array,
  strategy: PropTypes.string,
  offset: PropTypes.arrayOf(PropTypes.number),
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.object]),
  trigger: PropTypes.string,
  fade: PropTypes.bool,
  flip: PropTypes.bool
};
const DEFAULT_DELAYS = {
  show: 0,
  hide: 50
};
const defaultProps$E = {
  isOpen: false,
  hideArrow: false,
  autohide: false,
  delay: DEFAULT_DELAYS,
  toggle: function () {},
  trigger: 'click',
  fade: true
};

function isInDOMSubtree(element, subtreeRoot) {
  return subtreeRoot && (element === subtreeRoot || subtreeRoot.contains(element));
}

function isInDOMSubtrees(element, subtreeRoots = []) {
  return subtreeRoots && subtreeRoots.length && subtreeRoots.filter(subTreeRoot => isInDOMSubtree(element, subTreeRoot))[0];
}

class TooltipPopoverWrapper extends React__default.Component {
  constructor(props) {
    super(props);
    this._targets = [];
    this.currentTargetElement = null;
    this.addTargetEvents = this.addTargetEvents.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.removeTargetEvents = this.removeTargetEvents.bind(this);
    this.toggle = this.toggle.bind(this);
    this.showWithDelay = this.showWithDelay.bind(this);
    this.hideWithDelay = this.hideWithDelay.bind(this);
    this.onMouseOverTooltipContent = this.onMouseOverTooltipContent.bind(this);
    this.onMouseLeaveTooltipContent = this.onMouseLeaveTooltipContent.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.onEscKeyDown = this.onEscKeyDown.bind(this);
    this.getRef = this.getRef.bind(this);
    this.state = {
      isOpen: props.isOpen
    };
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    this.updateTarget();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.removeTargetEvents();
    this._targets = null;
    this.clearShowTimeout();
    this.clearHideTimeout();
  }

  static getDerivedStateFromProps(props, state) {
    if (props.isOpen && !state.isOpen) {
      return {
        isOpen: props.isOpen
      };
    }

    return null;
  }

  handleDocumentClick(e) {
    const triggers = this.props.trigger.split(' ');

    if (triggers.indexOf('legacy') > -1 && (this.props.isOpen || isInDOMSubtrees(e.target, this._targets))) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }

      if (this.props.isOpen && !isInDOMSubtree(e.target, this._popover)) {
        this.hideWithDelay(e);
      } else if (!this.props.isOpen) {
        this.showWithDelay(e);
      }
    } else if (triggers.indexOf('click') > -1 && isInDOMSubtrees(e.target, this._targets)) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }

      if (!this.props.isOpen) {
        this.showWithDelay(e);
      } else {
        this.hideWithDelay(e);
      }
    }
  }

  onMouseOverTooltipContent() {
    if (this.props.trigger.indexOf('hover') > -1 && !this.props.autohide) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }

      if (this.state.isOpen && !this.props.isOpen) {
        this.toggle();
      }
    }
  }

  onMouseLeaveTooltipContent(e) {
    if (this.props.trigger.indexOf('hover') > -1 && !this.props.autohide) {
      if (this._showTimeout) {
        this.clearShowTimeout();
      }

      e.persist();
      this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
    }
  }

  onEscKeyDown(e) {
    if (e.key === 'Escape') {
      this.hide(e);
    }
  }

  getRef(ref) {
    const {
      innerRef
    } = this.props;

    if (innerRef) {
      if (typeof innerRef === 'function') {
        innerRef(ref);
      } else if (typeof innerRef === 'object') {
        innerRef.current = ref;
      }
    }

    this._popover = ref;
  }

  getDelay(key) {
    const {
      delay
    } = this.props;

    if (typeof delay === 'object') {
      return isNaN(delay[key]) ? DEFAULT_DELAYS[key] : delay[key];
    }

    return delay;
  }

  getCurrentTarget(target) {
    if (!target) return null;

    const index = this._targets.indexOf(target);

    if (index >= 0) return this._targets[index];
    return this.getCurrentTarget(target.parentElement);
  }

  show(e) {
    if (!this.props.isOpen) {
      this.clearShowTimeout();
      this.currentTargetElement = e ? e.currentTarget || this.getCurrentTarget(e.target) : null;

      if (e && e.composedPath && typeof e.composedPath === 'function') {
        const path = e.composedPath();
        this.currentTargetElement = path && path[0] || this.currentTargetElement;
      }

      this.toggle(e);
    }
  }

  showWithDelay(e) {
    if (this._hideTimeout) {
      this.clearHideTimeout();
    }

    this._showTimeout = setTimeout(this.show.bind(this, e), this.getDelay('show'));
  }

  hide(e) {
    if (this.props.isOpen) {
      this.clearHideTimeout();
      this.currentTargetElement = null;
      this.toggle(e);
    }
  }

  hideWithDelay(e) {
    if (this._showTimeout) {
      this.clearShowTimeout();
    }

    this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
  }

  clearShowTimeout() {
    clearTimeout(this._showTimeout);
    this._showTimeout = undefined;
  }

  clearHideTimeout() {
    clearTimeout(this._hideTimeout);
    this._hideTimeout = undefined;
  }

  addEventOnTargets(type, handler, isBubble) {
    this._targets.forEach(target => {
      target.addEventListener(type, handler, isBubble);
    });
  }

  removeEventOnTargets(type, handler, isBubble) {
    this._targets.forEach(target => {
      target.removeEventListener(type, handler, isBubble);
    });
  }

  addTargetEvents() {
    if (this.props.trigger) {
      let triggers = this.props.trigger.split(' ');

      if (triggers.indexOf('manual') === -1) {
        if (triggers.indexOf('click') > -1 || triggers.indexOf('legacy') > -1) {
          document.addEventListener('click', this.handleDocumentClick, true);
        }

        if (this._targets && this._targets.length) {
          if (triggers.indexOf('hover') > -1) {
            this.addEventOnTargets('mouseover', this.showWithDelay, true);
            this.addEventOnTargets('mouseout', this.hideWithDelay, true);
          }

          if (triggers.indexOf('focus') > -1) {
            this.addEventOnTargets('focusin', this.show, true);
            this.addEventOnTargets('focusout', this.hide, true);
          }

          this.addEventOnTargets('keydown', this.onEscKeyDown, true);
        }
      }
    }
  }

  removeTargetEvents() {
    if (this._targets) {
      this.removeEventOnTargets('mouseover', this.showWithDelay, true);
      this.removeEventOnTargets('mouseout', this.hideWithDelay, true);
      this.removeEventOnTargets('keydown', this.onEscKeyDown, true);
      this.removeEventOnTargets('focusin', this.show, true);
      this.removeEventOnTargets('focusout', this.hide, true);
    }

    document.removeEventListener('click', this.handleDocumentClick, true);
  }

  updateTarget() {
    const newTarget = getTarget(this.props.target, true);

    if (newTarget !== this._targets) {
      this.removeTargetEvents();
      this._targets = newTarget ? Array.from(newTarget) : [];
      this.currentTargetElement = this.currentTargetElement || this._targets[0];
      this.addTargetEvents();
    }
  }

  toggle(e) {
    if (this.props.disabled || !this._isMounted) {
      return e && e.preventDefault();
    }

    return this.props.toggle(e);
  }

  render() {
    if (this.props.isOpen) {
      this.updateTarget();
    }

    const target = this.currentTargetElement || this._targets[0];

    if (!target) {
      return null;
    }

    const {
      className,
      cssModule,
      innerClassName,
      isOpen,
      hideArrow,
      boundariesElement,
      placement,
      placementPrefix,
      arrowClassName,
      popperClassName,
      container,
      modifiers,
      strategy,
      offset,
      fade,
      flip,
      children
    } = this.props;
    const attributes = omit(this.props, Object.keys(propTypes$E));
    const popperClasses = mapToCssModules(popperClassName, cssModule);
    const classes = mapToCssModules(innerClassName, cssModule);
    return /*#__PURE__*/React__default.createElement(PopperContent$1, {
      className: className,
      target: target,
      isOpen: isOpen,
      hideArrow: hideArrow,
      boundariesElement: boundariesElement,
      placement: placement,
      placementPrefix: placementPrefix,
      arrowClassName: arrowClassName,
      popperClassName: popperClasses,
      container: container,
      modifiers: modifiers,
      strategy: strategy,
      offset: offset,
      cssModule: cssModule,
      fade: fade,
      flip: flip
    }, ({
      update
    }) => /*#__PURE__*/React__default.createElement("div", _extends({}, attributes, {
      ref: this.getRef,
      className: classes,
      role: "tooltip",
      onMouseOver: this.onMouseOverTooltipContent,
      onMouseLeave: this.onMouseLeaveTooltipContent,
      onKeyDown: this.onEscKeyDown
    }), typeof children === 'function' ? children({
      update
    }) : children));
  }

}

TooltipPopoverWrapper.propTypes = propTypes$E;
TooltipPopoverWrapper.defaultProps = defaultProps$E;
var TooltipPopoverWrapper$1 = TooltipPopoverWrapper;

const defaultProps$D = {
  placement: 'right',
  placementPrefix: 'bs-popover',
  trigger: 'click',
  offset: [0, 8]
};

function Popover(props) {
  const popperClasses = classnames('popover', 'show', props.popperClassName);
  const classes = classnames('popover-inner', props.innerClassName);
  return /*#__PURE__*/React__default.createElement(TooltipPopoverWrapper$1, _extends({}, props, {
    arrowClassName: "popover-arrow",
    popperClassName: popperClasses,
    innerClassName: classes
  }));
}

Popover.propTypes = propTypes$E;
Popover.defaultProps = defaultProps$D;

const omitKeys$4 = ['defaultOpen'];
class UncontrolledPopover extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.defaultOpen || false
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  }

  render() {
    return /*#__PURE__*/React__default.createElement(Popover, _extends({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, omit(this.props, omitKeys$4)));
  }

}
UncontrolledPopover.propTypes = _objectSpread2({
  defaultOpen: PropTypes.bool
}, Popover.propTypes);
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  /** Enable animation to bar */
  animated: PropTypes.bool,
  bar: PropTypes.bool,
  barAriaLabelledBy: PropTypes.string,
  barAriaValueText: PropTypes.string,
  barClassName: PropTypes.string,
  barStyle: PropTypes.object,
  children: PropTypes.node,

  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Add custom color to the placeholder */
  color: PropTypes.string,

  /** Maximum value of progress */
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Minimum value of progress, defaults to zero */
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  multi: PropTypes.bool,

  /** Add stripes to progress bar */
  striped: PropTypes.bool,
  style: PropTypes.object,

  /** Set a custom element for this component */
  tag: tagPropType,

  /** Current value of progress */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
});

const propTypes$A = {
  children: PropTypes.node.isRequired,
  node: PropTypes.any
};

class Portal extends React__default.Component {
  componentWillUnmount() {
    if (this.defaultNode) {
      document.body.removeChild(this.defaultNode);
    }

    this.defaultNode = null;
  }

  render() {
    if (!canUseDOM) {
      return null;
    }

    if (!this.props.node && !this.defaultNode) {
      this.defaultNode = document.createElement('div');
      document.body.appendChild(this.defaultNode);
    }

    return ReactDOM__default.createPortal(this.props.children, this.props.node || this.defaultNode);
  }

}

Portal.propTypes = propTypes$A;
var Portal$1 = Portal;

function noop$1() {}

const FadePropTypes$1 = PropTypes.shape(Fade.propTypes);
const propTypes$z = {
  /** */
  autoFocus: PropTypes.bool,

  /** Add backdrop to modal */
  backdrop: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['static'])]),

  /** add custom classname to backdrop */
  backdropClassName: PropTypes.string,
  backdropTransition: FadePropTypes$1,

  /** Vertically center the modal */
  centered: PropTypes.bool,

  /** Add children for the modal to wrap */
  children: PropTypes.node,

  /** Add custom className for modal content */
  contentClassName: PropTypes.string,
  className: PropTypes.string,
  container: targetPropType,
  cssModule: PropTypes.object,
  external: PropTypes.node,

  /** Enable/Disable animation */
  fade: PropTypes.bool,

  /** Make the modal fullscreen */
  fullscreen: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['sm', 'md', 'lg', 'xl'])]),
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),

  /** The status of the modal, either open or close */
  isOpen: PropTypes.bool,

  /** Allow modal to be closed with escape key. */
  keyboard: PropTypes.bool,

  /** Identifies the element (or elements) that labels the current element. */
  labelledBy: PropTypes.string,
  modalClassName: PropTypes.string,
  modalTransition: FadePropTypes$1,

  /** Function to be triggered on close */
  onClosed: PropTypes.func,

  /** Function to be triggered on enter */
  onEnter: PropTypes.func,

  /** Function to be triggered on exit */
  onExit: PropTypes.func,

  /** Function to be triggered on open */
  onOpened: PropTypes.func,

  /** Returns focus to the element that triggered opening of the modal */
  returnFocusAfterClose: PropTypes.bool,

  /** Accessibility role */
  role: PropTypes.string,

  /** Make the modal scrollable */
  scrollable: PropTypes.bool,

  /** Two optional sizes `lg` and `sm` */
  size: PropTypes.string,

  /** Function to toggle modal visibility */
  toggle: PropTypes.func,
  trapFocus: PropTypes.bool,

  /** Unmounts the modal when modal is closed */
  unmountOnClose: PropTypes.bool,
  wrapClassName: PropTypes.string,
  zIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
const propsToOmit$1 = Object.keys(propTypes$z);
const defaultProps$z = {
  isOpen: false,
  autoFocus: true,
  centered: false,
  scrollable: false,
  role: 'dialog',
  backdrop: true,
  keyboard: true,
  zIndex: 1050,
  fade: true,
  onOpened: noop$1,
  onClosed: noop$1,
  modalTransition: {
    timeout: TransitionTimeouts.Modal
  },
  backdropTransition: {
    mountOnEnter: true,
    timeout: TransitionTimeouts.Fade // uses standard fade transition

  },
  unmountOnClose: true,
  returnFocusAfterClose: true,
  container: 'body',
  trapFocus: false
};

class Modal extends React__default.Component {
  constructor(props) {
    super(props);
    this._element = null;
    this._originalBodyPadding = null;
    this._originalBodyOverflow = null;
    this.getFocusableChildren = this.getFocusableChildren.bind(this);
    this.handleBackdropClick = this.handleBackdropClick.bind(this);
    this.handleBackdropMouseDown = this.handleBackdropMouseDown.bind(this);
    this.handleEscape = this.handleEscape.bind(this);
    this.handleStaticBackdropAnimation = this.handleStaticBackdropAnimation.bind(this);
    this.handleTab = this.handleTab.bind(this);
    this.onOpened = this.onOpened.bind(this);
    this.onClosed = this.onClosed.bind(this);
    this.manageFocusAfterClose = this.manageFocusAfterClose.bind(this);
    this.clearBackdropAnimationTimeout = this.clearBackdropAnimationTimeout.bind(this);
    this.trapFocus = this.trapFocus.bind(this);
    this.state = {
      isOpen: false,
      showStaticBackdropAnimation: false
    };
  }

  componentDidMount() {
    const {
      isOpen,
      autoFocus,
      onEnter
    } = this.props;

    if (isOpen) {
      this.init();
      this.setState({
        isOpen: true
      });

      if (autoFocus) {
        this.setFocus();
      }
    }

    if (onEnter) {
      onEnter();
    } // traps focus inside the Modal, even if the browser address bar is focused


    document.addEventListener('focus', this.trapFocus, true);
    this._isMounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.init();
      this.setState({
        isOpen: true
      }); // let render() renders Modal Dialog first

      return;
    } // now Modal Dialog is rendered and we can refer this._element and this._dialog


    if (this.props.autoFocus && this.state.isOpen && !prevState.isOpen) {
      this.setFocus();
    }

    if (this._element && prevProps.zIndex !== this.props.zIndex) {
      this._element.style.zIndex = this.props.zIndex;
    }
  }

  componentWillUnmount() {
    this.clearBackdropAnimationTimeout();

    if (this.props.onExit) {
      this.props.onExit();
    }

    if (this._element) {
      this.destroy();

      if (this.props.isOpen || this.state.isOpen) {
        this.close();
      }
    }

    document.removeEventListener('focus', this.trapFocus, true);
    this._isMounted = false;
  } // not mouseUp because scrollbar fires it, shouldn't close when user scrolls


  handleBackdropClick(e) {
    if (e.target === this._mouseDownElement) {
      e.stopPropagation();
      const backdrop = this._dialog ? this._dialog.parentNode : null;

      if (backdrop && e.target === backdrop && this.props.backdrop === 'static') {
        this.handleStaticBackdropAnimation();
      }

      if (!this.props.isOpen || this.props.backdrop !== true) return;

      if (backdrop && e.target === backdrop && this.props.toggle) {
        this.props.toggle(e);
      }
    }
  }

  handleTab(e) {
    if (e.which !== 9) return;
    if (this.modalIndex < Modal.openCount - 1) return; // last opened modal

    const focusableChildren = this.getFocusableChildren();
    const totalFocusable = focusableChildren.length;
    if (totalFocusable === 0) return;
    const currentFocus = this.getFocusedChild();
    let focusedIndex = 0;

    for (let i = 0; i < totalFocusable; i += 1) {
      if (focusableChildren[i] === currentFocus) {
        focusedIndex = i;
        break;
      }
    }

    if (e.shiftKey && focusedIndex === 0) {
      e.preventDefault();
      focusableChildren[totalFocusable - 1].focus();
    } else if (!e.shiftKey && focusedIndex === totalFocusable - 1) {
      e.preventDefault();
      focusableChildren[0].focus();
    }
  }

  handleBackdropMouseDown(e) {
    this._mouseDownElement = e.target;
  }

  handleEscape(e) {
    if (this.props.isOpen && e.keyCode === keyCodes.esc && this.props.toggle) {
      if (this.props.keyboard) {
        e.preventDefault();
        e.stopPropagation();
        this.props.toggle(e);
      } else if (this.props.backdrop === 'static') {
        e.preventDefault();
        e.stopPropagation();
        this.handleStaticBackdropAnimation();
      }
    }
  }

  handleStaticBackdropAnimation() {
    this.clearBackdropAnimationTimeout();
    this.setState({
      showStaticBackdropAnimation: true
    });
    this._backdropAnimationTimeout = setTimeout(() => {
      this.setState({
        showStaticBackdropAnimation: false
      });
    }, 100);
  }

  onOpened(node, isAppearing) {
    this.props.onOpened();
    (this.props.modalTransition.onEntered || noop$1)(node, isAppearing);
  }

  onClosed(node) {
    const {
      unmountOnClose
    } = this.props; // so all methods get called before it is unmounted

    this.props.onClosed();
    (this.props.modalTransition.onExited || noop$1)(node);

    if (unmountOnClose) {
      this.destroy();
    }

    this.close();

    if (this._isMounted) {
      this.setState({
        isOpen: false
      });
    }
  }

  setFocus() {
    if (this._dialog && this._dialog.parentNode && typeof this._dialog.parentNode.focus === 'function') {
      this._dialog.parentNode.focus();
    }
  }

  getFocusableChildren() {
    return this._element.querySelectorAll(focusableElements.join(', '));
  }

  getFocusedChild() {
    let currentFocus;
    const focusableChildren = this.getFocusableChildren();

    try {
      currentFocus = document.activeElement;
    } catch (err) {
      currentFocus = focusableChildren[0];
    }

    return currentFocus;
  }

  trapFocus(ev) {
    if (!this.props.trapFocus) {
      return;
    }

    if (!this._element) {
      // element is not attached
      return;
    }

    if (this._dialog && this._dialog.parentNode === ev.target) {
      // initial focus when the Modal is opened
      return;
    }

    if (this.modalIndex < Modal.openCount - 1) {
      // last opened modal
      return;
    }

    const children = this.getFocusableChildren();

    for (let i = 0; i < children.length; i += 1) {
      // focus is already inside the Modal
      if (children[i] === ev.target) return;
    }

    if (children.length > 0) {
      // otherwise focus the first focusable element in the Modal
      ev.preventDefault();
      ev.stopPropagation();
      children[0].focus();
    }
  }

  init() {
    try {
      this._triggeringElement = document.activeElement;
    } catch (err) {
      this._triggeringElement = null;
    }

    if (!this._element) {
      this._element = document.createElement('div');

      this._element.setAttribute('tabindex', '-1');

      this._element.style.position = 'relative';
      this._element.style.zIndex = this.props.zIndex;
      this._mountContainer = getTarget(this.props.container);

      this._mountContainer.appendChild(this._element);
    }

    this._originalBodyPadding = getOriginalBodyPadding();
    this._originalBodyOverflow = window.getComputedStyle(document.body).overflow;
    conditionallyUpdateScrollbar();

    if (Modal.openCount === 0) {
      document.body.className = classnames(document.body.className, mapToCssModules('modal-open', this.props.cssModule));
      document.body.style.overflow = 'hidden';
    }

    this.modalIndex = Modal.openCount;
    Modal.openCount += 1;
  }

  destroy() {
    if (this._element) {
      this._mountContainer.removeChild(this._element);

      this._element = null;
    }

    this.manageFocusAfterClose();
  }

  manageFocusAfterClose() {
    if (this._triggeringElement) {
      const {
        returnFocusAfterClose
      } = this.props;
      if (this._triggeringElement.focus && returnFocusAfterClose) this._triggeringElement.focus();
      this._triggeringElement = null;
    }
  }

  close() {
    if (Modal.openCount <= 1) {
      const modalOpenClassName = mapToCssModules('modal-open', this.props.cssModule); // Use regex to prevent matching `modal-open` as part of a different class, e.g. `my-modal-opened`

      const modalOpenClassNameRegex = new RegExp(`(^| )${modalOpenClassName}( |$)`);
      document.body.className = document.body.className.replace(modalOpenClassNameRegex, ' ').trim();
      document.body.style.overflow = this._originalBodyOverflow;
    }

    this.manageFocusAfterClose();
    Modal.openCount = Math.max(0, Modal.openCount - 1);
    setScrollbarWidth(this._originalBodyPadding);
  }

  clearBackdropAnimationTimeout() {
    if (this._backdropAnimationTimeout) {
      clearTimeout(this._backdropAnimationTimeout);
      this._backdropAnimationTimeout = undefined;
    }
  }

  renderModalDialog() {
    const attributes = omit(this.props, propsToOmit$1);
    const dialogBaseClass = 'modal-dialog';
    return /*#__PURE__*/React__default.createElement("div", _extends({}, attributes, {
      className: mapToCssModules(classnames(dialogBaseClass, this.props.className, {
        [`modal-${this.props.size}`]: this.props.size,
        [`${dialogBaseClass}-centered`]: this.props.centered,
        [`${dialogBaseClass}-scrollable`]: this.props.scrollable,
        'modal-fullscreen': this.props.fullscreen === true,
        [`modal-fullscreen-${this.props.fullscreen}-down`]: typeof this.props.fullscreen === 'string'
      }), this.props.cssModule),
      role: "document",
      ref: c => {
        this._dialog = c;
      }
    }), /*#__PURE__*/React__default.createElement("div", {
      className: mapToCssModules(classnames('modal-content', this.props.contentClassName), this.props.cssModule)
    }, this.props.children));
  }

  render() {
    const {
      unmountOnClose
    } = this.props;

    if (!!this._element && (this.state.isOpen || !unmountOnClose)) {
      const isModalHidden = !!this._element && !this.state.isOpen && !unmountOnClose;
      this._element.style.display = isModalHidden ? 'none' : 'block';
      const {
        wrapClassName,
        modalClassName,
        backdropClassName,
        cssModule,
        isOpen,
        backdrop,
        role,
        labelledBy,
        external,
        innerRef
      } = this.props;
      const modalAttributes = {
        onClick: this.handleBackdropClick,
        onMouseDown: this.handleBackdropMouseDown,
        onKeyUp: this.handleEscape,
        onKeyDown: this.handleTab,
        style: {
          display: 'block'
        },
        'aria-labelledby': labelledBy,
        role,
        tabIndex: '-1'
      };
      const hasTransition = this.props.fade;

      const modalTransition = _objectSpread2(_objectSpread2(_objectSpread2({}, Fade.defaultProps), this.props.modalTransition), {}, {
        baseClass: hasTransition ? this.props.modalTransition.baseClass : '',
        timeout: hasTransition ? this.props.modalTransition.timeout : 0
      });

      const backdropTransition = _objectSpread2(_objectSpread2(_objectSpread2({}, Fade.defaultProps), this.props.backdropTransition), {}, {
        baseClass: hasTransition ? this.props.backdropTransition.baseClass : '',
        timeout: hasTransition ? this.props.backdropTransition.timeout : 0
      });

      const Backdrop = backdrop && (hasTransition ? /*#__PURE__*/React__default.createElement(Fade, _extends({}, backdropTransition, {
        in: isOpen && !!backdrop,
        cssModule: cssModule,
        className: mapToCssModules(classnames('modal-backdrop', backdropClassName), cssModule)
      })) : /*#__PURE__*/React__default.createElement("div", {
        className: mapToCssModules(classnames('modal-backdrop', 'show', backdropClassName), cssModule)
      }));
      return /*#__PURE__*/React__default.createElement(Portal$1, {
        node: this._element
      }, /*#__PURE__*/React__default.createElement("div", {
        className: mapToCssModules(wrapClassName)
      }, /*#__PURE__*/React__default.createElement(Fade, _extends({}, modalAttributes, modalTransition, {
        in: isOpen,
        onEntered: this.onOpened,
        onExited: this.onClosed,
        cssModule: cssModule,
        className: mapToCssModules(classnames('modal', modalClassName, this.state.showStaticBackdropAnimation && 'modal-static'), cssModule),
        innerRef: innerRef
      }), external, this.renderModalDialog()), Backdrop));
    }

    return null;
  }

}

Modal.propTypes = propTypes$z;
Modal.defaultProps = defaultProps$z;
Modal.openCount = 0;
var Modal$1 = Modal;
({
  children: PropTypes.node,

  /** Add custom class */
  className: PropTypes.string,

  /** Custom close button */
  close: PropTypes.object,
  closeAriaLabel: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Set a custom element for this component */
  tag: tagPropType,

  /** Function to be triggered when close button is clicked */
  toggle: PropTypes.func,
  wrapTag: tagPropType
});

const _excluded$u = ["className", "cssModule", "tag"];
const propTypes$x = {
  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Set a custom element for this component */
  tag: tagPropType
};
const defaultProps$x = {
  tag: 'div'
};

function ModalBody(props) {
  const {
    className,
    cssModule,
    tag: Tag
  } = props,
        attributes = _objectWithoutProperties(props, _excluded$u);

  const classes = mapToCssModules(classnames(className, 'modal-body'), cssModule);
  return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}

ModalBody.propTypes = propTypes$x;
ModalBody.defaultProps = defaultProps$x;
({
  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Set a custom element for this component */
  tag: tagPropType
});

const defaultProps$v = {
  placement: 'top',
  autohide: true,
  placementPrefix: 'bs-tooltip',
  trigger: 'hover focus'
};

function Tooltip(props) {
  const popperClasses = classnames('tooltip', 'show', props.popperClassName);
  const classes = classnames('tooltip-inner', props.innerClassName);
  return /*#__PURE__*/React__default.createElement(TooltipPopoverWrapper$1, _extends({}, props, {
    arrowClassName: "tooltip-arrow",
    popperClassName: popperClasses,
    innerClassName: classes
  }));
}

Tooltip.propTypes = propTypes$E;
Tooltip.defaultProps = defaultProps$v;
({
  /** Adds border to all sides of table */
  bordered: PropTypes.bool,

  /** Removes all borders */
  borderless: PropTypes.bool,

  /** Adds custom class name to component */
  className: PropTypes.string,

  /**  */
  cssModule: PropTypes.object,

  /** Makes the table dark */
  dark: PropTypes.bool,

  /** Enables a hover state on the rows within `<tbody>` */
  hover: PropTypes.bool,
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.object]),

  /** Responsive tables allow tables to be scrolled horizontally with ease */
  responsive: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  responsiveTag: tagPropType,

  /** Make tables more compact by cutting cell padding in half when setting size as sm. */
  size: PropTypes.string,

  /** Adds zebra-striping to any table row within the `<tbody>` */
  striped: PropTypes.bool,

  /** Add custom tag to the component */
  tag: tagPropType
});
({
  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Remove borders to make the list appear flush */
  flush: PropTypes.bool,

  /** Make the list horizontal instead of vertical */
  horizontal: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),

  /** Add number to the ListItems */
  numbered: PropTypes.bool,

  /** Set a custom element for this component */
  tag: tagPropType
});

const _excluded$q = ["className", "cssModule", "tag", "innerRef"];
const propTypes$t = {
  children: PropTypes.node,
  tag: tagPropType,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  cssModule: PropTypes.object
};
const defaultProps$s = {
  tag: 'form'
};

class Form extends Component {
  constructor(props) {
    super(props);
    this.getRef = this.getRef.bind(this);
    this.submit = this.submit.bind(this);
  }

  getRef(ref) {
    if (this.props.innerRef) {
      this.props.innerRef(ref);
    }

    this.ref = ref;
  }

  submit() {
    if (this.ref) {
      this.ref.submit();
    }
  }

  render() {
    const _this$props = this.props,
          {
      className,
      cssModule,
      tag: Tag,
      innerRef
    } = _this$props,
          attributes = _objectWithoutProperties(_this$props, _excluded$q);

    const classes = mapToCssModules(className, cssModule);
    return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
      ref: innerRef,
      className: classes
    }));
  }

}

Form.propTypes = propTypes$t;
Form.defaultProps = defaultProps$s;
({
  children: PropTypes.node,
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  valid: PropTypes.bool,
  tooltip: PropTypes.bool
});
({
  children: PropTypes.node,
  row: PropTypes.bool,
  check: PropTypes.bool,
  switch: PropTypes.bool,
  inline: PropTypes.bool,
  floating: PropTypes.bool,
  disabled: PropTypes.bool,
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  children: PropTypes.node,
  inline: PropTypes.bool,
  tag: tagPropType,
  color: PropTypes.string,
  className: PropTypes.string,
  cssModule: PropTypes.object
});

const _excluded$m = ["className", "cssModule", "type", "bsSize", "valid", "invalid", "tag", "addon", "plaintext", "innerRef"];
const propTypes$p = {
  children: PropTypes.node,
  type: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  bsSize: PropTypes.string,
  valid: PropTypes.bool,
  invalid: PropTypes.bool,
  tag: tagPropType,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
  plaintext: PropTypes.bool,
  addon: PropTypes.bool,
  className: PropTypes.string,
  cssModule: PropTypes.object
};
const defaultProps$o = {
  type: 'text'
};

class Input extends React__default.Component {
  constructor(props) {
    super(props);
    this.getRef = this.getRef.bind(this);
    this.focus = this.focus.bind(this);
  }

  getRef(ref) {
    if (this.props.innerRef) {
      this.props.innerRef(ref);
    }

    this.ref = ref;
  }

  focus() {
    if (this.ref) {
      this.ref.focus();
    }
  }

  render() {
    let _this$props = this.props,
        {
      className,
      cssModule,
      type,
      bsSize,
      valid,
      invalid,
      tag,
      addon,
      plaintext,
      innerRef
    } = _this$props,
        attributes = _objectWithoutProperties(_this$props, _excluded$m);

    const checkInput = ['switch', 'radio', 'checkbox'].indexOf(type) > -1;
    const isNotaNumber = /\D/g;
    const textareaInput = type === 'textarea';
    const selectInput = type === 'select';
    const rangeInput = type === 'range';
    let Tag = tag || (selectInput || textareaInput ? type : 'input');
    let formControlClass = 'form-control';

    if (plaintext) {
      formControlClass = `${formControlClass}-plaintext`;
      Tag = tag || 'input';
    } else if (rangeInput) {
      formControlClass = 'form-range';
    } else if (selectInput) {
      formControlClass = 'form-select';
    } else if (checkInput) {
      if (addon) {
        formControlClass = null;
      } else {
        formControlClass = 'form-check-input';
      }
    }

    if (attributes.size && isNotaNumber.test(attributes.size)) {
      warnOnce('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
      bsSize = attributes.size;
      delete attributes.size;
    }

    const classes = mapToCssModules(classnames(className, invalid && 'is-invalid', valid && 'is-valid', bsSize ? selectInput ? `form-select-${bsSize}` : `form-control-${bsSize}` : false, formControlClass), cssModule);

    if (Tag === 'input' || tag && typeof tag === 'function') {
      attributes.type = type === 'switch' ? 'checkbox' : type;
    }

    if (attributes.children && !(plaintext || type === 'select' || typeof Tag !== 'string' || Tag === 'select')) {
      warnOnce(`Input with a type of "${type}" cannot have children. Please use "value"/"defaultValue" instead.`);
      delete attributes.children;
    }

    return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
      ref: innerRef,
      className: classes,
      "aria-invalid": invalid
    }));
  }

}

Input.propTypes = propTypes$p;
Input.defaultProps = defaultProps$o;
var Input$1 = Input;
({
  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Sets size of InputGroup */
  size: PropTypes.string,

  /** Set a custom element for this component */
  tag: tagPropType,
  type: PropTypes.string
});
({
  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Set a custom element for this component */
  tag: tagPropType
});
const stringOrNumberProp = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
const columnProps = PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number, PropTypes.shape({
  size: stringOrNumberProp,
  order: stringOrNumberProp,
  offset: stringOrNumberProp
})]);
({
  children: PropTypes.node,
  hidden: PropTypes.bool,
  check: PropTypes.bool,
  size: PropTypes.string,
  for: PropTypes.string,
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  xs: columnProps,
  sm: columnProps,
  md: columnProps,
  lg: columnProps,
  xl: columnProps,
  xxl: columnProps,
  widths: PropTypes.array
});
({
  body: PropTypes.bool,
  bottom: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  heading: PropTypes.bool,
  left: PropTypes.bool,
  list: PropTypes.bool,
  middle: PropTypes.bool,
  object: PropTypes.bool,
  right: PropTypes.bool,
  tag: tagPropType,
  top: PropTypes.bool
});

function noop() {}

const FadePropTypes = PropTypes.shape(Fade.propTypes);
const propTypes$k = {
  autoFocus: PropTypes.bool,
  backdrop: PropTypes.bool,
  backdropClassName: PropTypes.string,
  backdropTransition: FadePropTypes,
  children: PropTypes.node,
  className: PropTypes.string,
  container: targetPropType,
  cssModule: PropTypes.object,
  direction: PropTypes.oneOf(['start', 'end', 'bottom', 'top']),
  fade: PropTypes.bool,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),
  isOpen: PropTypes.bool,
  keyboard: PropTypes.bool,
  labelledBy: PropTypes.string,
  offcanvasTransition: FadePropTypes,
  onClosed: PropTypes.func,
  onEnter: PropTypes.func,
  onExit: PropTypes.func,
  style: PropTypes.object,
  onOpened: PropTypes.func,
  returnFocusAfterClose: PropTypes.bool,
  role: PropTypes.string,
  scrollable: PropTypes.bool,
  toggle: PropTypes.func,
  trapFocus: PropTypes.bool,
  unmountOnClose: PropTypes.bool,
  zIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
const propsToOmit = Object.keys(propTypes$k);
const defaultProps$k = {
  isOpen: false,
  autoFocus: true,
  direction: 'start',
  scrollable: false,
  role: 'dialog',
  backdrop: true,
  keyboard: true,
  zIndex: 1050,
  fade: true,
  onOpened: noop,
  onClosed: noop,
  offcanvasTransition: {
    timeout: TransitionTimeouts.Offcanvas
  },
  backdropTransition: {
    mountOnEnter: true,
    timeout: TransitionTimeouts.Fade // uses standard fade transition

  },
  unmountOnClose: true,
  returnFocusAfterClose: true,
  container: 'body',
  trapFocus: false
};

class Offcanvas extends React__default.Component {
  constructor(props) {
    super(props);
    this._element = null;
    this._originalBodyPadding = null;
    this.getFocusableChildren = this.getFocusableChildren.bind(this);
    this.handleBackdropClick = this.handleBackdropClick.bind(this);
    this.handleBackdropMouseDown = this.handleBackdropMouseDown.bind(this);
    this.handleEscape = this.handleEscape.bind(this);
    this.handleTab = this.handleTab.bind(this);
    this.onOpened = this.onOpened.bind(this);
    this.onClosed = this.onClosed.bind(this);
    this.manageFocusAfterClose = this.manageFocusAfterClose.bind(this);
    this.clearBackdropAnimationTimeout = this.clearBackdropAnimationTimeout.bind(this);
    this.trapFocus = this.trapFocus.bind(this);
    this.state = {
      isOpen: false
    };
  }

  componentDidMount() {
    const {
      isOpen,
      autoFocus,
      onEnter
    } = this.props;

    if (isOpen) {
      this.init();
      this.setState({
        isOpen: true
      });

      if (autoFocus) {
        this.setFocus();
      }
    }

    if (onEnter) {
      onEnter();
    } // traps focus inside the Offcanvas, even if the browser address bar is focused


    document.addEventListener('focus', this.trapFocus, true);
    this._isMounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.init();
      this.setState({
        isOpen: true
      });
      return;
    } // now Offcanvas Dialog is rendered and we can refer this._element and this._dialog


    if (this.props.autoFocus && this.state.isOpen && !prevState.isOpen) {
      this.setFocus();
    }

    if (this._element && prevProps.zIndex !== this.props.zIndex) {
      this._element.style.zIndex = this.props.zIndex;
    }
  }

  componentWillUnmount() {
    this.clearBackdropAnimationTimeout();

    if (this.props.onExit) {
      this.props.onExit();
    }

    if (this._element) {
      this.destroy();

      if (this.props.isOpen || this.state.isOpen) {
        this.close();
      }
    }

    document.removeEventListener('focus', this.trapFocus, true);
    this._isMounted = false;
  } // not mouseUp because scrollbar fires it, shouldn't close when user scrolls


  handleBackdropClick(e) {
    if (e.target === this._mouseDownElement) {
      e.stopPropagation();
      const backdrop = this._backdrop;
      if (!this.props.isOpen || this.props.backdrop !== true) return;

      if (backdrop && e.target === backdrop && this.props.toggle) {
        this.props.toggle(e);
      }
    }
  }

  handleTab(e) {
    if (e.which !== 9) return;
    if (this.offcanvasIndex < Offcanvas.openCount - 1) return; // last opened offcanvas

    const focusableChildren = this.getFocusableChildren();
    const totalFocusable = focusableChildren.length;
    if (totalFocusable === 0) return;
    const currentFocus = this.getFocusedChild();
    let focusedIndex = 0;

    for (let i = 0; i < totalFocusable; i += 1) {
      if (focusableChildren[i] === currentFocus) {
        focusedIndex = i;
        break;
      }
    }

    if (e.shiftKey && focusedIndex === 0) {
      e.preventDefault();
      focusableChildren[totalFocusable - 1].focus();
    } else if (!e.shiftKey && focusedIndex === totalFocusable - 1) {
      e.preventDefault();
      focusableChildren[0].focus();
    }
  }

  handleBackdropMouseDown(e) {
    this._mouseDownElement = e.target;
  }

  handleEscape(e) {
    if (this.props.isOpen && e.keyCode === keyCodes.esc && this.props.toggle) {
      if (this.props.keyboard) {
        e.preventDefault();
        e.stopPropagation();
        this.props.toggle(e);
      }
    }
  }

  onOpened(node, isAppearing) {
    this.props.onOpened();
    (this.props.offcanvasTransition.onEntered || noop)(node, isAppearing);
  }

  onClosed(node) {
    const {
      unmountOnClose
    } = this.props; // so all methods get called before it is unmounted

    this.props.onClosed();
    (this.props.offcanvasTransition.onExited || noop)(node);

    if (unmountOnClose) {
      this.destroy();
    }

    this.close();

    if (this._isMounted) {
      this.setState({
        isOpen: false
      });
    }
  }

  setFocus() {
    if (this._dialog && typeof this._dialog.focus === 'function') {
      this._dialog.focus();
    }
  }

  getFocusableChildren() {
    return this._element.querySelectorAll(focusableElements.join(', '));
  }

  getFocusedChild() {
    let currentFocus;
    const focusableChildren = this.getFocusableChildren();

    try {
      currentFocus = document.activeElement;
    } catch (err) {
      currentFocus = focusableChildren[0];
    }

    return currentFocus;
  }

  trapFocus(ev) {
    if (!this.props.trapFocus) {
      return;
    }

    if (!this._element) {
      // element is not attached
      return;
    }

    if (this._dialog === ev.target) {
      // initial focus when the Offcanvas is opened
      return;
    }

    if (this.offcanvasIndex < Offcanvas.openCount - 1) {
      // last opened offcanvas
      return;
    }

    const children = this.getFocusableChildren();

    for (let i = 0; i < children.length; i += 1) {
      // focus is already inside the Offcanvas
      if (children[i] === ev.target) return;
    }

    if (children.length > 0) {
      // otherwise focus the first focusable element in the Offcanvas
      ev.preventDefault();
      ev.stopPropagation();
      children[0].focus();
    }
  }

  init() {
    try {
      this._triggeringElement = document.activeElement;
    } catch (err) {
      this._triggeringElement = null;
    }

    if (!this._element) {
      this._element = document.createElement('div');

      this._element.setAttribute('tabindex', '-1');

      this._element.style.position = 'relative';
      this._element.style.zIndex = this.props.zIndex;
      this._mountContainer = getTarget(this.props.container);

      this._mountContainer.appendChild(this._element);
    }

    this._originalBodyPadding = getOriginalBodyPadding();
    conditionallyUpdateScrollbar();

    if (Offcanvas.openCount === 0 && this.props.backdrop && !this.props.scrollable) {
      document.body.style.overflow = 'hidden';
    }

    this.offcanvasIndex = Offcanvas.openCount;
    Offcanvas.openCount += 1;
  }

  destroy() {
    if (this._element) {
      this._mountContainer.removeChild(this._element);

      this._element = null;
    }

    this.manageFocusAfterClose();
  }

  manageFocusAfterClose() {
    if (this._triggeringElement) {
      const {
        returnFocusAfterClose
      } = this.props;
      if (this._triggeringElement.focus && returnFocusAfterClose) this._triggeringElement.focus();
      this._triggeringElement = null;
    }
  }

  close() {
    this.manageFocusAfterClose();
    Offcanvas.openCount = Math.max(0, Offcanvas.openCount - 1);
    document.body.style.overflow = null;
    setScrollbarWidth(this._originalBodyPadding);
  }

  clearBackdropAnimationTimeout() {
    if (this._backdropAnimationTimeout) {
      clearTimeout(this._backdropAnimationTimeout);
      this._backdropAnimationTimeout = undefined;
    }
  }

  render() {
    const {
      direction,
      unmountOnClose
    } = this.props;

    if (!!this._element && (this.state.isOpen || !unmountOnClose)) {
      const isOffcanvasHidden = !!this._element && !this.state.isOpen && !unmountOnClose;
      this._element.style.display = isOffcanvasHidden ? 'none' : 'block';
      const {
        className,
        backdropClassName,
        cssModule,
        isOpen,
        backdrop,
        role,
        labelledBy,
        style
      } = this.props;
      const offcanvasAttributes = {
        onKeyUp: this.handleEscape,
        onKeyDown: this.handleTab,
        'aria-labelledby': labelledBy,
        role,
        tabIndex: '-1'
      };
      const hasTransition = this.props.fade;

      const offcanvasTransition = _objectSpread2(_objectSpread2(_objectSpread2({}, Fade.defaultProps), this.props.offcanvasTransition), {}, {
        baseClass: hasTransition ? this.props.offcanvasTransition.baseClass : '',
        timeout: hasTransition ? this.props.offcanvasTransition.timeout : 0
      });

      const backdropTransition = _objectSpread2(_objectSpread2(_objectSpread2({}, Fade.defaultProps), this.props.backdropTransition), {}, {
        baseClass: hasTransition ? this.props.backdropTransition.baseClass : '',
        timeout: hasTransition ? this.props.backdropTransition.timeout : 0
      });

      const Backdrop = backdrop && (hasTransition ? /*#__PURE__*/React__default.createElement(Fade, _extends({}, backdropTransition, {
        in: isOpen && !!backdrop,
        innerRef: c => {
          this._backdrop = c;
        },
        cssModule: cssModule,
        className: mapToCssModules(classnames('offcanvas-backdrop', backdropClassName), cssModule),
        onClick: this.handleBackdropClick,
        onMouseDown: this.handleBackdropMouseDown
      })) : /*#__PURE__*/React__default.createElement("div", {
        className: mapToCssModules(classnames('offcanvas-backdrop', 'show', backdropClassName), cssModule),
        onClick: this.handleBackdropClick,
        onMouseDown: this.handleBackdropMouseDown
      }));
      const attributes = omit(this.props, propsToOmit);
      return /*#__PURE__*/React__default.createElement(Portal$1, {
        node: this._element
      }, /*#__PURE__*/React__default.createElement(Fade, _extends({}, attributes, offcanvasAttributes, offcanvasTransition, {
        in: isOpen,
        onEntered: this.onOpened,
        onExited: this.onClosed,
        cssModule: cssModule,
        className: mapToCssModules(classnames('offcanvas', className, `offcanvas-${direction}`), cssModule),
        innerRef: c => {
          this._dialog = c;
        },
        style: _objectSpread2(_objectSpread2({}, style), {}, {
          visibility: isOpen ? 'visible' : 'hidden'
        })
      }), this.props.children), Backdrop);
    }

    return null;
  }

}

Offcanvas.propTypes = propTypes$k;
Offcanvas.defaultProps = defaultProps$k;
Offcanvas.openCount = 0;
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  children: PropTypes.node,
  className: PropTypes.string,
  close: PropTypes.object,
  closeAriaLabel: PropTypes.string,
  cssModule: PropTypes.object,
  tag: tagPropType,
  toggle: PropTypes.func,
  wrapTag: tagPropType
});
({
  children: PropTypes.node,

  /** Add custom class */
  className: PropTypes.string,

  /** Add custom class for list */
  listClassName: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Make the Pagination bigger or smaller  */
  size: PropTypes.string,

  /** Set a custom element for this component */
  tag: tagPropType,

  /** Set a custom element for list component */
  listTag: tagPropType,
  'aria-label': PropTypes.string
});
({
  /** Set item as active */
  active: PropTypes.bool,
  children: PropTypes.node,

  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Set item as disabled */
  disabled: PropTypes.bool,

  /** Set a custom element for this component */
  tag: tagPropType
});
({
  'aria-label': PropTypes.string,
  children: PropTypes.node,

  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Add to next button to add default aria label and icon */
  next: PropTypes.bool,

  /** Add to previous button to add default aria label and icon */
  previous: PropTypes.bool,

  /** Add to first button to add default aria label and icon */
  first: PropTypes.bool,

  /** Add to last button to add default aria label and icon */
  last: PropTypes.bool,

  /** Set a custom element for this component */
  tag: tagPropType
});

/**
 * TabContext
 * {
 *  activeTabId: PropTypes.any
 * }
 */

const TabContext = React__default.createContext({});

const propTypes$e = {
  tag: tagPropType,
  activeTab: PropTypes.any,
  className: PropTypes.string,
  cssModule: PropTypes.object
};
const defaultProps$e = {
  tag: 'div'
};

class TabContent extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.activeTab !== nextProps.activeTab) {
      return {
        activeTab: nextProps.activeTab
      };
    }

    return null;
  }

  constructor(props) {
    super(props);
    this.state = {
      activeTab: this.props.activeTab
    };
  }

  render() {
    const {
      className,
      cssModule,
      tag: Tag
    } = this.props;
    const attributes = omit(this.props, Object.keys(propTypes$e));
    const classes = mapToCssModules(classnames('tab-content', className), cssModule);
    return /*#__PURE__*/React__default.createElement(TabContext.Provider, {
      value: {
        activeTabId: this.state.activeTab
      }
    }, /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
      className: classes
    })));
  }

}
TabContent.propTypes = propTypes$e;
TabContent.defaultProps = defaultProps$e;
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  tabId: PropTypes.any
});
({
  /** Pass children so this component can wrap the child elements */
  children: PropTypes.node,

  /** Add custom class */
  className: PropTypes.string,

  /** Add custom class for close button */
  closeClassName: PropTypes.string,

  /** Aria label for close button */
  closeAriaLabel: PropTypes.string,

  /** Change color of alert */
  color: PropTypes.string,

  /** Change existing className with a new className */
  cssModule: PropTypes.object,

  /** Toggle fade animation */
  fade: PropTypes.bool,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),

  /** Control visibility state of Alert */
  isOpen: PropTypes.bool,

  /** Set a custom element for this component */
  tag: tagPropType,

  /** Function to toggle visibility */
  toggle: PropTypes.func,

  /** Props to be passed to `Fade` to modify transition */
  transition: PropTypes.shape(Fade.propTypes)
});
({
  color: 'success',
  isOpen: true,
  tag: 'div',
  closeAriaLabel: 'Close',
  fade: true,
  transition: _objectSpread2(_objectSpread2({}, Fade.defaultProps), {}, {
    unmountOnExit: true
  })
});
({
  children: PropTypes.node,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  fade: PropTypes.bool,
  isOpen: PropTypes.bool,
  tag: tagPropType,
  transition: PropTypes.shape(Fade.propTypes),
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func])
});
({
  isOpen: true,
  tag: 'div',
  fade: true,
  transition: _objectSpread2(_objectSpread2({}, Fade.defaultProps), {}, {
    unmountOnExit: true
  })
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func])
});
({
  tag: tagPropType,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  wrapTag: tagPropType,
  toggle: PropTypes.func,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  children: PropTypes.node,
  closeAriaLabel: PropTypes.string,
  charCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  close: PropTypes.object,
  tagClassName: PropTypes.string
});
({
  /** Add action prop to give effects while hovering over element */
  action: PropTypes.bool,

  /** Add active prop to make the current selection active */
  active: PropTypes.bool,

  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Add background colour to the list item */
  color: PropTypes.string,

  /** Make the list item appear disabled */
  disabled: PropTypes.bool,

  /** Set a custom element for this component */
  tag: tagPropType
});
({
  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Set a custom element for this component */
  tag: tagPropType
});
({
  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Set a custom element for this component */
  tag: tagPropType
});

const _excluded$4 = ["className", "cssModule", "tag", "type"];
const propTypes$5 = {
  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Set a custom element for this component */
  tag: tagPropType,

  /** Type of list `unstyled` or `inline` */
  type: PropTypes.string
};
const defaultProps$5 = {
  tag: 'ul'
};
const List = forwardRef((props, ref) => {
  const {
    className,
    cssModule,
    tag: Tag,
    type
  } = props,
        attributes = _objectWithoutProperties(props, _excluded$4);

  const classes = mapToCssModules(classnames(className, type ? `list-${type}` : false), cssModule);
  return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
    className: classes,
    ref: ref
  }));
});
List.name = 'List';
List.propTypes = propTypes$5;
List.defaultProps = defaultProps$5;

const _excluded$3 = ["className", "cssModule", "tag"];
const propTypes$4 = {
  /** Add custom class */
  className: PropTypes.string,

  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,

  /** Set a custom element for this component */
  tag: tagPropType
};
const defaultProps$4 = {
  tag: 'li'
};
const ListInlineItem = forwardRef((props, ref) => {
  const {
    className,
    cssModule,
    tag: Tag
  } = props,
        attributes = _objectWithoutProperties(props, _excluded$3);

  const classes = mapToCssModules(classnames(className, 'list-inline-item'), cssModule);
  return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
    className: classes,
    ref: ref
  }));
});
ListInlineItem.name = 'ListInlineItem';
ListInlineItem.propTypes = propTypes$4;
ListInlineItem.defaultProps = defaultProps$4;

const omitKeys$3 = ['defaultOpen'];
class UncontrolledButtonDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.defaultOpen || false
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  }

  render() {
    return /*#__PURE__*/React__default.createElement(ButtonDropdown, _extends({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, omit(this.props, omitKeys$3)));
  }

}
UncontrolledButtonDropdown.propTypes = _objectSpread2({
  defaultOpen: PropTypes.bool
}, ButtonDropdown.propTypes);

const omitKeys$2 = ['toggleEvents', 'defaultOpen'];
const propTypes$3 = {
  /** set if Collapse is open by default */
  defaultOpen: PropTypes.bool,

  /** id of the element that should trigger toggle */
  toggler: PropTypes.string.isRequired,

  /** Events that should trigger the toggle */
  toggleEvents: PropTypes.arrayOf(PropTypes.string)
};
const defaultProps$3 = {
  toggleEvents: defaultToggleEvents
};

class UncontrolledCollapse extends Component {
  constructor(props) {
    super(props);
    this.togglers = null;
    this.removeEventListeners = null;
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: props.defaultOpen || false
    };
  }

  componentDidMount() {
    this.togglers = findDOMElements(this.props.toggler);

    if (this.togglers.length) {
      this.removeEventListeners = addMultipleEventListeners(this.togglers, this.toggle, this.props.toggleEvents);
    }
  }

  componentWillUnmount() {
    if (this.togglers.length && this.removeEventListeners) {
      this.removeEventListeners();
    }
  }

  toggle(e) {
    this.setState(({
      isOpen
    }) => ({
      isOpen: !isOpen
    }));
    e.preventDefault();
  }

  render() {
    return /*#__PURE__*/React__default.createElement(Collapse$1, _extends({
      isOpen: this.state.isOpen
    }, omit(this.props, omitKeys$2)));
  }

}

UncontrolledCollapse.propTypes = propTypes$3;
UncontrolledCollapse.defaultProps = defaultProps$3;

const omitKeys$1 = ['defaultOpen'];
class UncontrolledDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.defaultOpen || false
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle(e) {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }), () => {
      if (this.props.onToggle) {
        this.props.onToggle(e, this.state.isOpen);
      }
    });
  }

  render() {
    return /*#__PURE__*/React__default.createElement(Dropdown$1, _extends({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, omit(this.props, omitKeys$1)));
  }

}
UncontrolledDropdown.propTypes = _objectSpread2({
  defaultOpen: PropTypes.bool,
  onToggle: PropTypes.func
}, Dropdown$1.propTypes);

const omitKeys = ['defaultOpen'];
class UncontrolledTooltip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.defaultOpen || false
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  }

  render() {
    return /*#__PURE__*/React__default.createElement(Tooltip, _extends({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, omit(this.props, omitKeys)));
  }

}
UncontrolledTooltip.propTypes = _objectSpread2({
  defaultOpen: PropTypes.bool
}, Tooltip.propTypes);
({
  /** Set a custom element for this component */
  tag: tagPropType,

  /** Change animation of spinner */
  type: PropTypes.oneOf(['border', 'grow']),

  /** Change size of spinner */
  size: PropTypes.oneOf(['sm']),

  /** Change color of spinner */
  color: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark']),

  /** Add custom class */
  className: PropTypes.string,

  /** Change existing className with a new className */
  cssModule: PropTypes.object,

  /** Pass children so this component can wrap the child elements */
  children: PropTypes.string
});

_objectSpread2(_objectSpread2({}, Col.propTypes), {}, {
  /** Add custom color to the placeholder */
  color: PropTypes.string,

  /** Add custom tag. */
  tag: tagPropType,

  /** Apply either `glow` or `wave` animation. */
  animation: PropTypes.oneOf(['glow', 'wave']),
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),

  /** Make the size larger */
  size: PropTypes.oneOf(['lg', 'sm', 'xs'])
});
({
  size: PropTypes.string,
  color: PropTypes.string,
  outline: PropTypes.bool,
  className: PropTypes.string,
  tag: tagPropType,
  cssModule: PropTypes.object
});

(() => {
  if (typeof window !== 'object' || typeof window.CustomEvent === 'function') return;

  const CustomEvent = (event, params) => {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: null
    };
    let evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  };

  window.CustomEvent = CustomEvent;
})();

(() => {
  if (typeof Object.values === 'function') return;

  const values = O => Object.keys(O).map(key => O[key]);

  Object.values = values;
})();

var css_248z$1 = "@charset \"UTF-8\";\n.sabpaisa-css-utils-classes-version-five {\n  /*!\n   * Bootstrap  v5.2.3 (https://getbootstrap.com/)\n   * Copyright 2011-2022 The Bootstrap Authors\n   * Copyright 2011-2022 Twitter, Inc.\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n  /* rtl:raw:\n  [type=\"tel\"],\n  [type=\"url\"],\n  [type=\"email\"],\n  [type=\"number\"] {\n    direction: ltr;\n  }\n  */\n  /* rtl:begin:ignore */\n  /* rtl:end:ignore */\n  /* rtl:begin:ignore */\n  /* rtl:end:ignore */\n  /* rtl:begin:ignore */\n  /* rtl:end:ignore */\n  /* rtl:begin:ignore */\n  /* rtl:end:ignore */\n  /* rtl:options: {\n    \"autoRename\": true,\n    \"stringMap\":[ {\n      \"name\"    : \"prev-next\",\n      \"search\"  : \"prev\",\n      \"replace\" : \"next\"\n    } ]\n  } */\n  /* rtl:begin:remove */\n  /* rtl:end:remove */\n}\n.sabpaisa-css-utils-classes-version-five :root {\n  --bs-blue: #0d6efd;\n  --bs-indigo: #6610f2;\n  --bs-purple: #6f42c1;\n  --bs-pink: #d63384;\n  --bs-red: #dc3545;\n  --bs-orange: #fd7e14;\n  --bs-yellow: #ffc107;\n  --bs-green: #198754;\n  --bs-teal: #20c997;\n  --bs-cyan: #0dcaf0;\n  --bs-black: #000;\n  --bs-white: #fff;\n  --bs-gray: #6c757d;\n  --bs-gray-dark: #343a40;\n  --bs-gray-100: #f8f9fa;\n  --bs-gray-200: #e9ecef;\n  --bs-gray-300: #dee2e6;\n  --bs-gray-400: #ced4da;\n  --bs-gray-500: #adb5bd;\n  --bs-gray-600: #6c757d;\n  --bs-gray-700: #495057;\n  --bs-gray-800: #343a40;\n  --bs-gray-900: #212529;\n  --bs-primary: #0d6efd;\n  --bs-secondary: #6c757d;\n  --bs-success: #198754;\n  --bs-info: #0dcaf0;\n  --bs-warning: #ffc107;\n  --bs-danger: #dc3545;\n  --bs-light: #f8f9fa;\n  --bs-dark: #212529;\n  --bs-primary-rgb: 13, 110, 253;\n  --bs-secondary-rgb: 108, 117, 125;\n  --bs-success-rgb: 25, 135, 84;\n  --bs-info-rgb: 13, 202, 240;\n  --bs-warning-rgb: 255, 193, 7;\n  --bs-danger-rgb: 220, 53, 69;\n  --bs-light-rgb: 248, 249, 250;\n  --bs-dark-rgb: 33, 37, 41;\n  --bs-white-rgb: 255, 255, 255;\n  --bs-black-rgb: 0, 0, 0;\n  --bs-body-color-rgb: 33, 37, 41;\n  --bs-body-bg-rgb: 255, 255, 255;\n  --bs-font-sans-serif: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n  --bs-body-font-family: var(--bs-font-sans-serif);\n  --bs-body-font-size: 1rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.5;\n  --bs-body-color: #212529;\n  --bs-body-bg: #fff;\n  --bs-border-width: 1px;\n  --bs-border-style: solid;\n  --bs-border-color: #dee2e6;\n  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);\n  --bs-border-radius: 0.375rem;\n  --bs-border-radius-sm: 0.25rem;\n  --bs-border-radius-lg: 0.5rem;\n  --bs-border-radius-xl: 1rem;\n  --bs-border-radius-2xl: 2rem;\n  --bs-border-radius-pill: 50rem;\n  --bs-link-color: #0d6efd;\n  --bs-link-hover-color: #0a58ca;\n  --bs-code-color: #d63384;\n  --bs-highlight-bg: #fff3cd;\n}\n.sabpaisa-css-utils-classes-version-five *,\n.sabpaisa-css-utils-classes-version-five *::before,\n.sabpaisa-css-utils-classes-version-five *::after {\n  box-sizing: border-box;\n}\n@media (prefers-reduced-motion: no-preference) {\n  .sabpaisa-css-utils-classes-version-five :root {\n    scroll-behavior: smooth;\n  }\n}\n.sabpaisa-css-utils-classes-version-five body {\n  margin: 0;\n  font-family: var(--bs-body-font-family);\n  font-size: var(--bs-body-font-size);\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  color: var(--bs-body-color);\n  text-align: var(--bs-body-text-align);\n  background-color: var(--bs-body-bg);\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.sabpaisa-css-utils-classes-version-five hr {\n  margin: 1rem 0;\n  color: inherit;\n  border: 0;\n  border-top: 1px solid;\n  opacity: 0.25;\n}\n\n.sabpaisa-css-utils-classes-version-five h1, .sabpaisa-css-utils-classes-version-five .h1 {\n  font-size: calc(1.375rem + 1.5vw);\n}\n@media (min-width: 1200px) {\n  .sabpaisa-css-utils-classes-version-five h1, .sabpaisa-css-utils-classes-version-five .h1 {\n    font-size: 2.5rem;\n  }\n}\n\n\n\n\n\n.sabpaisa-css-utils-classes-version-five abbr[title] {\n  text-decoration: underline dotted;\n  cursor: help;\n  text-decoration-skip-ink: none;\n}\n.sabpaisa-css-utils-classes-version-five address {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n.sabpaisa-css-utils-classes-version-five ol,\n.sabpaisa-css-utils-classes-version-five ul {\n  padding-left: 2rem;\n}\n.sabpaisa-css-utils-classes-version-five ol,\n.sabpaisa-css-utils-classes-version-five ul,\n.sabpaisa-css-utils-classes-version-five dl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n.sabpaisa-css-utils-classes-version-five ol ol,\n.sabpaisa-css-utils-classes-version-five ul ul,\n.sabpaisa-css-utils-classes-version-five ol ul,\n.sabpaisa-css-utils-classes-version-five ul ol {\n  margin-bottom: 0;\n}\n.sabpaisa-css-utils-classes-version-five dt {\n  font-weight: 700;\n}\n.sabpaisa-css-utils-classes-version-five dd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n.sabpaisa-css-utils-classes-version-five blockquote {\n  margin: 0 0 1rem;\n}\n.sabpaisa-css-utils-classes-version-five b,\n.sabpaisa-css-utils-classes-version-five strong {\n  font-weight: bolder;\n}\n.sabpaisa-css-utils-classes-version-five small, .sabpaisa-css-utils-classes-version-five .small {\n  font-size: 0.875em;\n}\n.sabpaisa-css-utils-classes-version-five mark, .sabpaisa-css-utils-classes-version-five .mark {\n  padding: 0.1875em;\n  background-color: var(--bs-highlight-bg);\n}\n.sabpaisa-css-utils-classes-version-five sub,\n.sabpaisa-css-utils-classes-version-five sup {\n  position: relative;\n  font-size: 0.75em;\n  line-height: 0;\n  vertical-align: baseline;\n}\n.sabpaisa-css-utils-classes-version-five sub {\n  bottom: -0.25em;\n}\n.sabpaisa-css-utils-classes-version-five sup {\n  top: -0.5em;\n}\n.sabpaisa-css-utils-classes-version-five a {\n  color: var(--bs-link-color);\n  text-decoration: underline;\n}\n.sabpaisa-css-utils-classes-version-five a:hover {\n  color: var(--bs-link-hover-color);\n}\n.sabpaisa-css-utils-classes-version-five a:not([href]):not([class]), .sabpaisa-css-utils-classes-version-five a:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n.sabpaisa-css-utils-classes-version-five pre,\n.sabpaisa-css-utils-classes-version-five code,\n.sabpaisa-css-utils-classes-version-five kbd,\n.sabpaisa-css-utils-classes-version-five samp {\n  font-family: var(--bs-font-monospace);\n  font-size: 1em;\n}\n.sabpaisa-css-utils-classes-version-five pre {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  font-size: 0.875em;\n}\n.sabpaisa-css-utils-classes-version-five pre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n.sabpaisa-css-utils-classes-version-five code {\n  font-size: 0.875em;\n  color: var(--bs-code-color);\n  word-wrap: break-word;\n}\na > .sabpaisa-css-utils-classes-version-five code {\n  color: inherit;\n}\n.sabpaisa-css-utils-classes-version-five kbd {\n  padding: 0.1875rem 0.375rem;\n  font-size: 0.875em;\n  color: var(--bs-body-bg);\n  background-color: var(--bs-body-color);\n  border-radius: 0.25rem;\n}\n.sabpaisa-css-utils-classes-version-five kbd kbd {\n  padding: 0;\n  font-size: 1em;\n}\n.sabpaisa-css-utils-classes-version-five figure {\n  margin: 0 0 1rem;\n}\n.sabpaisa-css-utils-classes-version-five img,\n.sabpaisa-css-utils-classes-version-five svg {\n  vertical-align: middle;\n}\n.sabpaisa-css-utils-classes-version-five table {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n.sabpaisa-css-utils-classes-version-five caption {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: #6c757d;\n  text-align: left;\n}\n.sabpaisa-css-utils-classes-version-five th {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n.sabpaisa-css-utils-classes-version-five thead,\n.sabpaisa-css-utils-classes-version-five tbody,\n.sabpaisa-css-utils-classes-version-five tfoot,\n.sabpaisa-css-utils-classes-version-five tr,\n.sabpaisa-css-utils-classes-version-five td,\n.sabpaisa-css-utils-classes-version-five th {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n.sabpaisa-css-utils-classes-version-five label {\n  display: inline-block;\n}\n.sabpaisa-css-utils-classes-version-five button {\n  border-radius: 0;\n}\n.sabpaisa-css-utils-classes-version-five button:focus:not(:focus-visible) {\n  outline: 0;\n}\n.sabpaisa-css-utils-classes-version-five input,\n.sabpaisa-css-utils-classes-version-five button,\n.sabpaisa-css-utils-classes-version-five select,\n.sabpaisa-css-utils-classes-version-five optgroup,\n.sabpaisa-css-utils-classes-version-five textarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n.sabpaisa-css-utils-classes-version-five button,\n.sabpaisa-css-utils-classes-version-five select {\n  text-transform: none;\n}\n.sabpaisa-css-utils-classes-version-five [role=button] {\n  cursor: pointer;\n}\n.sabpaisa-css-utils-classes-version-five select {\n  word-wrap: normal;\n}\n.sabpaisa-css-utils-classes-version-five select:disabled {\n  opacity: 1;\n}\n.sabpaisa-css-utils-classes-version-five [list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n.sabpaisa-css-utils-classes-version-five button,\n.sabpaisa-css-utils-classes-version-five [type=button],\n.sabpaisa-css-utils-classes-version-five [type=reset],\n.sabpaisa-css-utils-classes-version-five [type=submit] {\n  -webkit-appearance: button;\n}\n.sabpaisa-css-utils-classes-version-five button:not(:disabled),\n.sabpaisa-css-utils-classes-version-five [type=button]:not(:disabled),\n.sabpaisa-css-utils-classes-version-five [type=reset]:not(:disabled),\n.sabpaisa-css-utils-classes-version-five [type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n.sabpaisa-css-utils-classes-version-five ::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n.sabpaisa-css-utils-classes-version-five textarea {\n  resize: vertical;\n}\n.sabpaisa-css-utils-classes-version-five fieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n.sabpaisa-css-utils-classes-version-five legend {\n  float: left;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: calc(1.275rem + 0.3vw);\n  line-height: inherit;\n}\n@media (min-width: 1200px) {\n  .sabpaisa-css-utils-classes-version-five legend {\n    font-size: 1.5rem;\n  }\n}\n.sabpaisa-css-utils-classes-version-five legend + * {\n  clear: left;\n}\n.sabpaisa-css-utils-classes-version-five ::-webkit-datetime-edit-fields-wrapper,\n.sabpaisa-css-utils-classes-version-five ::-webkit-datetime-edit-text,\n.sabpaisa-css-utils-classes-version-five ::-webkit-datetime-edit-minute,\n.sabpaisa-css-utils-classes-version-five ::-webkit-datetime-edit-hour-field,\n.sabpaisa-css-utils-classes-version-five ::-webkit-datetime-edit-day-field,\n.sabpaisa-css-utils-classes-version-five ::-webkit-datetime-edit-month-field,\n.sabpaisa-css-utils-classes-version-five ::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n.sabpaisa-css-utils-classes-version-five ::-webkit-inner-spin-button {\n  height: auto;\n}\n.sabpaisa-css-utils-classes-version-five [type=search] {\n  outline-offset: -2px;\n  -webkit-appearance: textfield;\n}\n.sabpaisa-css-utils-classes-version-five ::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n.sabpaisa-css-utils-classes-version-five ::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n.sabpaisa-css-utils-classes-version-five ::file-selector-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n.sabpaisa-css-utils-classes-version-five output {\n  display: inline-block;\n}\n.sabpaisa-css-utils-classes-version-five iframe {\n  border: 0;\n}\n.sabpaisa-css-utils-classes-version-five summary {\n  display: list-item;\n  cursor: pointer;\n}\n.sabpaisa-css-utils-classes-version-five progress {\n  vertical-align: baseline;\n}\n.sabpaisa-css-utils-classes-version-five [hidden] {\n  display: none !important;\n}\n.sabpaisa-css-utils-classes-version-five .lead {\n  font-size: 1.25rem;\n  font-weight: 300;\n}\n.sabpaisa-css-utils-classes-version-five .display-1 {\n  font-size: calc(1.625rem + 4.5vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .sabpaisa-css-utils-classes-version-five .display-1 {\n    font-size: 5rem;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .display-2 {\n  font-size: calc(1.575rem + 3.9vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .sabpaisa-css-utils-classes-version-five .display-2 {\n    font-size: 4.5rem;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .display-3 {\n  font-size: calc(1.525rem + 3.3vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .sabpaisa-css-utils-classes-version-five .display-3 {\n    font-size: 4rem;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .display-4 {\n  font-size: calc(1.475rem + 2.7vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .sabpaisa-css-utils-classes-version-five .display-4 {\n    font-size: 3.5rem;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .display-5 {\n  font-size: calc(1.425rem + 2.1vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .sabpaisa-css-utils-classes-version-five .display-5 {\n    font-size: 3rem;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .display-6 {\n  font-size: calc(1.375rem + 1.5vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .sabpaisa-css-utils-classes-version-five .display-6 {\n    font-size: 2.5rem;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n.sabpaisa-css-utils-classes-version-five .list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n.sabpaisa-css-utils-classes-version-five .list-inline-item {\n  display: inline-block;\n}\n.sabpaisa-css-utils-classes-version-five .list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n.sabpaisa-css-utils-classes-version-five .initialism {\n  font-size: 0.875em;\n  text-transform: uppercase;\n}\n.sabpaisa-css-utils-classes-version-five .blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.25rem;\n}\n.sabpaisa-css-utils-classes-version-five .blockquote > :last-child {\n  margin-bottom: 0;\n}\n.sabpaisa-css-utils-classes-version-five .blockquote-footer {\n  margin-top: -1rem;\n  margin-bottom: 1rem;\n  font-size: 0.875em;\n  color: #6c757d;\n}\n.sabpaisa-css-utils-classes-version-five .blockquote-footer::before {\n  content: \"— \";\n}\n.sabpaisa-css-utils-classes-version-five .img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n.sabpaisa-css-utils-classes-version-five .img-thumbnail {\n  padding: 0.25rem;\n  background-color: #fff;\n  border: 1px solid var(--bs-border-color);\n  border-radius: 0.375rem;\n  max-width: 100%;\n  height: auto;\n}\n.sabpaisa-css-utils-classes-version-five .figure {\n  display: inline-block;\n}\n.sabpaisa-css-utils-classes-version-five .figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n.sabpaisa-css-utils-classes-version-five .figure-caption {\n  font-size: 0.875em;\n  color: #6c757d;\n}\n.sabpaisa-css-utils-classes-version-five .container,\n.sabpaisa-css-utils-classes-version-five .container-fluid,\n.sabpaisa-css-utils-classes-version-five .container-xxl,\n.sabpaisa-css-utils-classes-version-five .container-xl,\n.sabpaisa-css-utils-classes-version-five .container-lg,\n.sabpaisa-css-utils-classes-version-five .container-md,\n.sabpaisa-css-utils-classes-version-five .container-sm {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-right: auto;\n  margin-left: auto;\n}\n@media (min-width: 576px) {\n  .sabpaisa-css-utils-classes-version-five .container-sm, .sabpaisa-css-utils-classes-version-five .container {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .sabpaisa-css-utils-classes-version-five .container-md, .sabpaisa-css-utils-classes-version-five .container-sm, .sabpaisa-css-utils-classes-version-five .container {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .sabpaisa-css-utils-classes-version-five .container-lg, .sabpaisa-css-utils-classes-version-five .container-md, .sabpaisa-css-utils-classes-version-five .container-sm, .sabpaisa-css-utils-classes-version-five .container {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .sabpaisa-css-utils-classes-version-five .container-xl, .sabpaisa-css-utils-classes-version-five .container-lg, .sabpaisa-css-utils-classes-version-five .container-md, .sabpaisa-css-utils-classes-version-five .container-sm, .sabpaisa-css-utils-classes-version-five .container {\n    max-width: 1140px;\n  }\n}\n@media (min-width: 1400px) {\n  .sabpaisa-css-utils-classes-version-five .container-xxl, .sabpaisa-css-utils-classes-version-five .container-xl, .sabpaisa-css-utils-classes-version-five .container-lg, .sabpaisa-css-utils-classes-version-five .container-md, .sabpaisa-css-utils-classes-version-five .container-sm, .sabpaisa-css-utils-classes-version-five .container {\n    max-width: 1320px;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .row {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: calc(-1 * var(--bs-gutter-y));\n  margin-right: calc(-0.5 * var(--bs-gutter-x));\n  margin-left: calc(-0.5 * var(--bs-gutter-x));\n}\n.sabpaisa-css-utils-classes-version-five .row > * {\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-top: var(--bs-gutter-y);\n}\n.sabpaisa-css-utils-classes-version-five .col {\n  flex: 1 0 0%;\n}\n.sabpaisa-css-utils-classes-version-five .row-cols-auto > * {\n  flex: 0 0 auto;\n  width: auto;\n}\n.sabpaisa-css-utils-classes-version-five .row-cols-1 > * {\n  flex: 0 0 auto;\n  width: 100%;\n}\n.sabpaisa-css-utils-classes-version-five .row-cols-2 > * {\n  flex: 0 0 auto;\n  width: 50%;\n}\n.sabpaisa-css-utils-classes-version-five .row-cols-3 > * {\n  flex: 0 0 auto;\n  width: 33.3333333333%;\n}\n.sabpaisa-css-utils-classes-version-five .row-cols-4 > * {\n  flex: 0 0 auto;\n  width: 25%;\n}\n.sabpaisa-css-utils-classes-version-five .row-cols-5 > * {\n  flex: 0 0 auto;\n  width: 20%;\n}\n.sabpaisa-css-utils-classes-version-five .row-cols-6 > * {\n  flex: 0 0 auto;\n  width: 16.6666666667%;\n}\n.sabpaisa-css-utils-classes-version-five .col-auto {\n  flex: 0 0 auto;\n  width: auto;\n}\n.sabpaisa-css-utils-classes-version-five .col-1 {\n  flex: 0 0 auto;\n  width: 8.33333333%;\n}\n.sabpaisa-css-utils-classes-version-five .col-2 {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n.sabpaisa-css-utils-classes-version-five .col-3 {\n  flex: 0 0 auto;\n  width: 25%;\n}\n.sabpaisa-css-utils-classes-version-five .col-4 {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n.sabpaisa-css-utils-classes-version-five .col-5 {\n  flex: 0 0 auto;\n  width: 41.66666667%;\n}\n.sabpaisa-css-utils-classes-version-five .col-6 {\n  flex: 0 0 auto;\n  width: 50%;\n}\n.sabpaisa-css-utils-classes-version-five .col-7 {\n  flex: 0 0 auto;\n  width: 58.33333333%;\n}\n.sabpaisa-css-utils-classes-version-five .col-8 {\n  flex: 0 0 auto;\n  width: 66.66666667%;\n}\n.sabpaisa-css-utils-classes-version-five .col-9 {\n  flex: 0 0 auto;\n  width: 75%;\n}\n.sabpaisa-css-utils-classes-version-five .col-10 {\n  flex: 0 0 auto;\n  width: 83.33333333%;\n}\n.sabpaisa-css-utils-classes-version-five .col-11 {\n  flex: 0 0 auto;\n  width: 91.66666667%;\n}\n.sabpaisa-css-utils-classes-version-five .col-12 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n.sabpaisa-css-utils-classes-version-five .offset-1 {\n  margin-left: 8.33333333%;\n}\n.sabpaisa-css-utils-classes-version-five .offset-2 {\n  margin-left: 16.66666667%;\n}\n.sabpaisa-css-utils-classes-version-five .offset-3 {\n  margin-left: 25%;\n}\n.sabpaisa-css-utils-classes-version-five .offset-4 {\n  margin-left: 33.33333333%;\n}\n.sabpaisa-css-utils-classes-version-five .offset-5 {\n  margin-left: 41.66666667%;\n}\n.sabpaisa-css-utils-classes-version-five .offset-6 {\n  margin-left: 50%;\n}\n.sabpaisa-css-utils-classes-version-five .offset-7 {\n  margin-left: 58.33333333%;\n}\n.sabpaisa-css-utils-classes-version-five .offset-8 {\n  margin-left: 66.66666667%;\n}\n.sabpaisa-css-utils-classes-version-five .offset-9 {\n  margin-left: 75%;\n}\n.sabpaisa-css-utils-classes-version-five .offset-10 {\n  margin-left: 83.33333333%;\n}\n.sabpaisa-css-utils-classes-version-five .offset-11 {\n  margin-left: 91.66666667%;\n}\n.sabpaisa-css-utils-classes-version-five .g-0,\n.sabpaisa-css-utils-classes-version-five .gx-0 {\n  --bs-gutter-x: 0;\n}\n.sabpaisa-css-utils-classes-version-five .g-0,\n.sabpaisa-css-utils-classes-version-five .gy-0 {\n  --bs-gutter-y: 0;\n}\n.sabpaisa-css-utils-classes-version-five .g-1,\n.sabpaisa-css-utils-classes-version-five .gx-1 {\n  --bs-gutter-x: 0.25rem;\n}\n.sabpaisa-css-utils-classes-version-five .g-1,\n.sabpaisa-css-utils-classes-version-five .gy-1 {\n  --bs-gutter-y: 0.25rem;\n}\n.sabpaisa-css-utils-classes-version-five .g-2,\n.sabpaisa-css-utils-classes-version-five .gx-2 {\n  --bs-gutter-x: 0.5rem;\n}\n.sabpaisa-css-utils-classes-version-five .g-2,\n.sabpaisa-css-utils-classes-version-five .gy-2 {\n  --bs-gutter-y: 0.5rem;\n}\n.sabpaisa-css-utils-classes-version-five .g-3,\n.sabpaisa-css-utils-classes-version-five .gx-3 {\n  --bs-gutter-x: 1rem;\n}\n.sabpaisa-css-utils-classes-version-five .g-3,\n.sabpaisa-css-utils-classes-version-five .gy-3 {\n  --bs-gutter-y: 1rem;\n}\n.sabpaisa-css-utils-classes-version-five .g-4,\n.sabpaisa-css-utils-classes-version-five .gx-4 {\n  --bs-gutter-x: 1.5rem;\n}\n.sabpaisa-css-utils-classes-version-five .g-4,\n.sabpaisa-css-utils-classes-version-five .gy-4 {\n  --bs-gutter-y: 1.5rem;\n}\n.sabpaisa-css-utils-classes-version-five .g-5,\n.sabpaisa-css-utils-classes-version-five .gx-5 {\n  --bs-gutter-x: 3rem;\n}\n.sabpaisa-css-utils-classes-version-five .g-5,\n.sabpaisa-css-utils-classes-version-five .gy-5 {\n  --bs-gutter-y: 3rem;\n}\n@media (min-width: 576px) {\n  .sabpaisa-css-utils-classes-version-five .col-sm {\n    flex: 1 0 0%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-sm-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-sm-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-sm-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-sm-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-sm-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-sm-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-sm-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-sm-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-sm-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-sm-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-sm-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-sm-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-sm-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-sm-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-sm-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-sm-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-sm-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-sm-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-sm-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-sm-0 {\n    margin-left: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-sm-0,\n  .sabpaisa-css-utils-classes-version-five .gx-sm-0 {\n    --bs-gutter-x: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-sm-0,\n  .sabpaisa-css-utils-classes-version-five .gy-sm-0 {\n    --bs-gutter-y: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-sm-1,\n  .sabpaisa-css-utils-classes-version-five .gx-sm-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-sm-1,\n  .sabpaisa-css-utils-classes-version-five .gy-sm-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-sm-2,\n  .sabpaisa-css-utils-classes-version-five .gx-sm-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-sm-2,\n  .sabpaisa-css-utils-classes-version-five .gy-sm-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-sm-3,\n  .sabpaisa-css-utils-classes-version-five .gx-sm-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-sm-3,\n  .sabpaisa-css-utils-classes-version-five .gy-sm-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-sm-4,\n  .sabpaisa-css-utils-classes-version-five .gx-sm-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-sm-4,\n  .sabpaisa-css-utils-classes-version-five .gy-sm-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-sm-5,\n  .sabpaisa-css-utils-classes-version-five .gx-sm-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-sm-5,\n  .sabpaisa-css-utils-classes-version-five .gy-sm-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 768px) {\n  .sabpaisa-css-utils-classes-version-five .col-md {\n    flex: 1 0 0%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-md-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-md-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-md-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-md-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-md-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-md-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-md-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-md-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-md-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-md-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-md-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-md-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-md-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-md-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-md-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-md-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-md-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-md-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-md-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-md-0 {\n    margin-left: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-md-3 {\n    margin-left: 25%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-md-6 {\n    margin-left: 50%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-md-9 {\n    margin-left: 75%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-md-0,\n  .sabpaisa-css-utils-classes-version-five .gx-md-0 {\n    --bs-gutter-x: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-md-0,\n  .sabpaisa-css-utils-classes-version-five .gy-md-0 {\n    --bs-gutter-y: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-md-1,\n  .sabpaisa-css-utils-classes-version-five .gx-md-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-md-1,\n  .sabpaisa-css-utils-classes-version-five .gy-md-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-md-2,\n  .sabpaisa-css-utils-classes-version-five .gx-md-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-md-2,\n  .sabpaisa-css-utils-classes-version-five .gy-md-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-md-3,\n  .sabpaisa-css-utils-classes-version-five .gx-md-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-md-3,\n  .sabpaisa-css-utils-classes-version-five .gy-md-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-md-4,\n  .sabpaisa-css-utils-classes-version-five .gx-md-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-md-4,\n  .sabpaisa-css-utils-classes-version-five .gy-md-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-md-5,\n  .sabpaisa-css-utils-classes-version-five .gx-md-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-md-5,\n  .sabpaisa-css-utils-classes-version-five .gy-md-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 992px) {\n  .sabpaisa-css-utils-classes-version-five .col-lg {\n    flex: 1 0 0%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-lg-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-lg-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-lg-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-lg-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-lg-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-lg-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-lg-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-lg-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-lg-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-lg-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-lg-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-lg-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-lg-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-lg-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-lg-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-lg-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-lg-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-lg-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-lg-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-lg-0 {\n    margin-left: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-lg-0,\n  .sabpaisa-css-utils-classes-version-five .gx-lg-0 {\n    --bs-gutter-x: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-lg-0,\n  .sabpaisa-css-utils-classes-version-five .gy-lg-0 {\n    --bs-gutter-y: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-lg-1,\n  .sabpaisa-css-utils-classes-version-five .gx-lg-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-lg-1,\n  .sabpaisa-css-utils-classes-version-five .gy-lg-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-lg-2,\n  .sabpaisa-css-utils-classes-version-five .gx-lg-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-lg-2,\n  .sabpaisa-css-utils-classes-version-five .gy-lg-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-lg-3,\n  .sabpaisa-css-utils-classes-version-five .gx-lg-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-lg-3,\n  .sabpaisa-css-utils-classes-version-five .gy-lg-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-lg-4,\n  .sabpaisa-css-utils-classes-version-five .gx-lg-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-lg-4,\n  .sabpaisa-css-utils-classes-version-five .gy-lg-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-lg-5,\n  .sabpaisa-css-utils-classes-version-five .gx-lg-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-lg-5,\n  .sabpaisa-css-utils-classes-version-five .gy-lg-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 1200px) {\n  .sabpaisa-css-utils-classes-version-five .col-xl {\n    flex: 1 0 0%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-xl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-xl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-xl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-xl-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-xl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-xl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-xl-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xl-0 {\n    margin-left: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xl-0,\n  .sabpaisa-css-utils-classes-version-five .gx-xl-0 {\n    --bs-gutter-x: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xl-0,\n  .sabpaisa-css-utils-classes-version-five .gy-xl-0 {\n    --bs-gutter-y: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xl-1,\n  .sabpaisa-css-utils-classes-version-five .gx-xl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xl-1,\n  .sabpaisa-css-utils-classes-version-five .gy-xl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xl-2,\n  .sabpaisa-css-utils-classes-version-five .gx-xl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xl-2,\n  .sabpaisa-css-utils-classes-version-five .gy-xl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xl-3,\n  .sabpaisa-css-utils-classes-version-five .gx-xl-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xl-3,\n  .sabpaisa-css-utils-classes-version-five .gy-xl-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xl-4,\n  .sabpaisa-css-utils-classes-version-five .gx-xl-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xl-4,\n  .sabpaisa-css-utils-classes-version-five .gy-xl-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xl-5,\n  .sabpaisa-css-utils-classes-version-five .gx-xl-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xl-5,\n  .sabpaisa-css-utils-classes-version-five .gy-xl-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 1400px) {\n  .sabpaisa-css-utils-classes-version-five .col-xxl {\n    flex: 1 0 0%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-xxl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-xxl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-xxl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-xxl-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-xxl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-xxl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .sabpaisa-css-utils-classes-version-five .row-cols-xxl-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xxl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xxl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xxl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xxl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xxl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xxl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xxl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xxl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xxl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xxl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xxl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .col-xxl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xxl-0 {\n    margin-left: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xxl-1 {\n    margin-left: 8.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xxl-2 {\n    margin-left: 16.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xxl-3 {\n    margin-left: 25%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xxl-4 {\n    margin-left: 33.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xxl-5 {\n    margin-left: 41.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xxl-6 {\n    margin-left: 50%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xxl-7 {\n    margin-left: 58.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xxl-8 {\n    margin-left: 66.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xxl-9 {\n    margin-left: 75%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xxl-10 {\n    margin-left: 83.33333333%;\n  }\n  .sabpaisa-css-utils-classes-version-five .offset-xxl-11 {\n    margin-left: 91.66666667%;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xxl-0,\n  .sabpaisa-css-utils-classes-version-five .gx-xxl-0 {\n    --bs-gutter-x: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xxl-0,\n  .sabpaisa-css-utils-classes-version-five .gy-xxl-0 {\n    --bs-gutter-y: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xxl-1,\n  .sabpaisa-css-utils-classes-version-five .gx-xxl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xxl-1,\n  .sabpaisa-css-utils-classes-version-five .gy-xxl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xxl-2,\n  .sabpaisa-css-utils-classes-version-five .gx-xxl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xxl-2,\n  .sabpaisa-css-utils-classes-version-five .gy-xxl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xxl-3,\n  .sabpaisa-css-utils-classes-version-five .gx-xxl-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xxl-3,\n  .sabpaisa-css-utils-classes-version-five .gy-xxl-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xxl-4,\n  .sabpaisa-css-utils-classes-version-five .gx-xxl-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xxl-4,\n  .sabpaisa-css-utils-classes-version-five .gy-xxl-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xxl-5,\n  .sabpaisa-css-utils-classes-version-five .gx-xxl-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .sabpaisa-css-utils-classes-version-five .g-xxl-5,\n  .sabpaisa-css-utils-classes-version-five .gy-xxl-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .table {\n  --bs-table-color: var(--bs-body-color);\n  --bs-table-bg: transparent;\n  --bs-table-border-color: var(--bs-border-color);\n  --bs-table-accent-bg: transparent;\n  --bs-table-striped-color: var(--bs-body-color);\n  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);\n  --bs-table-active-color: var(--bs-body-color);\n  --bs-table-active-bg: rgba(0, 0, 0, 0.1);\n  --bs-table-hover-color: var(--bs-body-color);\n  --bs-table-hover-bg: rgba(0, 0, 0, 0.075);\n  width: 100%;\n  margin-bottom: 1rem;\n  color: var(--bs-table-color);\n  vertical-align: top;\n  border-color: var(--bs-table-border-color);\n}\n.sabpaisa-css-utils-classes-version-five .table > :not(caption) > * > * {\n  padding: 0.5rem 0.5rem;\n  background-color: var(--bs-table-bg);\n  border-bottom-width: 1px;\n  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);\n}\n.sabpaisa-css-utils-classes-version-five .table > tbody {\n  vertical-align: inherit;\n}\n.sabpaisa-css-utils-classes-version-five .table > thead {\n  vertical-align: bottom;\n}\n.sabpaisa-css-utils-classes-version-five .table-group-divider {\n  border-top: 2px solid currentcolor;\n}\n.sabpaisa-css-utils-classes-version-five .caption-top {\n  caption-side: top;\n}\n.sabpaisa-css-utils-classes-version-five .table-sm > :not(caption) > * > * {\n  padding: 0.25rem 0.25rem;\n}\n.sabpaisa-css-utils-classes-version-five .table-bordered > :not(caption) > * {\n  border-width: 1px 0;\n}\n.sabpaisa-css-utils-classes-version-five .table-bordered > :not(caption) > * > * {\n  border-width: 0 1px;\n}\n.sabpaisa-css-utils-classes-version-five .table-borderless > :not(caption) > * > * {\n  border-bottom-width: 0;\n}\n.sabpaisa-css-utils-classes-version-five .table-borderless > :not(:first-child) {\n  border-top-width: 0;\n}\n.sabpaisa-css-utils-classes-version-five .table-striped > tbody > tr:nth-of-type(odd) > * {\n  --bs-table-accent-bg: var(--bs-table-striped-bg);\n  color: var(--bs-table-striped-color);\n}\n.sabpaisa-css-utils-classes-version-five .table-striped-columns > :not(caption) > tr > :nth-child(even) {\n  --bs-table-accent-bg: var(--bs-table-striped-bg);\n  color: var(--bs-table-striped-color);\n}\n.sabpaisa-css-utils-classes-version-five .table-active {\n  --bs-table-accent-bg: var(--bs-table-active-bg);\n  color: var(--bs-table-active-color);\n}\n.sabpaisa-css-utils-classes-version-five .table-hover > tbody > tr:hover > * {\n  --bs-table-accent-bg: var(--bs-table-hover-bg);\n  color: var(--bs-table-hover-color);\n}\n.sabpaisa-css-utils-classes-version-five .table-primary {\n  --bs-table-color: #000;\n  --bs-table-bg: #cfe2ff;\n  --bs-table-border-color: #bacbe6;\n  --bs-table-striped-bg: #c5d7f2;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #bacbe6;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #bfd1ec;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n.sabpaisa-css-utils-classes-version-five .table-secondary {\n  --bs-table-color: #000;\n  --bs-table-bg: #e2e3e5;\n  --bs-table-border-color: #cbccce;\n  --bs-table-striped-bg: #d7d8da;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #cbccce;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #d1d2d4;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n.sabpaisa-css-utils-classes-version-five .table-success {\n  --bs-table-color: #000;\n  --bs-table-bg: #d1e7dd;\n  --bs-table-border-color: #bcd0c7;\n  --bs-table-striped-bg: #c7dbd2;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #bcd0c7;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #c1d6cc;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n.sabpaisa-css-utils-classes-version-five .table-info {\n  --bs-table-color: #000;\n  --bs-table-bg: #cff4fc;\n  --bs-table-border-color: #badce3;\n  --bs-table-striped-bg: #c5e8ef;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #badce3;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #bfe2e9;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n.sabpaisa-css-utils-classes-version-five .table-warning {\n  --bs-table-color: #000;\n  --bs-table-bg: #fff3cd;\n  --bs-table-border-color: #e6dbb9;\n  --bs-table-striped-bg: #f2e7c3;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #e6dbb9;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #ece1be;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n.sabpaisa-css-utils-classes-version-five .table-danger {\n  --bs-table-color: #000;\n  --bs-table-bg: #f8d7da;\n  --bs-table-border-color: #dfc2c4;\n  --bs-table-striped-bg: #eccccf;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #dfc2c4;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #e5c7ca;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n.sabpaisa-css-utils-classes-version-five .table-light {\n  --bs-table-color: #000;\n  --bs-table-bg: #f8f9fa;\n  --bs-table-border-color: #dfe0e1;\n  --bs-table-striped-bg: #ecedee;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #dfe0e1;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #e5e6e7;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n.sabpaisa-css-utils-classes-version-five .table-dark {\n  --bs-table-color: #fff;\n  --bs-table-bg: #212529;\n  --bs-table-border-color: #373b3e;\n  --bs-table-striped-bg: #2c3034;\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: #373b3e;\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: #323539;\n  --bs-table-hover-color: #fff;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n.sabpaisa-css-utils-classes-version-five .table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n@media (max-width: 575.98px) {\n  .sabpaisa-css-utils-classes-version-five .table-responsive-sm {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 767.98px) {\n  .sabpaisa-css-utils-classes-version-five .table-responsive-md {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 991.98px) {\n  .sabpaisa-css-utils-classes-version-five .table-responsive-lg {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1199.98px) {\n  .sabpaisa-css-utils-classes-version-five .table-responsive-xl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1399.98px) {\n  .sabpaisa-css-utils-classes-version-five .table-responsive-xxl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .form-label {\n  margin-bottom: 0.5rem;\n}\n.sabpaisa-css-utils-classes-version-five .col-form-label {\n  padding-top: calc(0.375rem + 1px);\n  padding-bottom: calc(0.375rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n.sabpaisa-css-utils-classes-version-five .col-form-label-lg {\n  padding-top: calc(0.5rem + 1px);\n  padding-bottom: calc(0.5rem + 1px);\n  font-size: 1.25rem;\n}\n.sabpaisa-css-utils-classes-version-five .col-form-label-sm {\n  padding-top: calc(0.25rem + 1px);\n  padding-bottom: calc(0.25rem + 1px);\n  font-size: 0.875rem;\n}\n.sabpaisa-css-utils-classes-version-five .form-text {\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: #6c757d;\n}\n.sabpaisa-css-utils-classes-version-five .form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  appearance: none;\n  border-radius: 0.375rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .form-control {\n    transition: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .form-control[type=file] {\n  overflow: hidden;\n}\n.sabpaisa-css-utils-classes-version-five .form-control[type=file]:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.sabpaisa-css-utils-classes-version-five .form-control:focus {\n  color: #212529;\n  background-color: #fff;\n  border-color: #86b7fe;\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.sabpaisa-css-utils-classes-version-five .form-control::-webkit-date-and-time-value {\n  height: 1.5em;\n}\n.sabpaisa-css-utils-classes-version-five .form-control::placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n.sabpaisa-css-utils-classes-version-five .form-control:disabled {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n.sabpaisa-css-utils-classes-version-five .form-control::file-selector-button {\n  padding: 0.375rem 0.75rem;\n  margin: -0.375rem -0.75rem;\n  margin-inline-end: 0.75rem;\n  color: #212529;\n  background-color: #e9ecef;\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: 1px;\n  border-radius: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .form-control::file-selector-button {\n    transition: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n  background-color: #dde0e3;\n}\n.sabpaisa-css-utils-classes-version-five .form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0;\n  margin-bottom: 0;\n  line-height: 1.5;\n  color: #212529;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n.sabpaisa-css-utils-classes-version-five .form-control-plaintext:focus {\n  outline: 0;\n}\n.sabpaisa-css-utils-classes-version-five .form-control-plaintext.form-control-sm, .sabpaisa-css-utils-classes-version-five .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n.sabpaisa-css-utils-classes-version-five .form-control-sm {\n  min-height: calc(1.5em + 0.5rem + 2px);\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  border-radius: 0.25rem;\n}\n.sabpaisa-css-utils-classes-version-five .form-control-sm::file-selector-button {\n  padding: 0.25rem 0.5rem;\n  margin: -0.25rem -0.5rem;\n  margin-inline-end: 0.5rem;\n}\n.sabpaisa-css-utils-classes-version-five .form-control-lg {\n  min-height: calc(1.5em + 1rem + 2px);\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  border-radius: 0.5rem;\n}\n.sabpaisa-css-utils-classes-version-five .form-control-lg::file-selector-button {\n  padding: 0.5rem 1rem;\n  margin: -0.5rem -1rem;\n  margin-inline-end: 1rem;\n}\n.sabpaisa-css-utils-classes-version-five textarea.form-control {\n  min-height: calc(1.5em + 0.75rem + 2px);\n}\n.sabpaisa-css-utils-classes-version-five textarea.form-control-sm {\n  min-height: calc(1.5em + 0.5rem + 2px);\n}\n.sabpaisa-css-utils-classes-version-five textarea.form-control-lg {\n  min-height: calc(1.5em + 1rem + 2px);\n}\n.sabpaisa-css-utils-classes-version-five .form-control-color {\n  width: 3rem;\n  height: calc(1.5em + 0.75rem + 2px);\n  padding: 0.375rem;\n}\n.sabpaisa-css-utils-classes-version-five .form-control-color:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.sabpaisa-css-utils-classes-version-five .form-control-color::-moz-color-swatch {\n  border: 0 !important;\n  border-radius: 0.375rem;\n}\n.sabpaisa-css-utils-classes-version-five .form-control-color::-webkit-color-swatch {\n  border-radius: 0.375rem;\n}\n.sabpaisa-css-utils-classes-version-five .form-control-color.form-control-sm {\n  height: calc(1.5em + 0.5rem + 2px);\n}\n.sabpaisa-css-utils-classes-version-five .form-control-color.form-control-lg {\n  height: calc(1.5em + 1rem + 2px);\n}\n.sabpaisa-css-utils-classes-version-five .form-select {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 2.25rem 0.375rem 0.75rem;\n  -moz-padding-start: calc(0.75rem - 3px);\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  background-color: #fff;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 16px 12px;\n  border: 1px solid #ced4da;\n  border-radius: 0.375rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .form-select {\n    transition: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .form-select:focus {\n  border-color: #86b7fe;\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.sabpaisa-css-utils-classes-version-five .form-select[multiple], .sabpaisa-css-utils-classes-version-five .form-select[size]:not([size=\"1\"]) {\n  padding-right: 0.75rem;\n  background-image: none;\n}\n.sabpaisa-css-utils-classes-version-five .form-select:disabled {\n  background-color: #e9ecef;\n}\n.sabpaisa-css-utils-classes-version-five .form-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #212529;\n}\n.sabpaisa-css-utils-classes-version-five .form-select-sm {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  font-size: 0.875rem;\n  border-radius: 0.25rem;\n}\n.sabpaisa-css-utils-classes-version-five .form-select-lg {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1rem;\n  font-size: 1.25rem;\n  border-radius: 0.5rem;\n}\n.sabpaisa-css-utils-classes-version-five .form-check {\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 1.5em;\n  margin-bottom: 0.125rem;\n}\n.sabpaisa-css-utils-classes-version-five .form-check .form-check-input {\n  float: left;\n  margin-left: -1.5em;\n}\n.sabpaisa-css-utils-classes-version-five .form-check-reverse {\n  padding-right: 1.5em;\n  padding-left: 0;\n  text-align: right;\n}\n.sabpaisa-css-utils-classes-version-five .form-check-reverse .form-check-input {\n  float: right;\n  margin-right: -1.5em;\n  margin-left: 0;\n}\n.sabpaisa-css-utils-classes-version-five .form-check-input {\n  width: 1em;\n  height: 1em;\n  margin-top: 0.25em;\n  vertical-align: top;\n  background-color: #fff;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  appearance: none;\n  print-color-adjust: exact;\n}\n.sabpaisa-css-utils-classes-version-five .form-check-input[type=checkbox] {\n  border-radius: 0.25em;\n}\n.sabpaisa-css-utils-classes-version-five .form-check-input[type=radio] {\n  border-radius: 50%;\n}\n.sabpaisa-css-utils-classes-version-five .form-check-input:active {\n  filter: brightness(90%);\n}\n.sabpaisa-css-utils-classes-version-five .form-check-input:focus {\n  border-color: #86b7fe;\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.sabpaisa-css-utils-classes-version-five .form-check-input:checked {\n  background-color: #0d6efd;\n  border-color: #0d6efd;\n}\n.sabpaisa-css-utils-classes-version-five .form-check-input:checked[type=checkbox] {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e\");\n}\n.sabpaisa-css-utils-classes-version-five .form-check-input:checked[type=radio] {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.sabpaisa-css-utils-classes-version-five .form-check-input[type=checkbox]:indeterminate {\n  background-color: #0d6efd;\n  border-color: #0d6efd;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n}\n.sabpaisa-css-utils-classes-version-five .form-check-input:disabled {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.5;\n}\n.sabpaisa-css-utils-classes-version-five .form-check-input[disabled] ~ .form-check-label, .sabpaisa-css-utils-classes-version-five .form-check-input:disabled ~ .form-check-label {\n  cursor: default;\n  opacity: 0.5;\n}\n.sabpaisa-css-utils-classes-version-five .form-switch {\n  padding-left: 2.5em;\n}\n.sabpaisa-css-utils-classes-version-five .form-switch .form-check-input {\n  width: 2em;\n  margin-left: -2.5em;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n  background-position: left center;\n  border-radius: 2em;\n  transition: background-position 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .form-switch .form-check-input {\n    transition: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .form-switch .form-check-input:focus {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%2386b7fe'/%3e%3c/svg%3e\");\n}\n.sabpaisa-css-utils-classes-version-five .form-switch .form-check-input:checked {\n  background-position: right center;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.sabpaisa-css-utils-classes-version-five .form-switch.form-check-reverse {\n  padding-right: 2.5em;\n  padding-left: 0;\n}\n.sabpaisa-css-utils-classes-version-five .form-switch.form-check-reverse .form-check-input {\n  margin-right: -2.5em;\n  margin-left: 0;\n}\n.sabpaisa-css-utils-classes-version-five .form-check-inline {\n  display: inline-block;\n  margin-right: 1rem;\n}\n.sabpaisa-css-utils-classes-version-five .btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.sabpaisa-css-utils-classes-version-five .btn-check[disabled] + .btn, .sabpaisa-css-utils-classes-version-five .btn-check:disabled + .btn {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.65;\n}\n.sabpaisa-css-utils-classes-version-five .form-range {\n  width: 100%;\n  height: 1.5rem;\n  padding: 0;\n  background-color: transparent;\n  appearance: none;\n}\n.sabpaisa-css-utils-classes-version-five .form-range:focus {\n  outline: 0;\n}\n.sabpaisa-css-utils-classes-version-five .form-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.sabpaisa-css-utils-classes-version-five .form-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.sabpaisa-css-utils-classes-version-five .form-range::-moz-focus-outer {\n  border: 0;\n}\n.sabpaisa-css-utils-classes-version-five .form-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  background-color: #0d6efd;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .form-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .form-range::-webkit-slider-thumb:active {\n  background-color: #b6d4fe;\n}\n.sabpaisa-css-utils-classes-version-five .form-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #dee2e6;\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.sabpaisa-css-utils-classes-version-five .form-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  background-color: #0d6efd;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .form-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .form-range::-moz-range-thumb:active {\n  background-color: #b6d4fe;\n}\n.sabpaisa-css-utils-classes-version-five .form-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #dee2e6;\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.sabpaisa-css-utils-classes-version-five .form-range:disabled {\n  pointer-events: none;\n}\n.sabpaisa-css-utils-classes-version-five .form-range:disabled::-webkit-slider-thumb {\n  background-color: #adb5bd;\n}\n.sabpaisa-css-utils-classes-version-five .form-range:disabled::-moz-range-thumb {\n  background-color: #adb5bd;\n}\n.sabpaisa-css-utils-classes-version-five .form-floating {\n  position: relative;\n}\n.sabpaisa-css-utils-classes-version-five .form-floating > .form-control,\n.sabpaisa-css-utils-classes-version-five .form-floating > .form-control-plaintext,\n.sabpaisa-css-utils-classes-version-five .form-floating > .form-select {\n  height: calc(3.5rem + 2px);\n  line-height: 1.25;\n}\n.sabpaisa-css-utils-classes-version-five .form-floating > label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  padding: 1rem 0.75rem;\n  overflow: hidden;\n  text-align: start;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  pointer-events: none;\n  border: 1px solid transparent;\n  transform-origin: 0 0;\n  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .form-floating > label {\n    transition: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .form-floating > .form-control,\n.sabpaisa-css-utils-classes-version-five .form-floating > .form-control-plaintext {\n  padding: 1rem 0.75rem;\n}\n.sabpaisa-css-utils-classes-version-five .form-floating > .form-control::placeholder,\n.sabpaisa-css-utils-classes-version-five .form-floating > .form-control-plaintext::placeholder {\n  color: transparent;\n}\n.sabpaisa-css-utils-classes-version-five .form-floating > .form-control:focus, .sabpaisa-css-utils-classes-version-five .form-floating > .form-control:not(:placeholder-shown),\n.sabpaisa-css-utils-classes-version-five .form-floating > .form-control-plaintext:focus,\n.sabpaisa-css-utils-classes-version-five .form-floating > .form-control-plaintext:not(:placeholder-shown) {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.sabpaisa-css-utils-classes-version-five .form-floating > .form-control:-webkit-autofill,\n.sabpaisa-css-utils-classes-version-five .form-floating > .form-control-plaintext:-webkit-autofill {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.sabpaisa-css-utils-classes-version-five .form-floating > .form-select {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.sabpaisa-css-utils-classes-version-five .form-floating > .form-control:focus ~ label,\n.sabpaisa-css-utils-classes-version-five .form-floating > .form-control:not(:placeholder-shown) ~ label,\n.sabpaisa-css-utils-classes-version-five .form-floating > .form-control-plaintext ~ label,\n.sabpaisa-css-utils-classes-version-five .form-floating > .form-select ~ label {\n  opacity: 0.65;\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.sabpaisa-css-utils-classes-version-five .form-floating > .form-control:-webkit-autofill ~ label {\n  opacity: 0.65;\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.sabpaisa-css-utils-classes-version-five .form-floating > .form-control-plaintext ~ label {\n  border-width: 1px 0;\n}\n.sabpaisa-css-utils-classes-version-five .input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n.sabpaisa-css-utils-classes-version-five .input-group > .form-control,\n.sabpaisa-css-utils-classes-version-five .input-group > .form-select,\n.sabpaisa-css-utils-classes-version-five .input-group > .form-floating {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n}\n.sabpaisa-css-utils-classes-version-five .input-group > .form-control:focus,\n.sabpaisa-css-utils-classes-version-five .input-group > .form-select:focus,\n.sabpaisa-css-utils-classes-version-five .input-group > .form-floating:focus-within {\n  z-index: 5;\n}\n.sabpaisa-css-utils-classes-version-five .input-group .btn {\n  position: relative;\n  z-index: 2;\n}\n.sabpaisa-css-utils-classes-version-five .input-group .btn:focus {\n  z-index: 5;\n}\n.sabpaisa-css-utils-classes-version-five .input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #e9ecef;\n  border: 1px solid #ced4da;\n  border-radius: 0.375rem;\n}\n.sabpaisa-css-utils-classes-version-five .input-group-lg > .form-control,\n.sabpaisa-css-utils-classes-version-five .input-group-lg > .form-select,\n.sabpaisa-css-utils-classes-version-five .input-group-lg > .input-group-text,\n.sabpaisa-css-utils-classes-version-five .input-group-lg > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  border-radius: 0.5rem;\n}\n.sabpaisa-css-utils-classes-version-five .input-group-sm > .form-control,\n.sabpaisa-css-utils-classes-version-five .input-group-sm > .form-select,\n.sabpaisa-css-utils-classes-version-five .input-group-sm > .input-group-text,\n.sabpaisa-css-utils-classes-version-five .input-group-sm > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  border-radius: 0.25rem;\n}\n.sabpaisa-css-utils-classes-version-five .input-group-lg > .form-select,\n.sabpaisa-css-utils-classes-version-five .input-group-sm > .form-select {\n  padding-right: 3rem;\n}\n.sabpaisa-css-utils-classes-version-five .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.sabpaisa-css-utils-classes-version-five .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),\n.sabpaisa-css-utils-classes-version-five .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,\n.sabpaisa-css-utils-classes-version-five .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.sabpaisa-css-utils-classes-version-five .input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.sabpaisa-css-utils-classes-version-five .input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),\n.sabpaisa-css-utils-classes-version-five .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,\n.sabpaisa-css-utils-classes-version-five .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.sabpaisa-css-utils-classes-version-five .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: -1px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.sabpaisa-css-utils-classes-version-five .input-group > .form-floating:not(:first-child) > .form-control,\n.sabpaisa-css-utils-classes-version-five .input-group > .form-floating:not(:first-child) > .form-select {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.sabpaisa-css-utils-classes-version-five .valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: #198754;\n}\n.sabpaisa-css-utils-classes-version-five .valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  color: #fff;\n  background-color: rgba(25, 135, 84, 0.9);\n  border-radius: 0.375rem;\n}\n.was-validated .sabpaisa-css-utils-classes-version-five:valid ~ .valid-feedback,\n.was-validated .sabpaisa-css-utils-classes-version-five:valid ~ .valid-tooltip, .sabpaisa-css-utils-classes-version-five.is-valid ~ .valid-feedback,\n.sabpaisa-css-utils-classes-version-five.is-valid ~ .valid-tooltip {\n  display: block;\n}\n.was-validated .sabpaisa-css-utils-classes-version-five .form-control:valid, .sabpaisa-css-utils-classes-version-five .form-control.is-valid {\n  border-color: #198754;\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .sabpaisa-css-utils-classes-version-five .form-control:valid:focus, .sabpaisa-css-utils-classes-version-five .form-control.is-valid:focus {\n  border-color: #198754;\n  box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, 0.25);\n}\n.was-validated .sabpaisa-css-utils-classes-version-five textarea.form-control:valid, .sabpaisa-css-utils-classes-version-five textarea.form-control.is-valid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n.was-validated .sabpaisa-css-utils-classes-version-five .form-select:valid, .sabpaisa-css-utils-classes-version-five .form-select.is-valid {\n  border-color: #198754;\n}\n.was-validated .sabpaisa-css-utils-classes-version-five .form-select:valid:not([multiple]):not([size]), .was-validated .sabpaisa-css-utils-classes-version-five .form-select:valid:not([multiple])[size=\"1\"], .sabpaisa-css-utils-classes-version-five .form-select.is-valid:not([multiple]):not([size]), .sabpaisa-css-utils-classes-version-five .form-select.is-valid:not([multiple])[size=\"1\"] {\n  padding-right: 4.125rem;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\"), url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-position: right 0.75rem center, center right 2.25rem;\n  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .sabpaisa-css-utils-classes-version-five .form-select:valid:focus, .sabpaisa-css-utils-classes-version-five .form-select.is-valid:focus {\n  border-color: #198754;\n  box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, 0.25);\n}\n.was-validated .sabpaisa-css-utils-classes-version-five .form-control-color:valid, .sabpaisa-css-utils-classes-version-five .form-control-color.is-valid {\n  width: calc(3rem + calc(1.5em + 0.75rem));\n}\n.was-validated .sabpaisa-css-utils-classes-version-five .form-check-input:valid, .sabpaisa-css-utils-classes-version-five .form-check-input.is-valid {\n  border-color: #198754;\n}\n.was-validated .sabpaisa-css-utils-classes-version-five .form-check-input:valid:checked, .sabpaisa-css-utils-classes-version-five .form-check-input.is-valid:checked {\n  background-color: #198754;\n}\n.was-validated .sabpaisa-css-utils-classes-version-five .form-check-input:valid:focus, .sabpaisa-css-utils-classes-version-five .form-check-input.is-valid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, 0.25);\n}\n.was-validated .sabpaisa-css-utils-classes-version-five .form-check-input:valid ~ .form-check-label, .sabpaisa-css-utils-classes-version-five .form-check-input.is-valid ~ .form-check-label {\n  color: #198754;\n}\n.sabpaisa-css-utils-classes-version-five .form-check-inline .form-check-input ~ .valid-feedback {\n  margin-left: 0.5em;\n}\n.was-validated .sabpaisa-css-utils-classes-version-five .input-group > .form-control:not(:focus):valid, .sabpaisa-css-utils-classes-version-five .input-group > .form-control:not(:focus).is-valid,\n.was-validated .sabpaisa-css-utils-classes-version-five .input-group > .form-select:not(:focus):valid,\n.sabpaisa-css-utils-classes-version-five .input-group > .form-select:not(:focus).is-valid,\n.was-validated .sabpaisa-css-utils-classes-version-five .input-group > .form-floating:not(:focus-within):valid,\n.sabpaisa-css-utils-classes-version-five .input-group > .form-floating:not(:focus-within).is-valid {\n  z-index: 3;\n}\n.sabpaisa-css-utils-classes-version-five .invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: #dc3545;\n}\n.sabpaisa-css-utils-classes-version-five .invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  color: #fff;\n  background-color: rgba(220, 53, 69, 0.9);\n  border-radius: 0.375rem;\n}\n.was-validated .sabpaisa-css-utils-classes-version-five:invalid ~ .invalid-feedback,\n.was-validated .sabpaisa-css-utils-classes-version-five:invalid ~ .invalid-tooltip, .sabpaisa-css-utils-classes-version-five.is-invalid ~ .invalid-feedback,\n.sabpaisa-css-utils-classes-version-five.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n.was-validated .sabpaisa-css-utils-classes-version-five .form-control:invalid, .sabpaisa-css-utils-classes-version-five .form-control.is-invalid {\n  border-color: #dc3545;\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .sabpaisa-css-utils-classes-version-five .form-control:invalid:focus, .sabpaisa-css-utils-classes-version-five .form-control.is-invalid:focus {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);\n}\n.was-validated .sabpaisa-css-utils-classes-version-five textarea.form-control:invalid, .sabpaisa-css-utils-classes-version-five textarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n.was-validated .sabpaisa-css-utils-classes-version-five .form-select:invalid, .sabpaisa-css-utils-classes-version-five .form-select.is-invalid {\n  border-color: #dc3545;\n}\n.was-validated .sabpaisa-css-utils-classes-version-five .form-select:invalid:not([multiple]):not([size]), .was-validated .sabpaisa-css-utils-classes-version-five .form-select:invalid:not([multiple])[size=\"1\"], .sabpaisa-css-utils-classes-version-five .form-select.is-invalid:not([multiple]):not([size]), .sabpaisa-css-utils-classes-version-five .form-select.is-invalid:not([multiple])[size=\"1\"] {\n  padding-right: 4.125rem;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\"), url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\n  background-position: right 0.75rem center, center right 2.25rem;\n  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .sabpaisa-css-utils-classes-version-five .form-select:invalid:focus, .sabpaisa-css-utils-classes-version-five .form-select.is-invalid:focus {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);\n}\n.was-validated .sabpaisa-css-utils-classes-version-five .form-control-color:invalid, .sabpaisa-css-utils-classes-version-five .form-control-color.is-invalid {\n  width: calc(3rem + calc(1.5em + 0.75rem));\n}\n.was-validated .sabpaisa-css-utils-classes-version-five .form-check-input:invalid, .sabpaisa-css-utils-classes-version-five .form-check-input.is-invalid {\n  border-color: #dc3545;\n}\n.was-validated .sabpaisa-css-utils-classes-version-five .form-check-input:invalid:checked, .sabpaisa-css-utils-classes-version-five .form-check-input.is-invalid:checked {\n  background-color: #dc3545;\n}\n.was-validated .sabpaisa-css-utils-classes-version-five .form-check-input:invalid:focus, .sabpaisa-css-utils-classes-version-five .form-check-input.is-invalid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);\n}\n.was-validated .sabpaisa-css-utils-classes-version-five .form-check-input:invalid ~ .form-check-label, .sabpaisa-css-utils-classes-version-five .form-check-input.is-invalid ~ .form-check-label {\n  color: #dc3545;\n}\n.sabpaisa-css-utils-classes-version-five .form-check-inline .form-check-input ~ .invalid-feedback {\n  margin-left: 0.5em;\n}\n.was-validated .sabpaisa-css-utils-classes-version-five .input-group > .form-control:not(:focus):invalid, .sabpaisa-css-utils-classes-version-five .input-group > .form-control:not(:focus).is-invalid,\n.was-validated .sabpaisa-css-utils-classes-version-five .input-group > .form-select:not(:focus):invalid,\n.sabpaisa-css-utils-classes-version-five .input-group > .form-select:not(:focus).is-invalid,\n.was-validated .sabpaisa-css-utils-classes-version-five .input-group > .form-floating:not(:focus-within):invalid,\n.sabpaisa-css-utils-classes-version-five .input-group > .form-floating:not(:focus-within).is-invalid {\n  z-index: 4;\n}\n.sabpaisa-css-utils-classes-version-five .btn {\n  --bs-btn-padding-x: 0.75rem;\n  --bs-btn-padding-y: 0.375rem;\n  --bs-btn-font-family: ;\n  --bs-btn-font-size: 1rem;\n  --bs-btn-font-weight: 400;\n  --bs-btn-line-height: 1.5;\n  --bs-btn-color: #212529;\n  --bs-btn-bg: transparent;\n  --bs-btn-border-width: 1px;\n  --bs-btn-border-color: transparent;\n  --bs-btn-border-radius: 0.375rem;\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\n  --bs-btn-disabled-opacity: 0.65;\n  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);\n  display: inline-block;\n  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);\n  font-family: var(--bs-btn-font-family);\n  font-size: var(--bs-btn-font-size);\n  font-weight: var(--bs-btn-font-weight);\n  line-height: var(--bs-btn-line-height);\n  color: var(--bs-btn-color);\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);\n  border-radius: var(--bs-btn-border-radius);\n  background-color: var(--bs-btn-bg);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .btn {\n    transition: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .btn:hover {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n}\n.btn-check + .sabpaisa-css-utils-classes-version-five .btn:hover {\n  color: var(--bs-btn-color);\n  background-color: var(--bs-btn-bg);\n  border-color: var(--bs-btn-border-color);\n}\n.sabpaisa-css-utils-classes-version-five .btn:focus-visible {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:focus-visible + .sabpaisa-css-utils-classes-version-five .btn {\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:checked + .sabpaisa-css-utils-classes-version-five .btn, :not(.btn-check) + .sabpaisa-css-utils-classes-version-five .btn:active, .sabpaisa-css-utils-classes-version-five .btn:first-child:active, .sabpaisa-css-utils-classes-version-five .btn.active, .sabpaisa-css-utils-classes-version-five .btn.show {\n  color: var(--bs-btn-active-color);\n  background-color: var(--bs-btn-active-bg);\n  border-color: var(--bs-btn-active-border-color);\n}\n.btn-check:checked + .sabpaisa-css-utils-classes-version-five .btn:focus-visible, :not(.btn-check) + .sabpaisa-css-utils-classes-version-five .btn:active:focus-visible, .sabpaisa-css-utils-classes-version-five .btn:first-child:active:focus-visible, .sabpaisa-css-utils-classes-version-five .btn.active:focus-visible, .sabpaisa-css-utils-classes-version-five .btn.show:focus-visible {\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.sabpaisa-css-utils-classes-version-five .btn:disabled, .sabpaisa-css-utils-classes-version-five .btn.disabled, fieldset:disabled .sabpaisa-css-utils-classes-version-five .btn {\n  color: var(--bs-btn-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-btn-disabled-bg);\n  border-color: var(--bs-btn-disabled-border-color);\n  opacity: var(--bs-btn-disabled-opacity);\n}\n.sabpaisa-css-utils-classes-version-five .btn-primary {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #0d6efd;\n  --bs-btn-border-color: #0d6efd;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #0b5ed7;\n  --bs-btn-hover-border-color: #0a58ca;\n  --bs-btn-focus-shadow-rgb: 49, 132, 253;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #0a58ca;\n  --bs-btn-active-border-color: #0a53be;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #0d6efd;\n  --bs-btn-disabled-border-color: #0d6efd;\n}\n.sabpaisa-css-utils-classes-version-five .btn-secondary {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #6c757d;\n  --bs-btn-border-color: #6c757d;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #5c636a;\n  --bs-btn-hover-border-color: #565e64;\n  --bs-btn-focus-shadow-rgb: 130, 138, 145;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #565e64;\n  --bs-btn-active-border-color: #51585e;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #6c757d;\n  --bs-btn-disabled-border-color: #6c757d;\n}\n.sabpaisa-css-utils-classes-version-five .btn-success {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #198754;\n  --bs-btn-border-color: #198754;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #157347;\n  --bs-btn-hover-border-color: #146c43;\n  --bs-btn-focus-shadow-rgb: 60, 153, 110;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #146c43;\n  --bs-btn-active-border-color: #13653f;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #198754;\n  --bs-btn-disabled-border-color: #198754;\n}\n.sabpaisa-css-utils-classes-version-five .btn-info {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #0dcaf0;\n  --bs-btn-border-color: #0dcaf0;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #31d2f2;\n  --bs-btn-hover-border-color: #25cff2;\n  --bs-btn-focus-shadow-rgb: 11, 172, 204;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #3dd5f3;\n  --bs-btn-active-border-color: #25cff2;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #0dcaf0;\n  --bs-btn-disabled-border-color: #0dcaf0;\n}\n.sabpaisa-css-utils-classes-version-five .btn-warning {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #ffc107;\n  --bs-btn-border-color: #ffc107;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #ffca2c;\n  --bs-btn-hover-border-color: #ffc720;\n  --bs-btn-focus-shadow-rgb: 217, 164, 6;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #ffcd39;\n  --bs-btn-active-border-color: #ffc720;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #ffc107;\n  --bs-btn-disabled-border-color: #ffc107;\n}\n.sabpaisa-css-utils-classes-version-five .btn-danger {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #dc3545;\n  --bs-btn-border-color: #dc3545;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #bb2d3b;\n  --bs-btn-hover-border-color: #b02a37;\n  --bs-btn-focus-shadow-rgb: 225, 83, 97;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #b02a37;\n  --bs-btn-active-border-color: #a52834;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #dc3545;\n  --bs-btn-disabled-border-color: #dc3545;\n}\n.sabpaisa-css-utils-classes-version-five .btn-light {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #f8f9fa;\n  --bs-btn-border-color: #f8f9fa;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #d3d4d5;\n  --bs-btn-hover-border-color: #c6c7c8;\n  --bs-btn-focus-shadow-rgb: 211, 212, 213;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #c6c7c8;\n  --bs-btn-active-border-color: #babbbc;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #f8f9fa;\n  --bs-btn-disabled-border-color: #f8f9fa;\n}\n.sabpaisa-css-utils-classes-version-five .btn-dark {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #212529;\n  --bs-btn-border-color: #212529;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #424649;\n  --bs-btn-hover-border-color: #373b3e;\n  --bs-btn-focus-shadow-rgb: 66, 70, 73;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #4d5154;\n  --bs-btn-active-border-color: #373b3e;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #212529;\n  --bs-btn-disabled-border-color: #212529;\n}\n.sabpaisa-css-utils-classes-version-five .btn-outline-primary {\n  --bs-btn-color: #0d6efd;\n  --bs-btn-border-color: #0d6efd;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #0d6efd;\n  --bs-btn-hover-border-color: #0d6efd;\n  --bs-btn-focus-shadow-rgb: 13, 110, 253;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #0d6efd;\n  --bs-btn-active-border-color: #0d6efd;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #0d6efd;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #0d6efd;\n  --bs-gradient: none;\n}\n.sabpaisa-css-utils-classes-version-five .btn-outline-secondary {\n  --bs-btn-color: #6c757d;\n  --bs-btn-border-color: #6c757d;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #6c757d;\n  --bs-btn-hover-border-color: #6c757d;\n  --bs-btn-focus-shadow-rgb: 108, 117, 125;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #6c757d;\n  --bs-btn-active-border-color: #6c757d;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #6c757d;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #6c757d;\n  --bs-gradient: none;\n}\n.sabpaisa-css-utils-classes-version-five .btn-outline-success {\n  --bs-btn-color: #198754;\n  --bs-btn-border-color: #198754;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #198754;\n  --bs-btn-hover-border-color: #198754;\n  --bs-btn-focus-shadow-rgb: 25, 135, 84;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #198754;\n  --bs-btn-active-border-color: #198754;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #198754;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #198754;\n  --bs-gradient: none;\n}\n.sabpaisa-css-utils-classes-version-five .btn-outline-info {\n  --bs-btn-color: #0dcaf0;\n  --bs-btn-border-color: #0dcaf0;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #0dcaf0;\n  --bs-btn-hover-border-color: #0dcaf0;\n  --bs-btn-focus-shadow-rgb: 13, 202, 240;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #0dcaf0;\n  --bs-btn-active-border-color: #0dcaf0;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #0dcaf0;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #0dcaf0;\n  --bs-gradient: none;\n}\n.sabpaisa-css-utils-classes-version-five .btn-outline-warning {\n  --bs-btn-color: #ffc107;\n  --bs-btn-border-color: #ffc107;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #ffc107;\n  --bs-btn-hover-border-color: #ffc107;\n  --bs-btn-focus-shadow-rgb: 255, 193, 7;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #ffc107;\n  --bs-btn-active-border-color: #ffc107;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffc107;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ffc107;\n  --bs-gradient: none;\n}\n.sabpaisa-css-utils-classes-version-five .btn-outline-danger {\n  --bs-btn-color: #dc3545;\n  --bs-btn-border-color: #dc3545;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #dc3545;\n  --bs-btn-hover-border-color: #dc3545;\n  --bs-btn-focus-shadow-rgb: 220, 53, 69;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #dc3545;\n  --bs-btn-active-border-color: #dc3545;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #dc3545;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #dc3545;\n  --bs-gradient: none;\n}\n.sabpaisa-css-utils-classes-version-five .btn-outline-light {\n  --bs-btn-color: #f8f9fa;\n  --bs-btn-border-color: #f8f9fa;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #f8f9fa;\n  --bs-btn-hover-border-color: #f8f9fa;\n  --bs-btn-focus-shadow-rgb: 248, 249, 250;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #f8f9fa;\n  --bs-btn-active-border-color: #f8f9fa;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #f8f9fa;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #f8f9fa;\n  --bs-gradient: none;\n}\n.sabpaisa-css-utils-classes-version-five .btn-outline-dark {\n  --bs-btn-color: #212529;\n  --bs-btn-border-color: #212529;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #212529;\n  --bs-btn-hover-border-color: #212529;\n  --bs-btn-focus-shadow-rgb: 33, 37, 41;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #212529;\n  --bs-btn-active-border-color: #212529;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #212529;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #212529;\n  --bs-gradient: none;\n}\n.sabpaisa-css-utils-classes-version-five .btn-link {\n  --bs-btn-font-weight: 400;\n  --bs-btn-color: var(--bs-link-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: transparent;\n  --bs-btn-hover-color: var(--bs-link-hover-color);\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-active-color: var(--bs-link-hover-color);\n  --bs-btn-active-border-color: transparent;\n  --bs-btn-disabled-color: #6c757d;\n  --bs-btn-disabled-border-color: transparent;\n  --bs-btn-box-shadow: none;\n  --bs-btn-focus-shadow-rgb: 49, 132, 253;\n  text-decoration: underline;\n}\n.sabpaisa-css-utils-classes-version-five .btn-link:focus-visible {\n  color: var(--bs-btn-color);\n}\n.sabpaisa-css-utils-classes-version-five .btn-link:hover {\n  color: var(--bs-btn-hover-color);\n}\n.sabpaisa-css-utils-classes-version-five .btn-lg, .sabpaisa-css-utils-classes-version-five .btn-group-lg > .btn {\n  --bs-btn-padding-y: 0.5rem;\n  --bs-btn-padding-x: 1rem;\n  --bs-btn-font-size: 1.25rem;\n  --bs-btn-border-radius: 0.5rem;\n}\n.sabpaisa-css-utils-classes-version-five .btn-sm, .sabpaisa-css-utils-classes-version-five .btn-group-sm > .btn {\n  --bs-btn-padding-y: 0.25rem;\n  --bs-btn-padding-x: 0.5rem;\n  --bs-btn-font-size: 0.875rem;\n  --bs-btn-border-radius: 0.25rem;\n}\n.sabpaisa-css-utils-classes-version-five .fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .fade {\n    transition: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .fade:not(.show) {\n  opacity: 0;\n}\n.sabpaisa-css-utils-classes-version-five .collapse:not(.show) {\n  display: none;\n}\n.sabpaisa-css-utils-classes-version-five .collapsing {\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .collapsing {\n    transition: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .collapsing.collapse-horizontal {\n  width: 0;\n  height: auto;\n  transition: width 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .collapsing.collapse-horizontal {\n    transition: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .dropup,\n.sabpaisa-css-utils-classes-version-five .dropend,\n.sabpaisa-css-utils-classes-version-five .dropdown,\n.sabpaisa-css-utils-classes-version-five .dropstart,\n.sabpaisa-css-utils-classes-version-five .dropup-center,\n.sabpaisa-css-utils-classes-version-five .dropdown-center {\n  position: relative;\n}\n.sabpaisa-css-utils-classes-version-five .dropdown-toggle {\n  white-space: nowrap;\n}\n.sabpaisa-css-utils-classes-version-five .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.sabpaisa-css-utils-classes-version-five .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.sabpaisa-css-utils-classes-version-five .dropdown-menu {\n  --bs-dropdown-zindex: 1000;\n  --bs-dropdown-min-width: 10rem;\n  --bs-dropdown-padding-x: 0;\n  --bs-dropdown-padding-y: 0.5rem;\n  --bs-dropdown-spacer: 0.125rem;\n  --bs-dropdown-font-size: 1rem;\n  --bs-dropdown-color: #212529;\n  --bs-dropdown-bg: #fff;\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-border-radius: 0.375rem;\n  --bs-dropdown-border-width: 1px;\n  --bs-dropdown-inner-border-radius: calc(0.375rem - 1px);\n  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n  --bs-dropdown-divider-margin-y: 0.5rem;\n  --bs-dropdown-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  --bs-dropdown-link-color: #212529;\n  --bs-dropdown-link-hover-color: #1e2125;\n  --bs-dropdown-link-hover-bg: #e9ecef;\n  --bs-dropdown-link-active-color: #fff;\n  --bs-dropdown-link-active-bg: #0d6efd;\n  --bs-dropdown-link-disabled-color: #adb5bd;\n  --bs-dropdown-item-padding-x: 1rem;\n  --bs-dropdown-item-padding-y: 0.25rem;\n  --bs-dropdown-header-color: #6c757d;\n  --bs-dropdown-header-padding-x: 1rem;\n  --bs-dropdown-header-padding-y: 0.5rem;\n  position: absolute;\n  z-index: var(--bs-dropdown-zindex);\n  display: none;\n  min-width: var(--bs-dropdown-min-width);\n  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);\n  margin: 0;\n  font-size: var(--bs-dropdown-font-size);\n  color: var(--bs-dropdown-color);\n  text-align: left;\n  list-style: none;\n  background-color: var(--bs-dropdown-bg);\n  background-clip: padding-box;\n  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);\n  border-radius: var(--bs-dropdown-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .dropdown-menu[data-bs-popper] {\n  top: 100%;\n  left: 0;\n  margin-top: var(--bs-dropdown-spacer);\n}\n.sabpaisa-css-utils-classes-version-five .dropdown-menu-start {\n  --bs-position: start;\n}\n.sabpaisa-css-utils-classes-version-five .dropdown-menu-start[data-bs-popper] {\n  right: auto;\n  left: 0;\n}\n.sabpaisa-css-utils-classes-version-five .dropdown-menu-end {\n  --bs-position: end;\n}\n.sabpaisa-css-utils-classes-version-five .dropdown-menu-end[data-bs-popper] {\n  right: 0;\n  left: auto;\n}\n@media (min-width: 576px) {\n  .sabpaisa-css-utils-classes-version-five .dropdown-menu-sm-start {\n    --bs-position: start;\n  }\n  .sabpaisa-css-utils-classes-version-five .dropdown-menu-sm-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .dropdown-menu-sm-end {\n    --bs-position: end;\n  }\n  .sabpaisa-css-utils-classes-version-five .dropdown-menu-sm-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 768px) {\n  .sabpaisa-css-utils-classes-version-five .dropdown-menu-md-start {\n    --bs-position: start;\n  }\n  .sabpaisa-css-utils-classes-version-five .dropdown-menu-md-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .dropdown-menu-md-end {\n    --bs-position: end;\n  }\n  .sabpaisa-css-utils-classes-version-five .dropdown-menu-md-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 992px) {\n  .sabpaisa-css-utils-classes-version-five .dropdown-menu-lg-start {\n    --bs-position: start;\n  }\n  .sabpaisa-css-utils-classes-version-five .dropdown-menu-lg-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .dropdown-menu-lg-end {\n    --bs-position: end;\n  }\n  .sabpaisa-css-utils-classes-version-five .dropdown-menu-lg-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .sabpaisa-css-utils-classes-version-five .dropdown-menu-xl-start {\n    --bs-position: start;\n  }\n  .sabpaisa-css-utils-classes-version-five .dropdown-menu-xl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .dropdown-menu-xl-end {\n    --bs-position: end;\n  }\n  .sabpaisa-css-utils-classes-version-five .dropdown-menu-xl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1400px) {\n  .sabpaisa-css-utils-classes-version-five .dropdown-menu-xxl-start {\n    --bs-position: start;\n  }\n  .sabpaisa-css-utils-classes-version-five .dropdown-menu-xxl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .dropdown-menu-xxl-end {\n    --bs-position: end;\n  }\n  .sabpaisa-css-utils-classes-version-five .dropdown-menu-xxl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .dropup .dropdown-menu[data-bs-popper] {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: var(--bs-dropdown-spacer);\n}\n.sabpaisa-css-utils-classes-version-five .dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n.sabpaisa-css-utils-classes-version-five .dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.sabpaisa-css-utils-classes-version-five .dropend .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: var(--bs-dropdown-spacer);\n}\n.sabpaisa-css-utils-classes-version-five .dropend .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n.sabpaisa-css-utils-classes-version-five .dropend .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.sabpaisa-css-utils-classes-version-five .dropend .dropdown-toggle::after {\n  vertical-align: 0;\n}\n.sabpaisa-css-utils-classes-version-five .dropstart .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: var(--bs-dropdown-spacer);\n}\n.sabpaisa-css-utils-classes-version-five .dropstart .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n.sabpaisa-css-utils-classes-version-five .dropstart .dropdown-toggle::after {\n  display: none;\n}\n.sabpaisa-css-utils-classes-version-five .dropstart .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n.sabpaisa-css-utils-classes-version-five .dropstart .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.sabpaisa-css-utils-classes-version-five .dropstart .dropdown-toggle::before {\n  vertical-align: 0;\n}\n.sabpaisa-css-utils-classes-version-five .dropdown-divider {\n  height: 0;\n  margin: var(--bs-dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--bs-dropdown-divider-bg);\n  opacity: 1;\n}\n.sabpaisa-css-utils-classes-version-five .dropdown-item {\n  display: block;\n  width: 100%;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  clear: both;\n  font-weight: 400;\n  color: var(--bs-dropdown-link-color);\n  text-align: inherit;\n  text-decoration: none;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n}\n.sabpaisa-css-utils-classes-version-five .dropdown-item:hover, .sabpaisa-css-utils-classes-version-five .dropdown-item:focus {\n  color: var(--bs-dropdown-link-hover-color);\n  background-color: var(--bs-dropdown-link-hover-bg);\n}\n.sabpaisa-css-utils-classes-version-five .dropdown-item.active, .sabpaisa-css-utils-classes-version-five .dropdown-item:active {\n  color: var(--bs-dropdown-link-active-color);\n  text-decoration: none;\n  background-color: var(--bs-dropdown-link-active-bg);\n}\n.sabpaisa-css-utils-classes-version-five .dropdown-item.disabled, .sabpaisa-css-utils-classes-version-five .dropdown-item:disabled {\n  color: var(--bs-dropdown-link-disabled-color);\n  pointer-events: none;\n  background-color: transparent;\n}\n.sabpaisa-css-utils-classes-version-five .dropdown-menu.show {\n  display: block;\n}\n.sabpaisa-css-utils-classes-version-five .dropdown-header {\n  display: block;\n  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  color: var(--bs-dropdown-header-color);\n  white-space: nowrap;\n}\n.sabpaisa-css-utils-classes-version-five .dropdown-item-text {\n  display: block;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  color: var(--bs-dropdown-link-color);\n}\n.sabpaisa-css-utils-classes-version-five .dropdown-menu-dark {\n  --bs-dropdown-color: #dee2e6;\n  --bs-dropdown-bg: #343a40;\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-box-shadow: ;\n  --bs-dropdown-link-color: #dee2e6;\n  --bs-dropdown-link-hover-color: #fff;\n  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);\n  --bs-dropdown-link-active-color: #fff;\n  --bs-dropdown-link-active-bg: #0d6efd;\n  --bs-dropdown-link-disabled-color: #adb5bd;\n  --bs-dropdown-header-color: #adb5bd;\n}\n.sabpaisa-css-utils-classes-version-five .btn-group,\n.sabpaisa-css-utils-classes-version-five .btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.sabpaisa-css-utils-classes-version-five .btn-group > .btn,\n.sabpaisa-css-utils-classes-version-five .btn-group-vertical > .btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n.sabpaisa-css-utils-classes-version-five .btn-group > .btn-check:checked + .btn,\n.sabpaisa-css-utils-classes-version-five .btn-group > .btn-check:focus + .btn,\n.sabpaisa-css-utils-classes-version-five .btn-group > .btn:hover,\n.sabpaisa-css-utils-classes-version-five .btn-group > .btn:focus,\n.sabpaisa-css-utils-classes-version-five .btn-group > .btn:active,\n.sabpaisa-css-utils-classes-version-five .btn-group > .btn.active,\n.sabpaisa-css-utils-classes-version-five .btn-group-vertical > .btn-check:checked + .btn,\n.sabpaisa-css-utils-classes-version-five .btn-group-vertical > .btn-check:focus + .btn,\n.sabpaisa-css-utils-classes-version-five .btn-group-vertical > .btn:hover,\n.sabpaisa-css-utils-classes-version-five .btn-group-vertical > .btn:focus,\n.sabpaisa-css-utils-classes-version-five .btn-group-vertical > .btn:active,\n.sabpaisa-css-utils-classes-version-five .btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n.sabpaisa-css-utils-classes-version-five .btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.sabpaisa-css-utils-classes-version-five .btn-toolbar .input-group {\n  width: auto;\n}\n.sabpaisa-css-utils-classes-version-five .btn-group {\n  border-radius: 0.375rem;\n}\n.sabpaisa-css-utils-classes-version-five .btn-group > :not(.btn-check:first-child) + .btn,\n.sabpaisa-css-utils-classes-version-five .btn-group > .btn-group:not(:first-child) {\n  margin-left: -1px;\n}\n.sabpaisa-css-utils-classes-version-five .btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.sabpaisa-css-utils-classes-version-five .btn-group > .btn.dropdown-toggle-split:first-child,\n.sabpaisa-css-utils-classes-version-five .btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.sabpaisa-css-utils-classes-version-five .btn-group > .btn:nth-child(n+3),\n.sabpaisa-css-utils-classes-version-five .btn-group > :not(.btn-check) + .btn,\n.sabpaisa-css-utils-classes-version-five .btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.sabpaisa-css-utils-classes-version-five .dropdown-toggle-split {\n  padding-right: 0.5625rem;\n  padding-left: 0.5625rem;\n}\n.sabpaisa-css-utils-classes-version-five .dropdown-toggle-split::after, .dropup .sabpaisa-css-utils-classes-version-five .dropdown-toggle-split::after, .dropend .sabpaisa-css-utils-classes-version-five .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n.dropstart .sabpaisa-css-utils-classes-version-five .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n.sabpaisa-css-utils-classes-version-five .btn-sm + .dropdown-toggle-split, .sabpaisa-css-utils-classes-version-five .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.375rem;\n  padding-left: 0.375rem;\n}\n.sabpaisa-css-utils-classes-version-five .btn-lg + .dropdown-toggle-split, .sabpaisa-css-utils-classes-version-five .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n.sabpaisa-css-utils-classes-version-five .btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.sabpaisa-css-utils-classes-version-five .btn-group-vertical > .btn,\n.sabpaisa-css-utils-classes-version-five .btn-group-vertical > .btn-group {\n  width: 100%;\n}\n.sabpaisa-css-utils-classes-version-five .btn-group-vertical > .btn:not(:first-child),\n.sabpaisa-css-utils-classes-version-five .btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: -1px;\n}\n.sabpaisa-css-utils-classes-version-five .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.sabpaisa-css-utils-classes-version-five .btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.sabpaisa-css-utils-classes-version-five .btn-group-vertical > .btn ~ .btn,\n.sabpaisa-css-utils-classes-version-five .btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.sabpaisa-css-utils-classes-version-five .nav {\n  --bs-nav-link-padding-x: 1rem;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-link-color);\n  --bs-nav-link-hover-color: var(--bs-link-hover-color);\n  --bs-nav-link-disabled-color: #6c757d;\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.sabpaisa-css-utils-classes-version-five .nav-link {\n  display: block;\n  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n  font-size: var(--bs-nav-link-font-size);\n  font-weight: var(--bs-nav-link-font-weight);\n  color: var(--bs-nav-link-color);\n  text-decoration: none;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .nav-link {\n    transition: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .nav-link:hover, .sabpaisa-css-utils-classes-version-five .nav-link:focus {\n  color: var(--bs-nav-link-hover-color);\n}\n.sabpaisa-css-utils-classes-version-five .nav-link.disabled {\n  color: var(--bs-nav-link-disabled-color);\n  pointer-events: none;\n  cursor: default;\n}\n.sabpaisa-css-utils-classes-version-five .nav-tabs {\n  --bs-nav-tabs-border-width: 1px;\n  --bs-nav-tabs-border-color: #dee2e6;\n  --bs-nav-tabs-border-radius: 0.375rem;\n  --bs-nav-tabs-link-hover-border-color: #e9ecef #e9ecef #dee2e6;\n  --bs-nav-tabs-link-active-color: #495057;\n  --bs-nav-tabs-link-active-bg: #fff;\n  --bs-nav-tabs-link-active-border-color: #dee2e6 #dee2e6 #fff;\n  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);\n}\n.sabpaisa-css-utils-classes-version-five .nav-tabs .nav-link {\n  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));\n  background: none;\n  border: var(--bs-nav-tabs-border-width) solid transparent;\n  border-top-left-radius: var(--bs-nav-tabs-border-radius);\n  border-top-right-radius: var(--bs-nav-tabs-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .nav-tabs .nav-link:hover, .sabpaisa-css-utils-classes-version-five .nav-tabs .nav-link:focus {\n  isolation: isolate;\n  border-color: var(--bs-nav-tabs-link-hover-border-color);\n}\n.sabpaisa-css-utils-classes-version-five .nav-tabs .nav-link.disabled, .sabpaisa-css-utils-classes-version-five .nav-tabs .nav-link:disabled {\n  color: var(--bs-nav-link-disabled-color);\n  background-color: transparent;\n  border-color: transparent;\n}\n.sabpaisa-css-utils-classes-version-five .nav-tabs .nav-link.active,\n.sabpaisa-css-utils-classes-version-five .nav-tabs .nav-item.show .nav-link {\n  color: var(--bs-nav-tabs-link-active-color);\n  background-color: var(--bs-nav-tabs-link-active-bg);\n  border-color: var(--bs-nav-tabs-link-active-border-color);\n}\n.sabpaisa-css-utils-classes-version-five .nav-tabs .dropdown-menu {\n  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.sabpaisa-css-utils-classes-version-five .nav-pills {\n  --bs-nav-pills-border-radius: 0.375rem;\n  --bs-nav-pills-link-active-color: #fff;\n  --bs-nav-pills-link-active-bg: #0d6efd;\n}\n.sabpaisa-css-utils-classes-version-five .nav-pills .nav-link {\n  background: none;\n  border: 0;\n  border-radius: var(--bs-nav-pills-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .nav-pills .nav-link:disabled {\n  color: var(--bs-nav-link-disabled-color);\n  background-color: transparent;\n  border-color: transparent;\n}\n.sabpaisa-css-utils-classes-version-five .nav-pills .nav-link.active,\n.sabpaisa-css-utils-classes-version-five .nav-pills .show > .nav-link {\n  color: var(--bs-nav-pills-link-active-color);\n  background-color: var(--bs-nav-pills-link-active-bg);\n}\n.sabpaisa-css-utils-classes-version-five .nav-fill > .nav-link,\n.sabpaisa-css-utils-classes-version-five .nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n.sabpaisa-css-utils-classes-version-five .nav-justified > .nav-link,\n.sabpaisa-css-utils-classes-version-five .nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n.sabpaisa-css-utils-classes-version-five .nav-fill .nav-item .nav-link,\n.sabpaisa-css-utils-classes-version-five .nav-justified .nav-item .nav-link {\n  width: 100%;\n}\n.sabpaisa-css-utils-classes-version-five .tab-content > .tab-pane {\n  display: none;\n}\n.sabpaisa-css-utils-classes-version-five .tab-content > .active {\n  display: block;\n}\n.sabpaisa-css-utils-classes-version-five .navbar {\n  --bs-navbar-padding-x: 0;\n  --bs-navbar-padding-y: 0.5rem;\n  --bs-navbar-color: rgba(0, 0, 0, 0.55);\n  --bs-navbar-hover-color: rgba(0, 0, 0, 0.7);\n  --bs-navbar-disabled-color: rgba(0, 0, 0, 0.3);\n  --bs-navbar-active-color: rgba(0, 0, 0, 0.9);\n  --bs-navbar-brand-padding-y: 0.3125rem;\n  --bs-navbar-brand-margin-end: 1rem;\n  --bs-navbar-brand-font-size: 1.25rem;\n  --bs-navbar-brand-color: rgba(0, 0, 0, 0.9);\n  --bs-navbar-brand-hover-color: rgba(0, 0, 0, 0.9);\n  --bs-navbar-nav-link-padding-x: 0.5rem;\n  --bs-navbar-toggler-padding-y: 0.25rem;\n  --bs-navbar-toggler-padding-x: 0.75rem;\n  --bs-navbar-toggler-font-size: 1.25rem;\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n  --bs-navbar-toggler-border-color: rgba(0, 0, 0, 0.1);\n  --bs-navbar-toggler-border-radius: 0.375rem;\n  --bs-navbar-toggler-focus-width: 0.25rem;\n  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);\n}\n.sabpaisa-css-utils-classes-version-five .navbar > .container,\n.sabpaisa-css-utils-classes-version-five .navbar > .container-fluid,\n.sabpaisa-css-utils-classes-version-five .navbar > .container-sm,\n.sabpaisa-css-utils-classes-version-five .navbar > .container-md,\n.sabpaisa-css-utils-classes-version-five .navbar > .container-lg,\n.sabpaisa-css-utils-classes-version-five .navbar > .container-xl,\n.sabpaisa-css-utils-classes-version-five .navbar > .container-xxl {\n  display: flex;\n  flex-wrap: inherit;\n  align-items: center;\n  justify-content: space-between;\n}\n.sabpaisa-css-utils-classes-version-five .navbar-brand {\n  padding-top: var(--bs-navbar-brand-padding-y);\n  padding-bottom: var(--bs-navbar-brand-padding-y);\n  margin-right: var(--bs-navbar-brand-margin-end);\n  font-size: var(--bs-navbar-brand-font-size);\n  color: var(--bs-navbar-brand-color);\n  text-decoration: none;\n  white-space: nowrap;\n}\n.sabpaisa-css-utils-classes-version-five .navbar-brand:hover, .sabpaisa-css-utils-classes-version-five .navbar-brand:focus {\n  color: var(--bs-navbar-brand-hover-color);\n}\n.sabpaisa-css-utils-classes-version-five .navbar-nav {\n  --bs-nav-link-padding-x: 0;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-navbar-color);\n  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.sabpaisa-css-utils-classes-version-five .navbar-nav .show > .nav-link,\n.sabpaisa-css-utils-classes-version-five .navbar-nav .nav-link.active {\n  color: var(--bs-navbar-active-color);\n}\n.sabpaisa-css-utils-classes-version-five .navbar-nav .dropdown-menu {\n  position: static;\n}\n.sabpaisa-css-utils-classes-version-five .navbar-text {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: var(--bs-navbar-color);\n}\n.sabpaisa-css-utils-classes-version-five .navbar-text a,\n.sabpaisa-css-utils-classes-version-five .navbar-text a:hover,\n.sabpaisa-css-utils-classes-version-five .navbar-text a:focus {\n  color: var(--bs-navbar-active-color);\n}\n.sabpaisa-css-utils-classes-version-five .navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center;\n}\n.sabpaisa-css-utils-classes-version-five .navbar-toggler {\n  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);\n  font-size: var(--bs-navbar-toggler-font-size);\n  line-height: 1;\n  color: var(--bs-navbar-color);\n  background-color: transparent;\n  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);\n  border-radius: var(--bs-navbar-toggler-border-radius);\n  transition: var(--bs-navbar-toggler-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .navbar-toggler {\n    transition: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .navbar-toggler:hover {\n  text-decoration: none;\n}\n.sabpaisa-css-utils-classes-version-five .navbar-toggler:focus {\n  text-decoration: none;\n  outline: 0;\n  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);\n}\n.sabpaisa-css-utils-classes-version-five .navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--bs-navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n.sabpaisa-css-utils-classes-version-five .navbar-nav-scroll {\n  max-height: var(--bs-scroll-height, 75vh);\n  overflow-y: auto;\n}\n@media (min-width: 576px) {\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-sm {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-sm .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-sm .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-sm .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-sm .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 768px) {\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-md {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-md .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-md .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-md .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-md .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 992px) {\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-lg {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-lg .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-lg .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-lg .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-lg .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-xl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-xl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-xl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-xl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-xl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-xxl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-xxl .navbar-nav {\n    flex-direction: row;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-xxl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-xxl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-xxl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-xxl .navbar-toggler {\n    display: none;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-xxl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-xxl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .sabpaisa-css-utils-classes-version-five .navbar-expand-xxl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .navbar-expand {\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n}\n.sabpaisa-css-utils-classes-version-five .navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n.sabpaisa-css-utils-classes-version-five .navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.sabpaisa-css-utils-classes-version-five .navbar-expand .navbar-nav .nav-link {\n  padding-right: var(--bs-navbar-nav-link-padding-x);\n  padding-left: var(--bs-navbar-nav-link-padding-x);\n}\n.sabpaisa-css-utils-classes-version-five .navbar-expand .navbar-nav-scroll {\n  overflow: visible;\n}\n.sabpaisa-css-utils-classes-version-five .navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n.sabpaisa-css-utils-classes-version-five .navbar-expand .navbar-toggler {\n  display: none;\n}\n.sabpaisa-css-utils-classes-version-five .navbar-expand .offcanvas {\n  position: static;\n  z-index: auto;\n  flex-grow: 1;\n  width: auto !important;\n  height: auto !important;\n  visibility: visible !important;\n  background-color: transparent !important;\n  border: 0 !important;\n  transform: none !important;\n  transition: none;\n}\n.sabpaisa-css-utils-classes-version-five .navbar-expand .offcanvas .offcanvas-header {\n  display: none;\n}\n.sabpaisa-css-utils-classes-version-five .navbar-expand .offcanvas .offcanvas-body {\n  display: flex;\n  flex-grow: 0;\n  padding: 0;\n  overflow-y: visible;\n}\n.sabpaisa-css-utils-classes-version-five .navbar-dark {\n  --bs-navbar-color: rgba(255, 255, 255, 0.55);\n  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);\n  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);\n  --bs-navbar-active-color: #fff;\n  --bs-navbar-brand-color: #fff;\n  --bs-navbar-brand-hover-color: #fff;\n  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n.sabpaisa-css-utils-classes-version-five .card {\n  --bs-card-spacer-y: 1rem;\n  --bs-card-spacer-x: 1rem;\n  --bs-card-title-spacer-y: 0.5rem;\n  --bs-card-border-width: 1px;\n  --bs-card-border-color: var(--bs-border-color-translucent);\n  --bs-card-border-radius: 0.375rem;\n  --bs-card-box-shadow: ;\n  --bs-card-inner-border-radius: calc(0.375rem - 1px);\n  --bs-card-cap-padding-y: 0.5rem;\n  --bs-card-cap-padding-x: 1rem;\n  --bs-card-cap-bg: rgba(0, 0, 0, 0.03);\n  --bs-card-cap-color: ;\n  --bs-card-height: ;\n  --bs-card-color: ;\n  --bs-card-bg: #fff;\n  --bs-card-img-overlay-padding: 1rem;\n  --bs-card-group-margin: 0.75rem;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  height: var(--bs-card-height);\n  word-wrap: break-word;\n  background-color: var(--bs-card-bg);\n  background-clip: border-box;\n  border: var(--bs-card-border-width) solid var(--bs-card-border-color);\n  border-radius: var(--bs-card-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n.sabpaisa-css-utils-classes-version-five .card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n.sabpaisa-css-utils-classes-version-five .card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .card > .card-header + .list-group,\n.sabpaisa-css-utils-classes-version-five .card > .list-group + .card-footer {\n  border-top: 0;\n}\n.sabpaisa-css-utils-classes-version-five .card-body {\n  flex: 1 1 auto;\n  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);\n  color: var(--bs-card-color);\n}\n.sabpaisa-css-utils-classes-version-five .card-title {\n  margin-bottom: var(--bs-card-title-spacer-y);\n}\n.sabpaisa-css-utils-classes-version-five .card-subtitle {\n  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));\n  margin-bottom: 0;\n}\n.sabpaisa-css-utils-classes-version-five .card-text:last-child {\n  margin-bottom: 0;\n}\n.sabpaisa-css-utils-classes-version-five .card-link + .card-link {\n  margin-left: var(--bs-card-spacer-x);\n}\n.sabpaisa-css-utils-classes-version-five .card-header {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  margin-bottom: 0;\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.sabpaisa-css-utils-classes-version-five .card-header:first-child {\n  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;\n}\n.sabpaisa-css-utils-classes-version-five .card-footer {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.sabpaisa-css-utils-classes-version-five .card-footer:last-child {\n  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .card-header-tabs {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n  border-bottom: 0;\n}\n.sabpaisa-css-utils-classes-version-five .card-header-tabs .nav-link.active {\n  background-color: var(--bs-card-bg);\n  border-bottom-color: var(--bs-card-bg);\n}\n.sabpaisa-css-utils-classes-version-five .card-header-pills {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n}\n.sabpaisa-css-utils-classes-version-five .card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--bs-card-img-overlay-padding);\n  border-radius: var(--bs-card-inner-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .card-img,\n.sabpaisa-css-utils-classes-version-five .card-img-top,\n.sabpaisa-css-utils-classes-version-five .card-img-bottom {\n  width: 100%;\n}\n.sabpaisa-css-utils-classes-version-five .card-img,\n.sabpaisa-css-utils-classes-version-five .card-img-top {\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .card-img,\n.sabpaisa-css-utils-classes-version-five .card-img-bottom {\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .card-group > .card {\n  margin-bottom: var(--bs-card-group-margin);\n}\n@media (min-width: 576px) {\n  .sabpaisa-css-utils-classes-version-five .card-group {\n    display: flex;\n    flex-flow: row wrap;\n  }\n  .sabpaisa-css-utils-classes-version-five .card-group > .card {\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .card-group > .card:not(:last-child) .card-img-top,\n  .sabpaisa-css-utils-classes-version-five .card-group > .card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .card-group > .card:not(:last-child) .card-img-bottom,\n  .sabpaisa-css-utils-classes-version-five .card-group > .card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .card-group > .card:not(:first-child) .card-img-top,\n  .sabpaisa-css-utils-classes-version-five .card-group > .card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .card-group > .card:not(:first-child) .card-img-bottom,\n  .sabpaisa-css-utils-classes-version-five .card-group > .card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .accordion {\n  --bs-accordion-color: #212529;\n  --bs-accordion-bg: #fff;\n  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;\n  --bs-accordion-border-color: var(--bs-border-color);\n  --bs-accordion-border-width: 1px;\n  --bs-accordion-border-radius: 0.375rem;\n  --bs-accordion-inner-border-radius: calc(0.375rem - 1px);\n  --bs-accordion-btn-padding-x: 1.25rem;\n  --bs-accordion-btn-padding-y: 1rem;\n  --bs-accordion-btn-color: #212529;\n  --bs-accordion-btn-bg: var(--bs-accordion-bg);\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-icon-width: 1.25rem;\n  --bs-accordion-btn-icon-transform: rotate(-180deg);\n  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%230c63e4'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-focus-border-color: #86b7fe;\n  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n  --bs-accordion-body-padding-x: 1.25rem;\n  --bs-accordion-body-padding-y: 1rem;\n  --bs-accordion-active-color: #0c63e4;\n  --bs-accordion-active-bg: #e7f1ff;\n}\n.sabpaisa-css-utils-classes-version-five .accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);\n  font-size: 1rem;\n  color: var(--bs-accordion-btn-color);\n  text-align: left;\n  background-color: var(--bs-accordion-btn-bg);\n  border: 0;\n  border-radius: 0;\n  overflow-anchor: none;\n  transition: var(--bs-accordion-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .accordion-button {\n    transition: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .accordion-button:not(.collapsed) {\n  color: var(--bs-accordion-active-color);\n  background-color: var(--bs-accordion-active-bg);\n  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);\n}\n.sabpaisa-css-utils-classes-version-five .accordion-button:not(.collapsed)::after {\n  background-image: var(--bs-accordion-btn-active-icon);\n  transform: var(--bs-accordion-btn-icon-transform);\n}\n.sabpaisa-css-utils-classes-version-five .accordion-button::after {\n  flex-shrink: 0;\n  width: var(--bs-accordion-btn-icon-width);\n  height: var(--bs-accordion-btn-icon-width);\n  margin-left: auto;\n  content: \"\";\n  background-image: var(--bs-accordion-btn-icon);\n  background-repeat: no-repeat;\n  background-size: var(--bs-accordion-btn-icon-width);\n  transition: var(--bs-accordion-btn-icon-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .accordion-button::after {\n    transition: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .accordion-button:hover {\n  z-index: 2;\n}\n.sabpaisa-css-utils-classes-version-five .accordion-button:focus {\n  z-index: 3;\n  border-color: var(--bs-accordion-btn-focus-border-color);\n  outline: 0;\n  box-shadow: var(--bs-accordion-btn-focus-box-shadow);\n}\n.sabpaisa-css-utils-classes-version-five .accordion-header {\n  margin-bottom: 0;\n}\n.sabpaisa-css-utils-classes-version-five .accordion-item {\n  color: var(--bs-accordion-color);\n  background-color: var(--bs-accordion-bg);\n  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);\n}\n.sabpaisa-css-utils-classes-version-five .accordion-item:first-of-type {\n  border-top-left-radius: var(--bs-accordion-border-radius);\n  border-top-right-radius: var(--bs-accordion-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .accordion-item:first-of-type .accordion-button {\n  border-top-left-radius: var(--bs-accordion-inner-border-radius);\n  border-top-right-radius: var(--bs-accordion-inner-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .accordion-item:not(:first-of-type) {\n  border-top: 0;\n}\n.sabpaisa-css-utils-classes-version-five .accordion-item:last-of-type {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .accordion-item:last-of-type .accordion-button.collapsed {\n  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .accordion-item:last-of-type .accordion-collapse {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .accordion-body {\n  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);\n}\n.sabpaisa-css-utils-classes-version-five .accordion-flush .accordion-collapse {\n  border-width: 0;\n}\n.sabpaisa-css-utils-classes-version-five .accordion-flush .accordion-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n.sabpaisa-css-utils-classes-version-five .accordion-flush .accordion-item:first-child {\n  border-top: 0;\n}\n.sabpaisa-css-utils-classes-version-five .accordion-flush .accordion-item:last-child {\n  border-bottom: 0;\n}\n.sabpaisa-css-utils-classes-version-five .accordion-flush .accordion-item .accordion-button, .sabpaisa-css-utils-classes-version-five .accordion-flush .accordion-item .accordion-button.collapsed {\n  border-radius: 0;\n}\n.sabpaisa-css-utils-classes-version-five .breadcrumb {\n  --bs-breadcrumb-padding-x: 0;\n  --bs-breadcrumb-padding-y: 0;\n  --bs-breadcrumb-margin-bottom: 1rem;\n  --bs-breadcrumb-bg: ;\n  --bs-breadcrumb-border-radius: ;\n  --bs-breadcrumb-divider-color: #6c757d;\n  --bs-breadcrumb-item-padding-x: 0.5rem;\n  --bs-breadcrumb-item-active-color: #6c757d;\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);\n  margin-bottom: var(--bs-breadcrumb-margin-bottom);\n  font-size: var(--bs-breadcrumb-font-size);\n  list-style: none;\n  background-color: var(--bs-breadcrumb-bg);\n  border-radius: var(--bs-breadcrumb-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .breadcrumb-item + .breadcrumb-item {\n  padding-left: var(--bs-breadcrumb-item-padding-x);\n}\n.sabpaisa-css-utils-classes-version-five .breadcrumb-item + .breadcrumb-item::before {\n  float: left;\n  padding-right: var(--bs-breadcrumb-item-padding-x);\n  color: var(--bs-breadcrumb-divider-color);\n  content: var(--bs-breadcrumb-divider, \"/\") /* rtl: var(--bs-breadcrumb-divider, \"/\") */;\n}\n.sabpaisa-css-utils-classes-version-five .breadcrumb-item.active {\n  color: var(--bs-breadcrumb-item-active-color);\n}\n.sabpaisa-css-utils-classes-version-five .pagination {\n  --bs-pagination-padding-x: 0.75rem;\n  --bs-pagination-padding-y: 0.375rem;\n  --bs-pagination-font-size: 1rem;\n  --bs-pagination-color: var(--bs-link-color);\n  --bs-pagination-bg: #fff;\n  --bs-pagination-border-width: 1px;\n  --bs-pagination-border-color: #dee2e6;\n  --bs-pagination-border-radius: 0.375rem;\n  --bs-pagination-hover-color: var(--bs-link-hover-color);\n  --bs-pagination-hover-bg: #e9ecef;\n  --bs-pagination-hover-border-color: #dee2e6;\n  --bs-pagination-focus-color: var(--bs-link-hover-color);\n  --bs-pagination-focus-bg: #e9ecef;\n  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n  --bs-pagination-active-color: #fff;\n  --bs-pagination-active-bg: #0d6efd;\n  --bs-pagination-active-border-color: #0d6efd;\n  --bs-pagination-disabled-color: #6c757d;\n  --bs-pagination-disabled-bg: #fff;\n  --bs-pagination-disabled-border-color: #dee2e6;\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n.sabpaisa-css-utils-classes-version-five .page-link {\n  position: relative;\n  display: block;\n  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);\n  font-size: var(--bs-pagination-font-size);\n  color: var(--bs-pagination-color);\n  text-decoration: none;\n  background-color: var(--bs-pagination-bg);\n  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .page-link {\n    transition: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .page-link:hover {\n  z-index: 2;\n  color: var(--bs-pagination-hover-color);\n  background-color: var(--bs-pagination-hover-bg);\n  border-color: var(--bs-pagination-hover-border-color);\n}\n.sabpaisa-css-utils-classes-version-five .page-link:focus {\n  z-index: 3;\n  color: var(--bs-pagination-focus-color);\n  background-color: var(--bs-pagination-focus-bg);\n  outline: 0;\n  box-shadow: var(--bs-pagination-focus-box-shadow);\n}\n.sabpaisa-css-utils-classes-version-five .page-link.active, .active > .sabpaisa-css-utils-classes-version-five .page-link {\n  z-index: 3;\n  color: var(--bs-pagination-active-color);\n  background-color: var(--bs-pagination-active-bg);\n  border-color: var(--bs-pagination-active-border-color);\n}\n.sabpaisa-css-utils-classes-version-five .page-link.disabled, .disabled > .sabpaisa-css-utils-classes-version-five .page-link {\n  color: var(--bs-pagination-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-pagination-disabled-bg);\n  border-color: var(--bs-pagination-disabled-border-color);\n}\n.sabpaisa-css-utils-classes-version-five .page-item:not(:first-child) .page-link {\n  margin-left: -1px;\n}\n.sabpaisa-css-utils-classes-version-five .page-item:first-child .page-link {\n  border-top-left-radius: var(--bs-pagination-border-radius);\n  border-bottom-left-radius: var(--bs-pagination-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .page-item:last-child .page-link {\n  border-top-right-radius: var(--bs-pagination-border-radius);\n  border-bottom-right-radius: var(--bs-pagination-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .pagination-lg {\n  --bs-pagination-padding-x: 1.5rem;\n  --bs-pagination-padding-y: 0.75rem;\n  --bs-pagination-font-size: 1.25rem;\n  --bs-pagination-border-radius: 0.5rem;\n}\n.sabpaisa-css-utils-classes-version-five .pagination-sm {\n  --bs-pagination-padding-x: 0.5rem;\n  --bs-pagination-padding-y: 0.25rem;\n  --bs-pagination-font-size: 0.875rem;\n  --bs-pagination-border-radius: 0.25rem;\n}\n.sabpaisa-css-utils-classes-version-five .badge {\n  --bs-badge-padding-x: 0.65em;\n  --bs-badge-padding-y: 0.35em;\n  --bs-badge-font-size: 0.75em;\n  --bs-badge-font-weight: 700;\n  --bs-badge-color: #fff;\n  --bs-badge-border-radius: 0.375rem;\n  display: inline-block;\n  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);\n  font-size: var(--bs-badge-font-size);\n  font-weight: var(--bs-badge-font-weight);\n  line-height: 1;\n  color: var(--bs-badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: var(--bs-badge-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .badge:empty {\n  display: none;\n}\n.sabpaisa-css-utils-classes-version-five .btn .badge {\n  position: relative;\n  top: -1px;\n}\n.sabpaisa-css-utils-classes-version-five .alert {\n  --bs-alert-bg: transparent;\n  --bs-alert-padding-x: 1rem;\n  --bs-alert-padding-y: 1rem;\n  --bs-alert-margin-bottom: 1rem;\n  --bs-alert-color: inherit;\n  --bs-alert-border-color: transparent;\n  --bs-alert-border: 1px solid var(--bs-alert-border-color);\n  --bs-alert-border-radius: 0.375rem;\n  position: relative;\n  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);\n  margin-bottom: var(--bs-alert-margin-bottom);\n  color: var(--bs-alert-color);\n  background-color: var(--bs-alert-bg);\n  border: var(--bs-alert-border);\n  border-radius: var(--bs-alert-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .alert-heading {\n  color: inherit;\n}\n.sabpaisa-css-utils-classes-version-five .alert-link {\n  font-weight: 700;\n}\n.sabpaisa-css-utils-classes-version-five .alert-dismissible {\n  padding-right: 3rem;\n}\n.sabpaisa-css-utils-classes-version-five .alert-dismissible .btn-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 1.25rem 1rem;\n}\n.sabpaisa-css-utils-classes-version-five .alert-primary {\n  --bs-alert-color: #084298;\n  --bs-alert-bg: #cfe2ff;\n  --bs-alert-border-color: #b6d4fe;\n}\n.sabpaisa-css-utils-classes-version-five .alert-primary .alert-link {\n  color: #06357a;\n}\n.sabpaisa-css-utils-classes-version-five .alert-secondary {\n  --bs-alert-color: #41464b;\n  --bs-alert-bg: #e2e3e5;\n  --bs-alert-border-color: #d3d6d8;\n}\n.sabpaisa-css-utils-classes-version-five .alert-secondary .alert-link {\n  color: #34383c;\n}\n.sabpaisa-css-utils-classes-version-five .alert-success {\n  --bs-alert-color: #0f5132;\n  --bs-alert-bg: #d1e7dd;\n  --bs-alert-border-color: #badbcc;\n}\n.sabpaisa-css-utils-classes-version-five .alert-success .alert-link {\n  color: #0c4128;\n}\n.sabpaisa-css-utils-classes-version-five .alert-info {\n  --bs-alert-color: #055160;\n  --bs-alert-bg: #cff4fc;\n  --bs-alert-border-color: #b6effb;\n}\n.sabpaisa-css-utils-classes-version-five .alert-info .alert-link {\n  color: #04414d;\n}\n.sabpaisa-css-utils-classes-version-five .alert-warning {\n  --bs-alert-color: #664d03;\n  --bs-alert-bg: #fff3cd;\n  --bs-alert-border-color: #ffecb5;\n}\n.sabpaisa-css-utils-classes-version-five .alert-warning .alert-link {\n  color: #523e02;\n}\n.sabpaisa-css-utils-classes-version-five .alert-danger {\n  --bs-alert-color: #842029;\n  --bs-alert-bg: #f8d7da;\n  --bs-alert-border-color: #f5c2c7;\n}\n.sabpaisa-css-utils-classes-version-five .alert-danger .alert-link {\n  color: #6a1a21;\n}\n.sabpaisa-css-utils-classes-version-five .alert-light {\n  --bs-alert-color: #636464;\n  --bs-alert-bg: #fefefe;\n  --bs-alert-border-color: #fdfdfe;\n}\n.sabpaisa-css-utils-classes-version-five .alert-light .alert-link {\n  color: #4f5050;\n}\n.sabpaisa-css-utils-classes-version-five .alert-dark {\n  --bs-alert-color: #141619;\n  --bs-alert-bg: #d3d3d4;\n  --bs-alert-border-color: #bcbebf;\n}\n.sabpaisa-css-utils-classes-version-five .alert-dark .alert-link {\n  color: #101214;\n}\n@keyframes progress-bar-stripes {\n  0% {\n    background-position-x: 1rem;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .progress {\n  --bs-progress-height: 1rem;\n  --bs-progress-font-size: 0.75rem;\n  --bs-progress-bg: #e9ecef;\n  --bs-progress-border-radius: 0.375rem;\n  --bs-progress-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  --bs-progress-bar-color: #fff;\n  --bs-progress-bar-bg: #0d6efd;\n  --bs-progress-bar-transition: width 0.6s ease;\n  display: flex;\n  height: var(--bs-progress-height);\n  overflow: hidden;\n  font-size: var(--bs-progress-font-size);\n  background-color: var(--bs-progress-bg);\n  border-radius: var(--bs-progress-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--bs-progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-progress-bar-bg);\n  transition: var(--bs-progress-bar-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .progress-bar {\n    transition: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: var(--bs-progress-height) var(--bs-progress-height);\n}\n.sabpaisa-css-utils-classes-version-five .progress-bar-animated {\n  animation: 1s linear infinite progress-bar-stripes;\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .progress-bar-animated {\n    animation: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .list-group {\n  --bs-list-group-color: #212529;\n  --bs-list-group-bg: #fff;\n  --bs-list-group-border-color: rgba(0, 0, 0, 0.125);\n  --bs-list-group-border-width: 1px;\n  --bs-list-group-border-radius: 0.375rem;\n  --bs-list-group-item-padding-x: 1rem;\n  --bs-list-group-item-padding-y: 0.5rem;\n  --bs-list-group-action-color: #495057;\n  --bs-list-group-action-hover-color: #495057;\n  --bs-list-group-action-hover-bg: #f8f9fa;\n  --bs-list-group-action-active-color: #212529;\n  --bs-list-group-action-active-bg: #e9ecef;\n  --bs-list-group-disabled-color: #6c757d;\n  --bs-list-group-disabled-bg: #fff;\n  --bs-list-group-active-color: #fff;\n  --bs-list-group-active-bg: #0d6efd;\n  --bs-list-group-active-border-color: #0d6efd;\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: var(--bs-list-group-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-numbered > .list-group-item::before {\n  content: counters(section, \".\") \". \";\n  counter-increment: section;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-action {\n  width: 100%;\n  color: var(--bs-list-group-action-color);\n  text-align: inherit;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-action:hover, .sabpaisa-css-utils-classes-version-five .list-group-item-action:focus {\n  z-index: 1;\n  color: var(--bs-list-group-action-hover-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-action-hover-bg);\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-action:active {\n  color: var(--bs-list-group-action-active-color);\n  background-color: var(--bs-list-group-action-active-bg);\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);\n  color: var(--bs-list-group-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-bg);\n  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item.disabled, .sabpaisa-css-utils-classes-version-five .list-group-item:disabled {\n  color: var(--bs-list-group-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-list-group-disabled-bg);\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item.active {\n  z-index: 2;\n  color: var(--bs-list-group-active-color);\n  background-color: var(--bs-list-group-active-bg);\n  border-color: var(--bs-list-group-active-border-color);\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item + .list-group-item {\n  border-top-width: 0;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item + .list-group-item.active {\n  margin-top: calc(-1 * var(--bs-list-group-border-width));\n  border-top-width: var(--bs-list-group-border-width);\n}\n.sabpaisa-css-utils-classes-version-five .list-group-horizontal {\n  flex-direction: row;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-horizontal > .list-group-item:first-child:not(:last-child) {\n  border-bottom-left-radius: var(--bs-list-group-border-radius);\n  border-top-right-radius: 0;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-horizontal > .list-group-item:last-child:not(:first-child) {\n  border-top-right-radius: var(--bs-list-group-border-radius);\n  border-bottom-left-radius: 0;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-horizontal > .list-group-item.active {\n  margin-top: 0;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-horizontal > .list-group-item + .list-group-item {\n  border-top-width: var(--bs-list-group-border-width);\n  border-left-width: 0;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-horizontal > .list-group-item + .list-group-item.active {\n  margin-left: calc(-1 * var(--bs-list-group-border-width));\n  border-left-width: var(--bs-list-group-border-width);\n}\n@media (min-width: 576px) {\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-sm > .list-group-item.active {\n    margin-top: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-sm > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 768px) {\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-md {\n    flex-direction: row;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-md > .list-group-item.active {\n    margin-top: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-md > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 992px) {\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-lg > .list-group-item.active {\n    margin-top: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-lg > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1200px) {\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-xl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-xl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1400px) {\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-xxl {\n    flex-direction: row;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-xxl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-xxl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n.sabpaisa-css-utils-classes-version-five .list-group-flush {\n  border-radius: 0;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-flush > .list-group-item {\n  border-width: 0 0 var(--bs-list-group-border-width);\n}\n.sabpaisa-css-utils-classes-version-five .list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 0;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-primary {\n  color: #084298;\n  background-color: #cfe2ff;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-primary.list-group-item-action:hover, .sabpaisa-css-utils-classes-version-five .list-group-item-primary.list-group-item-action:focus {\n  color: #084298;\n  background-color: #bacbe6;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-primary.list-group-item-action.active {\n  color: #fff;\n  background-color: #084298;\n  border-color: #084298;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-secondary {\n  color: #41464b;\n  background-color: #e2e3e5;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-secondary.list-group-item-action:hover, .sabpaisa-css-utils-classes-version-five .list-group-item-secondary.list-group-item-action:focus {\n  color: #41464b;\n  background-color: #cbccce;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-secondary.list-group-item-action.active {\n  color: #fff;\n  background-color: #41464b;\n  border-color: #41464b;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-success {\n  color: #0f5132;\n  background-color: #d1e7dd;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-success.list-group-item-action:hover, .sabpaisa-css-utils-classes-version-five .list-group-item-success.list-group-item-action:focus {\n  color: #0f5132;\n  background-color: #bcd0c7;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-success.list-group-item-action.active {\n  color: #fff;\n  background-color: #0f5132;\n  border-color: #0f5132;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-info {\n  color: #055160;\n  background-color: #cff4fc;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-info.list-group-item-action:hover, .sabpaisa-css-utils-classes-version-five .list-group-item-info.list-group-item-action:focus {\n  color: #055160;\n  background-color: #badce3;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-info.list-group-item-action.active {\n  color: #fff;\n  background-color: #055160;\n  border-color: #055160;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-warning {\n  color: #664d03;\n  background-color: #fff3cd;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-warning.list-group-item-action:hover, .sabpaisa-css-utils-classes-version-five .list-group-item-warning.list-group-item-action:focus {\n  color: #664d03;\n  background-color: #e6dbb9;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-warning.list-group-item-action.active {\n  color: #fff;\n  background-color: #664d03;\n  border-color: #664d03;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-danger {\n  color: #842029;\n  background-color: #f8d7da;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-danger.list-group-item-action:hover, .sabpaisa-css-utils-classes-version-five .list-group-item-danger.list-group-item-action:focus {\n  color: #842029;\n  background-color: #dfc2c4;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-danger.list-group-item-action.active {\n  color: #fff;\n  background-color: #842029;\n  border-color: #842029;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-light {\n  color: #636464;\n  background-color: #fefefe;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-light.list-group-item-action:hover, .sabpaisa-css-utils-classes-version-five .list-group-item-light.list-group-item-action:focus {\n  color: #636464;\n  background-color: #e5e5e5;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-light.list-group-item-action.active {\n  color: #fff;\n  background-color: #636464;\n  border-color: #636464;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-dark {\n  color: #141619;\n  background-color: #d3d3d4;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-dark.list-group-item-action:hover, .sabpaisa-css-utils-classes-version-five .list-group-item-dark.list-group-item-action:focus {\n  color: #141619;\n  background-color: #bebebf;\n}\n.sabpaisa-css-utils-classes-version-five .list-group-item-dark.list-group-item-action.active {\n  color: #fff;\n  background-color: #141619;\n  border-color: #141619;\n}\n.sabpaisa-css-utils-classes-version-five .btn-close {\n  box-sizing: content-box;\n  width: 1em;\n  height: 1em;\n  padding: 0.25em 0.25em;\n  color: #000;\n  background: transparent url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\") center/1em auto no-repeat;\n  border: 0;\n  border-radius: 0.375rem;\n  opacity: 0.5;\n}\n.sabpaisa-css-utils-classes-version-five .btn-close:hover {\n  color: #000;\n  text-decoration: none;\n  opacity: 0.75;\n}\n.sabpaisa-css-utils-classes-version-five .btn-close:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n  opacity: 1;\n}\n.sabpaisa-css-utils-classes-version-five .btn-close:disabled, .sabpaisa-css-utils-classes-version-five .btn-close.disabled {\n  pointer-events: none;\n  user-select: none;\n  opacity: 0.25;\n}\n.sabpaisa-css-utils-classes-version-five .btn-close-white {\n  filter: invert(1) grayscale(100%) brightness(200%);\n}\n.sabpaisa-css-utils-classes-version-five .toast {\n  --bs-toast-zindex: 1090;\n  --bs-toast-padding-x: 0.75rem;\n  --bs-toast-padding-y: 0.5rem;\n  --bs-toast-spacing: 1.5rem;\n  --bs-toast-max-width: 350px;\n  --bs-toast-font-size: 0.875rem;\n  --bs-toast-color: ;\n  --bs-toast-bg: rgba(255, 255, 255, 0.85);\n  --bs-toast-border-width: 1px;\n  --bs-toast-border-color: var(--bs-border-color-translucent);\n  --bs-toast-border-radius: 0.375rem;\n  --bs-toast-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  --bs-toast-header-color: #6c757d;\n  --bs-toast-header-bg: rgba(255, 255, 255, 0.85);\n  --bs-toast-header-border-color: rgba(0, 0, 0, 0.05);\n  width: var(--bs-toast-max-width);\n  max-width: 100%;\n  font-size: var(--bs-toast-font-size);\n  color: var(--bs-toast-color);\n  pointer-events: auto;\n  background-color: var(--bs-toast-bg);\n  background-clip: padding-box;\n  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);\n  box-shadow: var(--bs-toast-box-shadow);\n  border-radius: var(--bs-toast-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .toast.showing {\n  opacity: 0;\n}\n.sabpaisa-css-utils-classes-version-five .toast:not(.show) {\n  display: none;\n}\n.sabpaisa-css-utils-classes-version-five .toast-container {\n  --bs-toast-zindex: 1090;\n  position: absolute;\n  z-index: var(--bs-toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n}\n.sabpaisa-css-utils-classes-version-five .toast-container > :not(:last-child) {\n  margin-bottom: var(--bs-toast-spacing);\n}\n.sabpaisa-css-utils-classes-version-five .toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);\n  color: var(--bs-toast-header-color);\n  background-color: var(--bs-toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);\n  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n}\n.sabpaisa-css-utils-classes-version-five .toast-header .btn-close {\n  margin-right: calc(-0.5 * var(--bs-toast-padding-x));\n  margin-left: var(--bs-toast-padding-x);\n}\n.sabpaisa-css-utils-classes-version-five .toast-body {\n  padding: var(--bs-toast-padding-x);\n  word-wrap: break-word;\n}\n.sabpaisa-css-utils-classes-version-five .modal {\n  --bs-modal-zindex: 1055;\n  --bs-modal-width: 500px;\n  --bs-modal-padding: 1rem;\n  --bs-modal-margin: 0.5rem;\n  --bs-modal-color: ;\n  --bs-modal-bg: #fff;\n  --bs-modal-border-color: var(--bs-border-color-translucent);\n  --bs-modal-border-width: 1px;\n  --bs-modal-border-radius: 0.5rem;\n  --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n  --bs-modal-inner-border-radius: calc(0.5rem - 1px);\n  --bs-modal-header-padding-x: 1rem;\n  --bs-modal-header-padding-y: 1rem;\n  --bs-modal-header-padding: 1rem 1rem;\n  --bs-modal-header-border-color: var(--bs-border-color);\n  --bs-modal-header-border-width: 1px;\n  --bs-modal-title-line-height: 1.5;\n  --bs-modal-footer-gap: 0.5rem;\n  --bs-modal-footer-bg: ;\n  --bs-modal-footer-border-color: var(--bs-border-color);\n  --bs-modal-footer-border-width: 1px;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n}\n.sabpaisa-css-utils-classes-version-five .modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--bs-modal-margin);\n  pointer-events: none;\n}\n.modal.fade .sabpaisa-css-utils-classes-version-five .modal-dialog {\n  transition: transform 0.3s ease-out;\n  transform: translate(0, -50px);\n}\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .sabpaisa-css-utils-classes-version-five .modal-dialog {\n    transition: none;\n  }\n}\n.modal.show .sabpaisa-css-utils-classes-version-five .modal-dialog {\n  transform: none;\n}\n.modal.modal-static .sabpaisa-css-utils-classes-version-five .modal-dialog {\n  transform: scale(1.02);\n}\n.sabpaisa-css-utils-classes-version-five .modal-dialog-scrollable {\n  height: calc(100% - var(--bs-modal-margin) * 2);\n}\n.sabpaisa-css-utils-classes-version-five .modal-dialog-scrollable .modal-content {\n  max-height: 100%;\n  overflow: hidden;\n}\n.sabpaisa-css-utils-classes-version-five .modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n.sabpaisa-css-utils-classes-version-five .modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--bs-modal-margin) * 2);\n}\n.sabpaisa-css-utils-classes-version-five .modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  color: var(--bs-modal-color);\n  pointer-events: auto;\n  background-color: var(--bs-modal-bg);\n  background-clip: padding-box;\n  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);\n  border-radius: var(--bs-modal-border-radius);\n  outline: 0;\n}\n.sabpaisa-css-utils-classes-version-five .modal-backdrop {\n  --bs-backdrop-zindex: 1050;\n  --bs-backdrop-bg: #000;\n  --bs-backdrop-opacity: 0.5;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-backdrop-zindex);\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--bs-backdrop-bg);\n}\n.sabpaisa-css-utils-classes-version-five .modal-backdrop.fade {\n  opacity: 0;\n}\n.sabpaisa-css-utils-classes-version-five .modal-backdrop.show {\n  opacity: var(--bs-backdrop-opacity);\n}\n.sabpaisa-css-utils-classes-version-five .modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-modal-header-padding);\n  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);\n  border-top-left-radius: var(--bs-modal-inner-border-radius);\n  border-top-right-radius: var(--bs-modal-inner-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .modal-header .btn-close {\n  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);\n  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;\n}\n.sabpaisa-css-utils-classes-version-five .modal-title {\n  margin-bottom: 0;\n  line-height: var(--bs-modal-title-line-height);\n}\n.sabpaisa-css-utils-classes-version-five .modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: var(--bs-modal-padding);\n}\n.sabpaisa-css-utils-classes-version-five .modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);\n  background-color: var(--bs-modal-footer-bg);\n  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);\n  border-bottom-right-radius: var(--bs-modal-inner-border-radius);\n  border-bottom-left-radius: var(--bs-modal-inner-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .modal-footer > * {\n  margin: calc(var(--bs-modal-footer-gap) * 0.5);\n}\n@media (min-width: 576px) {\n  .sabpaisa-css-utils-classes-version-five .modal {\n    --bs-modal-margin: 1.75rem;\n    --bs-modal-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  }\n  .sabpaisa-css-utils-classes-version-five .modal-dialog {\n    max-width: var(--bs-modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n  .sabpaisa-css-utils-classes-version-five .modal-sm {\n    --bs-modal-width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .sabpaisa-css-utils-classes-version-five .modal-lg,\n  .sabpaisa-css-utils-classes-version-five .modal-xl {\n    --bs-modal-width: 800px;\n  }\n}\n@media (min-width: 1200px) {\n  .sabpaisa-css-utils-classes-version-five .modal-xl {\n    --bs-modal-width: 1140px;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .modal-fullscreen {\n  width: 100vw;\n  max-width: none;\n  height: 100%;\n  margin: 0;\n}\n.sabpaisa-css-utils-classes-version-five .modal-fullscreen .modal-content {\n  height: 100%;\n  border: 0;\n  border-radius: 0;\n}\n.sabpaisa-css-utils-classes-version-five .modal-fullscreen .modal-header,\n.sabpaisa-css-utils-classes-version-five .modal-fullscreen .modal-footer {\n  border-radius: 0;\n}\n.sabpaisa-css-utils-classes-version-five .modal-fullscreen .modal-body {\n  overflow-y: auto;\n}\n@media (max-width: 575.98px) {\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-sm-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-sm-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-sm-down .modal-header,\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-sm-down .modal-footer {\n    border-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-sm-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 767.98px) {\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-md-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-md-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-md-down .modal-header,\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-md-down .modal-footer {\n    border-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-md-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 991.98px) {\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-lg-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-lg-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-lg-down .modal-header,\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-lg-down .modal-footer {\n    border-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-lg-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1199.98px) {\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-xl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-xl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-xl-down .modal-header,\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-xl-down .modal-footer {\n    border-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-xl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1399.98px) {\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-xxl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-xxl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-xxl-down .modal-header,\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-xxl-down .modal-footer {\n    border-radius: 0;\n  }\n  .sabpaisa-css-utils-classes-version-five .modal-fullscreen-xxl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .tooltip {\n  --bs-tooltip-zindex: 1080;\n  --bs-tooltip-max-width: 200px;\n  --bs-tooltip-padding-x: 0.5rem;\n  --bs-tooltip-padding-y: 0.25rem;\n  --bs-tooltip-margin: ;\n  --bs-tooltip-font-size: 0.875rem;\n  --bs-tooltip-color: #fff;\n  --bs-tooltip-bg: #000;\n  --bs-tooltip-border-radius: 0.375rem;\n  --bs-tooltip-opacity: 0.9;\n  --bs-tooltip-arrow-width: 0.8rem;\n  --bs-tooltip-arrow-height: 0.4rem;\n  z-index: var(--bs-tooltip-zindex);\n  display: block;\n  padding: var(--bs-tooltip-arrow-height);\n  margin: var(--bs-tooltip-margin);\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-tooltip-font-size);\n  word-wrap: break-word;\n  opacity: 0;\n}\n.sabpaisa-css-utils-classes-version-five .tooltip.show {\n  opacity: var(--bs-tooltip-opacity);\n}\n.sabpaisa-css-utils-classes-version-five .tooltip .tooltip-arrow {\n  display: block;\n  width: var(--bs-tooltip-arrow-width);\n  height: var(--bs-tooltip-arrow-height);\n}\n.sabpaisa-css-utils-classes-version-five .tooltip .tooltip-arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n.sabpaisa-css-utils-classes-version-five .bs-tooltip-top .tooltip-arrow, .sabpaisa-css-utils-classes-version-five .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {\n  bottom: 0;\n}\n.sabpaisa-css-utils-classes-version-five .bs-tooltip-top .tooltip-arrow::before, .sabpaisa-css-utils-classes-version-five .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n  top: -1px;\n  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-top-color: var(--bs-tooltip-bg);\n}\n.sabpaisa-css-utils-classes-version-five .bs-tooltip-end .tooltip-arrow, .sabpaisa-css-utils-classes-version-five .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {\n  left: 0;\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.sabpaisa-css-utils-classes-version-five .bs-tooltip-end .tooltip-arrow::before, .sabpaisa-css-utils-classes-version-five .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n  right: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-right-color: var(--bs-tooltip-bg);\n}\n.sabpaisa-css-utils-classes-version-five .bs-tooltip-bottom .tooltip-arrow, .sabpaisa-css-utils-classes-version-five .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {\n  top: 0;\n}\n.sabpaisa-css-utils-classes-version-five .bs-tooltip-bottom .tooltip-arrow::before, .sabpaisa-css-utils-classes-version-five .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n  bottom: -1px;\n  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-bottom-color: var(--bs-tooltip-bg);\n}\n.sabpaisa-css-utils-classes-version-five .bs-tooltip-start .tooltip-arrow, .sabpaisa-css-utils-classes-version-five .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {\n  right: 0;\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.sabpaisa-css-utils-classes-version-five .bs-tooltip-start .tooltip-arrow::before, .sabpaisa-css-utils-classes-version-five .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n  left: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-left-color: var(--bs-tooltip-bg);\n}\n.sabpaisa-css-utils-classes-version-five .tooltip-inner {\n  max-width: var(--bs-tooltip-max-width);\n  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);\n  color: var(--bs-tooltip-color);\n  text-align: center;\n  background-color: var(--bs-tooltip-bg);\n  border-radius: var(--bs-tooltip-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .popover {\n  --bs-popover-zindex: 1070;\n  --bs-popover-max-width: 276px;\n  --bs-popover-font-size: 0.875rem;\n  --bs-popover-bg: #fff;\n  --bs-popover-border-width: 1px;\n  --bs-popover-border-color: var(--bs-border-color-translucent);\n  --bs-popover-border-radius: 0.5rem;\n  --bs-popover-inner-border-radius: calc(0.5rem - 1px);\n  --bs-popover-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  --bs-popover-header-padding-x: 1rem;\n  --bs-popover-header-padding-y: 0.5rem;\n  --bs-popover-header-font-size: 1rem;\n  --bs-popover-header-color: ;\n  --bs-popover-header-bg: #f0f0f0;\n  --bs-popover-body-padding-x: 1rem;\n  --bs-popover-body-padding-y: 1rem;\n  --bs-popover-body-color: #212529;\n  --bs-popover-arrow-width: 1rem;\n  --bs-popover-arrow-height: 0.5rem;\n  --bs-popover-arrow-border: var(--bs-popover-border-color);\n  z-index: var(--bs-popover-zindex);\n  display: block;\n  max-width: var(--bs-popover-max-width);\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-popover-font-size);\n  word-wrap: break-word;\n  background-color: var(--bs-popover-bg);\n  background-clip: padding-box;\n  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-radius: var(--bs-popover-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .popover .popover-arrow {\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  height: var(--bs-popover-arrow-height);\n}\n.sabpaisa-css-utils-classes-version-five .popover .popover-arrow::before, .sabpaisa-css-utils-classes-version-five .popover .popover-arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n  border-width: 0;\n}\n.sabpaisa-css-utils-classes-version-five .bs-popover-top > .popover-arrow, .sabpaisa-css-utils-classes-version-five .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {\n  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.sabpaisa-css-utils-classes-version-five .bs-popover-top > .popover-arrow::before, .sabpaisa-css-utils-classes-version-five .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .sabpaisa-css-utils-classes-version-five .bs-popover-top > .popover-arrow::after, .sabpaisa-css-utils-classes-version-five .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.sabpaisa-css-utils-classes-version-five .bs-popover-top > .popover-arrow::before, .sabpaisa-css-utils-classes-version-five .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {\n  bottom: 0;\n  border-top-color: var(--bs-popover-arrow-border);\n}\n.sabpaisa-css-utils-classes-version-five .bs-popover-top > .popover-arrow::after, .sabpaisa-css-utils-classes-version-five .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  bottom: var(--bs-popover-border-width);\n  border-top-color: var(--bs-popover-bg);\n}\n.sabpaisa-css-utils-classes-version-five .bs-popover-end > .popover-arrow, .sabpaisa-css-utils-classes-version-five .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {\n  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.sabpaisa-css-utils-classes-version-five .bs-popover-end > .popover-arrow::before, .sabpaisa-css-utils-classes-version-five .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .sabpaisa-css-utils-classes-version-five .bs-popover-end > .popover-arrow::after, .sabpaisa-css-utils-classes-version-five .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.sabpaisa-css-utils-classes-version-five .bs-popover-end > .popover-arrow::before, .sabpaisa-css-utils-classes-version-five .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {\n  left: 0;\n  border-right-color: var(--bs-popover-arrow-border);\n}\n.sabpaisa-css-utils-classes-version-five .bs-popover-end > .popover-arrow::after, .sabpaisa-css-utils-classes-version-five .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  left: var(--bs-popover-border-width);\n  border-right-color: var(--bs-popover-bg);\n}\n.sabpaisa-css-utils-classes-version-five .bs-popover-bottom > .popover-arrow, .sabpaisa-css-utils-classes-version-five .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {\n  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.sabpaisa-css-utils-classes-version-five .bs-popover-bottom > .popover-arrow::before, .sabpaisa-css-utils-classes-version-five .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .sabpaisa-css-utils-classes-version-five .bs-popover-bottom > .popover-arrow::after, .sabpaisa-css-utils-classes-version-five .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.sabpaisa-css-utils-classes-version-five .bs-popover-bottom > .popover-arrow::before, .sabpaisa-css-utils-classes-version-five .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {\n  top: 0;\n  border-bottom-color: var(--bs-popover-arrow-border);\n}\n.sabpaisa-css-utils-classes-version-five .bs-popover-bottom > .popover-arrow::after, .sabpaisa-css-utils-classes-version-five .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  top: var(--bs-popover-border-width);\n  border-bottom-color: var(--bs-popover-bg);\n}\n.sabpaisa-css-utils-classes-version-five .bs-popover-bottom .popover-header::before, .sabpaisa-css-utils-classes-version-five .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));\n  content: \"\";\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);\n}\n.sabpaisa-css-utils-classes-version-five .bs-popover-start > .popover-arrow, .sabpaisa-css-utils-classes-version-five .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {\n  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.sabpaisa-css-utils-classes-version-five .bs-popover-start > .popover-arrow::before, .sabpaisa-css-utils-classes-version-five .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .sabpaisa-css-utils-classes-version-five .bs-popover-start > .popover-arrow::after, .sabpaisa-css-utils-classes-version-five .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.sabpaisa-css-utils-classes-version-five .bs-popover-start > .popover-arrow::before, .sabpaisa-css-utils-classes-version-five .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {\n  right: 0;\n  border-left-color: var(--bs-popover-arrow-border);\n}\n.sabpaisa-css-utils-classes-version-five .bs-popover-start > .popover-arrow::after, .sabpaisa-css-utils-classes-version-five .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  right: var(--bs-popover-border-width);\n  border-left-color: var(--bs-popover-bg);\n}\n.sabpaisa-css-utils-classes-version-five .popover-header {\n  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);\n  margin-bottom: 0;\n  font-size: var(--bs-popover-header-font-size);\n  color: var(--bs-popover-header-color);\n  background-color: var(--bs-popover-header-bg);\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-top-left-radius: var(--bs-popover-inner-border-radius);\n  border-top-right-radius: var(--bs-popover-inner-border-radius);\n}\n.sabpaisa-css-utils-classes-version-five .popover-header:empty {\n  display: none;\n}\n.sabpaisa-css-utils-classes-version-five .popover-body {\n  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);\n  color: var(--bs-popover-body-color);\n}\n.sabpaisa-css-utils-classes-version-five .carousel {\n  position: relative;\n}\n.sabpaisa-css-utils-classes-version-five .carousel.pointer-event {\n  touch-action: pan-y;\n}\n.sabpaisa-css-utils-classes-version-five .carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.sabpaisa-css-utils-classes-version-five .carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n.sabpaisa-css-utils-classes-version-five .carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .carousel-item {\n    transition: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .carousel-item.active,\n.sabpaisa-css-utils-classes-version-five .carousel-item-next,\n.sabpaisa-css-utils-classes-version-five .carousel-item-prev {\n  display: block;\n}\n.sabpaisa-css-utils-classes-version-five .carousel-item-next:not(.carousel-item-start),\n.sabpaisa-css-utils-classes-version-five .active.carousel-item-end {\n  transform: translateX(100%);\n}\n.sabpaisa-css-utils-classes-version-five .carousel-item-prev:not(.carousel-item-end),\n.sabpaisa-css-utils-classes-version-five .active.carousel-item-start {\n  transform: translateX(-100%);\n}\n.sabpaisa-css-utils-classes-version-five .carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n.sabpaisa-css-utils-classes-version-five .carousel-fade .carousel-item.active,\n.sabpaisa-css-utils-classes-version-five .carousel-fade .carousel-item-next.carousel-item-start,\n.sabpaisa-css-utils-classes-version-five .carousel-fade .carousel-item-prev.carousel-item-end {\n  z-index: 1;\n  opacity: 1;\n}\n.sabpaisa-css-utils-classes-version-five .carousel-fade .active.carousel-item-start,\n.sabpaisa-css-utils-classes-version-five .carousel-fade .active.carousel-item-end {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .carousel-fade .active.carousel-item-start,\n  .sabpaisa-css-utils-classes-version-five .carousel-fade .active.carousel-item-end {\n    transition: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .carousel-control-prev,\n.sabpaisa-css-utils-classes-version-five .carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  padding: 0;\n  color: #fff;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .carousel-control-prev,\n  .sabpaisa-css-utils-classes-version-five .carousel-control-next {\n    transition: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .carousel-control-prev:hover, .sabpaisa-css-utils-classes-version-five .carousel-control-prev:focus,\n.sabpaisa-css-utils-classes-version-five .carousel-control-next:hover,\n.sabpaisa-css-utils-classes-version-five .carousel-control-next:focus {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n.sabpaisa-css-utils-classes-version-five .carousel-control-prev {\n  left: 0;\n}\n.sabpaisa-css-utils-classes-version-five .carousel-control-next {\n  right: 0;\n}\n.sabpaisa-css-utils-classes-version-five .carousel-control-prev-icon,\n.sabpaisa-css-utils-classes-version-five .carousel-control-next-icon {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n.sabpaisa-css-utils-classes-version-five .carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\");\n}\n.sabpaisa-css-utils-classes-version-five .carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n.sabpaisa-css-utils-classes-version-five .carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  margin-right: 15%;\n  margin-bottom: 1rem;\n  margin-left: 15%;\n  list-style: none;\n}\n.sabpaisa-css-utils-classes-version-five .carousel-indicators [data-bs-target] {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  padding: 0;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .carousel-indicators [data-bs-target] {\n    transition: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .carousel-indicators .active {\n  opacity: 1;\n}\n.sabpaisa-css-utils-classes-version-five .carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 1.25rem;\n  left: 15%;\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n  color: #fff;\n  text-align: center;\n}\n.sabpaisa-css-utils-classes-version-five .carousel-dark .carousel-control-prev-icon,\n.sabpaisa-css-utils-classes-version-five .carousel-dark .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n.sabpaisa-css-utils-classes-version-five .carousel-dark .carousel-indicators [data-bs-target] {\n  background-color: #000;\n}\n.sabpaisa-css-utils-classes-version-five .carousel-dark .carousel-caption {\n  color: #000;\n}\n.sabpaisa-css-utils-classes-version-five .spinner-grow,\n.sabpaisa-css-utils-classes-version-five .spinner-border {\n  display: inline-block;\n  width: var(--bs-spinner-width);\n  height: var(--bs-spinner-height);\n  vertical-align: var(--bs-spinner-vertical-align);\n  border-radius: 50%;\n  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);\n}\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg) /* rtl:ignore */;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .spinner-border {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-border-width: 0.25em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-border;\n  border: var(--bs-spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n.sabpaisa-css-utils-classes-version-five .spinner-border-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n  --bs-spinner-border-width: 0.2em;\n}\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .spinner-grow {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-grow;\n  background-color: currentcolor;\n  opacity: 0;\n}\n.sabpaisa-css-utils-classes-version-five .spinner-grow-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .spinner-border,\n  .sabpaisa-css-utils-classes-version-five .spinner-grow {\n    --bs-spinner-animation-speed: 1.5s;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .offcanvas, .sabpaisa-css-utils-classes-version-five .offcanvas-xxl, .sabpaisa-css-utils-classes-version-five .offcanvas-xl, .sabpaisa-css-utils-classes-version-five .offcanvas-lg, .sabpaisa-css-utils-classes-version-five .offcanvas-md, .sabpaisa-css-utils-classes-version-five .offcanvas-sm {\n  --bs-offcanvas-zindex: 1045;\n  --bs-offcanvas-width: 400px;\n  --bs-offcanvas-height: 30vh;\n  --bs-offcanvas-padding-x: 1rem;\n  --bs-offcanvas-padding-y: 1rem;\n  --bs-offcanvas-color: ;\n  --bs-offcanvas-bg: #fff;\n  --bs-offcanvas-border-width: 1px;\n  --bs-offcanvas-border-color: var(--bs-border-color-translucent);\n  --bs-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n}\n@media (max-width: 575.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-sm {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: transform 0.3s ease-in-out;\n  }\n}\n@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-sm {\n    transition: none;\n  }\n}\n@media (max-width: 575.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-sm.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n}\n@media (max-width: 575.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-sm.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n}\n@media (max-width: 575.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-sm.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n}\n@media (max-width: 575.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-sm.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n}\n@media (max-width: 575.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-sm.showing, .sabpaisa-css-utils-classes-version-five .offcanvas-sm.show:not(.hiding) {\n    transform: none;\n  }\n}\n@media (max-width: 575.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-sm.showing, .sabpaisa-css-utils-classes-version-five .offcanvas-sm.hiding, .sabpaisa-css-utils-classes-version-five .offcanvas-sm.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 576px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-sm {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .offcanvas-sm .offcanvas-header {\n    display: none;\n  }\n  .sabpaisa-css-utils-classes-version-five .offcanvas-sm .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n@media (max-width: 767.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-md {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: transform 0.3s ease-in-out;\n  }\n}\n@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-md {\n    transition: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-md.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n}\n@media (max-width: 767.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-md.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n}\n@media (max-width: 767.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-md.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n}\n@media (max-width: 767.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-md.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n}\n@media (max-width: 767.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-md.showing, .sabpaisa-css-utils-classes-version-five .offcanvas-md.show:not(.hiding) {\n    transform: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-md.showing, .sabpaisa-css-utils-classes-version-five .offcanvas-md.hiding, .sabpaisa-css-utils-classes-version-five .offcanvas-md.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 768px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-md {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .offcanvas-md .offcanvas-header {\n    display: none;\n  }\n  .sabpaisa-css-utils-classes-version-five .offcanvas-md .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n@media (max-width: 991.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-lg {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: transform 0.3s ease-in-out;\n  }\n}\n@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-lg {\n    transition: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-lg.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n}\n@media (max-width: 991.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-lg.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n}\n@media (max-width: 991.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-lg.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n}\n@media (max-width: 991.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-lg.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n}\n@media (max-width: 991.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-lg.showing, .sabpaisa-css-utils-classes-version-five .offcanvas-lg.show:not(.hiding) {\n    transform: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-lg.showing, .sabpaisa-css-utils-classes-version-five .offcanvas-lg.hiding, .sabpaisa-css-utils-classes-version-five .offcanvas-lg.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 992px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-lg {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .offcanvas-lg .offcanvas-header {\n    display: none;\n  }\n  .sabpaisa-css-utils-classes-version-five .offcanvas-lg .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n@media (max-width: 1199.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-xl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: transform 0.3s ease-in-out;\n  }\n}\n@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-xl {\n    transition: none;\n  }\n}\n@media (max-width: 1199.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-xl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n}\n@media (max-width: 1199.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-xl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n}\n@media (max-width: 1199.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-xl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n}\n@media (max-width: 1199.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-xl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n}\n@media (max-width: 1199.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-xl.showing, .sabpaisa-css-utils-classes-version-five .offcanvas-xl.show:not(.hiding) {\n    transform: none;\n  }\n}\n@media (max-width: 1199.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-xl.showing, .sabpaisa-css-utils-classes-version-five .offcanvas-xl.hiding, .sabpaisa-css-utils-classes-version-five .offcanvas-xl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-xl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .offcanvas-xl .offcanvas-header {\n    display: none;\n  }\n  .sabpaisa-css-utils-classes-version-five .offcanvas-xl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n@media (max-width: 1399.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-xxl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: transform 0.3s ease-in-out;\n  }\n}\n@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-xxl {\n    transition: none;\n  }\n}\n@media (max-width: 1399.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-xxl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n}\n@media (max-width: 1399.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-xxl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n}\n@media (max-width: 1399.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-xxl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n}\n@media (max-width: 1399.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-xxl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n}\n@media (max-width: 1399.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-xxl.showing, .sabpaisa-css-utils-classes-version-five .offcanvas-xxl.show:not(.hiding) {\n    transform: none;\n  }\n}\n@media (max-width: 1399.98px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-xxl.showing, .sabpaisa-css-utils-classes-version-five .offcanvas-xxl.hiding, .sabpaisa-css-utils-classes-version-five .offcanvas-xxl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas-xxl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .offcanvas-xxl .offcanvas-header {\n    display: none;\n  }\n  .sabpaisa-css-utils-classes-version-five .offcanvas-xxl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .offcanvas {\n  position: fixed;\n  bottom: 0;\n  z-index: var(--bs-offcanvas-zindex);\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  color: var(--bs-offcanvas-color);\n  visibility: hidden;\n  background-color: var(--bs-offcanvas-bg);\n  background-clip: padding-box;\n  outline: 0;\n  transition: transform 0.3s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .sabpaisa-css-utils-classes-version-five .offcanvas {\n    transition: none;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .offcanvas.offcanvas-start {\n  top: 0;\n  left: 0;\n  width: var(--bs-offcanvas-width);\n  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(-100%);\n}\n.sabpaisa-css-utils-classes-version-five .offcanvas.offcanvas-end {\n  top: 0;\n  right: 0;\n  width: var(--bs-offcanvas-width);\n  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(100%);\n}\n.sabpaisa-css-utils-classes-version-five .offcanvas.offcanvas-top {\n  top: 0;\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(-100%);\n}\n.sabpaisa-css-utils-classes-version-five .offcanvas.offcanvas-bottom {\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(100%);\n}\n.sabpaisa-css-utils-classes-version-five .offcanvas.showing, .sabpaisa-css-utils-classes-version-five .offcanvas.show:not(.hiding) {\n  transform: none;\n}\n.sabpaisa-css-utils-classes-version-five .offcanvas.showing, .sabpaisa-css-utils-classes-version-five .offcanvas.hiding, .sabpaisa-css-utils-classes-version-five .offcanvas.show {\n  visibility: visible;\n}\n.sabpaisa-css-utils-classes-version-five .offcanvas-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n}\n.sabpaisa-css-utils-classes-version-five .offcanvas-backdrop.fade {\n  opacity: 0;\n}\n.sabpaisa-css-utils-classes-version-five .offcanvas-backdrop.show {\n  opacity: 0.5;\n}\n.sabpaisa-css-utils-classes-version-five .offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n}\n.sabpaisa-css-utils-classes-version-five .offcanvas-header .btn-close {\n  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);\n  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));\n  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));\n  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));\n}\n.sabpaisa-css-utils-classes-version-five .offcanvas-title {\n  margin-bottom: 0;\n  line-height: 1.5;\n}\n.sabpaisa-css-utils-classes-version-five .offcanvas-body {\n  flex-grow: 1;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n  overflow-y: auto;\n}\n.sabpaisa-css-utils-classes-version-five .placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: 0.5;\n}\n.sabpaisa-css-utils-classes-version-five .placeholder.btn::before {\n  display: inline-block;\n  content: \"\";\n}\n.sabpaisa-css-utils-classes-version-five .placeholder-xs {\n  min-height: 0.6em;\n}\n.sabpaisa-css-utils-classes-version-five .placeholder-sm {\n  min-height: 0.8em;\n}\n.sabpaisa-css-utils-classes-version-five .placeholder-lg {\n  min-height: 1.2em;\n}\n.sabpaisa-css-utils-classes-version-five .placeholder-glow .placeholder {\n  animation: placeholder-glow 2s ease-in-out infinite;\n}\n@keyframes placeholder-glow {\n  50% {\n    opacity: 0.2;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .placeholder-wave {\n  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n.sabpaisa-css-utils-classes-version-five .text-bg-primary {\n  color: #fff !important;\n  background-color: RGBA(13, 110, 253, var(--bs-bg-opacity, 1)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-bg-secondary {\n  color: #fff !important;\n  background-color: RGBA(108, 117, 125, var(--bs-bg-opacity, 1)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-bg-success {\n  color: #fff !important;\n  background-color: RGBA(25, 135, 84, var(--bs-bg-opacity, 1)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-bg-info {\n  color: #000 !important;\n  background-color: RGBA(13, 202, 240, var(--bs-bg-opacity, 1)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-bg-warning {\n  color: #000 !important;\n  background-color: RGBA(255, 193, 7, var(--bs-bg-opacity, 1)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-bg-danger {\n  color: #fff !important;\n  background-color: RGBA(220, 53, 69, var(--bs-bg-opacity, 1)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-bg-light {\n  color: #000 !important;\n  background-color: RGBA(248, 249, 250, var(--bs-bg-opacity, 1)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-bg-dark {\n  color: #fff !important;\n  background-color: RGBA(33, 37, 41, var(--bs-bg-opacity, 1)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .link-primary {\n  color: #0d6efd !important;\n}\n.sabpaisa-css-utils-classes-version-five .link-primary:hover, .sabpaisa-css-utils-classes-version-five .link-primary:focus {\n  color: #0a58ca !important;\n}\n.sabpaisa-css-utils-classes-version-five .link-secondary {\n  color: #6c757d !important;\n}\n.sabpaisa-css-utils-classes-version-five .link-secondary:hover, .sabpaisa-css-utils-classes-version-five .link-secondary:focus {\n  color: #565e64 !important;\n}\n.sabpaisa-css-utils-classes-version-five .link-success {\n  color: #198754 !important;\n}\n.sabpaisa-css-utils-classes-version-five .link-success:hover, .sabpaisa-css-utils-classes-version-five .link-success:focus {\n  color: #146c43 !important;\n}\n.sabpaisa-css-utils-classes-version-five .link-info {\n  color: #0dcaf0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .link-info:hover, .sabpaisa-css-utils-classes-version-five .link-info:focus {\n  color: #3dd5f3 !important;\n}\n.sabpaisa-css-utils-classes-version-five .link-warning {\n  color: #ffc107 !important;\n}\n.sabpaisa-css-utils-classes-version-five .link-warning:hover, .sabpaisa-css-utils-classes-version-five .link-warning:focus {\n  color: #ffcd39 !important;\n}\n.sabpaisa-css-utils-classes-version-five .link-danger {\n  color: #dc3545 !important;\n}\n.sabpaisa-css-utils-classes-version-five .link-danger:hover, .sabpaisa-css-utils-classes-version-five .link-danger:focus {\n  color: #b02a37 !important;\n}\n.sabpaisa-css-utils-classes-version-five .link-light {\n  color: #f8f9fa !important;\n}\n.sabpaisa-css-utils-classes-version-five .link-light:hover, .sabpaisa-css-utils-classes-version-five .link-light:focus {\n  color: #f9fafb !important;\n}\n.sabpaisa-css-utils-classes-version-five .link-dark {\n  color: #212529 !important;\n}\n.sabpaisa-css-utils-classes-version-five .link-dark:hover, .sabpaisa-css-utils-classes-version-five .link-dark:focus {\n  color: #1a1e21 !important;\n}\n.sabpaisa-css-utils-classes-version-five .ratio {\n  position: relative;\n  width: 100%;\n}\n.sabpaisa-css-utils-classes-version-five .ratio::before {\n  display: block;\n  padding-top: var(--bs-aspect-ratio);\n  content: \"\";\n}\n.sabpaisa-css-utils-classes-version-five .ratio > * {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.sabpaisa-css-utils-classes-version-five .ratio-1x1 {\n  --bs-aspect-ratio: 100%;\n}\n.sabpaisa-css-utils-classes-version-five .ratio-4x3 {\n  --bs-aspect-ratio: 75%;\n}\n.sabpaisa-css-utils-classes-version-five .ratio-16x9 {\n  --bs-aspect-ratio: 56.25%;\n}\n.sabpaisa-css-utils-classes-version-five .ratio-21x9 {\n  --bs-aspect-ratio: 42.8571428571%;\n}\n.sabpaisa-css-utils-classes-version-five .fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n.sabpaisa-css-utils-classes-version-five .fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n.sabpaisa-css-utils-classes-version-five .sticky-top {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n}\n.sabpaisa-css-utils-classes-version-five .sticky-bottom {\n  position: sticky;\n  bottom: 0;\n  z-index: 1020;\n}\n@media (min-width: 576px) {\n  .sabpaisa-css-utils-classes-version-five .sticky-sm-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sabpaisa-css-utils-classes-version-five .sticky-sm-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 768px) {\n  .sabpaisa-css-utils-classes-version-five .sticky-md-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sabpaisa-css-utils-classes-version-five .sticky-md-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 992px) {\n  .sabpaisa-css-utils-classes-version-five .sticky-lg-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sabpaisa-css-utils-classes-version-five .sticky-lg-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1200px) {\n  .sabpaisa-css-utils-classes-version-five .sticky-xl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sabpaisa-css-utils-classes-version-five .sticky-xl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1400px) {\n  .sabpaisa-css-utils-classes-version-five .sticky-xxl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sabpaisa-css-utils-classes-version-five .sticky-xxl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n.sabpaisa-css-utils-classes-version-five .hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n.sabpaisa-css-utils-classes-version-five .vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n.sabpaisa-css-utils-classes-version-five .visually-hidden,\n.sabpaisa-css-utils-classes-version-five .visually-hidden-focusable:not(:focus):not(:focus-within) {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  content: \"\";\n}\n.sabpaisa-css-utils-classes-version-five .text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.sabpaisa-css-utils-classes-version-five .vr {\n  display: inline-block;\n  align-self: stretch;\n  width: 1px;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: 0.25;\n}\n.sabpaisa-css-utils-classes-version-five .align-baseline {\n  vertical-align: baseline !important;\n}\n.sabpaisa-css-utils-classes-version-five .align-top {\n  vertical-align: top !important;\n}\n.sabpaisa-css-utils-classes-version-five .align-middle {\n  vertical-align: middle !important;\n}\n.sabpaisa-css-utils-classes-version-five .align-bottom {\n  vertical-align: bottom !important;\n}\n.sabpaisa-css-utils-classes-version-five .align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n.sabpaisa-css-utils-classes-version-five .align-text-top {\n  vertical-align: text-top !important;\n}\n.sabpaisa-css-utils-classes-version-five .float-start {\n  float: left !important;\n}\n.sabpaisa-css-utils-classes-version-five .float-end {\n  float: right !important;\n}\n.sabpaisa-css-utils-classes-version-five .float-none {\n  float: none !important;\n}\n.sabpaisa-css-utils-classes-version-five .opacity-0 {\n  opacity: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .opacity-25 {\n  opacity: 0.25 !important;\n}\n.sabpaisa-css-utils-classes-version-five .opacity-50 {\n  opacity: 0.5 !important;\n}\n.sabpaisa-css-utils-classes-version-five .opacity-75 {\n  opacity: 0.75 !important;\n}\n.sabpaisa-css-utils-classes-version-five .opacity-100 {\n  opacity: 1 !important;\n}\n.sabpaisa-css-utils-classes-version-five .overflow-auto {\n  overflow: auto !important;\n}\n.sabpaisa-css-utils-classes-version-five .overflow-hidden {\n  overflow: hidden !important;\n}\n.sabpaisa-css-utils-classes-version-five .overflow-visible {\n  overflow: visible !important;\n}\n.sabpaisa-css-utils-classes-version-five .overflow-scroll {\n  overflow: scroll !important;\n}\n.sabpaisa-css-utils-classes-version-five .d-inline {\n  display: inline !important;\n}\n.sabpaisa-css-utils-classes-version-five .d-inline-block {\n  display: inline-block !important;\n}\n.sabpaisa-css-utils-classes-version-five .d-block {\n  display: block !important;\n}\n.sabpaisa-css-utils-classes-version-five .d-grid {\n  display: grid !important;\n}\n.sabpaisa-css-utils-classes-version-five .d-table {\n  display: table !important;\n}\n.sabpaisa-css-utils-classes-version-five .d-table-row {\n  display: table-row !important;\n}\n.sabpaisa-css-utils-classes-version-five .d-table-cell {\n  display: table-cell !important;\n}\n.sabpaisa-css-utils-classes-version-five .d-flex {\n  display: flex !important;\n}\n.sabpaisa-css-utils-classes-version-five .d-inline-flex {\n  display: inline-flex !important;\n}\n.sabpaisa-css-utils-classes-version-five .d-none {\n  display: none !important;\n}\n.sabpaisa-css-utils-classes-version-five .shadow {\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n}\n.sabpaisa-css-utils-classes-version-five .shadow-sm {\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;\n}\n.sabpaisa-css-utils-classes-version-five .shadow-lg {\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;\n}\n.sabpaisa-css-utils-classes-version-five .shadow-none {\n  box-shadow: none !important;\n}\n.sabpaisa-css-utils-classes-version-five .position-static {\n  position: static !important;\n}\n.sabpaisa-css-utils-classes-version-five .position-relative {\n  position: relative !important;\n}\n.sabpaisa-css-utils-classes-version-five .position-absolute {\n  position: absolute !important;\n}\n.sabpaisa-css-utils-classes-version-five .position-fixed {\n  position: fixed !important;\n}\n.sabpaisa-css-utils-classes-version-five .position-sticky {\n  position: sticky !important;\n}\n.sabpaisa-css-utils-classes-version-five .top-0 {\n  top: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .top-50 {\n  top: 50% !important;\n}\n.sabpaisa-css-utils-classes-version-five .top-100 {\n  top: 100% !important;\n}\n.sabpaisa-css-utils-classes-version-five .bottom-0 {\n  bottom: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .bottom-50 {\n  bottom: 50% !important;\n}\n.sabpaisa-css-utils-classes-version-five .bottom-100 {\n  bottom: 100% !important;\n}\n.sabpaisa-css-utils-classes-version-five .start-0 {\n  left: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .start-50 {\n  left: 50% !important;\n}\n.sabpaisa-css-utils-classes-version-five .start-100 {\n  left: 100% !important;\n}\n.sabpaisa-css-utils-classes-version-five .end-0 {\n  right: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .end-50 {\n  right: 50% !important;\n}\n.sabpaisa-css-utils-classes-version-five .end-100 {\n  right: 100% !important;\n}\n.sabpaisa-css-utils-classes-version-five .translate-middle {\n  transform: translate(-50%, -50%) !important;\n}\n.sabpaisa-css-utils-classes-version-five .translate-middle-x {\n  transform: translateX(-50%) !important;\n}\n.sabpaisa-css-utils-classes-version-five .translate-middle-y {\n  transform: translateY(-50%) !important;\n}\n.sabpaisa-css-utils-classes-version-five .border {\n  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n.sabpaisa-css-utils-classes-version-five .border-0 {\n  border: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .border-top {\n  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n.sabpaisa-css-utils-classes-version-five .border-top-0 {\n  border-top: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .border-end {\n  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n.sabpaisa-css-utils-classes-version-five .border-end-0 {\n  border-right: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .border-bottom {\n  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n.sabpaisa-css-utils-classes-version-five .border-bottom-0 {\n  border-bottom: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .border-start {\n  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n.sabpaisa-css-utils-classes-version-five .border-start-0 {\n  border-left: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .border-primary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .border-secondary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .border-success {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .border-info {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .border-warning {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .border-danger {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .border-light {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .border-dark {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .border-white {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .border-1 {\n  --bs-border-width: 1px;\n}\n.sabpaisa-css-utils-classes-version-five .border-2 {\n  --bs-border-width: 2px;\n}\n.sabpaisa-css-utils-classes-version-five .border-3 {\n  --bs-border-width: 3px;\n}\n.sabpaisa-css-utils-classes-version-five .border-4 {\n  --bs-border-width: 4px;\n}\n.sabpaisa-css-utils-classes-version-five .border-5 {\n  --bs-border-width: 5px;\n}\n.sabpaisa-css-utils-classes-version-five .border-opacity-10 {\n  --bs-border-opacity: 0.1;\n}\n.sabpaisa-css-utils-classes-version-five .border-opacity-25 {\n  --bs-border-opacity: 0.25;\n}\n.sabpaisa-css-utils-classes-version-five .border-opacity-50 {\n  --bs-border-opacity: 0.5;\n}\n.sabpaisa-css-utils-classes-version-five .border-opacity-75 {\n  --bs-border-opacity: 0.75;\n}\n.sabpaisa-css-utils-classes-version-five .border-opacity-100 {\n  --bs-border-opacity: 1;\n}\n.sabpaisa-css-utils-classes-version-five .w-25 {\n  width: 25% !important;\n}\n.sabpaisa-css-utils-classes-version-five .w-50 {\n  width: 50% !important;\n}\n.sabpaisa-css-utils-classes-version-five .w-75 {\n  width: 75% !important;\n}\n.sabpaisa-css-utils-classes-version-five .w-100 {\n  width: 100% !important;\n}\n.sabpaisa-css-utils-classes-version-five .w-auto {\n  width: auto !important;\n}\n.sabpaisa-css-utils-classes-version-five .mw-100 {\n  max-width: 100% !important;\n}\n.sabpaisa-css-utils-classes-version-five .vw-100 {\n  width: 100vw !important;\n}\n.sabpaisa-css-utils-classes-version-five .min-vw-100 {\n  min-width: 100vw !important;\n}\n.sabpaisa-css-utils-classes-version-five .h-25 {\n  height: 25% !important;\n}\n.sabpaisa-css-utils-classes-version-five .h-50 {\n  height: 50% !important;\n}\n.sabpaisa-css-utils-classes-version-five .h-75 {\n  height: 75% !important;\n}\n.sabpaisa-css-utils-classes-version-five .h-100 {\n  height: 100% !important;\n}\n.sabpaisa-css-utils-classes-version-five .h-auto {\n  height: auto !important;\n}\n.sabpaisa-css-utils-classes-version-five .mh-100 {\n  max-height: 100% !important;\n}\n.sabpaisa-css-utils-classes-version-five .vh-100 {\n  height: 100vh !important;\n}\n.sabpaisa-css-utils-classes-version-five .min-vh-100 {\n  min-height: 100vh !important;\n}\n.sabpaisa-css-utils-classes-version-five .flex-fill {\n  flex: 1 1 auto !important;\n}\n.sabpaisa-css-utils-classes-version-five .flex-row {\n  flex-direction: row !important;\n}\n.sabpaisa-css-utils-classes-version-five .flex-column {\n  flex-direction: column !important;\n}\n.sabpaisa-css-utils-classes-version-five .flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n.sabpaisa-css-utils-classes-version-five .flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n.sabpaisa-css-utils-classes-version-five .flex-grow-0 {\n  flex-grow: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .flex-grow-1 {\n  flex-grow: 1 !important;\n}\n.sabpaisa-css-utils-classes-version-five .flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n.sabpaisa-css-utils-classes-version-five .flex-wrap {\n  flex-wrap: wrap !important;\n}\n.sabpaisa-css-utils-classes-version-five .flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n.sabpaisa-css-utils-classes-version-five .flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n.sabpaisa-css-utils-classes-version-five .justify-content-start {\n  justify-content: flex-start !important;\n}\n.sabpaisa-css-utils-classes-version-five .justify-content-end {\n  justify-content: flex-end !important;\n}\n.sabpaisa-css-utils-classes-version-five .justify-content-center {\n  justify-content: center !important;\n}\n.sabpaisa-css-utils-classes-version-five .justify-content-between {\n  justify-content: space-between !important;\n}\n.sabpaisa-css-utils-classes-version-five .justify-content-around {\n  justify-content: space-around !important;\n}\n.sabpaisa-css-utils-classes-version-five .justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n.sabpaisa-css-utils-classes-version-five .align-items-start {\n  align-items: flex-start !important;\n}\n.sabpaisa-css-utils-classes-version-five .align-items-end {\n  align-items: flex-end !important;\n}\n.sabpaisa-css-utils-classes-version-five .align-items-center {\n  align-items: center !important;\n}\n.sabpaisa-css-utils-classes-version-five .align-items-baseline {\n  align-items: baseline !important;\n}\n.sabpaisa-css-utils-classes-version-five .align-items-stretch {\n  align-items: stretch !important;\n}\n.sabpaisa-css-utils-classes-version-five .align-content-start {\n  align-content: flex-start !important;\n}\n.sabpaisa-css-utils-classes-version-five .align-content-end {\n  align-content: flex-end !important;\n}\n.sabpaisa-css-utils-classes-version-five .align-content-center {\n  align-content: center !important;\n}\n.sabpaisa-css-utils-classes-version-five .align-content-between {\n  align-content: space-between !important;\n}\n.sabpaisa-css-utils-classes-version-five .align-content-around {\n  align-content: space-around !important;\n}\n.sabpaisa-css-utils-classes-version-five .align-content-stretch {\n  align-content: stretch !important;\n}\n.sabpaisa-css-utils-classes-version-five .align-self-auto {\n  align-self: auto !important;\n}\n.sabpaisa-css-utils-classes-version-five .align-self-start {\n  align-self: flex-start !important;\n}\n.sabpaisa-css-utils-classes-version-five .align-self-end {\n  align-self: flex-end !important;\n}\n.sabpaisa-css-utils-classes-version-five .align-self-center {\n  align-self: center !important;\n}\n.sabpaisa-css-utils-classes-version-five .align-self-baseline {\n  align-self: baseline !important;\n}\n.sabpaisa-css-utils-classes-version-five .align-self-stretch {\n  align-self: stretch !important;\n}\n.sabpaisa-css-utils-classes-version-five .order-first {\n  order: -1 !important;\n}\n.sabpaisa-css-utils-classes-version-five .order-0 {\n  order: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .order-1 {\n  order: 1 !important;\n}\n.sabpaisa-css-utils-classes-version-five .order-2 {\n  order: 2 !important;\n}\n.sabpaisa-css-utils-classes-version-five .order-3 {\n  order: 3 !important;\n}\n.sabpaisa-css-utils-classes-version-five .order-4 {\n  order: 4 !important;\n}\n.sabpaisa-css-utils-classes-version-five .order-5 {\n  order: 5 !important;\n}\n.sabpaisa-css-utils-classes-version-five .order-last {\n  order: 6 !important;\n}\n.sabpaisa-css-utils-classes-version-five .m-0 {\n  margin: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .m-1 {\n  margin: 0.25rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .m-2 {\n  margin: 0.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .m-3 {\n  margin: 1rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .m-4 {\n  margin: 1.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .m-5 {\n  margin: 3rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .m-auto {\n  margin: auto !important;\n}\n.sabpaisa-css-utils-classes-version-five .mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .mx-1 {\n  margin-right: 0.25rem !important;\n  margin-left: 0.25rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .mx-2 {\n  margin-right: 0.5rem !important;\n  margin-left: 0.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .mx-3 {\n  margin-right: 1rem !important;\n  margin-left: 1rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .mx-4 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .mx-5 {\n  margin-right: 3rem !important;\n  margin-left: 3rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n.sabpaisa-css-utils-classes-version-five .my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .my-1 {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .my-2 {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .my-3 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .my-4 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .my-5 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n.sabpaisa-css-utils-classes-version-five .mt-0 {\n  margin-top: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .mt-1 {\n  margin-top: 0.25rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .mt-2 {\n  margin-top: 0.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .mt-3 {\n  margin-top: 1rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .mt-4 {\n  margin-top: 1.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .mt-5 {\n  margin-top: 3rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .mt-auto {\n  margin-top: auto !important;\n}\n.sabpaisa-css-utils-classes-version-five .me-0 {\n  margin-right: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .me-1 {\n  margin-right: 0.25rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .me-2 {\n  margin-right: 0.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .me-3 {\n  margin-right: 1rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .me-4 {\n  margin-right: 1.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .me-5 {\n  margin-right: 3rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .me-auto {\n  margin-right: auto !important;\n}\n.sabpaisa-css-utils-classes-version-five .mb-0 {\n  margin-bottom: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .mb-1 {\n  margin-bottom: 0.25rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .mb-3 {\n  margin-bottom: 1rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .mb-5 {\n  margin-bottom: 3rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .mb-auto {\n  margin-bottom: auto !important;\n}\n.sabpaisa-css-utils-classes-version-five .ms-0 {\n  margin-left: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .ms-1 {\n  margin-left: 0.25rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .ms-2 {\n  margin-left: 0.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .ms-3 {\n  margin-left: 1rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .ms-4 {\n  margin-left: 1.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .ms-5 {\n  margin-left: 3rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .ms-auto {\n  margin-left: auto !important;\n}\n.sabpaisa-css-utils-classes-version-five .p-0 {\n  padding: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .p-1 {\n  padding: 0.25rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .p-2 {\n  padding: 0.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .p-3 {\n  padding: 1rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .p-4 {\n  padding: 1.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .p-5 {\n  padding: 3rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .px-1 {\n  padding-right: 0.25rem !important;\n  padding-left: 0.25rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .px-2 {\n  padding-right: 0.5rem !important;\n  padding-left: 0.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .px-3 {\n  padding-right: 1rem !important;\n  padding-left: 1rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .px-4 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .px-5 {\n  padding-right: 3rem !important;\n  padding-left: 3rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .py-1 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .py-2 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .py-3 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .py-4 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .py-5 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .pt-0 {\n  padding-top: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .pt-1 {\n  padding-top: 0.25rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .pt-2 {\n  padding-top: 0.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .pt-3 {\n  padding-top: 1rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .pt-4 {\n  padding-top: 1.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .pt-5 {\n  padding-top: 3rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .pe-0 {\n  padding-right: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .pe-1 {\n  padding-right: 0.25rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .pe-2 {\n  padding-right: 0.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .pe-3 {\n  padding-right: 1rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .pe-4 {\n  padding-right: 1.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .pe-5 {\n  padding-right: 3rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .pb-0 {\n  padding-bottom: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .pb-1 {\n  padding-bottom: 0.25rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .pb-2 {\n  padding-bottom: 0.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .pb-3 {\n  padding-bottom: 1rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .pb-4 {\n  padding-bottom: 1.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .pb-5 {\n  padding-bottom: 3rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .ps-0 {\n  padding-left: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .ps-1 {\n  padding-left: 0.25rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .ps-2 {\n  padding-left: 0.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .ps-3 {\n  padding-left: 1rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .ps-4 {\n  padding-left: 1.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .ps-5 {\n  padding-left: 3rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .gap-0 {\n  gap: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .gap-1 {\n  gap: 0.25rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .gap-2 {\n  gap: 0.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .gap-3 {\n  gap: 1rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .gap-4 {\n  gap: 1.5rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .gap-5 {\n  gap: 3rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .font-monospace {\n  font-family: var(--bs-font-monospace) !important;\n}\n.sabpaisa-css-utils-classes-version-five .fs-1 {\n  font-size: calc(1.375rem + 1.5vw) !important;\n}\n.sabpaisa-css-utils-classes-version-five .fs-2 {\n  font-size: calc(1.325rem + 0.9vw) !important;\n}\n.sabpaisa-css-utils-classes-version-five .fs-3 {\n  font-size: calc(1.3rem + 0.6vw) !important;\n}\n.sabpaisa-css-utils-classes-version-five .fs-4 {\n  font-size: calc(1.275rem + 0.3vw) !important;\n}\n.sabpaisa-css-utils-classes-version-five .fs-5 {\n  font-size: 1.25rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .fs-6 {\n  font-size: 1rem !important;\n}\n.sabpaisa-css-utils-classes-version-five .fst-italic {\n  font-style: italic !important;\n}\n.sabpaisa-css-utils-classes-version-five .fst-normal {\n  font-style: normal !important;\n}\n.sabpaisa-css-utils-classes-version-five .fw-light {\n  font-weight: 300 !important;\n}\n.sabpaisa-css-utils-classes-version-five .fw-lighter {\n  font-weight: lighter !important;\n}\n.sabpaisa-css-utils-classes-version-five .fw-normal {\n  font-weight: 400 !important;\n}\n.sabpaisa-css-utils-classes-version-five .fw-bold {\n  font-weight: 700 !important;\n}\n.sabpaisa-css-utils-classes-version-five .fw-semibold {\n  font-weight: 600 !important;\n}\n.sabpaisa-css-utils-classes-version-five .fw-bolder {\n  font-weight: bolder !important;\n}\n.sabpaisa-css-utils-classes-version-five .lh-1 {\n  line-height: 1 !important;\n}\n.sabpaisa-css-utils-classes-version-five .lh-sm {\n  line-height: 1.25 !important;\n}\n.sabpaisa-css-utils-classes-version-five .lh-base {\n  line-height: 1.5 !important;\n}\n.sabpaisa-css-utils-classes-version-five .lh-lg {\n  line-height: 2 !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-start {\n  text-align: left !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-end {\n  text-align: right !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-center {\n  text-align: center !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-decoration-none {\n  text-decoration: none !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-decoration-underline {\n  text-decoration: underline !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-lowercase {\n  text-transform: lowercase !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-uppercase {\n  text-transform: uppercase !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-capitalize {\n  text-transform: capitalize !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-wrap {\n  white-space: normal !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-nowrap {\n  white-space: nowrap !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-break {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-primary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-secondary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-success {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-info {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-warning {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-danger {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-light {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-dark {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-black {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;\n}\n\n.sabpaisa-css-utils-classes-version-five .text-body {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-muted {\n  --bs-text-opacity: 1;\n  color: #6c757d !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-black-50 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-white-50 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-reset {\n  --bs-text-opacity: 1;\n  color: inherit !important;\n}\n.sabpaisa-css-utils-classes-version-five .text-opacity-25 {\n  --bs-text-opacity: 0.25;\n}\n.sabpaisa-css-utils-classes-version-five .text-opacity-50 {\n  --bs-text-opacity: 0.5;\n}\n.sabpaisa-css-utils-classes-version-five .text-opacity-75 {\n  --bs-text-opacity: 0.75;\n}\n.sabpaisa-css-utils-classes-version-five .text-opacity-100 {\n  --bs-text-opacity: 1;\n}\n.sabpaisa-css-utils-classes-version-five .bg-primary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .bg-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .bg-success {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .bg-info {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .bg-warning {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .bg-danger {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .bg-light {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .bg-dark {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .bg-black {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .bg-white {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .bg-body {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n.sabpaisa-css-utils-classes-version-five .bg-transparent {\n  --bs-bg-opacity: 1;\n  background-color: transparent !important;\n}\n.sabpaisa-css-utils-classes-version-five .bg-opacity-10 {\n  --bs-bg-opacity: 0.1;\n}\n.sabpaisa-css-utils-classes-version-five .bg-opacity-25 {\n  --bs-bg-opacity: 0.25;\n}\n.sabpaisa-css-utils-classes-version-five .bg-opacity-50 {\n  --bs-bg-opacity: 0.5;\n}\n.sabpaisa-css-utils-classes-version-five .bg-opacity-75 {\n  --bs-bg-opacity: 0.75;\n}\n.sabpaisa-css-utils-classes-version-five .bg-opacity-100 {\n  --bs-bg-opacity: 1;\n}\n.sabpaisa-css-utils-classes-version-five .bg-gradient {\n  background-image: var(--bs-gradient) !important;\n}\n.sabpaisa-css-utils-classes-version-five .user-select-all {\n  user-select: all !important;\n}\n.sabpaisa-css-utils-classes-version-five .user-select-auto {\n  user-select: auto !important;\n}\n.sabpaisa-css-utils-classes-version-five .user-select-none {\n  user-select: none !important;\n}\n.sabpaisa-css-utils-classes-version-five .pe-none {\n  pointer-events: none !important;\n}\n.sabpaisa-css-utils-classes-version-five .pe-auto {\n  pointer-events: auto !important;\n}\n.sabpaisa-css-utils-classes-version-five .rounded {\n  border-radius: var(--bs-border-radius) !important;\n}\n.sabpaisa-css-utils-classes-version-five .rounded-0 {\n  border-radius: 0 !important;\n}\n.sabpaisa-css-utils-classes-version-five .rounded-1 {\n  border-radius: var(--bs-border-radius-sm) !important;\n}\n.sabpaisa-css-utils-classes-version-five .rounded-2 {\n  border-radius: var(--bs-border-radius) !important;\n}\n.sabpaisa-css-utils-classes-version-five .rounded-3 {\n  border-radius: var(--bs-border-radius-lg) !important;\n}\n.sabpaisa-css-utils-classes-version-five .rounded-4 {\n  border-radius: var(--bs-border-radius-xl) !important;\n}\n.sabpaisa-css-utils-classes-version-five .rounded-5 {\n  border-radius: var(--bs-border-radius-2xl) !important;\n}\n.sabpaisa-css-utils-classes-version-five .rounded-circle {\n  border-radius: 50% !important;\n}\n.sabpaisa-css-utils-classes-version-five .rounded-pill {\n  border-radius: var(--bs-border-radius-pill) !important;\n}\n.sabpaisa-css-utils-classes-version-five .rounded-top {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n.sabpaisa-css-utils-classes-version-five .rounded-end {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n.sabpaisa-css-utils-classes-version-five .rounded-bottom {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n.sabpaisa-css-utils-classes-version-five .rounded-start {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n.sabpaisa-css-utils-classes-version-five .visible {\n  visibility: visible !important;\n}\n.sabpaisa-css-utils-classes-version-five .invisible {\n  visibility: hidden !important;\n}\n@media (min-width: 576px) {\n  .sabpaisa-css-utils-classes-version-five .float-sm-start {\n    float: left !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .float-sm-end {\n    float: right !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .float-sm-none {\n    float: none !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-sm-inline {\n    display: inline !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-sm-block {\n    display: block !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-sm-grid {\n    display: grid !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-sm-table {\n    display: table !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-sm-table-row {\n    display: table-row !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-sm-flex {\n    display: flex !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-sm-none {\n    display: none !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-sm-row {\n    flex-direction: row !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-sm-column {\n    flex-direction: column !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-sm-evenly {\n    justify-content: space-evenly !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-sm-center {\n    align-items: center !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-sm-center {\n    align-content: center !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-sm-center {\n    align-self: center !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-sm-first {\n    order: -1 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-sm-0 {\n    order: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-sm-1 {\n    order: 1 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-sm-2 {\n    order: 2 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-sm-3 {\n    order: 3 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-sm-4 {\n    order: 4 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-sm-5 {\n    order: 5 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-sm-last {\n    order: 6 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-sm-0 {\n    margin: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-sm-3 {\n    margin: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-sm-4 {\n    margin: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-sm-5 {\n    margin: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-sm-auto {\n    margin: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-sm-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-sm-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-sm-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-sm-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-sm-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-sm-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-sm-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-sm-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-sm-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-sm-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-sm-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-sm-0 {\n    margin-top: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-sm-3 {\n    margin-top: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-sm-4 {\n    margin-top: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-sm-5 {\n    margin-top: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-sm-auto {\n    margin-top: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-sm-0 {\n    margin-right: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-sm-3 {\n    margin-right: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-sm-4 {\n    margin-right: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-sm-5 {\n    margin-right: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-sm-auto {\n    margin-right: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-sm-3 {\n    margin-bottom: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-sm-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-sm-5 {\n    margin-bottom: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-sm-0 {\n    margin-left: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-sm-3 {\n    margin-left: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-sm-4 {\n    margin-left: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-sm-5 {\n    margin-left: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-sm-auto {\n    margin-left: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-sm-0 {\n    padding: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-sm-3 {\n    padding: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-sm-4 {\n    padding: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-sm-5 {\n    padding: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-sm-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-sm-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-sm-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-sm-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-sm-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-sm-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-sm-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-sm-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-sm-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-sm-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-sm-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-sm-0 {\n    padding-top: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-sm-3 {\n    padding-top: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-sm-4 {\n    padding-top: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-sm-5 {\n    padding-top: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-sm-0 {\n    padding-right: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-sm-3 {\n    padding-right: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-sm-4 {\n    padding-right: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-sm-5 {\n    padding-right: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-sm-3 {\n    padding-bottom: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-sm-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-sm-5 {\n    padding-bottom: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-sm-0 {\n    padding-left: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-sm-3 {\n    padding-left: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-sm-4 {\n    padding-left: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-sm-5 {\n    padding-left: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-sm-0 {\n    gap: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-sm-1 {\n    gap: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-sm-2 {\n    gap: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-sm-3 {\n    gap: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-sm-4 {\n    gap: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-sm-5 {\n    gap: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .text-sm-start {\n    text-align: left !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .text-sm-end {\n    text-align: right !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .text-sm-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 768px) {\n  .sabpaisa-css-utils-classes-version-five .float-md-start {\n    float: left !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .float-md-end {\n    float: right !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .float-md-none {\n    float: none !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-md-inline {\n    display: inline !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-md-block {\n    display: block !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-md-grid {\n    display: grid !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-md-table {\n    display: table !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-md-table-row {\n    display: table-row !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-md-flex {\n    display: flex !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-md-none {\n    display: none !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-md-row {\n    flex-direction: row !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-md-column {\n    flex-direction: column !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-md-center {\n    justify-content: center !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-md-evenly {\n    justify-content: space-evenly !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-md-center {\n    align-items: center !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-md-center {\n    align-content: center !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-md-between {\n    align-content: space-between !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-md-around {\n    align-content: space-around !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-md-auto {\n    align-self: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-md-center {\n    align-self: center !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-md-first {\n    order: -1 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-md-0 {\n    order: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-md-1 {\n    order: 1 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-md-2 {\n    order: 2 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-md-3 {\n    order: 3 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-md-4 {\n    order: 4 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-md-5 {\n    order: 5 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-md-last {\n    order: 6 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-md-0 {\n    margin: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-md-1 {\n    margin: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-md-2 {\n    margin: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-md-3 {\n    margin: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-md-4 {\n    margin: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-md-5 {\n    margin: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-md-auto {\n    margin: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-md-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-md-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-md-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-md-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-md-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-md-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-md-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-md-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-md-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-md-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-md-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-md-0 {\n    margin-top: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-md-1 {\n    margin-top: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-md-2 {\n    margin-top: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-md-3 {\n    margin-top: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-md-4 {\n    margin-top: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-md-5 {\n    margin-top: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-md-auto {\n    margin-top: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-md-0 {\n    margin-right: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-md-1 {\n    margin-right: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-md-2 {\n    margin-right: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-md-3 {\n    margin-right: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-md-4 {\n    margin-right: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-md-5 {\n    margin-right: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-md-auto {\n    margin-right: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-md-3 {\n    margin-bottom: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-md-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-md-5 {\n    margin-bottom: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-md-auto {\n    margin-bottom: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-md-0 {\n    margin-left: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-md-1 {\n    margin-left: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-md-2 {\n    margin-left: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-md-3 {\n    margin-left: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-md-4 {\n    margin-left: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-md-5 {\n    margin-left: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-md-auto {\n    margin-left: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-md-0 {\n    padding: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-md-1 {\n    padding: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-md-2 {\n    padding: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-md-3 {\n    padding: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-md-4 {\n    padding: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-md-5 {\n    padding: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-md-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-md-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-md-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-md-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-md-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-md-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-md-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-md-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-md-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-md-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-md-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-md-0 {\n    padding-top: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-md-1 {\n    padding-top: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-md-2 {\n    padding-top: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-md-3 {\n    padding-top: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-md-4 {\n    padding-top: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-md-5 {\n    padding-top: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-md-0 {\n    padding-right: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-md-1 {\n    padding-right: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-md-2 {\n    padding-right: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-md-3 {\n    padding-right: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-md-4 {\n    padding-right: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-md-5 {\n    padding-right: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-md-3 {\n    padding-bottom: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-md-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-md-5 {\n    padding-bottom: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-md-0 {\n    padding-left: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-md-1 {\n    padding-left: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-md-2 {\n    padding-left: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-md-3 {\n    padding-left: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-md-4 {\n    padding-left: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-md-5 {\n    padding-left: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-md-0 {\n    gap: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-md-1 {\n    gap: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-md-2 {\n    gap: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-md-3 {\n    gap: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-md-4 {\n    gap: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-md-5 {\n    gap: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .text-md-start {\n    text-align: left !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .text-md-end {\n    text-align: right !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .text-md-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 992px) {\n  .sabpaisa-css-utils-classes-version-five .float-lg-start {\n    float: left !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .float-lg-end {\n    float: right !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .float-lg-none {\n    float: none !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-lg-inline {\n    display: inline !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-lg-block {\n    display: block !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-lg-grid {\n    display: grid !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-lg-table {\n    display: table !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-lg-table-row {\n    display: table-row !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-lg-flex {\n    display: flex !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-lg-none {\n    display: none !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-lg-row {\n    flex-direction: row !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-lg-column {\n    flex-direction: column !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-lg-evenly {\n    justify-content: space-evenly !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-lg-center {\n    align-items: center !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-lg-center {\n    align-content: center !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-lg-center {\n    align-self: center !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-lg-first {\n    order: -1 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-lg-0 {\n    order: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-lg-1 {\n    order: 1 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-lg-2 {\n    order: 2 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-lg-3 {\n    order: 3 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-lg-4 {\n    order: 4 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-lg-5 {\n    order: 5 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-lg-last {\n    order: 6 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-lg-0 {\n    margin: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-lg-3 {\n    margin: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-lg-4 {\n    margin: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-lg-5 {\n    margin: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-lg-auto {\n    margin: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-lg-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-lg-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-lg-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-lg-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-lg-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-lg-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-lg-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-lg-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-lg-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-lg-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-lg-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-lg-0 {\n    margin-top: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-lg-3 {\n    margin-top: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-lg-4 {\n    margin-top: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-lg-5 {\n    margin-top: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-lg-auto {\n    margin-top: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-lg-0 {\n    margin-right: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-lg-3 {\n    margin-right: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-lg-4 {\n    margin-right: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-lg-5 {\n    margin-right: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-lg-auto {\n    margin-right: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-lg-3 {\n    margin-bottom: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-lg-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-lg-5 {\n    margin-bottom: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-lg-0 {\n    margin-left: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-lg-3 {\n    margin-left: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-lg-4 {\n    margin-left: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-lg-5 {\n    margin-left: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-lg-auto {\n    margin-left: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-lg-0 {\n    padding: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-lg-3 {\n    padding: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-lg-4 {\n    padding: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-lg-5 {\n    padding: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-lg-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-lg-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-lg-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-lg-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-lg-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-lg-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-lg-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-lg-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-lg-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-lg-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-lg-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-lg-0 {\n    padding-top: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-lg-3 {\n    padding-top: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-lg-4 {\n    padding-top: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-lg-5 {\n    padding-top: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-lg-0 {\n    padding-right: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-lg-3 {\n    padding-right: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-lg-4 {\n    padding-right: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-lg-5 {\n    padding-right: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-lg-3 {\n    padding-bottom: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-lg-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-lg-5 {\n    padding-bottom: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-lg-0 {\n    padding-left: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-lg-3 {\n    padding-left: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-lg-4 {\n    padding-left: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-lg-5 {\n    padding-left: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-lg-0 {\n    gap: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-lg-1 {\n    gap: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-lg-2 {\n    gap: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-lg-3 {\n    gap: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-lg-4 {\n    gap: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-lg-5 {\n    gap: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .text-lg-start {\n    text-align: left !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .text-lg-end {\n    text-align: right !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .text-lg-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .sabpaisa-css-utils-classes-version-five .float-xl-start {\n    float: left !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .float-xl-end {\n    float: right !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .float-xl-none {\n    float: none !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-xl-inline {\n    display: inline !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-xl-block {\n    display: block !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-xl-grid {\n    display: grid !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-xl-table {\n    display: table !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-xl-table-row {\n    display: table-row !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-xl-flex {\n    display: flex !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-xl-none {\n    display: none !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xl-row {\n    flex-direction: row !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xl-column {\n    flex-direction: column !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-xl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-xl-center {\n    align-items: center !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-xl-center {\n    align-content: center !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-xl-center {\n    align-self: center !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-xl-first {\n    order: -1 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-xl-0 {\n    order: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-xl-1 {\n    order: 1 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-xl-2 {\n    order: 2 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-xl-3 {\n    order: 3 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-xl-4 {\n    order: 4 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-xl-5 {\n    order: 5 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-xl-last {\n    order: 6 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-xl-0 {\n    margin: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-xl-3 {\n    margin: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-xl-4 {\n    margin: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-xl-5 {\n    margin: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-xl-auto {\n    margin: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-xl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-xl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-xl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-xl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-xl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-xl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-xl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-xl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-xl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-xl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-xl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-xl-0 {\n    margin-top: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-xl-3 {\n    margin-top: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-xl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-xl-5 {\n    margin-top: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-xl-auto {\n    margin-top: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-xl-0 {\n    margin-right: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-xl-3 {\n    margin-right: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-xl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-xl-5 {\n    margin-right: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-xl-auto {\n    margin-right: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-xl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-xl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-xl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-xl-0 {\n    margin-left: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-xl-3 {\n    margin-left: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-xl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-xl-5 {\n    margin-left: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-xl-auto {\n    margin-left: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-xl-0 {\n    padding: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-xl-3 {\n    padding: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-xl-4 {\n    padding: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-xl-5 {\n    padding: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-xl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-xl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-xl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-xl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-xl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-xl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-xl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-xl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-xl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-xl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-xl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-xl-0 {\n    padding-top: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-xl-3 {\n    padding-top: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-xl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-xl-5 {\n    padding-top: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-xl-0 {\n    padding-right: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-xl-3 {\n    padding-right: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-xl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-xl-5 {\n    padding-right: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-xl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-xl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-xl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-xl-0 {\n    padding-left: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-xl-3 {\n    padding-left: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-xl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-xl-5 {\n    padding-left: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-xl-0 {\n    gap: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-xl-1 {\n    gap: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-xl-2 {\n    gap: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-xl-3 {\n    gap: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-xl-4 {\n    gap: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-xl-5 {\n    gap: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .text-xl-start {\n    text-align: left !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .text-xl-end {\n    text-align: right !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .text-xl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1400px) {\n  .sabpaisa-css-utils-classes-version-five .float-xxl-start {\n    float: left !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .float-xxl-end {\n    float: right !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .float-xxl-none {\n    float: none !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-xxl-inline {\n    display: inline !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-xxl-block {\n    display: block !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-xxl-grid {\n    display: grid !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-xxl-table {\n    display: table !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-xxl-table-row {\n    display: table-row !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-xxl-flex {\n    display: flex !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-xxl-none {\n    display: none !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xxl-row {\n    flex-direction: row !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xxl-column {\n    flex-direction: column !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-xxl-start {\n    justify-content: flex-start !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-xxl-end {\n    justify-content: flex-end !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-xxl-center {\n    justify-content: center !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-xxl-between {\n    justify-content: space-between !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-xxl-around {\n    justify-content: space-around !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .justify-content-xxl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-xxl-start {\n    align-items: flex-start !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-xxl-end {\n    align-items: flex-end !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-xxl-center {\n    align-items: center !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-xxl-baseline {\n    align-items: baseline !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-items-xxl-stretch {\n    align-items: stretch !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-xxl-center {\n    align-content: center !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-xxl-between {\n    align-content: space-between !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-xxl-around {\n    align-content: space-around !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-xxl-center {\n    align-self: center !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-xxl-first {\n    order: -1 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-xxl-0 {\n    order: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-xxl-1 {\n    order: 1 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-xxl-2 {\n    order: 2 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-xxl-3 {\n    order: 3 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-xxl-4 {\n    order: 4 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-xxl-5 {\n    order: 5 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .order-xxl-last {\n    order: 6 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-xxl-0 {\n    margin: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-xxl-1 {\n    margin: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-xxl-2 {\n    margin: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-xxl-3 {\n    margin: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-xxl-4 {\n    margin: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-xxl-5 {\n    margin: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .m-xxl-auto {\n    margin: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-xxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-xxl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-xxl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-xxl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-xxl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-xxl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-xxl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-xxl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-xxl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-xxl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-xxl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-xxl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .my-xxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-xxl-0 {\n    margin-top: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-xxl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-xxl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-xxl-3 {\n    margin-top: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-xxl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-xxl-5 {\n    margin-top: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mt-xxl-auto {\n    margin-top: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-xxl-0 {\n    margin-right: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-xxl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-xxl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-xxl-3 {\n    margin-right: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-xxl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-xxl-5 {\n    margin-right: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .me-xxl-auto {\n    margin-right: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-xxl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-xxl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-xxl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-xxl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-xxl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .mb-xxl-auto {\n    margin-bottom: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-xxl-0 {\n    margin-left: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-xxl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-xxl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-xxl-3 {\n    margin-left: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-xxl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-xxl-5 {\n    margin-left: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ms-xxl-auto {\n    margin-left: auto !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-xxl-0 {\n    padding: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-xxl-1 {\n    padding: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-xxl-2 {\n    padding: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-xxl-3 {\n    padding: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-xxl-4 {\n    padding: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .p-xxl-5 {\n    padding: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-xxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-xxl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-xxl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-xxl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-xxl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .px-xxl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-xxl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-xxl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-xxl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-xxl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-xxl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .py-xxl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-xxl-0 {\n    padding-top: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-xxl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-xxl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-xxl-3 {\n    padding-top: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-xxl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pt-xxl-5 {\n    padding-top: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-xxl-0 {\n    padding-right: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-xxl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-xxl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-xxl-3 {\n    padding-right: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-xxl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pe-xxl-5 {\n    padding-right: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-xxl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-xxl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-xxl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-xxl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .pb-xxl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-xxl-0 {\n    padding-left: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-xxl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-xxl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-xxl-3 {\n    padding-left: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-xxl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .ps-xxl-5 {\n    padding-left: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-xxl-0 {\n    gap: 0 !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-xxl-1 {\n    gap: 0.25rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-xxl-2 {\n    gap: 0.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-xxl-3 {\n    gap: 1rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-xxl-4 {\n    gap: 1.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .gap-xxl-5 {\n    gap: 3rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .text-xxl-start {\n    text-align: left !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .text-xxl-end {\n    text-align: right !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .text-xxl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .sabpaisa-css-utils-classes-version-five .fs-1 {\n    font-size: 2.5rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .fs-2 {\n    font-size: 2rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .fs-3 {\n    font-size: 1.75rem !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .fs-4 {\n    font-size: 1.5rem !important;\n  }\n}\n@media print {\n  .sabpaisa-css-utils-classes-version-five .d-print-inline {\n    display: inline !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-print-block {\n    display: block !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-print-grid {\n    display: grid !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-print-table {\n    display: table !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-print-table-row {\n    display: table-row !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-print-flex {\n    display: flex !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n  .sabpaisa-css-utils-classes-version-five .d-print-none {\n    display: none !important;\n  }\n}\n";
styleInject(css_248z$1);

var css_248z = "@font-face {\n  font-family: \"Satoshi-Light\";\n  src: url(\"./assets/fonts/Satoshi-Light.woff2\") format(\"woff2\"), url(\"./assets/fonts/Satoshi-Light.woff\") format(\"woff\");\n  font-weight: 300;\n  font-display: swap;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Satoshi-Regular\";\n  src: url(\"./assets/fonts/Satoshi-Regular.woff2\") format(\"woff2\"), url(\"./assets/fonts/Satoshi-Regular.woff\") format(\"woff\");\n  font-weight: 400;\n  font-display: swap;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Satoshi-Medium\";\n  src: url(\"./assets/fonts/Satoshi-Medium.woff2\") format(\"woff2\"), url(\"./assets/fonts/Satoshi-Medium.woff\") format(\"woff\");\n  font-weight: 500;\n  font-display: swap;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Satoshi-Bold\";\n  src: url(\"./assets/fonts/Satoshi-Bold.woff2\") format(\"woff2\"), url(\"./assets/fonts/Satoshi-Bold.woff\") format(\"woff\");\n  font-weight: 700;\n  font-display: swap;\n  font-style: normal;\n}\n\n#pg-sdk #overlay {\n  display: block;\n  content: \"\";\n  position: absolute;\n  /* -webkit-backdrop-filter: blur(8px);\n  backdrop-filter: blur(8px); */\n  top: 0;\n  left: 0;\n  z-index: -1;\n  /* overflow: scroll; */\n}\n\n#pg-sdk #overlay::-webkit-scrollbar {\n  width: 0px;\n  height: auto;\n  background: transparent;\n}\n\n#pg-sdk #sdkPopup {\n  overflow: auto;\n  max-height: 98vh !important;\n  border-radius: 10px;\n  background: #EDF2F7;\n  font-family: \"Satoshi-Regular\", sans-serif;\n  height: auto;\n  min-height: 675px;\n  width: 430px;\n  box-shadow: 0px 0px 25px #aaa;\n  /* min-height: 700px; */\n  position: relative;\n  top: 0px;\n  left: calc((100% - 420px) / 2);\n  z-index: 111111111;\n  /* The switch - the box around the slider */\n  /* Hide default HTML checkbox */\n  /* The slider */\n  /* Rounded sliders */\n}\n\n::-webkit-scrollbar {\n  width: 0px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #EDF2F7;\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n\n  background: #555;\n}\n\n#sdkPopup h1,\n#sdkPopup h2,\n#sdkPopup h3,\n#sdkPopup h4,\n#sdkPopup h5,\n#sdkPopup h6,\n#sdkPopup p,\n#sdkPopup ul,\n#sdkPopup ol,\n#sdkPopup li,\n#sdkPopup input,\n#sdkPopup select,\n#sdkPopup button {\n  margin: 0;\n  padding: 0;\n  border: none;\n  outline: none;\n  font-family: \"Satoshi-Regular\", sans-serif;\n}\n\n#sdkPopup a {\n  text-decoration: none;\n  color: #1D1C1D;\n}\n\n#sdkPopup input:focus,\n#sdkPopup input:hover,\n#sdkPopup select:focus,\n#sdkPopup select:hover {\n  outline: none;\n  border: none;\n}\n\n#sdkPopup .text-white {\n  color: #fff;\n}\n\n#sdkPopup .text-dark {\n  color: #1D1C1D !important;\n}\n\n#sdkPopup .text-blue {\n  color: #0055B1;\n}\n\n#sdkPopup .text-center {\n  text-align: center;\n}\n\n#sdkPopup .text-small {\n  font-size: 0.8rem;\n}\n\n#sdkPopup .text-bold {\n  font-family: \"Satoshi-Bold\", sans-serif;\n  font-weight: 700;\n}\n\n#sdkPopup .text-medium {\n  font-family: \"Satoshi-Medium\", sans-serif;\n  font-weight: 600;\n}\n\n#sdkPopup .text-black {\n  color: #000000;\n}\n\n#sdkPopup .text-secondary {\n  color: #0055B1;\n}\n\n#sdkPopup .warning-text {\n  color: #ff0000;\n}\n\n#sdkPopup .thin {\n  font-family: \"Satoshi-Regular\", sans-serif;\n  font-weight: normal;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 119%;\n}\n\n#sdkPopup .textBeforeSection {\n  font-size: 0.9rem;\n  font-weight: 500;\n  margin-left: 10px;\n  color: #000;\n}\n\n#sdkPopup .flex {\n  display: flex;\n  align-items: center;\n}\n\n#sdkPopup .flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n#sdkPopup .flex-between {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n#sdkPopup .flex-between .half-input {\n  max-width: 185px !important;\n}\n\n#sdkPopup .flex-column-between {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: column;\n}\n\n#sdkPopup .align-right {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  flex-direction: column;\n}\n\n#sdkPopup .inline-image {\n  display: inline-block;\n}\n\n#sdkPopup .primaryButton {\n  padding: 15px 0px;\n  background: #1A68CD;\n  color: #fff;\n  text-align: center;\n  font-size: 1rem;\n  font-weight: 600;\n  width: 100%;\n  border-radius: 30px;\n  letter-spacing: 0.05rem;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 22px;\n  letter-spacing: 0.05em;\n  color: #FFFFFF;\n}\n\n#sdkPopup .primaryButton:hover {\n  transform: scale(0.9);\n  transition: 0.5s ease;\n  box-shadow: 5px 5px 20px rgba(0, 85, 177, 0.6784313725);\n}\n\n#sdkPopup .squareButton {\n  padding: 12px 0px;\n  background: #1A68CD;\n  color: #fff;\n  text-align: center;\n  font-size: 1rem;\n  font-weight: 600;\n  width: 100%;\n  letter-spacing: 0.05rem;\n}\n\n#sdkPopup .squareButton:hover {\n  transform: scale(0.9);\n  transition: 0.5s ease;\n  box-shadow: 5px 5px 20px rgba(0, 85, 177, 0.6784313725);\n}\n\n#sdkPopup .inputButton {\n  position: absolute;\n  right: 11px;\n  padding: 11px 24px;\n  background: #1A68CD;\n  color: #fff;\n  text-align: center;\n  font-size: 1rem;\n  font-weight: 600;\n  width: 100%;\n  max-width: -webkit-fit-content;\n  max-width: -moz-fit-content;\n  max-width: fit-content;\n  letter-spacing: 0.05rem;\n  border: 1px solid #1A68CD;\n  border-radius: 0px 7px 7px 0px;\n}\n\n#sdkPopup .inputButton:hover {\n  transition: 0.5s ease;\n  box-shadow: 5px 5px 20px rgba(0, 85, 177, 0.6784313725);\n}\n\n#sdkPopup .btnGroup {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  width: 100%;\n  margin: 40px auto 20px auto;\n}\n\n#sdkPopup .btnGroup .btn {\n  color: #fff !important;\n  padding: 10px 35px;\n  border-radius: 30px;\n  font-weight: 600;\n}\n\n#sdkPopup .btnGroup .btnPrimary {\n  background: #1A68CD;\n}\n\n#sdkPopup .btnGroup .btnNeutral {\n  background: #EBEAEB;\n}\n\n#sdkPopup .errorInput {\n  color: #ff0000;\n  border: 1px solid #ff0000;\n}\n\n#sdkPopup .successInput {\n  color: #4BB543;\n  border: 1px solid #4BB543;\n}\n\n#sdkPopup .input-underline {\n  border-bottom: 1px solid #696969;\n  padding: 10px 15px;\n  display: flex;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n#sdkPopup .input-underline input {\n  width: 100%;\n  background: transparent;\n}\n\n#sdkPopup .switch {\n  position: relative;\n  display: block;\n  width: 40px;\n  height: 22px;\n  margin-right: 10px;\n}\n\n#sdkPopup .switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n#sdkPopup .slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: 0.4s;\n}\n\n#sdkPopup .slider:before {\n  position: absolute;\n  content: \"\";\n  height: 14px;\n  width: 14px;\n  left: 2px;\n  bottom: 1.5px;\n  background: linear-gradient(270.55deg, #4285F8 -14.11%, #0055B1 95.84%);\n  transition: 0.4s;\n}\n\n#sdkPopup input:checked+.slider {\n  /* background: linear-gradient(270.55deg, #4285F8 -14.11%, #0055B1 95.84%); */\n  /* border-radius: 34px;\n  border: solid 3px transparent;\n  background-image: linear-gradient(270.55deg, #4285F8 -14.11%, #0055B1 95.84%), linear-gradient(101deg, #4285F8, #0055B1);\n  background-origin: border-box;\n  background-clip: content-box, border-box;\n  box-shadow: 2px 100px 1px #fff inset; */\n  border-radius: 34px;\n  border: solid 3px #0055B1;\n  background: #fff;\n}\n\n#sdkPopup input:focus+.slider {\n  box-shadow: 0 0 1px #2196F3;\n}\n\n#sdkPopup input:checked+.slider:before {\n  background: linear-gradient(270.55deg, #4285F8 -14.11%, #0055B1 95.84%);\n  transform: translateX(17px);\n}\n\n#sdkPopup .slider.round {\n  border-radius: 34px;\n  border: solid 3px #0055B1;\n  background: #fff;\n  /* background-image: linear-gradient(270.55deg, #4285F8 -14.11%, #0055B1 95.84%), linear-gradient(101deg, #4285F8, #0055B1);\n  background-origin: border-box;\n  background-clip: content-box, border-box;\n  box-shadow: 2px 100px 1px #fff inset; */\n}\n\n#sdkPopup .slider.round:before {\n  border-radius: 50%;\n}\n\n#sdkPopup .customRadio {\n  margin-top: -10px;\n  /* Hide the browser's default radio button */\n  /* Create a custom radio button */\n  /* On mouse-over, add a grey background color */\n  /* When the radio button is checked, add a blue background */\n  /* Create the indicator (the dot/circle - hidden when not checked) */\n  /* Show the indicator (dot/circle) when checked */\n  /* Style the indicator (dot/circle) */\n}\n\n#sdkPopup .customRadio .container {\n  display: block;\n  position: relative;\n  padding-left: 35px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n#sdkPopup .customRadio .container input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n\n#sdkPopup .customRadio .checkmark {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 21px;\n  width: 21px;\n  background-color: #f5f5f5;\n  border: 1px solid #696969;\n  border-radius: 50%;\n}\n\n#sdkPopup .customRadio .container:hover input~.checkmark {\n  background-color: #f5f5f5;\n}\n\n#sdkPopup .customRadio .container input:checked~.checkmark {\n  background-color: #1A68CD;\n  border: 1px solid #fff;\n}\n\n#sdkPopup .customRadio .checkmark:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n#sdkPopup .customRadio .container input:checked~.checkmark:after {\n  display: block;\n}\n\n#sdkPopup .customRadio .container .checkmark:after {\n  top: 5px;\n  left: 5px;\n  width: 11px;\n  height: 11px;\n  border-radius: 50%;\n  background: white;\n}\n\n#sdkPopup .popupHeader {\n  padding: 20px 10px;\n  width: 100%;\n  text-align: center;\n  background: #0055B1;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n#sdkPopup .popupHeader img {\n  width: 14px;\n  /* width: 59px; */\n  height: 18px;\n  margin-right: 6px;\n}\n\n#sdkPopup .popupHeader span {\n  font-style: normal;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 119%;\n  margin-bottom: -2.1px;\n}\n\n#sdkPopup .radio {\n  margin-top: -30px;\n}\n\n#sdkPopup .radio [type=radio]:checked,\n#sdkPopup .radio [type=radio]:not(:checked) {\n  position: absolute;\n  left: -9999px;\n}\n\n#sdkPopup .radio [type=radio]:checked+label,\n#sdkPopup .radio [type=radio]:not(:checked)+label {\n  position: relative;\n  padding-left: 28px;\n  cursor: pointer;\n  line-height: 20px;\n  display: inline-block;\n  color: #666;\n}\n\n#sdkPopup .radio [type=radio]:checked+label:before,\n#sdkPopup .radio [type=radio]:not(:checked)+label:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 18px;\n  height: 18px;\n  border: 1px solid #ddd;\n  border-radius: 100%;\n  background: #fff;\n}\n\n#sdkPopup .radio [type=radio]:checked+label:after,\n#sdkPopup .radio [type=radio]:not(:checked)+label:after {\n  content: \"\";\n  width: 12px;\n  height: 12px;\n  background: #4BB543;\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  border-radius: 100%;\n  transition: all 0.2s ease;\n}\n\n#sdkPopup .radio [type=radio]:not(:checked)+label:after {\n  opacity: 0;\n  transform: scale(0);\n}\n\n#sdkPopup .radio [type=radio]:checked+label:after {\n  opacity: 1;\n  transform: scale(1);\n}\n\n#sdkPopup .banklogo {\n  margin-right: 10px;\n}\n\n#sdkPopup .bankname {\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n#sdkPopup .popupBody {\n  padding: 17px 10px 0px 12px;\n  /* min-height: 600px; */\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n#sdkPopup .popupBody .sectionHeading-large {\n  font-size: 24px;\n  font-weight: 600;\n  margin-top: 0.5rem;\n  margin-bottom: 8px;\n}\n\n#sdkPopup .popupBody .clippedCard {\n  padding: 20px;\n  /* margin-top: 10px; */\n  background: linear-gradient(270deg, #4285F8 9.98%, #0055B1 96.75%);\n  border-radius: 10px;\n  position: relative;\n}\n\n#sdkPopup .popupBody .clippedCard::before {\n  content: \"\";\n  position: absolute;\n  width: 15px;\n  height: 15px;\n  top: 50%;\n  transform: translate(-50%, -50%) rotate(45deg);\n  border: 5px solid transparent;\n  border-top-color: #EDF2F7;\n  border-right-color: #EDF2F7;\n  border-radius: 100%;\n  pointer-events: none;\n  left: 0px;\n  background: #EDF2F7;\n}\n\n#sdkPopup .popupBody .clippedCard::after {\n  content: \"\";\n  position: absolute;\n  width: 15px;\n  height: 15px;\n  top: 50%;\n  transform: translate(-50%, -50%) rotate(45deg);\n  border: 5px solid transparent;\n  border-top-color: #EDF2F7;\n  border-right-color: #EDF2F7;\n  border-radius: 100%;\n  pointer-events: none;\n  right: -15px;\n  background: #EDF2F7;\n}\n\n#sdkPopup .popupBody .clippedCard .profileSection {\n  display: flex;\n}\n\n#sdkPopup .popupBody .clippedCard .profileSection .profilePicture {\n  height: auto;\n  text-align: center;\n  margin-bottom: 10px;\n  max-width: 47px;\n}\n\n#sdkPopup .popupBody .clippedCard .profileSection .beneficiaryName {\n  /* text-align: center; */\n  font-size: 20px;\n  font-weight: 700;\n  text-transform: capitalize;\n  line-height: 24.8px;\n  margin-left: 24px;\n}\n\n#sdkPopup .popupBody .clippedCard .metaSection .partnerName {\n  margin-bottom: 0.3rem;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 124%;\n}\n\n#pg-sdk .border-right {\n  border-right: 1px solid #dee2e6 !important;\n}\n\n.clientDetails .border-right h3 {\n  margin-bottom: 0.3rem;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 124%;\n}\n\n#sdkPopup .popupBody .clippedCard .metaSection {\n  margin-left: 24px;\n}\n\n#sdkPopup .popupBody .clippedCard .metaSection p {\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: 0.6px;\n}\n\n#sdkPopup .popupBody .clippedCard .metaSection h3 {\n  font-size: 24px !important;\n  letter-spacing: 0.6px;\n  font-weight: 700;\n  margin-top: 18px !important;\n}\n\n#sdkPopup .popupBody .clippedCard .metaSection strong {\n  font-weight: 600;\n}\n\n#sdkPopup .popupBody .clippedCard .metaSection .amount {\n  margin-top: 0.8rem;\n  font-size: 1.4rem;\n}\n\n#sdkPopup .popupBody .clippedCard .metaSection .amount img {\n  height: 1.2rem;\n  margin-right: 0.4rem;\n}\n\n#sdkPopup .popupBody .clippedCard .clientDetails {\n  border-bottom: 1px dashed #fff;\n  border-top: 1px dashed #fff;\n  /* border-bottom: 1px dashed #fff; */\n  margin-left: 0px;\n  margin-right: 0px;\n  padding: 6px 0px;\n}\n\n\n#sdkPopup .popupBody .clippedCard .clientDetails .client {\n  padding: 5px 15px 5px 0px;\n  width: 100%;\n}\n\n#sdkPopup .popupBody .clippedCard .clientDetails .client .partnerName {\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n  line-height: 1.8rem;\n}\n\n#sdkPopup .popupBody .clippedCard .clientDetails .client h3.thin {\n  font-size: 1.2rem;\n  margin-bottom: .5rem;\n}\n\n#sdkPopup .popupBody .clippedCard .clientDetails .client #clientName {\n  font-size: 24px !important;\n  font-weight: 600;\n  letter-spacing: 0.8px;\n}\n\n#sdkPopup .popupBody .clippedCard .clientDetails .clientInfo {\n  padding: 5px 0px 5px 15px;\n  /* width: 100%; */\n}\n\n#sdkPopup .popupBody .clippedCard .clientDetails .clientInfo .field {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 2px 0px;\n}\n\n#sdkPopup .popupBody .clippedCard .clientDetails .clientInfo .field .parameter,\n#sdkPopup .popupBody .clippedCard .clientDetails .clientInfo .field .value {\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 99.9%;\n  letter-spacing: 0.06em;\n  color: #FFFFFF;\n}\n\n#sdkPopup .popupBody .clippedCard .clientDetails .clientInfo .field .value {\n  letter-spacing: 0px;\n}\n\n#sdkPopup .popupBody .clippedCard .clientDetails .clientInfo .field {\n  margin-bottom: 17px;\n}\n\n#sdkPopup .popupBody .clippedCard .clientDetails .clientInfo .field:nth-child(2) {\n  margin-bottom: 0;\n}\n\n\n#sdkPopup .popupBody .clippedCard .clientDetails .clientInfo .field .value img {\n  letter-spacing: 0px;\n  padding-right: 8px;\n\n}\n\n\n#sdkPopup .popupBody .clippedCard .amountDetails .dataTable {\n  width: 100%;\n  margin-top: 10px;\n  border-bottom: 1px dashed #EBEAEB;\n  padding-bottom: 8px\n}\n\n#sdkPopup .popupBody .clippedCard .amountDetails .dataTable .field {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 2px 0px;\n}\n\n#sdkPopup .popupBody .clippedCard .amountDetails .dataTable .field .parameter,\n#sdkPopup .popupBody .clippedCard .amountDetails .dataTable .field .value {\n  color: #fff;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 16px;\n}\n\n#sdkPopup .popupBody .clippedCard .amountDetails .dataTable .field .value {\n  letter-spacing: 1px;\n}\n\n#sdkPopup .popupBody .clippedCard .totalRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 18px;\n}\n\n#sdkPopup .popupBody .clippedCard .totalRow p {\n  font-weight: 700;\n  font-size: 18px;\n  color: #FFFFFF;\n}\n\n#sdkPopup .popupBody .buttonWrapper {\n  width: 100%;\n  height: 60px;\n}\n\n#sdkPopup .popupBody .buttonWrapper .changeMode {\n  padding: 8px 24px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  background: #4285F8;\n  float: right;\n  margin: 20px 10px;\n}\n\n#sdkPopup .popupBody .buttonWrapper .changeMode img {\n  margin-right: 10px;\n}\n\n#sdkPopup .popupBody .buttonWrapper .changeMode span {\n  color: #fff;\n}\n\n#sdkPopup .popupBody .activity .form .form-header {\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n#sdkPopup .popupBody .activity .form .form-header .form-heading {\n  font-size: 24px;\n  font-weight: 700;\n  font-family: \"Satoshi-Bold\", sans-serif;\n  /* margin: 0px auto; */\n}\n\n\n#sdkPopup .popupBody .activity .form .form-header .expandIcon {\n  height: 10px;\n  margin-right: 5px;\n  transform: rotate(180deg);\n  cursor: pointer;\n}\n\n#sdkPopup .popupBody .activity label {\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 20.25px;\n  color: #1D1C1D;\n  margin-bottom: 8px;\n}\n\n#sdkPopup .form-collapsible-client {\n  display: none;\n  visibility: hidden;\n  font-family: \"Satoshi-Medium\", sans-serif;\n}\n\n#sdkPopup .form-collapsible.showForm {\n  display: block;\n  visibility: visible;\n}\n\n#sdkPopup .popupBody .activity .form .form-header .expandIcon.down {\n  transform: rotate(-0deg) !important;\n}\n\n#sdkPopup .popupBody .activity .input {\n  /* margin-top: 0.4rem; */\n  margin-bottom: 0.4rem;\n  border: 1px solid #1D1C1D;\n  border-radius: 8px;\n  background: #fff;\n  padding: 15px 20px;\n  max-height: 50px;\n  height: 58px;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  width: 406px;\n}\n\n#pg-sdk .paddingForm .select__control {\n  margin-top: 0.4rem;\n  margin-bottom: 1rem;\n  border: 1px solid #1D1C1D;\n  border-radius: 8px;\n  background: #fff;\n  padding: 5px 20px;\n  max-height: 50px;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n}\n\n\n\n#sdkPopup .popupBody .activity .input:focus {\n  border: 1px solid #1A68CD;\n  flex-direction: row-reverse;\n  transition: flex-direction 0.6s ease-in;\n}\n\n#sdkPopup .popupBody .activity .input .active {\n  border: 1px solid #0055B1;\n}\n\n#sdkPopup .popupBody .activity .input img.inputIcon {\n  height: 15px !important;\n  padding-right: 14px;\n}\n\n#sdkPopup .popupBody .activity .input input {\n  font-size: 1rem;\n  letter-spacing: 0.05rem;\n  font-family: \"Satoshi-Regular\", sans-serif;\n  width: 100%;\n  margin-left: 15px;\n  height: 42px;\n  padding-left: 10px;\n  margin-right: -17px;\n  border-radius: 0px 7px 7px 0px;\n}\n\n#sdkPopup .popupBody .activity .input input:focus {\n  outline: none;\n  flex-direction: row-reverse;\n  transition: flex-direction 0.6s ease-in;\n}\n\n#sdkPopup .popupBody .activity .leftInput input {\n  height: 40px;\n  margin-left: -16px;\n  margin-right: 20px;\n  padding: 10px;\n  border-radius: 3px;\n}\n\n#sdkPopup .popupBody .activity select {\n  padding: 12px 24px;\n  border: 1px solid #696969;\n  font-family: \"Satoshi-Regular\", sans-serif;\n  width: 100%;\n}\n\n#sdkPopup .popupBody .activity .field-bordered {\n  border: 1px solid #696969;\n  padding: 12px 15px;\n  margin-bottom: 20px;\n  border-radius: 6px;\n}\n\n#sdkPopup .popupBody .activity .savedCard {\n  display: flex;\n  align-items: center;\n  position: relative;\n  background: #fff;\n  padding: 15px;\n  border-radius: 8px;\n  border: 1px solid #696969;\n  margin: 10px 0px;\n}\n\n#sdkPopup .popupBody .activity .savedCard .cardInfo .text-dark {\n  font-size: 0.9rem;\n  line-height: 1.2rem;\n}\n\n#sdkPopup .popupBody .activity .savedCard .cardInfo .cvv {\n  background: #D9D9D9;\n  padding: 12px 16px;\n  border: 1px solid #696969;\n  font-family: \"Satoshi-Medium\", sans-serif;\n  font-size: 0.9rem;\n  border-radius: 0px;\n  max-width: 100px;\n  color: #000000;\n  margin: 1rem 0;\n}\n\n#sdkPopup .popupBody .activity .savedCard .delete {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  background: transparent;\n}\n\n#sdkPopup .popupBody .paymentInProgress h2 {\n  margin-top: 4rem;\n  margin-bottom: 0.5rem;\n}\n\n#sdkPopup .popupBody .paymentInProgress p {\n  margin-bottom: 2rem;\n}\n\n#sdkPopup .popupBody .paymentInProgress .timer {\n  padding: 9px 18px;\n  border-radius: 9px;\n  background: #ff5523;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  margin: 1rem auto;\n  font-weight: 600;\n  color: #fff;\n}\n\n#sdkPopup .popupBody .paymentInProgress .timer img {\n  margin-right: 10px;\n}\n\n#sdkPopup .popupBody .paymentInProgress .timer span {\n  padding: 0px 2px;\n}\n\n#sdkPopup .popupBody .methods .payMethods {\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: 95%;\n  justify-content: space-between;\n  margin: 20px auto;\n  padding: 10px 0px 20px 0px;\n  padding-top: 0px;\n  border-bottom: 1px solid #EBEAEB;\n  /* overflow-x: scroll;\n  height: 100px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between; */\n}\n\n#sdkPopup .popupBody .methods .payMethods::-webkit-scrollbar {\n  height: 2px;\n}\n\n#sdkPopup .popupBody .methods .payMethods::-webkit-scrollbar-track {\n  background: #eee;\n  /* border-radius: 1px; */\n}\n\n#sdkPopup .popupBody .methods .payMethods::-webkit-scrollbar-thumb {\n  background: #1A68CD;\n}\n\n#sdkPopup .popupBody .methods .payMethods::-webkit-scrollbar-thumb:hover {\n  background: #2196F3;\n}\n\n@-webkit-keyframes internal {\n  0% {\n    stroke-dashoffset: 187;\n  }\n\n  25% {\n    stroke-dashoffset: 80;\n  }\n\n  100% {\n    stroke-dashoffset: 187;\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes internal {\n  0% {\n    stroke-dashoffset: 187;\n  }\n\n  25% {\n    stroke-dashoffset: 80;\n  }\n\n  100% {\n    stroke-dashoffset: 187;\n    transform: rotate(360deg);\n  }\n}\n\n@-webkit-keyframes external {\n  0% {\n    stroke-dashoffset: 312;\n    transform: rotate(70deg);\n  }\n\n  60% {\n    stroke-dashoffset: -312;\n  }\n\n  100% {\n    stroke-dashoffset: -312;\n    transform: rotate(450deg);\n  }\n}\n\n@keyframes external {\n  0% {\n    stroke-dashoffset: 312;\n    transform: rotate(70deg);\n  }\n\n  60% {\n    stroke-dashoffset: -312;\n  }\n\n  100% {\n    stroke-dashoffset: -312;\n    transform: rotate(450deg);\n  }\n}\n\n@-webkit-keyframes bgcolors {\n  0% {\n    background: #1a87c5;\n  }\n\n  25% {\n    background: #c51a3a;\n  }\n\n  50% {\n    background: #e6d121;\n  }\n\n  75% {\n    background: #22cf76;\n  }\n\n  100% {\n    background: #1a87c5;\n  }\n}\n\n@keyframes bgcolors {\n  0% {\n    background: #1a87c5;\n  }\n\n  25% {\n    background: #c51a3a;\n  }\n\n  50% {\n    background: #e6d121;\n  }\n\n  75% {\n    background: #22cf76;\n  }\n\n  100% {\n    background: #1a87c5;\n  }\n}\n\n#sdkPopup #overlayContent {\n  position: absolute;\n  z-index: 111111111;\n  top: 80px;\n}\n\n#sdkPopup #overlayContent::before {\n  display: block;\n  content: \"\";\n  position: absolute;\n  height: 1500px;\n  width: 104%;\n  background: rgba(0, 0, 0, 0.7);\n  -webkit-backdrop-filter: blur(8px);\n  backdrop-filter: blur(8px);\n  border: none;\n  top: -60%;\n  left: 0;\n  z-index: -1;\n  overflow: scroll;\n}\n\n#pg-sdk .credit-card__header {\n  margin-bottom: 20px;\n  display: grid;\n  grid-template-columns: auto auto;\n  /* border: 1px solid rgba(27, 42, 59, 0.1); */\n}\n\n#pg-sdk .credit-card__header span {\n  padding: 10px 0;\n  display: inline-block;\n  cursor: pointer;\n  text-align: center;\n  transition: all 0.3s ease-in;\n  border: 1px solid rgba(27, 42, 59, 0.1);\n\n  /* border-bottom: 3px solid transparent !important; */\n  /* border: 1px solid rgba(27, 42, 59, 0.1); */\n}\n\n#pg-sdk .credit-card__header .border-bottom {\n  border-bottom: 5px solid rgb(78, 224, 78) !important;\n}\n\n#sdkPopup #overlayContent::before::-webkit-scrollbar {\n  width: 1px;\n  height: auto;\n  background: transparent;\n}\n\n#sdkPopup #greenLoader {\n  border: 8px solid transparent;\n  /* Light grey */\n  border-top: 8px solid #4BB543;\n  /* Blue */\n  border-radius: 50%;\n  width: 120px;\n  height: 120px;\n  -webkit-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n  margin: 80px auto;\n}\n\n@-webkit-keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n#pg-sdk .popupOverlay::-webkit-scrollbar {\n  width: 1px;\n  height: auto;\n  background: transparent;\n}\n\n#pg-sdk .modal-content {\n  border: none !important;\n}\n\n#pg-sdk a {\n  cursor: pointer;\n}\n\n#pg-sdk .cursor-pointer {\n  cursor: pointer;\n}\n\n#pg-sdk .modal-dialog {\n  margin-top: 0px !important;\n}\n\n#pg-sdk .modal-body {\n  /* padding-top: 8px !important; */\n}\n\n\n#sdkPopup .popupBody .credits .flex-center p {\n  color: #1D1C1D;\n  font-weight: 500;\n  font-size: 12px;\n  margin-left: 10px;\n}\n\n#sdkPopup .popupBody .credits p.text-center {\n  font-size: 14px;\n}\n\n#sdkPopup .popupBody .credits p.text-center a {\n  font-weight: 600;\n}\n\n#sdkPopup .popupBody .credits .partners {\n  margin-bottom: 20px;\n}\n\n#sdkPopup .popupBody .credits .partners img {\n  -o-object-fit: contain;\n  object-fit: contain;\n  margin-top: 10px;\n}\n\n#sdkPopup .popupBody .credits .clientlogo {\n  margin: 1rem .25rem;\n}\n\n#pg-sdk .partner-logo {\n  margin-left: 40px;\n}\n\n#pg-sdk .close {\n  position: absolute;\n  right: 14px;\n  top: 21px;\n  width: 32px;\n  height: 32px;\n  opacity: 0.3;\n}\n\n#pg-sdk .close:hover {\n  opacity: 1;\n}\n\n#pg-sdk .close:before,\n#pg-sdk .close:after {\n  position: absolute;\n  left: 15px;\n  content: ' ';\n  height: 14px;\n  width: 2px;\n  background-color: #333;\n}\n\n#pg-sdk .close:before {\n  transform: rotate(45deg);\n}\n\n#pg-sdk .close:after {\n  transform: rotate(-45deg);\n}\n\n#pg-sdk .mt-16 {\n  margin-top: 16px;\n}";
styleInject(css_248z);

var devUrl = "https://secure.sabpaisa.in/SabPaisa/sabPaisaInit?v=1";
var stagUrl = "https://stage-securepay.sabpaisa.in/SabPaisa/sabPaisaInit?v=1";
var prodUrl = "https://securepay.sabpaisa.in/SabPaisa/sabPaisaInit?v=1";
var s3Url = "https://icon.sabpaisa.in/sabpaisa/checkout/";

var _nodeResolve_empty = {};

var _nodeResolve_empty$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': _nodeResolve_empty
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(_nodeResolve_empty$1);

var core = createCommonjsModule(function (module, exports) {
(function (root, factory) {
	{
		// CommonJS
		module.exports = factory();
	}
}(commonjsGlobal, function () {

	/*globals window, global, require*/

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined$1) {

	    var crypto;

	    // Native crypto from window (Browser)
	    if (typeof window !== 'undefined' && window.crypto) {
	        crypto = window.crypto;
	    }

	    // Native crypto in web worker (Browser)
	    if (typeof self !== 'undefined' && self.crypto) {
	        crypto = self.crypto;
	    }

	    // Native crypto from worker
	    if (typeof globalThis !== 'undefined' && globalThis.crypto) {
	        crypto = globalThis.crypto;
	    }

	    // Native (experimental IE 11) crypto from window (Browser)
	    if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
	        crypto = window.msCrypto;
	    }

	    // Native crypto from global (NodeJS)
	    if (!crypto && typeof commonjsGlobal !== 'undefined' && commonjsGlobal.crypto) {
	        crypto = commonjsGlobal.crypto;
	    }

	    // Native crypto import via require (NodeJS)
	    if (!crypto && typeof commonjsRequire === 'function') {
	        try {
	            crypto = require$$0;
	        } catch (err) {}
	    }

	    /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */
	    var cryptoSecureRandomInt = function () {
	        if (crypto) {
	            // Use getRandomValues method (Browser)
	            if (typeof crypto.getRandomValues === 'function') {
	                try {
	                    return crypto.getRandomValues(new Uint32Array(1))[0];
	                } catch (err) {}
	            }

	            // Use randomBytes method (NodeJS)
	            if (typeof crypto.randomBytes === 'function') {
	                try {
	                    return crypto.randomBytes(4).readInt32LE();
	                } catch (err) {}
	            }
	        }

	        throw new Error('Native crypto module could not be used to get secure random number.');
	    };

	    /*
	     * Local polyfill of Object.create

	     */
	    var create = Object.create || (function () {
	        function F() {}

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }());

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined$1) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var j = 0; j < thatSigBytes; j += 4) {
	                    thisWords[(thisSigBytes + j) >>> 2] = thatWords[j >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            for (var i = 0; i < nBytes; i += 4) {
	                words.push(cryptoSecureRandomInt());
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            var processedWords;

	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));
});

var x64Core = createCommonjsModule(function (module, exports) {
(function (root, factory) {
	{
		// CommonJS
		module.exports = factory(core);
	}
}(commonjsGlobal, function (CryptoJS) {

	(function (undefined$1) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var X32WordArray = C_lib.WordArray;

	    /**
	     * x64 namespace.
	     */
	    var C_x64 = C.x64 = {};

	    /**
	     * A 64-bit word.
	     */
	    C_x64.Word = Base.extend({
	        /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */
	        init: function (high, low) {
	            this.high = high;
	            this.low = low;
	        }

	        /**
	         * Bitwise NOTs this word.
	         *
	         * @return {X64Word} A new x64-Word object after negating.
	         *
	         * @example
	         *
	         *     var negated = x64Word.not();
	         */
	        // not: function () {
	            // var high = ~this.high;
	            // var low = ~this.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ANDs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to AND with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ANDing.
	         *
	         * @example
	         *
	         *     var anded = x64Word.and(anotherX64Word);
	         */
	        // and: function (word) {
	            // var high = this.high & word.high;
	            // var low = this.low & word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to OR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ORing.
	         *
	         * @example
	         *
	         *     var ored = x64Word.or(anotherX64Word);
	         */
	        // or: function (word) {
	            // var high = this.high | word.high;
	            // var low = this.low | word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise XORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to XOR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after XORing.
	         *
	         * @example
	         *
	         *     var xored = x64Word.xor(anotherX64Word);
	         */
	        // xor: function (word) {
	            // var high = this.high ^ word.high;
	            // var low = this.low ^ word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the left.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftL(25);
	         */
	        // shiftL: function (n) {
	            // if (n < 32) {
	                // var high = (this.high << n) | (this.low >>> (32 - n));
	                // var low = this.low << n;
	            // } else {
	                // var high = this.low << (n - 32);
	                // var low = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the right.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftR(7);
	         */
	        // shiftR: function (n) {
	            // if (n < 32) {
	                // var low = (this.low >>> n) | (this.high << (32 - n));
	                // var high = this.high >>> n;
	            // } else {
	                // var low = this.high >>> (n - 32);
	                // var high = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Rotates this word n bits to the left.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotL(25);
	         */
	        // rotL: function (n) {
	            // return this.shiftL(n).or(this.shiftR(64 - n));
	        // },

	        /**
	         * Rotates this word n bits to the right.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotR(7);
	         */
	        // rotR: function (n) {
	            // return this.shiftR(n).or(this.shiftL(64 - n));
	        // },

	        /**
	         * Adds this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to add with this word.
	         *
	         * @return {X64Word} A new x64-Word object after adding.
	         *
	         * @example
	         *
	         *     var added = x64Word.add(anotherX64Word);
	         */
	        // add: function (word) {
	            // var low = (this.low + word.low) | 0;
	            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
	            // var high = (this.high + word.high + carry) | 0;

	            // return X64Word.create(high, low);
	        // }
	    });

	    /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    C_x64.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined$1) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 8;
	            }
	        },

	        /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */
	        toX32: function () {
	            // Shortcuts
	            var x64Words = this.words;
	            var x64WordsLength = x64Words.length;

	            // Convert
	            var x32Words = [];
	            for (var i = 0; i < x64WordsLength; i++) {
	                var x64Word = x64Words[i];
	                x32Words.push(x64Word.high);
	                x32Words.push(x64Word.low);
	            }

	            return X32WordArray.create(x32Words, this.sigBytes);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);

	            // Clone "words" array
	            var words = clone.words = this.words.slice(0);

	            // Clone each X64Word object
	            var wordsLength = words.length;
	            for (var i = 0; i < wordsLength; i++) {
	                words[i] = words[i].clone();
	            }

	            return clone;
	        }
	    });
	}());


	return CryptoJS;

}));
});

var libTypedarrays = createCommonjsModule(function (module, exports) {
(function (root, factory) {
	{
		// CommonJS
		module.exports = factory(core);
	}
}(commonjsGlobal, function (CryptoJS) {

	(function () {
	    // Check if typed arrays are supported
	    if (typeof ArrayBuffer != 'function') {
	        return;
	    }

	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;

	    // Reference original init
	    var superInit = WordArray.init;

	    // Augment WordArray.init to handle typed arrays
	    var subInit = WordArray.init = function (typedArray) {
	        // Convert buffers to uint8
	        if (typedArray instanceof ArrayBuffer) {
	            typedArray = new Uint8Array(typedArray);
	        }

	        // Convert other array views to uint8
	        if (
	            typedArray instanceof Int8Array ||
	            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
	            typedArray instanceof Int16Array ||
	            typedArray instanceof Uint16Array ||
	            typedArray instanceof Int32Array ||
	            typedArray instanceof Uint32Array ||
	            typedArray instanceof Float32Array ||
	            typedArray instanceof Float64Array
	        ) {
	            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
	        }

	        // Handle Uint8Array
	        if (typedArray instanceof Uint8Array) {
	            // Shortcut
	            var typedArrayByteLength = typedArray.byteLength;

	            // Extract bytes
	            var words = [];
	            for (var i = 0; i < typedArrayByteLength; i++) {
	                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
	            }

	            // Initialize this word array
	            superInit.call(this, words, typedArrayByteLength);
	        } else {
	            // Else call normal init
	            superInit.apply(this, arguments);
	        }
	    };

	    subInit.prototype = WordArray;
	}());


	return CryptoJS.lib.WordArray;

}));
});

var encUtf16 = createCommonjsModule(function (module, exports) {
(function (root, factory) {
	{
		// CommonJS
		module.exports = factory(core);
	}
}(commonjsGlobal, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * UTF-16 BE encoding strategy.
	     */
	    C_enc.Utf16 = C_enc.Utf16BE = {
	        /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    /**
	     * UTF-16 LE encoding strategy.
	     */
	    C_enc.Utf16LE = {
	        /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    function swapEndian(word) {
	        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
	    }
	}());


	return CryptoJS.enc.Utf16;

}));
});

var encBase64 = createCommonjsModule(function (module, exports) {
(function (root, factory) {
	{
		// CommonJS
		module.exports = factory(core);
	}
}(commonjsGlobal, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              var bitsCombined = bits1 | bits2;
	              words[nBytes >>> 2] |= bitsCombined << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	return CryptoJS.enc.Base64;

}));
});

var encBase64url = createCommonjsModule(function (module, exports) {
(function (root, factory) {
	{
		// CommonJS
		module.exports = factory(core);
	}
}(commonjsGlobal, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64url encoding strategy.
	     */
	    C_enc.Base64url = {
	        /**
	         * Converts a word array to a Base64url string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {string} The Base64url string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
	         */
	        stringify: function (wordArray, urlSafe=true) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = urlSafe ? this._safe_map : this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64url string to a word array.
	         *
	         * @param {string} base64Str The Base64url string.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
	         */
	        parse: function (base64Str, urlSafe=true) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = urlSafe ? this._safe_map : this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                reverseMap = this._reverseMap = [];
	                for (var j = 0; j < map.length; j++) {
	                    reverseMap[map.charCodeAt(j)] = j;
	                }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
	        _safe_map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_',
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	        var words = [];
	        var nBytes = 0;
	        for (var i = 0; i < base64StrLength; i++) {
	            if (i % 4) {
	                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	                var bitsCombined = bits1 | bits2;
	                words[nBytes >>> 2] |= bitsCombined << (24 - (nBytes % 4) * 8);
	                nBytes++;
	            }
	        }
	        return WordArray.create(words, nBytes);
	    }
	}());

	return CryptoJS.enc.Base64url;

}));
});

var md5 = createCommonjsModule(function (module, exports) {
(function (root, factory) {
	{
		// CommonJS
		module.exports = factory(core);
	}
}(commonjsGlobal, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var T = [];

	    // Compute constants
	    (function () {
	        for (var i = 0; i < 64; i++) {
	            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
	        }
	    }());

	    /**
	     * MD5 hash algorithm.
	     */
	    var MD5 = C_algo.MD5 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }

	            // Shortcuts
	            var H = this._hash.words;

	            var M_offset_0  = M[offset + 0];
	            var M_offset_1  = M[offset + 1];
	            var M_offset_2  = M[offset + 2];
	            var M_offset_3  = M[offset + 3];
	            var M_offset_4  = M[offset + 4];
	            var M_offset_5  = M[offset + 5];
	            var M_offset_6  = M[offset + 6];
	            var M_offset_7  = M[offset + 7];
	            var M_offset_8  = M[offset + 8];
	            var M_offset_9  = M[offset + 9];
	            var M_offset_10 = M[offset + 10];
	            var M_offset_11 = M[offset + 11];
	            var M_offset_12 = M[offset + 12];
	            var M_offset_13 = M[offset + 13];
	            var M_offset_14 = M[offset + 14];
	            var M_offset_15 = M[offset + 15];

	            // Working varialbes
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];

	            // Computation
	            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
	            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
	            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
	            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
	            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
	            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
	            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
	            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
	            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
	            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
	            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
	            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
	            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
	            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
	            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
	            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

	            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
	            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
	            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
	            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
	            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
	            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
	            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
	            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
	            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
	            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
	            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
	            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
	            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
	            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
	            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
	            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

	            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
	            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
	            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
	            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
	            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
	            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
	            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
	            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
	            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
	            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
	            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
	            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
	            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
	            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
	            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
	            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

	            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
	            d = II(d, a, b, c, M_offset_7,  10, T[49]);
	            c = II(c, d, a, b, M_offset_14, 15, T[50]);
	            b = II(b, c, d, a, M_offset_5,  21, T[51]);
	            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
	            d = II(d, a, b, c, M_offset_3,  10, T[53]);
	            c = II(c, d, a, b, M_offset_10, 15, T[54]);
	            b = II(b, c, d, a, M_offset_1,  21, T[55]);
	            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
	            d = II(d, a, b, c, M_offset_15, 10, T[57]);
	            c = II(c, d, a, b, M_offset_6,  15, T[58]);
	            b = II(b, c, d, a, M_offset_13, 21, T[59]);
	            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
	            d = II(d, a, b, c, M_offset_11, 10, T[61]);
	            c = II(c, d, a, b, M_offset_2,  15, T[62]);
	            b = II(b, c, d, a, M_offset_9,  21, T[63]);

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

	            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
	            var nBitsTotalL = nBitsTotal;
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
	                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
	            );
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
	            );

	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                // Shortcut
	                var H_i = H[i];

	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    function FF(a, b, c, d, x, s, t) {
	        var n = a + ((b & c) | (~b & d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function GG(a, b, c, d, x, s, t) {
	        var n = a + ((b & d) | (c & ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function HH(a, b, c, d, x, s, t) {
	        var n = a + (b ^ c ^ d) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function II(a, b, c, d, x, s, t) {
	        var n = a + (c ^ (b | ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */
	    C.MD5 = Hasher._createHelper(MD5);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */
	    C.HmacMD5 = Hasher._createHmacHelper(MD5);
	}(Math));


	return CryptoJS.MD5;

}));
});

var sha1 = createCommonjsModule(function (module, exports) {
(function (root, factory) {
	{
		// CommonJS
		module.exports = factory(core);
	}
}(commonjsGlobal, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));
});

var sha256 = createCommonjsModule(function (module, exports) {
(function (root, factory) {
	{
		// CommonJS
		module.exports = factory(core);
	}
}(commonjsGlobal, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));
});

var sha224 = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, sha256);
	}
}(commonjsGlobal, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA256 = C_algo.SHA256;

	    /**
	     * SHA-224 hash algorithm.
	     */
	    var SHA224 = C_algo.SHA224 = SHA256.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
	                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA256._doFinalize.call(this);

	            hash.sigBytes -= 4;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */
	    C.SHA224 = SHA256._createHelper(SHA224);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */
	    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
	}());


	return CryptoJS.SHA224;

}));
});

var sha512 = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, x64Core);
	}
}(commonjsGlobal, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;

	    function X64Word_create() {
	        return X64Word.create.apply(X64Word, arguments);
	    }

	    // Constants
	    var K = [
	        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
	        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
	        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
	        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
	        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
	        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
	        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
	        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
	        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
	        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
	        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
	        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
	        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
	        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
	        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
	        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
	        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
	        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
	        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
	        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
	        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
	        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
	        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
	        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
	        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
	        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
	        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
	        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
	        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
	        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
	        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
	        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
	        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
	        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
	        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
	        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
	        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
	        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
	        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
	        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
	    ];

	    // Reusable objects
	    var W = [];
	    (function () {
	        for (var i = 0; i < 80; i++) {
	            W[i] = X64Word_create();
	        }
	    }());

	    /**
	     * SHA-512 hash algorithm.
	     */
	    var SHA512 = C_algo.SHA512 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
	                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
	                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
	                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var H = this._hash.words;

	            var H0 = H[0];
	            var H1 = H[1];
	            var H2 = H[2];
	            var H3 = H[3];
	            var H4 = H[4];
	            var H5 = H[5];
	            var H6 = H[6];
	            var H7 = H[7];

	            var H0h = H0.high;
	            var H0l = H0.low;
	            var H1h = H1.high;
	            var H1l = H1.low;
	            var H2h = H2.high;
	            var H2l = H2.low;
	            var H3h = H3.high;
	            var H3l = H3.low;
	            var H4h = H4.high;
	            var H4l = H4.low;
	            var H5h = H5.high;
	            var H5l = H5.low;
	            var H6h = H6.high;
	            var H6l = H6.low;
	            var H7h = H7.high;
	            var H7l = H7.low;

	            // Working variables
	            var ah = H0h;
	            var al = H0l;
	            var bh = H1h;
	            var bl = H1l;
	            var ch = H2h;
	            var cl = H2l;
	            var dh = H3h;
	            var dl = H3l;
	            var eh = H4h;
	            var el = H4l;
	            var fh = H5h;
	            var fl = H5l;
	            var gh = H6h;
	            var gl = H6l;
	            var hh = H7h;
	            var hl = H7l;

	            // Rounds
	            for (var i = 0; i < 80; i++) {
	                var Wil;
	                var Wih;

	                // Shortcut
	                var Wi = W[i];

	                // Extend message
	                if (i < 16) {
	                    Wih = Wi.high = M[offset + i * 2]     | 0;
	                    Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
	                } else {
	                    // Gamma0
	                    var gamma0x  = W[i - 15];
	                    var gamma0xh = gamma0x.high;
	                    var gamma0xl = gamma0x.low;
	                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
	                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));

	                    // Gamma1
	                    var gamma1x  = W[i - 2];
	                    var gamma1xh = gamma1x.high;
	                    var gamma1xl = gamma1x.low;
	                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
	                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));

	                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	                    var Wi7  = W[i - 7];
	                    var Wi7h = Wi7.high;
	                    var Wi7l = Wi7.low;

	                    var Wi16  = W[i - 16];
	                    var Wi16h = Wi16.high;
	                    var Wi16l = Wi16.low;

	                    Wil = gamma0l + Wi7l;
	                    Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
	                    Wil = Wil + gamma1l;
	                    Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
	                    Wil = Wil + Wi16l;
	                    Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);

	                    Wi.high = Wih;
	                    Wi.low  = Wil;
	                }

	                var chh  = (eh & fh) ^ (~eh & gh);
	                var chl  = (el & fl) ^ (~el & gl);
	                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
	                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);

	                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
	                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
	                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
	                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));

	                // t1 = h + sigma1 + ch + K[i] + W[i]
	                var Ki  = K[i];
	                var Kih = Ki.high;
	                var Kil = Ki.low;

	                var t1l = hl + sigma1l;
	                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
	                var t1l = t1l + chl;
	                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
	                var t1l = t1l + Kil;
	                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
	                var t1l = t1l + Wil;
	                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);

	                // t2 = sigma0 + maj
	                var t2l = sigma0l + majl;
	                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);

	                // Update working variables
	                hh = gh;
	                hl = gl;
	                gh = fh;
	                gl = fl;
	                fh = eh;
	                fl = el;
	                el = (dl + t1l) | 0;
	                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
	                dh = ch;
	                dl = cl;
	                ch = bh;
	                cl = bl;
	                bh = ah;
	                bl = al;
	                al = (t1l + t2l) | 0;
	                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
	            }

	            // Intermediate hash value
	            H0l = H0.low  = (H0l + al);
	            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
	            H1l = H1.low  = (H1l + bl);
	            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
	            H2l = H2.low  = (H2l + cl);
	            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
	            H3l = H3.low  = (H3l + dl);
	            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
	            H4l = H4.low  = (H4l + el);
	            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
	            H5l = H5.low  = (H5l + fl);
	            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
	            H6l = H6.low  = (H6l + gl);
	            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
	            H7l = H7.low  = (H7l + hl);
	            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Convert hash to 32-bit word array before returning
	            var hash = this._hash.toX32();

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        },

	        blockSize: 1024/32
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */
	    C.SHA512 = Hasher._createHelper(SHA512);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */
	    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
	}());


	return CryptoJS.SHA512;

}));
});

var sha384 = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, x64Core, sha512);
	}
}(commonjsGlobal, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;
	    var SHA512 = C_algo.SHA512;

	    /**
	     * SHA-384 hash algorithm.
	     */
	    var SHA384 = C_algo.SHA384 = SHA512.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
	                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
	                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
	                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA512._doFinalize.call(this);

	            hash.sigBytes -= 16;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */
	    C.SHA384 = SHA512._createHelper(SHA384);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */
	    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
	}());


	return CryptoJS.SHA384;

}));
});

var sha3 = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, x64Core);
	}
}(commonjsGlobal, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var C_algo = C.algo;

	    // Constants tables
	    var RHO_OFFSETS = [];
	    var PI_INDEXES  = [];
	    var ROUND_CONSTANTS = [];

	    // Compute Constants
	    (function () {
	        // Compute rho offset constants
	        var x = 1, y = 0;
	        for (var t = 0; t < 24; t++) {
	            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;

	            var newX = y % 5;
	            var newY = (2 * x + 3 * y) % 5;
	            x = newX;
	            y = newY;
	        }

	        // Compute pi index constants
	        for (var x = 0; x < 5; x++) {
	            for (var y = 0; y < 5; y++) {
	                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
	            }
	        }

	        // Compute round constants
	        var LFSR = 0x01;
	        for (var i = 0; i < 24; i++) {
	            var roundConstantMsw = 0;
	            var roundConstantLsw = 0;

	            for (var j = 0; j < 7; j++) {
	                if (LFSR & 0x01) {
	                    var bitPosition = (1 << j) - 1;
	                    if (bitPosition < 32) {
	                        roundConstantLsw ^= 1 << bitPosition;
	                    } else /* if (bitPosition >= 32) */ {
	                        roundConstantMsw ^= 1 << (bitPosition - 32);
	                    }
	                }

	                // Compute next LFSR
	                if (LFSR & 0x80) {
	                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
	                    LFSR = (LFSR << 1) ^ 0x71;
	                } else {
	                    LFSR <<= 1;
	                }
	            }

	            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
	        }
	    }());

	    // Reusable objects for temporary values
	    var T = [];
	    (function () {
	        for (var i = 0; i < 25; i++) {
	            T[i] = X64Word.create();
	        }
	    }());

	    /**
	     * SHA-3 hash algorithm.
	     */
	    var SHA3 = C_algo.SHA3 = Hasher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */
	        cfg: Hasher.cfg.extend({
	            outputLength: 512
	        }),

	        _doReset: function () {
	            var state = this._state = [];
	            for (var i = 0; i < 25; i++) {
	                state[i] = new X64Word.init();
	            }

	            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var state = this._state;
	            var nBlockSizeLanes = this.blockSize / 2;

	            // Absorb
	            for (var i = 0; i < nBlockSizeLanes; i++) {
	                // Shortcuts
	                var M2i  = M[offset + 2 * i];
	                var M2i1 = M[offset + 2 * i + 1];

	                // Swap endian
	                M2i = (
	                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
	                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
	                );
	                M2i1 = (
	                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
	                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
	                );

	                // Absorb message into state
	                var lane = state[i];
	                lane.high ^= M2i1;
	                lane.low  ^= M2i;
	            }

	            // Rounds
	            for (var round = 0; round < 24; round++) {
	                // Theta
	                for (var x = 0; x < 5; x++) {
	                    // Mix column lanes
	                    var tMsw = 0, tLsw = 0;
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        tMsw ^= lane.high;
	                        tLsw ^= lane.low;
	                    }

	                    // Temporary values
	                    var Tx = T[x];
	                    Tx.high = tMsw;
	                    Tx.low  = tLsw;
	                }
	                for (var x = 0; x < 5; x++) {
	                    // Shortcuts
	                    var Tx4 = T[(x + 4) % 5];
	                    var Tx1 = T[(x + 1) % 5];
	                    var Tx1Msw = Tx1.high;
	                    var Tx1Lsw = Tx1.low;

	                    // Mix surrounding columns
	                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
	                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        lane.high ^= tMsw;
	                        lane.low  ^= tLsw;
	                    }
	                }

	                // Rho Pi
	                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
	                    var tMsw;
	                    var tLsw;

	                    // Shortcuts
	                    var lane = state[laneIndex];
	                    var laneMsw = lane.high;
	                    var laneLsw = lane.low;
	                    var rhoOffset = RHO_OFFSETS[laneIndex];

	                    // Rotate lanes
	                    if (rhoOffset < 32) {
	                        tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
	                        tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
	                    } else /* if (rhoOffset >= 32) */ {
	                        tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
	                        tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
	                    }

	                    // Transpose lanes
	                    var TPiLane = T[PI_INDEXES[laneIndex]];
	                    TPiLane.high = tMsw;
	                    TPiLane.low  = tLsw;
	                }

	                // Rho pi at x = y = 0
	                var T0 = T[0];
	                var state0 = state[0];
	                T0.high = state0.high;
	                T0.low  = state0.low;

	                // Chi
	                for (var x = 0; x < 5; x++) {
	                    for (var y = 0; y < 5; y++) {
	                        // Shortcuts
	                        var laneIndex = x + 5 * y;
	                        var lane = state[laneIndex];
	                        var TLane = T[laneIndex];
	                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
	                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];

	                        // Mix rows
	                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
	                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
	                    }
	                }

	                // Iota
	                var lane = state[0];
	                var roundConstant = ROUND_CONSTANTS[round];
	                lane.high ^= roundConstant.high;
	                lane.low  ^= roundConstant.low;
	            }
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;
	            var blockSizeBits = this.blockSize * 32;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
	            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var state = this._state;
	            var outputLengthBytes = this.cfg.outputLength / 8;
	            var outputLengthLanes = outputLengthBytes / 8;

	            // Squeeze
	            var hashWords = [];
	            for (var i = 0; i < outputLengthLanes; i++) {
	                // Shortcuts
	                var lane = state[i];
	                var laneMsw = lane.high;
	                var laneLsw = lane.low;

	                // Swap endian
	                laneMsw = (
	                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
	                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
	                );
	                laneLsw = (
	                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
	                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
	                );

	                // Squeeze state to retrieve hash
	                hashWords.push(laneLsw);
	                hashWords.push(laneMsw);
	            }

	            // Return final computed hash
	            return new WordArray.init(hashWords, outputLengthBytes);
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);

	            var state = clone._state = this._state.slice(0);
	            for (var i = 0; i < 25; i++) {
	                state[i] = state[i].clone();
	            }

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */
	    C.SHA3 = Hasher._createHelper(SHA3);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */
	    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
	}(Math));


	return CryptoJS.SHA3;

}));
});

var ripemd160 = createCommonjsModule(function (module, exports) {
(function (root, factory) {
	{
		// CommonJS
		module.exports = factory(core);
	}
}(commonjsGlobal, function (CryptoJS) {

	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var _zl = WordArray.create([
	        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
	    var _zr = WordArray.create([
	        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
	    var _sl = WordArray.create([
	         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
	    var _sr = WordArray.create([
	        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);

	    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
	    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);

	    /**
	     * RIPEMD160 hash algorithm.
	     */
	    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
	        _doReset: function () {
	            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
	        },

	        _doProcessBlock: function (M, offset) {

	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                // Swap
	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }
	            // Shortcut
	            var H  = this._hash.words;
	            var hl = _hl.words;
	            var hr = _hr.words;
	            var zl = _zl.words;
	            var zr = _zr.words;
	            var sl = _sl.words;
	            var sr = _sr.words;

	            // Working variables
	            var al, bl, cl, dl, el;
	            var ar, br, cr, dr, er;

	            ar = al = H[0];
	            br = bl = H[1];
	            cr = cl = H[2];
	            dr = dl = H[3];
	            er = el = H[4];
	            // Computation
	            var t;
	            for (var i = 0; i < 80; i += 1) {
	                t = (al +  M[offset+zl[i]])|0;
	                if (i<16){
		            t +=  f1(bl,cl,dl) + hl[0];
	                } else if (i<32) {
		            t +=  f2(bl,cl,dl) + hl[1];
	                } else if (i<48) {
		            t +=  f3(bl,cl,dl) + hl[2];
	                } else if (i<64) {
		            t +=  f4(bl,cl,dl) + hl[3];
	                } else {// if (i<80) {
		            t +=  f5(bl,cl,dl) + hl[4];
	                }
	                t = t|0;
	                t =  rotl(t,sl[i]);
	                t = (t+el)|0;
	                al = el;
	                el = dl;
	                dl = rotl(cl, 10);
	                cl = bl;
	                bl = t;

	                t = (ar + M[offset+zr[i]])|0;
	                if (i<16){
		            t +=  f5(br,cr,dr) + hr[0];
	                } else if (i<32) {
		            t +=  f4(br,cr,dr) + hr[1];
	                } else if (i<48) {
		            t +=  f3(br,cr,dr) + hr[2];
	                } else if (i<64) {
		            t +=  f2(br,cr,dr) + hr[3];
	                } else {// if (i<80) {
		            t +=  f1(br,cr,dr) + hr[4];
	                }
	                t = t|0;
	                t =  rotl(t,sr[i]) ;
	                t = (t+er)|0;
	                ar = er;
	                er = dr;
	                dr = rotl(cr, 10);
	                cr = br;
	                br = t;
	            }
	            // Intermediate hash value
	            t    = (H[1] + cl + dr)|0;
	            H[1] = (H[2] + dl + er)|0;
	            H[2] = (H[3] + el + ar)|0;
	            H[3] = (H[4] + al + br)|0;
	            H[4] = (H[0] + bl + cr)|0;
	            H[0] =  t;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	            );
	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 5; i++) {
	                // Shortcut
	                var H_i = H[i];

	                // Swap
	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });


	    function f1(x, y, z) {
	        return ((x) ^ (y) ^ (z));

	    }

	    function f2(x, y, z) {
	        return (((x)&(y)) | ((~x)&(z)));
	    }

	    function f3(x, y, z) {
	        return (((x) | (~(y))) ^ (z));
	    }

	    function f4(x, y, z) {
	        return (((x) & (z)) | ((y)&(~(z))));
	    }

	    function f5(x, y, z) {
	        return ((x) ^ ((y) |(~(z))));

	    }

	    function rotl(x,n) {
	        return (x<<n) | (x>>>(32-n));
	    }


	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */
	    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */
	    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
	}());


	return CryptoJS.RIPEMD160;

}));
});

var hmac = createCommonjsModule(function (module, exports) {
(function (root, factory) {
	{
		// CommonJS
		module.exports = factory(core);
	}
}(commonjsGlobal, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));
});

var pbkdf2 = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, sha1, hmac);
	}
}(commonjsGlobal, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA1 = C_algo.SHA1;
	    var HMAC = C_algo.HMAC;

	    /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */
	    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA1
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: SHA1,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init HMAC
	            var hmac = HMAC.create(cfg.hasher, password);

	            // Initial values
	            var derivedKey = WordArray.create();
	            var blockIndex = WordArray.create([0x00000001]);

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var blockIndexWords = blockIndex.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                var block = hmac.update(salt).finalize(blockIndex);
	                hmac.reset();

	                // Shortcuts
	                var blockWords = block.words;
	                var blockWordsLength = blockWords.length;

	                // Iterations
	                var intermediate = block;
	                for (var i = 1; i < iterations; i++) {
	                    intermediate = hmac.finalize(intermediate);
	                    hmac.reset();

	                    // Shortcut
	                    var intermediateWords = intermediate.words;

	                    // XOR intermediate with block
	                    for (var j = 0; j < blockWordsLength; j++) {
	                        blockWords[j] ^= intermediateWords[j];
	                    }
	                }

	                derivedKey.concat(block);
	                blockIndexWords[0]++;
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.PBKDF2 = function (password, salt, cfg) {
	        return PBKDF2.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.PBKDF2;

}));
});

var evpkdf = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, sha1, hmac);
	}
}(commonjsGlobal, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var MD5 = C_algo.MD5;

	    /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */
	    var EvpKDF = C_algo.EvpKDF = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: MD5,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            var block;

	            // Shortcut
	            var cfg = this.cfg;

	            // Init hasher
	            var hasher = cfg.hasher.create();

	            // Initial values
	            var derivedKey = WordArray.create();

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                if (block) {
	                    hasher.update(block);
	                }
	                block = hasher.update(password).finalize(salt);
	                hasher.reset();

	                // Iterations
	                for (var i = 1; i < iterations; i++) {
	                    block = hasher.finalize(block);
	                    hasher.reset();
	                }

	                derivedKey.concat(block);
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.EvpKDF = function (password, salt, cfg) {
	        return EvpKDF.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.EvpKDF;

}));
});

var cipherCore = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, evpkdf);
	}
}(commonjsGlobal, function (CryptoJS) {

	/**
	 * Cipher core components.
	 */
	CryptoJS.lib.Cipher || (function (undefined$1) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
	    var C_enc = C.enc;
	    C_enc.Utf8;
	    var Base64 = C_enc.Base64;
	    var C_algo = C.algo;
	    var EvpKDF = C_algo.EvpKDF;

	    /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */
	    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */
	        cfg: Base.extend(),

	        /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createEncryptor: function (key, cfg) {
	            return this.create(this._ENC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createDecryptor: function (key, cfg) {
	            return this.create(this._DEC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */
	        init: function (xformMode, key, cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Store transform mode and key
	            this._xformMode = xformMode;
	            this._key = key;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-cipher logic
	            this._doReset();
	        },

	        /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */
	        process: function (dataUpdate) {
	            // Append
	            this._append(dataUpdate);

	            // Process available blocks
	            return this._process();
	        },

	        /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */
	        finalize: function (dataUpdate) {
	            // Final data update
	            if (dataUpdate) {
	                this._append(dataUpdate);
	            }

	            // Perform concrete-cipher logic
	            var finalProcessedData = this._doFinalize();

	            return finalProcessedData;
	        },

	        keySize: 128/32,

	        ivSize: 128/32,

	        _ENC_XFORM_MODE: 1,

	        _DEC_XFORM_MODE: 2,

	        /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */
	        _createHelper: (function () {
	            function selectCipherStrategy(key) {
	                if (typeof key == 'string') {
	                    return PasswordBasedCipher;
	                } else {
	                    return SerializableCipher;
	                }
	            }

	            return function (cipher) {
	                return {
	                    encrypt: function (message, key, cfg) {
	                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
	                    },

	                    decrypt: function (ciphertext, key, cfg) {
	                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
	                    }
	                };
	            };
	        }())
	    });

	    /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */
	    C_lib.StreamCipher = Cipher.extend({
	        _doFinalize: function () {
	            // Process partial blocks
	            var finalProcessedBlocks = this._process(!!'flush');

	            return finalProcessedBlocks;
	        },

	        blockSize: 1
	    });

	    /**
	     * Mode namespace.
	     */
	    var C_mode = C.mode = {};

	    /**
	     * Abstract base block cipher mode template.
	     */
	    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
	        /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */
	        createEncryptor: function (cipher, iv) {
	            return this.Encryptor.create(cipher, iv);
	        },

	        /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */
	        createDecryptor: function (cipher, iv) {
	            return this.Decryptor.create(cipher, iv);
	        },

	        /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */
	        init: function (cipher, iv) {
	            this._cipher = cipher;
	            this._iv = iv;
	        }
	    });

	    /**
	     * Cipher Block Chaining mode.
	     */
	    var CBC = C_mode.CBC = (function () {
	        /**
	         * Abstract base CBC mode.
	         */
	        var CBC = BlockCipherMode.extend();

	        /**
	         * CBC encryptor.
	         */
	        CBC.Encryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // XOR and encrypt
	                xorBlock.call(this, words, offset, blockSize);
	                cipher.encryptBlock(words, offset);

	                // Remember this block to use with next block
	                this._prevBlock = words.slice(offset, offset + blockSize);
	            }
	        });

	        /**
	         * CBC decryptor.
	         */
	        CBC.Decryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // Remember this block to use with next block
	                var thisBlock = words.slice(offset, offset + blockSize);

	                // Decrypt and XOR
	                cipher.decryptBlock(words, offset);
	                xorBlock.call(this, words, offset, blockSize);

	                // This block becomes the previous block
	                this._prevBlock = thisBlock;
	            }
	        });

	        function xorBlock(words, offset, blockSize) {
	            var block;

	            // Shortcut
	            var iv = this._iv;

	            // Choose mixing block
	            if (iv) {
	                block = iv;

	                // Remove IV for subsequent blocks
	                this._iv = undefined$1;
	            } else {
	                block = this._prevBlock;
	            }

	            // XOR blocks
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= block[i];
	            }
	        }

	        return CBC;
	    }());

	    /**
	     * Padding namespace.
	     */
	    var C_pad = C.pad = {};

	    /**
	     * PKCS #5/7 padding strategy.
	     */
	    var Pkcs7 = C_pad.Pkcs7 = {
	        /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */
	        pad: function (data, blockSize) {
	            // Shortcut
	            var blockSizeBytes = blockSize * 4;

	            // Count padding bytes
	            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	            // Create padding word
	            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;

	            // Create padding
	            var paddingWords = [];
	            for (var i = 0; i < nPaddingBytes; i += 4) {
	                paddingWords.push(paddingWord);
	            }
	            var padding = WordArray.create(paddingWords, nPaddingBytes);

	            // Add padding
	            data.concat(padding);
	        },

	        /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */
	        unpad: function (data) {
	            // Get number of padding bytes from last byte
	            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	            // Remove padding
	            data.sigBytes -= nPaddingBytes;
	        }
	    };

	    /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */
	    C_lib.BlockCipher = Cipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */
	        cfg: Cipher.cfg.extend({
	            mode: CBC,
	            padding: Pkcs7
	        }),

	        reset: function () {
	            var modeCreator;

	            // Reset cipher
	            Cipher.reset.call(this);

	            // Shortcuts
	            var cfg = this.cfg;
	            var iv = cfg.iv;
	            var mode = cfg.mode;

	            // Reset block mode
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                modeCreator = mode.createEncryptor;
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                modeCreator = mode.createDecryptor;
	                // Keep at least one block in the buffer for unpadding
	                this._minBufferSize = 1;
	            }

	            if (this._mode && this._mode.__creator == modeCreator) {
	                this._mode.init(this, iv && iv.words);
	            } else {
	                this._mode = modeCreator.call(mode, this, iv && iv.words);
	                this._mode.__creator = modeCreator;
	            }
	        },

	        _doProcessBlock: function (words, offset) {
	            this._mode.processBlock(words, offset);
	        },

	        _doFinalize: function () {
	            var finalProcessedBlocks;

	            // Shortcut
	            var padding = this.cfg.padding;

	            // Finalize
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                // Pad data
	                padding.pad(this._data, this.blockSize);

	                // Process final blocks
	                finalProcessedBlocks = this._process(!!'flush');
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                // Process final blocks
	                finalProcessedBlocks = this._process(!!'flush');

	                // Unpad data
	                padding.unpad(finalProcessedBlocks);
	            }

	            return finalProcessedBlocks;
	        },

	        blockSize: 128/32
	    });

	    /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */
	    var CipherParams = C_lib.CipherParams = Base.extend({
	        /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */
	        init: function (cipherParams) {
	            this.mixIn(cipherParams);
	        },

	        /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */
	        toString: function (formatter) {
	            return (formatter || this.formatter).stringify(this);
	        }
	    });

	    /**
	     * Format namespace.
	     */
	    var C_format = C.format = {};

	    /**
	     * OpenSSL formatting strategy.
	     */
	    var OpenSSLFormatter = C_format.OpenSSL = {
	        /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            var wordArray;

	            // Shortcuts
	            var ciphertext = cipherParams.ciphertext;
	            var salt = cipherParams.salt;

	            // Format
	            if (salt) {
	                wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
	            } else {
	                wordArray = ciphertext;
	            }

	            return wordArray.toString(Base64);
	        },

	        /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */
	        parse: function (openSSLStr) {
	            var salt;

	            // Parse base64
	            var ciphertext = Base64.parse(openSSLStr);

	            // Shortcut
	            var ciphertextWords = ciphertext.words;

	            // Test for salt
	            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
	                // Extract salt
	                salt = WordArray.create(ciphertextWords.slice(2, 4));

	                // Remove salt from ciphertext
	                ciphertextWords.splice(0, 4);
	                ciphertext.sigBytes -= 16;
	            }

	            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
	        }
	    };

	    /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */
	    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */
	        cfg: Base.extend({
	            format: OpenSSLFormatter
	        }),

	        /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Encrypt
	            var encryptor = cipher.createEncryptor(key, cfg);
	            var ciphertext = encryptor.finalize(message);

	            // Shortcut
	            var cipherCfg = encryptor.cfg;

	            // Create and return serializable cipher params
	            return CipherParams.create({
	                ciphertext: ciphertext,
	                key: key,
	                iv: cipherCfg.iv,
	                algorithm: cipher,
	                mode: cipherCfg.mode,
	                padding: cipherCfg.padding,
	                blockSize: cipher.blockSize,
	                formatter: cfg.format
	            });
	        },

	        /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Decrypt
	            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

	            return plaintext;
	        },

	        /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */
	        _parse: function (ciphertext, format) {
	            if (typeof ciphertext == 'string') {
	                return format.parse(ciphertext, this);
	            } else {
	                return ciphertext;
	            }
	        }
	    });

	    /**
	     * Key derivation function namespace.
	     */
	    var C_kdf = C.kdf = {};

	    /**
	     * OpenSSL key derivation function.
	     */
	    var OpenSSLKdf = C_kdf.OpenSSL = {
	        /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */
	        execute: function (password, keySize, ivSize, salt) {
	            // Generate random salt
	            if (!salt) {
	                salt = WordArray.random(64/8);
	            }

	            // Derive key and IV
	            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);

	            // Separate key and IV
	            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
	            key.sigBytes = keySize * 4;

	            // Return params
	            return CipherParams.create({ key: key, iv: iv, salt: salt });
	        }
	    };

	    /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */
	    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */
	        cfg: SerializableCipher.cfg.extend({
	            kdf: OpenSSLKdf
	        }),

	        /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Encrypt
	            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

	            // Mix in derived params
	            ciphertext.mixIn(derivedParams);

	            return ciphertext;
	        },

	        /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Decrypt
	            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

	            return plaintext;
	        }
	    });
	}());


}));
});

var modeCfb = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, cipherCore);
	}
}(commonjsGlobal, function (CryptoJS) {

	/**
	 * Cipher Feedback block mode.
	 */
	CryptoJS.mode.CFB = (function () {
	    var CFB = CryptoJS.lib.BlockCipherMode.extend();

	    CFB.Encryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // Remember this block to use with next block
	            this._prevBlock = words.slice(offset, offset + blockSize);
	        }
	    });

	    CFB.Decryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            // Remember this block to use with next block
	            var thisBlock = words.slice(offset, offset + blockSize);

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // This block becomes the previous block
	            this._prevBlock = thisBlock;
	        }
	    });

	    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
	        var keystream;

	        // Shortcut
	        var iv = this._iv;

	        // Generate keystream
	        if (iv) {
	            keystream = iv.slice(0);

	            // Remove IV for subsequent blocks
	            this._iv = undefined;
	        } else {
	            keystream = this._prevBlock;
	        }
	        cipher.encryptBlock(keystream, 0);

	        // Encrypt
	        for (var i = 0; i < blockSize; i++) {
	            words[offset + i] ^= keystream[i];
	        }
	    }

	    return CFB;
	}());


	return CryptoJS.mode.CFB;

}));
});

var modeCtr = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, cipherCore);
	}
}(commonjsGlobal, function (CryptoJS) {

	/**
	 * Counter block mode.
	 */
	CryptoJS.mode.CTR = (function () {
	    var CTR = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = CTR.Encryptor = CTR.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Increment counter
	            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0;

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTR.Decryptor = Encryptor;

	    return CTR;
	}());


	return CryptoJS.mode.CTR;

}));
});

var modeCtrGladman = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, cipherCore);
	}
}(commonjsGlobal, function (CryptoJS) {

	/** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */
	CryptoJS.mode.CTRGladman = (function () {
	    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

		function incWord(word)
		{
			if (((word >> 24) & 0xff) === 0xff) { //overflow
			var b1 = (word >> 16)&0xff;
			var b2 = (word >> 8)&0xff;
			var b3 = word & 0xff;

			if (b1 === 0xff) // overflow b1
			{
			b1 = 0;
			if (b2 === 0xff)
			{
				b2 = 0;
				if (b3 === 0xff)
				{
					b3 = 0;
				}
				else
				{
					++b3;
				}
			}
			else
			{
				++b2;
			}
			}
			else
			{
			++b1;
			}

			word = 0;
			word += (b1 << 16);
			word += (b2 << 8);
			word += b3;
			}
			else
			{
			word += (0x01 << 24);
			}
			return word;
		}

		function incCounter(counter)
		{
			if ((counter[0] = incWord(counter[0])) === 0)
			{
				// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
				counter[1] = incWord(counter[1]);
			}
			return counter;
		}

	    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }

				incCounter(counter);

				var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTRGladman.Decryptor = Encryptor;

	    return CTRGladman;
	}());




	return CryptoJS.mode.CTRGladman;

}));
});

var modeOfb = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, cipherCore);
	}
}(commonjsGlobal, function (CryptoJS) {

	/**
	 * Output Feedback block mode.
	 */
	CryptoJS.mode.OFB = (function () {
	    var OFB = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = OFB.Encryptor = OFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var keystream = this._keystream;

	            // Generate keystream
	            if (iv) {
	                keystream = this._keystream = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    OFB.Decryptor = Encryptor;

	    return OFB;
	}());


	return CryptoJS.mode.OFB;

}));
});

var modeEcb = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, cipherCore);
	}
}(commonjsGlobal, function (CryptoJS) {

	/**
	 * Electronic Codebook block mode.
	 */
	CryptoJS.mode.ECB = (function () {
	    var ECB = CryptoJS.lib.BlockCipherMode.extend();

	    ECB.Encryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.encryptBlock(words, offset);
	        }
	    });

	    ECB.Decryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.decryptBlock(words, offset);
	        }
	    });

	    return ECB;
	}());


	return CryptoJS.mode.ECB;

}));
});

var padAnsix923 = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, cipherCore);
	}
}(commonjsGlobal, function (CryptoJS) {

	/**
	 * ANSI X.923 padding strategy.
	 */
	CryptoJS.pad.AnsiX923 = {
	    pad: function (data, blockSize) {
	        // Shortcuts
	        var dataSigBytes = data.sigBytes;
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;

	        // Compute last byte position
	        var lastBytePos = dataSigBytes + nPaddingBytes - 1;

	        // Pad
	        data.clamp();
	        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
	        data.sigBytes += nPaddingBytes;
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Ansix923;

}));
});

var padIso10126 = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, cipherCore);
	}
}(commonjsGlobal, function (CryptoJS) {

	/**
	 * ISO 10126 padding strategy.
	 */
	CryptoJS.pad.Iso10126 = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	        // Pad
	        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
	             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Iso10126;

}));
});

var padIso97971 = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, cipherCore);
	}
}(commonjsGlobal, function (CryptoJS) {

	/**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */
	CryptoJS.pad.Iso97971 = {
	    pad: function (data, blockSize) {
	        // Add 0x80 byte
	        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));

	        // Zero pad the rest
	        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
	    },

	    unpad: function (data) {
	        // Remove zero padding
	        CryptoJS.pad.ZeroPadding.unpad(data);

	        // Remove one more byte -- the 0x80 byte
	        data.sigBytes--;
	    }
	};


	return CryptoJS.pad.Iso97971;

}));
});

var padZeropadding = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, cipherCore);
	}
}(commonjsGlobal, function (CryptoJS) {

	/**
	 * Zero padding strategy.
	 */
	CryptoJS.pad.ZeroPadding = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Pad
	        data.clamp();
	        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
	    },

	    unpad: function (data) {
	        // Shortcut
	        var dataWords = data.words;

	        // Unpad
	        var i = data.sigBytes - 1;
	        for (var i = data.sigBytes - 1; i >= 0; i--) {
	            if (((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
	                data.sigBytes = i + 1;
	                break;
	            }
	        }
	    }
	};


	return CryptoJS.pad.ZeroPadding;

}));
});

var padNopadding = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, cipherCore);
	}
}(commonjsGlobal, function (CryptoJS) {

	/**
	 * A noop padding strategy.
	 */
	CryptoJS.pad.NoPadding = {
	    pad: function () {
	    },

	    unpad: function () {
	    }
	};


	return CryptoJS.pad.NoPadding;

}));
});

var formatHex = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, cipherCore);
	}
}(commonjsGlobal, function (CryptoJS) {

	(function (undefined$1) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var CipherParams = C_lib.CipherParams;
	    var C_enc = C.enc;
	    var Hex = C_enc.Hex;
	    var C_format = C.format;

	    C_format.Hex = {
	        /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            return cipherParams.ciphertext.toString(Hex);
	        },

	        /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */
	        parse: function (input) {
	            var ciphertext = Hex.parse(input);
	            return CipherParams.create({ ciphertext: ciphertext });
	        }
	    };
	}());


	return CryptoJS.format.Hex;

}));
});

var aes = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, encBase64, md5, evpkdf, cipherCore);
	}
}(commonjsGlobal, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Lookup tables
	    var SBOX = [];
	    var INV_SBOX = [];
	    var SUB_MIX_0 = [];
	    var SUB_MIX_1 = [];
	    var SUB_MIX_2 = [];
	    var SUB_MIX_3 = [];
	    var INV_SUB_MIX_0 = [];
	    var INV_SUB_MIX_1 = [];
	    var INV_SUB_MIX_2 = [];
	    var INV_SUB_MIX_3 = [];

	    // Compute lookup tables
	    (function () {
	        // Compute double table
	        var d = [];
	        for (var i = 0; i < 256; i++) {
	            if (i < 128) {
	                d[i] = i << 1;
	            } else {
	                d[i] = (i << 1) ^ 0x11b;
	            }
	        }

	        // Walk GF(2^8)
	        var x = 0;
	        var xi = 0;
	        for (var i = 0; i < 256; i++) {
	            // Compute sbox
	            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	            SBOX[x] = sx;
	            INV_SBOX[sx] = x;

	            // Compute multiplication
	            var x2 = d[x];
	            var x4 = d[x2];
	            var x8 = d[x4];

	            // Compute sub bytes, mix columns tables
	            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
	            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
	            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
	            SUB_MIX_3[x] = t;

	            // Compute inv sub bytes, inv mix columns tables
	            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
	            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
	            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
	            INV_SUB_MIX_3[sx] = t;

	            // Compute next counter
	            if (!x) {
	                x = xi = 1;
	            } else {
	                x = x2 ^ d[d[d[x8 ^ x2]]];
	                xi ^= d[d[xi]];
	            }
	        }
	    }());

	    // Precomputed Rcon lookup
	    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

	    /**
	     * AES block cipher algorithm.
	     */
	    var AES = C_algo.AES = BlockCipher.extend({
	        _doReset: function () {
	            var t;

	            // Skip reset of nRounds has been set before and key did not change
	            if (this._nRounds && this._keyPriorReset === this._key) {
	                return;
	            }

	            // Shortcuts
	            var key = this._keyPriorReset = this._key;
	            var keyWords = key.words;
	            var keySize = key.sigBytes / 4;

	            // Compute number of rounds
	            var nRounds = this._nRounds = keySize + 6;

	            // Compute number of key schedule rows
	            var ksRows = (nRounds + 1) * 4;

	            // Compute key schedule
	            var keySchedule = this._keySchedule = [];
	            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
	                if (ksRow < keySize) {
	                    keySchedule[ksRow] = keyWords[ksRow];
	                } else {
	                    t = keySchedule[ksRow - 1];

	                    if (!(ksRow % keySize)) {
	                        // Rot word
	                        t = (t << 8) | (t >>> 24);

	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];

	                        // Mix Rcon
	                        t ^= RCON[(ksRow / keySize) | 0] << 24;
	                    } else if (keySize > 6 && ksRow % keySize == 4) {
	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	                    }

	                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
	                }
	            }

	            // Compute inv key schedule
	            var invKeySchedule = this._invKeySchedule = [];
	            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
	                var ksRow = ksRows - invKsRow;

	                if (invKsRow % 4) {
	                    var t = keySchedule[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 4];
	                }

	                if (invKsRow < 4 || ksRow <= 4) {
	                    invKeySchedule[invKsRow] = t;
	                } else {
	                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
	                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
	                }
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
	        },

	        decryptBlock: function (M, offset) {
	            // Swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;

	            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

	            // Inv swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;
	        },

	        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
	            // Shortcut
	            var nRounds = this._nRounds;

	            // Get input, add round key
	            var s0 = M[offset]     ^ keySchedule[0];
	            var s1 = M[offset + 1] ^ keySchedule[1];
	            var s2 = M[offset + 2] ^ keySchedule[2];
	            var s3 = M[offset + 3] ^ keySchedule[3];

	            // Key schedule row counter
	            var ksRow = 4;

	            // Rounds
	            for (var round = 1; round < nRounds; round++) {
	                // Shift rows, sub bytes, mix columns, add round key
	                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
	                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
	                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
	                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

	                // Update state
	                s0 = t0;
	                s1 = t1;
	                s2 = t2;
	                s3 = t3;
	            }

	            // Shift rows, sub bytes, add round key
	            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

	            // Set output
	            M[offset]     = t0;
	            M[offset + 1] = t1;
	            M[offset + 2] = t2;
	            M[offset + 3] = t3;
	        },

	        keySize: 256/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */
	    C.AES = BlockCipher._createHelper(AES);
	}());


	return CryptoJS.AES;

}));
});

var tripledes = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, encBase64, md5, evpkdf, cipherCore);
	}
}(commonjsGlobal, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Permuted Choice 1 constants
	    var PC1 = [
	        57, 49, 41, 33, 25, 17, 9,  1,
	        58, 50, 42, 34, 26, 18, 10, 2,
	        59, 51, 43, 35, 27, 19, 11, 3,
	        60, 52, 44, 36, 63, 55, 47, 39,
	        31, 23, 15, 7,  62, 54, 46, 38,
	        30, 22, 14, 6,  61, 53, 45, 37,
	        29, 21, 13, 5,  28, 20, 12, 4
	    ];

	    // Permuted Choice 2 constants
	    var PC2 = [
	        14, 17, 11, 24, 1,  5,
	        3,  28, 15, 6,  21, 10,
	        23, 19, 12, 4,  26, 8,
	        16, 7,  27, 20, 13, 2,
	        41, 52, 31, 37, 47, 55,
	        30, 40, 51, 45, 33, 48,
	        44, 49, 39, 56, 34, 53,
	        46, 42, 50, 36, 29, 32
	    ];

	    // Cumulative bit shift constants
	    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];

	    // SBOXes and round permutation constants
	    var SBOX_P = [
	        {
	            0x0: 0x808200,
	            0x10000000: 0x8000,
	            0x20000000: 0x808002,
	            0x30000000: 0x2,
	            0x40000000: 0x200,
	            0x50000000: 0x808202,
	            0x60000000: 0x800202,
	            0x70000000: 0x800000,
	            0x80000000: 0x202,
	            0x90000000: 0x800200,
	            0xa0000000: 0x8200,
	            0xb0000000: 0x808000,
	            0xc0000000: 0x8002,
	            0xd0000000: 0x800002,
	            0xe0000000: 0x0,
	            0xf0000000: 0x8202,
	            0x8000000: 0x0,
	            0x18000000: 0x808202,
	            0x28000000: 0x8202,
	            0x38000000: 0x8000,
	            0x48000000: 0x808200,
	            0x58000000: 0x200,
	            0x68000000: 0x808002,
	            0x78000000: 0x2,
	            0x88000000: 0x800200,
	            0x98000000: 0x8200,
	            0xa8000000: 0x808000,
	            0xb8000000: 0x800202,
	            0xc8000000: 0x800002,
	            0xd8000000: 0x8002,
	            0xe8000000: 0x202,
	            0xf8000000: 0x800000,
	            0x1: 0x8000,
	            0x10000001: 0x2,
	            0x20000001: 0x808200,
	            0x30000001: 0x800000,
	            0x40000001: 0x808002,
	            0x50000001: 0x8200,
	            0x60000001: 0x200,
	            0x70000001: 0x800202,
	            0x80000001: 0x808202,
	            0x90000001: 0x808000,
	            0xa0000001: 0x800002,
	            0xb0000001: 0x8202,
	            0xc0000001: 0x202,
	            0xd0000001: 0x800200,
	            0xe0000001: 0x8002,
	            0xf0000001: 0x0,
	            0x8000001: 0x808202,
	            0x18000001: 0x808000,
	            0x28000001: 0x800000,
	            0x38000001: 0x200,
	            0x48000001: 0x8000,
	            0x58000001: 0x800002,
	            0x68000001: 0x2,
	            0x78000001: 0x8202,
	            0x88000001: 0x8002,
	            0x98000001: 0x800202,
	            0xa8000001: 0x202,
	            0xb8000001: 0x808200,
	            0xc8000001: 0x800200,
	            0xd8000001: 0x0,
	            0xe8000001: 0x8200,
	            0xf8000001: 0x808002
	        },
	        {
	            0x0: 0x40084010,
	            0x1000000: 0x4000,
	            0x2000000: 0x80000,
	            0x3000000: 0x40080010,
	            0x4000000: 0x40000010,
	            0x5000000: 0x40084000,
	            0x6000000: 0x40004000,
	            0x7000000: 0x10,
	            0x8000000: 0x84000,
	            0x9000000: 0x40004010,
	            0xa000000: 0x40000000,
	            0xb000000: 0x84010,
	            0xc000000: 0x80010,
	            0xd000000: 0x0,
	            0xe000000: 0x4010,
	            0xf000000: 0x40080000,
	            0x800000: 0x40004000,
	            0x1800000: 0x84010,
	            0x2800000: 0x10,
	            0x3800000: 0x40004010,
	            0x4800000: 0x40084010,
	            0x5800000: 0x40000000,
	            0x6800000: 0x80000,
	            0x7800000: 0x40080010,
	            0x8800000: 0x80010,
	            0x9800000: 0x0,
	            0xa800000: 0x4000,
	            0xb800000: 0x40080000,
	            0xc800000: 0x40000010,
	            0xd800000: 0x84000,
	            0xe800000: 0x40084000,
	            0xf800000: 0x4010,
	            0x10000000: 0x0,
	            0x11000000: 0x40080010,
	            0x12000000: 0x40004010,
	            0x13000000: 0x40084000,
	            0x14000000: 0x40080000,
	            0x15000000: 0x10,
	            0x16000000: 0x84010,
	            0x17000000: 0x4000,
	            0x18000000: 0x4010,
	            0x19000000: 0x80000,
	            0x1a000000: 0x80010,
	            0x1b000000: 0x40000010,
	            0x1c000000: 0x84000,
	            0x1d000000: 0x40004000,
	            0x1e000000: 0x40000000,
	            0x1f000000: 0x40084010,
	            0x10800000: 0x84010,
	            0x11800000: 0x80000,
	            0x12800000: 0x40080000,
	            0x13800000: 0x4000,
	            0x14800000: 0x40004000,
	            0x15800000: 0x40084010,
	            0x16800000: 0x10,
	            0x17800000: 0x40000000,
	            0x18800000: 0x40084000,
	            0x19800000: 0x40000010,
	            0x1a800000: 0x40004010,
	            0x1b800000: 0x80010,
	            0x1c800000: 0x0,
	            0x1d800000: 0x4010,
	            0x1e800000: 0x40080010,
	            0x1f800000: 0x84000
	        },
	        {
	            0x0: 0x104,
	            0x100000: 0x0,
	            0x200000: 0x4000100,
	            0x300000: 0x10104,
	            0x400000: 0x10004,
	            0x500000: 0x4000004,
	            0x600000: 0x4010104,
	            0x700000: 0x4010000,
	            0x800000: 0x4000000,
	            0x900000: 0x4010100,
	            0xa00000: 0x10100,
	            0xb00000: 0x4010004,
	            0xc00000: 0x4000104,
	            0xd00000: 0x10000,
	            0xe00000: 0x4,
	            0xf00000: 0x100,
	            0x80000: 0x4010100,
	            0x180000: 0x4010004,
	            0x280000: 0x0,
	            0x380000: 0x4000100,
	            0x480000: 0x4000004,
	            0x580000: 0x10000,
	            0x680000: 0x10004,
	            0x780000: 0x104,
	            0x880000: 0x4,
	            0x980000: 0x100,
	            0xa80000: 0x4010000,
	            0xb80000: 0x10104,
	            0xc80000: 0x10100,
	            0xd80000: 0x4000104,
	            0xe80000: 0x4010104,
	            0xf80000: 0x4000000,
	            0x1000000: 0x4010100,
	            0x1100000: 0x10004,
	            0x1200000: 0x10000,
	            0x1300000: 0x4000100,
	            0x1400000: 0x100,
	            0x1500000: 0x4010104,
	            0x1600000: 0x4000004,
	            0x1700000: 0x0,
	            0x1800000: 0x4000104,
	            0x1900000: 0x4000000,
	            0x1a00000: 0x4,
	            0x1b00000: 0x10100,
	            0x1c00000: 0x4010000,
	            0x1d00000: 0x104,
	            0x1e00000: 0x10104,
	            0x1f00000: 0x4010004,
	            0x1080000: 0x4000000,
	            0x1180000: 0x104,
	            0x1280000: 0x4010100,
	            0x1380000: 0x0,
	            0x1480000: 0x10004,
	            0x1580000: 0x4000100,
	            0x1680000: 0x100,
	            0x1780000: 0x4010004,
	            0x1880000: 0x10000,
	            0x1980000: 0x4010104,
	            0x1a80000: 0x10104,
	            0x1b80000: 0x4000004,
	            0x1c80000: 0x4000104,
	            0x1d80000: 0x4010000,
	            0x1e80000: 0x4,
	            0x1f80000: 0x10100
	        },
	        {
	            0x0: 0x80401000,
	            0x10000: 0x80001040,
	            0x20000: 0x401040,
	            0x30000: 0x80400000,
	            0x40000: 0x0,
	            0x50000: 0x401000,
	            0x60000: 0x80000040,
	            0x70000: 0x400040,
	            0x80000: 0x80000000,
	            0x90000: 0x400000,
	            0xa0000: 0x40,
	            0xb0000: 0x80001000,
	            0xc0000: 0x80400040,
	            0xd0000: 0x1040,
	            0xe0000: 0x1000,
	            0xf0000: 0x80401040,
	            0x8000: 0x80001040,
	            0x18000: 0x40,
	            0x28000: 0x80400040,
	            0x38000: 0x80001000,
	            0x48000: 0x401000,
	            0x58000: 0x80401040,
	            0x68000: 0x0,
	            0x78000: 0x80400000,
	            0x88000: 0x1000,
	            0x98000: 0x80401000,
	            0xa8000: 0x400000,
	            0xb8000: 0x1040,
	            0xc8000: 0x80000000,
	            0xd8000: 0x400040,
	            0xe8000: 0x401040,
	            0xf8000: 0x80000040,
	            0x100000: 0x400040,
	            0x110000: 0x401000,
	            0x120000: 0x80000040,
	            0x130000: 0x0,
	            0x140000: 0x1040,
	            0x150000: 0x80400040,
	            0x160000: 0x80401000,
	            0x170000: 0x80001040,
	            0x180000: 0x80401040,
	            0x190000: 0x80000000,
	            0x1a0000: 0x80400000,
	            0x1b0000: 0x401040,
	            0x1c0000: 0x80001000,
	            0x1d0000: 0x400000,
	            0x1e0000: 0x40,
	            0x1f0000: 0x1000,
	            0x108000: 0x80400000,
	            0x118000: 0x80401040,
	            0x128000: 0x0,
	            0x138000: 0x401000,
	            0x148000: 0x400040,
	            0x158000: 0x80000000,
	            0x168000: 0x80001040,
	            0x178000: 0x40,
	            0x188000: 0x80000040,
	            0x198000: 0x1000,
	            0x1a8000: 0x80001000,
	            0x1b8000: 0x80400040,
	            0x1c8000: 0x1040,
	            0x1d8000: 0x80401000,
	            0x1e8000: 0x400000,
	            0x1f8000: 0x401040
	        },
	        {
	            0x0: 0x80,
	            0x1000: 0x1040000,
	            0x2000: 0x40000,
	            0x3000: 0x20000000,
	            0x4000: 0x20040080,
	            0x5000: 0x1000080,
	            0x6000: 0x21000080,
	            0x7000: 0x40080,
	            0x8000: 0x1000000,
	            0x9000: 0x20040000,
	            0xa000: 0x20000080,
	            0xb000: 0x21040080,
	            0xc000: 0x21040000,
	            0xd000: 0x0,
	            0xe000: 0x1040080,
	            0xf000: 0x21000000,
	            0x800: 0x1040080,
	            0x1800: 0x21000080,
	            0x2800: 0x80,
	            0x3800: 0x1040000,
	            0x4800: 0x40000,
	            0x5800: 0x20040080,
	            0x6800: 0x21040000,
	            0x7800: 0x20000000,
	            0x8800: 0x20040000,
	            0x9800: 0x0,
	            0xa800: 0x21040080,
	            0xb800: 0x1000080,
	            0xc800: 0x20000080,
	            0xd800: 0x21000000,
	            0xe800: 0x1000000,
	            0xf800: 0x40080,
	            0x10000: 0x40000,
	            0x11000: 0x80,
	            0x12000: 0x20000000,
	            0x13000: 0x21000080,
	            0x14000: 0x1000080,
	            0x15000: 0x21040000,
	            0x16000: 0x20040080,
	            0x17000: 0x1000000,
	            0x18000: 0x21040080,
	            0x19000: 0x21000000,
	            0x1a000: 0x1040000,
	            0x1b000: 0x20040000,
	            0x1c000: 0x40080,
	            0x1d000: 0x20000080,
	            0x1e000: 0x0,
	            0x1f000: 0x1040080,
	            0x10800: 0x21000080,
	            0x11800: 0x1000000,
	            0x12800: 0x1040000,
	            0x13800: 0x20040080,
	            0x14800: 0x20000000,
	            0x15800: 0x1040080,
	            0x16800: 0x80,
	            0x17800: 0x21040000,
	            0x18800: 0x40080,
	            0x19800: 0x21040080,
	            0x1a800: 0x0,
	            0x1b800: 0x21000000,
	            0x1c800: 0x1000080,
	            0x1d800: 0x40000,
	            0x1e800: 0x20040000,
	            0x1f800: 0x20000080
	        },
	        {
	            0x0: 0x10000008,
	            0x100: 0x2000,
	            0x200: 0x10200000,
	            0x300: 0x10202008,
	            0x400: 0x10002000,
	            0x500: 0x200000,
	            0x600: 0x200008,
	            0x700: 0x10000000,
	            0x800: 0x0,
	            0x900: 0x10002008,
	            0xa00: 0x202000,
	            0xb00: 0x8,
	            0xc00: 0x10200008,
	            0xd00: 0x202008,
	            0xe00: 0x2008,
	            0xf00: 0x10202000,
	            0x80: 0x10200000,
	            0x180: 0x10202008,
	            0x280: 0x8,
	            0x380: 0x200000,
	            0x480: 0x202008,
	            0x580: 0x10000008,
	            0x680: 0x10002000,
	            0x780: 0x2008,
	            0x880: 0x200008,
	            0x980: 0x2000,
	            0xa80: 0x10002008,
	            0xb80: 0x10200008,
	            0xc80: 0x0,
	            0xd80: 0x10202000,
	            0xe80: 0x202000,
	            0xf80: 0x10000000,
	            0x1000: 0x10002000,
	            0x1100: 0x10200008,
	            0x1200: 0x10202008,
	            0x1300: 0x2008,
	            0x1400: 0x200000,
	            0x1500: 0x10000000,
	            0x1600: 0x10000008,
	            0x1700: 0x202000,
	            0x1800: 0x202008,
	            0x1900: 0x0,
	            0x1a00: 0x8,
	            0x1b00: 0x10200000,
	            0x1c00: 0x2000,
	            0x1d00: 0x10002008,
	            0x1e00: 0x10202000,
	            0x1f00: 0x200008,
	            0x1080: 0x8,
	            0x1180: 0x202000,
	            0x1280: 0x200000,
	            0x1380: 0x10000008,
	            0x1480: 0x10002000,
	            0x1580: 0x2008,
	            0x1680: 0x10202008,
	            0x1780: 0x10200000,
	            0x1880: 0x10202000,
	            0x1980: 0x10200008,
	            0x1a80: 0x2000,
	            0x1b80: 0x202008,
	            0x1c80: 0x200008,
	            0x1d80: 0x0,
	            0x1e80: 0x10000000,
	            0x1f80: 0x10002008
	        },
	        {
	            0x0: 0x100000,
	            0x10: 0x2000401,
	            0x20: 0x400,
	            0x30: 0x100401,
	            0x40: 0x2100401,
	            0x50: 0x0,
	            0x60: 0x1,
	            0x70: 0x2100001,
	            0x80: 0x2000400,
	            0x90: 0x100001,
	            0xa0: 0x2000001,
	            0xb0: 0x2100400,
	            0xc0: 0x2100000,
	            0xd0: 0x401,
	            0xe0: 0x100400,
	            0xf0: 0x2000000,
	            0x8: 0x2100001,
	            0x18: 0x0,
	            0x28: 0x2000401,
	            0x38: 0x2100400,
	            0x48: 0x100000,
	            0x58: 0x2000001,
	            0x68: 0x2000000,
	            0x78: 0x401,
	            0x88: 0x100401,
	            0x98: 0x2000400,
	            0xa8: 0x2100000,
	            0xb8: 0x100001,
	            0xc8: 0x400,
	            0xd8: 0x2100401,
	            0xe8: 0x1,
	            0xf8: 0x100400,
	            0x100: 0x2000000,
	            0x110: 0x100000,
	            0x120: 0x2000401,
	            0x130: 0x2100001,
	            0x140: 0x100001,
	            0x150: 0x2000400,
	            0x160: 0x2100400,
	            0x170: 0x100401,
	            0x180: 0x401,
	            0x190: 0x2100401,
	            0x1a0: 0x100400,
	            0x1b0: 0x1,
	            0x1c0: 0x0,
	            0x1d0: 0x2100000,
	            0x1e0: 0x2000001,
	            0x1f0: 0x400,
	            0x108: 0x100400,
	            0x118: 0x2000401,
	            0x128: 0x2100001,
	            0x138: 0x1,
	            0x148: 0x2000000,
	            0x158: 0x100000,
	            0x168: 0x401,
	            0x178: 0x2100400,
	            0x188: 0x2000001,
	            0x198: 0x2100000,
	            0x1a8: 0x0,
	            0x1b8: 0x2100401,
	            0x1c8: 0x100401,
	            0x1d8: 0x400,
	            0x1e8: 0x2000400,
	            0x1f8: 0x100001
	        },
	        {
	            0x0: 0x8000820,
	            0x1: 0x20000,
	            0x2: 0x8000000,
	            0x3: 0x20,
	            0x4: 0x20020,
	            0x5: 0x8020820,
	            0x6: 0x8020800,
	            0x7: 0x800,
	            0x8: 0x8020000,
	            0x9: 0x8000800,
	            0xa: 0x20800,
	            0xb: 0x8020020,
	            0xc: 0x820,
	            0xd: 0x0,
	            0xe: 0x8000020,
	            0xf: 0x20820,
	            0x80000000: 0x800,
	            0x80000001: 0x8020820,
	            0x80000002: 0x8000820,
	            0x80000003: 0x8000000,
	            0x80000004: 0x8020000,
	            0x80000005: 0x20800,
	            0x80000006: 0x20820,
	            0x80000007: 0x20,
	            0x80000008: 0x8000020,
	            0x80000009: 0x820,
	            0x8000000a: 0x20020,
	            0x8000000b: 0x8020800,
	            0x8000000c: 0x0,
	            0x8000000d: 0x8020020,
	            0x8000000e: 0x8000800,
	            0x8000000f: 0x20000,
	            0x10: 0x20820,
	            0x11: 0x8020800,
	            0x12: 0x20,
	            0x13: 0x800,
	            0x14: 0x8000800,
	            0x15: 0x8000020,
	            0x16: 0x8020020,
	            0x17: 0x20000,
	            0x18: 0x0,
	            0x19: 0x20020,
	            0x1a: 0x8020000,
	            0x1b: 0x8000820,
	            0x1c: 0x8020820,
	            0x1d: 0x20800,
	            0x1e: 0x820,
	            0x1f: 0x8000000,
	            0x80000010: 0x20000,
	            0x80000011: 0x800,
	            0x80000012: 0x8020020,
	            0x80000013: 0x20820,
	            0x80000014: 0x20,
	            0x80000015: 0x8020000,
	            0x80000016: 0x8000000,
	            0x80000017: 0x8000820,
	            0x80000018: 0x8020820,
	            0x80000019: 0x8000020,
	            0x8000001a: 0x8000800,
	            0x8000001b: 0x0,
	            0x8000001c: 0x20800,
	            0x8000001d: 0x820,
	            0x8000001e: 0x20020,
	            0x8000001f: 0x8020800
	        }
	    ];

	    // Masks that select the SBOX input
	    var SBOX_MASK = [
	        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
	        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
	    ];

	    /**
	     * DES block cipher algorithm.
	     */
	    var DES = C_algo.DES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Select 56 bits according to PC1
	            var keyBits = [];
	            for (var i = 0; i < 56; i++) {
	                var keyBitPos = PC1[i] - 1;
	                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
	            }

	            // Assemble 16 subkeys
	            var subKeys = this._subKeys = [];
	            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
	                // Create subkey
	                var subKey = subKeys[nSubKey] = [];

	                // Shortcut
	                var bitShift = BIT_SHIFTS[nSubKey];

	                // Select 48 bits according to PC2
	                for (var i = 0; i < 24; i++) {
	                    // Select from the left 28 key bits
	                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);

	                    // Select from the right 28 key bits
	                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
	                }

	                // Since each subkey is applied to an expanded 32-bit input,
	                // the subkey can be broken into 8 values scaled to 32-bits,
	                // which allows the key to be used without expansion
	                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
	                for (var i = 1; i < 7; i++) {
	                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
	                }
	                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
	            }

	            // Compute inverse subkeys
	            var invSubKeys = this._invSubKeys = [];
	            for (var i = 0; i < 16; i++) {
	                invSubKeys[i] = subKeys[15 - i];
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._subKeys);
	        },

	        decryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._invSubKeys);
	        },

	        _doCryptBlock: function (M, offset, subKeys) {
	            // Get input
	            this._lBlock = M[offset];
	            this._rBlock = M[offset + 1];

	            // Initial permutation
	            exchangeLR.call(this, 4,  0x0f0f0f0f);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeLR.call(this, 1,  0x55555555);

	            // Rounds
	            for (var round = 0; round < 16; round++) {
	                // Shortcuts
	                var subKey = subKeys[round];
	                var lBlock = this._lBlock;
	                var rBlock = this._rBlock;

	                // Feistel function
	                var f = 0;
	                for (var i = 0; i < 8; i++) {
	                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
	                }
	                this._lBlock = rBlock;
	                this._rBlock = lBlock ^ f;
	            }

	            // Undo swap from last round
	            var t = this._lBlock;
	            this._lBlock = this._rBlock;
	            this._rBlock = t;

	            // Final permutation
	            exchangeLR.call(this, 1,  0x55555555);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeLR.call(this, 4,  0x0f0f0f0f);

	            // Set output
	            M[offset] = this._lBlock;
	            M[offset + 1] = this._rBlock;
	        },

	        keySize: 64/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    // Swap bits across the left and right words
	    function exchangeLR(offset, mask) {
	        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
	        this._rBlock ^= t;
	        this._lBlock ^= t << offset;
	    }

	    function exchangeRL(offset, mask) {
	        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
	        this._lBlock ^= t;
	        this._rBlock ^= t << offset;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */
	    C.DES = BlockCipher._createHelper(DES);

	    /**
	     * Triple-DES block cipher algorithm.
	     */
	    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;
	            // Make sure the key length is valid (64, 128 or >= 192 bit)
	            if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) {
	                throw new Error('Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.');
	            }

	            // Extend the key according to the keying options defined in 3DES standard
	            var key1 = keyWords.slice(0, 2);
	            var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
	            var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);

	            // Create DES instances
	            this._des1 = DES.createEncryptor(WordArray.create(key1));
	            this._des2 = DES.createEncryptor(WordArray.create(key2));
	            this._des3 = DES.createEncryptor(WordArray.create(key3));
	        },

	        encryptBlock: function (M, offset) {
	            this._des1.encryptBlock(M, offset);
	            this._des2.decryptBlock(M, offset);
	            this._des3.encryptBlock(M, offset);
	        },

	        decryptBlock: function (M, offset) {
	            this._des3.decryptBlock(M, offset);
	            this._des2.encryptBlock(M, offset);
	            this._des1.decryptBlock(M, offset);
	        },

	        keySize: 192/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */
	    C.TripleDES = BlockCipher._createHelper(TripleDES);
	}());


	return CryptoJS.TripleDES;

}));
});

var rc4 = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, encBase64, md5, evpkdf, cipherCore);
	}
}(commonjsGlobal, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    /**
	     * RC4 stream cipher algorithm.
	     */
	    var RC4 = C_algo.RC4 = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;
	            var keySigBytes = key.sigBytes;

	            // Init sbox
	            var S = this._S = [];
	            for (var i = 0; i < 256; i++) {
	                S[i] = i;
	            }

	            // Key setup
	            for (var i = 0, j = 0; i < 256; i++) {
	                var keyByteIndex = i % keySigBytes;
	                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;

	                j = (j + S[i] + keyByte) % 256;

	                // Swap
	                var t = S[i];
	                S[i] = S[j];
	                S[j] = t;
	            }

	            // Counters
	            this._i = this._j = 0;
	        },

	        _doProcessBlock: function (M, offset) {
	            M[offset] ^= generateKeystreamWord.call(this);
	        },

	        keySize: 256/32,

	        ivSize: 0
	    });

	    function generateKeystreamWord() {
	        // Shortcuts
	        var S = this._S;
	        var i = this._i;
	        var j = this._j;

	        // Generate keystream word
	        var keystreamWord = 0;
	        for (var n = 0; n < 4; n++) {
	            i = (i + 1) % 256;
	            j = (j + S[i]) % 256;

	            // Swap
	            var t = S[i];
	            S[i] = S[j];
	            S[j] = t;

	            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
	        }

	        // Update counters
	        this._i = i;
	        this._j = j;

	        return keystreamWord;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4 = StreamCipher._createHelper(RC4);

	    /**
	     * Modified RC4 stream cipher algorithm.
	     */
	    var RC4Drop = C_algo.RC4Drop = RC4.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */
	        cfg: RC4.cfg.extend({
	            drop: 192
	        }),

	        _doReset: function () {
	            RC4._doReset.call(this);

	            // Drop
	            for (var i = this.cfg.drop; i > 0; i--) {
	                generateKeystreamWord.call(this);
	            }
	        }
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
	}());


	return CryptoJS.RC4;

}));
});

var rabbit = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, encBase64, md5, evpkdf, cipherCore);
	}
}(commonjsGlobal, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm
	     */
	    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
	                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
	            }

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */
	    C.Rabbit = StreamCipher._createHelper(Rabbit);
	}());


	return CryptoJS.Rabbit;

}));
});

var rabbitLegacy = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, encBase64, md5, evpkdf, cipherCore);
	}
}(commonjsGlobal, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */
	    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */
	    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
	}());


	return CryptoJS.RabbitLegacy;

}));
});

var cryptoJs = createCommonjsModule(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core, x64Core, libTypedarrays, encUtf16, encBase64, encBase64url, md5, sha1, sha256, sha224, sha512, sha384, sha3, ripemd160, hmac, pbkdf2, evpkdf, cipherCore, modeCfb, modeCtr, modeCtrGladman, modeOfb, modeEcb, padAnsix923, padIso10126, padIso97971, padZeropadding, padNopadding, formatHex, aes, tripledes, rc4, rabbit, rabbitLegacy);
	}
}(commonjsGlobal, function (CryptoJS) {

	return CryptoJS;

}));
});

/**
A function that returns a universally unique identifier (uuid).  
example: 1b83fd69-abe7-468c-bea1-306a8aa1c81d
@returns `string` : 32 character uuid (see example)
*/
function uuid() {
  const hashTable = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
  ];
  let uuid = [];
  for (let i = 0; i < 35; i++) {
    if (i === 7 || i === 12 || i === 17 || i === 22) {
      uuid[i] = '-';
    } else {
      uuid[i] = hashTable[Math.floor(Math.random() * hashTable.length - 1)];
    }
  }
  return uuid.join('');
}

var uuid_1 = uuid;

var encrypt = function (plain_text, secret, ivString) {
    var msg = plain_text;
    // key & iv - 128-bit (16 byte)
    var key = cryptoJs.enc.Utf8.parse(secret);
    var iv = cryptoJs.enc.Utf8.parse(ivString);
    // AES-128
    var enc = cryptoJs.AES.encrypt(msg, key, {
        iv: iv,
        mode: cryptoJs.mode.CBC,
    }).ciphertext.toString(cryptoJs.enc.Base64);
    return enc;
};
var encryptAESString = function (data, authkey, authiv) {
    var encData = encrypt(data, authkey, authiv);
    return encData;
};
var decrypt = function (plain_text, encryptionMethod, secret, ivString) {
    var msg = plain_text;
    // key & iv - 128-bit (16 byte)
    var key = cryptoJs.enc.Utf8.parse(secret);
    var iv = cryptoJs.enc.Utf8.parse(ivString);
    // AES-128
    var dec = cryptoJs.AES.decrypt(msg, key, {
        iv: iv,
        mode: cryptoJs.mode.CBC,
    });
    return dec.toString(cryptoJs.enc.Utf8);
};
var decAESString = function (data, authkey, authiv) {
    var decData = decrypt(data, "aes-128-cbc", authkey, authiv);
    return decData;
};
var getUUID = function () {
    return uuid_1();
};
var getPaymentUrl = function (env) {
    if (env === void 0) { env = ""; }
    var finalUrl = "";
    switch (env) {
        case "dev":
            finalUrl = devUrl;
            break;
        case "stag":
            finalUrl = stagUrl;
            break;
        case "prod":
            finalUrl = prodUrl;
            break;
        default:
            finalUrl = devUrl;
            break;
    }
    return finalUrl;
};

var ClientDetails = /** @class */ (function (_super) {
    __extends(ClientDetails, _super);
    function ClientDetails(props) {
        var _this = _super.call(this, props) || this;
        _this.onchangeHandler = function (e) {
            var _a, _b;
            var _c = e.target, value = _c.value, name = _c.name;
            if (name === "payerMobile" || name === "amount") {
                var regex = /^\d+$/;
                regex.test(value || "12") && _this.setState((_a = {}, _a[name] = value, _a));
            }
            else {
                _this.setState((_b = {}, _b[name] = value, _b));
            }
        };
        _this.getEncData = function () {
            var _a = _this.state, payerName = _a.payerName, payerEmail = _a.payerEmail, amount = _a.amount, clientCode = _a.clientCode, clientTxnId = _a.clientTxnId, payerMobile = _a.payerMobile, udf1 = _a.udf1, udf2 = _a.udf2, udf3 = _a.udf3, udf4 = _a.udf4, udf5 = _a.udf5, udf6 = _a.udf6, udf7 = _a.udf7, udf8 = _a.udf8, udf9 = _a.udf9, udf10 = _a.udf10, udf11 = _a.udf11, udf12 = _a.udf12, udf13 = _a.udf13, udf14 = _a.udf14, udf15 = _a.udf15, udf16 = _a.udf16, udf17 = _a.udf17, udf18 = _a.udf18, udf19 = _a.udf19, udf20 = _a.udf20, channelId = _a.channelId, programId = _a.programId, mcc = _a.mcc;
            var _b = _this.props, transUserName = _b.transUserName, transUserPassword = _b.transUserPassword, authkey = _b.authkey, authiv = _b.authiv;
            var callbackUrl = window.location.href; //Location of the 
            var data = "payerName=".concat(payerName, "&payerEmail=").concat(payerEmail, "&payerMobile=").concat(payerMobile, "&clientTxnId=").concat(clientTxnId ? clientTxnId : getUUID(), "&amount=").concat(amount, "&clientCode=").concat(clientCode, "&transUserName=").concat(transUserName, "&transUserPassword=").concat(transUserPassword, "&callbackUrl=").concat(callbackUrl, "&udf1=").concat(udf1, "&udf2=").concat(udf2, "&udf3=").concat(udf3, "&udf4=").concat(udf4, "&udf5=").concat(udf5, "&udf6=").concat(udf6, "&udf7=").concat(udf7, "&udf8=").concat(udf8, "&udf9=").concat(udf9, "&udf10=").concat(udf10, "&udf11=").concat(udf11, "&udf12=").concat(udf12, "&udf13=").concat(udf13, "&udf14=").concat(udf14, "&udf15=").concat(udf15, "&udf16=").concat(udf16, "&udf17=").concat(udf17, "&udf18=").concat(udf18, "&udf19=").concat(udf19, "&udf20=").concat(udf20, "&channelId=").concat(channelId ? channelId : "npm", "&programId=").concat(programId ? programId : "c", "&mcc=").concat(mcc);
            var enc = encryptAESString(data, authkey, authiv);
            return enc;
        };
        _this.state = {
            submitted: false, currentState: 0, payerMobile: "", clientTxnId: "", clientCode: "", payerName: "", payerEmail: "", amount: "", showFormCD: true, showFormPD: true, udf1: "", udf2: "", udf3: "", udf4: "", udf5: "", udf6: "", udf7: "", udf8: "", udf9: "", udf10: "", udf11: "", udf12: "", udf13: "", udf14: "", udf15: "", udf16: "", udf17: "", udf18: "", udf19: "", udf20: "", channelId: "", programId: "", mcc: ""
        };
        return _this;
    }
    ClientDetails.prototype.componentDidMount = function () {
        var _this = this;
        // ?clientCode=TM001&encResponse=0WaBLOC/95n0Dd37I8tROEUSF6OO2190JFXJHAyhH190dMyw0VR76tMidU9w20ydXwziilLK7Kq0u9AfDos8t1GNlQqNwSCvq+bcBrTD7xD602ZsnjKRnCb5xICCRaQXuAOiiO4vLIyloobdCaAMNanwEg4fIHKyu5iMy90SzDDPwFBLN0sWuQ4k10HGkVX0/ToRSs6tRIyPYritJO1enWzw/LCByp17pfsF65/H7rlZ3RUXGqIQb/iTVny+bO5nCQqFKhydXc9YpRI+4+pWGms/A+THehAiKKTFp75szvE1go8IoMEPCH4BI1FCr7NBKGHrhFAm+ziWP8RXEXLa+e441Jvmeo62qZKX4lfYMF7T9w8llfdWTsYke5uV6nljvn9wC1WKJXyLhuER8gqIORh28ptVmE9INBT4Wnc22VX5DApEnhQCLH7YXpz6XpYmmaCZiIVnjV5gPDTewrzpCacRE0VAqtVnZDeZq4CG/zRkWQRlTCjk4OJNKQEKPNv05aFqbsQ/eSBb6vVjkQeuVrKH9ByZU+E/O/MhcIzlsbCzuw/+wNfz2eTFxiARIR+AjcPBR2DkupOV03wRnfds63m4Xeja983IYChfC5ZCtedKGYmK+a9kpu/S8BvJqWr4cxpnr/3ScLNCCP78odxQ7+XL3A9fx5PDPj5YMfYdc+5rMqs0/VWYeUaKohX0JbKSkmTDgIwG9sV4F/nDZDhh8ufDE/cJm5H/M8WjqKjWiBXmSDe/z27O7qz2jjxnevNNVPcHm75P2Tic2Prh17Ov0zx8sqW4b16APwYFc9BxHY8gkS8jGlLNjavOZWHJjIuAMy7qX3paRJUHdo8v2BJtnOXIbTQyq85DPNJix2Cvr2di9qYL6psJM0OeyA8v6Bjpl56D+6Km1thDknrZ7WGdYrb90TH6UKmUfd4YbMG6vtjSiVI0qPd0obAPSNJWedtts+F0uyMajysvmO3n2EEo+g==
        this.setState(__assign({}, this.props), (function () {
            var _a = _this.state, payerMobile = _a.payerMobile, clientCode = _a.clientCode, payerName = _a.payerName, payerEmail = _a.payerEmail, amount = _a.amount, clientTxnId = _a.clientTxnId;
            var emailRegex = /\S+@\S+\.\S+/;
            var form = document.getElementById('pg-form');
            var disable = (!payerMobile || !clientCode || !payerName || !amount || !emailRegex.test(payerEmail) || !clientTxnId);
            if (!disable) {
                form.submit(); //If we have all the value then automatically submit the form
            }
        }));
    };
    ClientDetails.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.isResponsed !== this.props.isResponsed) {
            this.setState(__assign({}, this.props));
        }
    };
    ClientDetails.prototype.render = function () {
        var _this = this;
        var _a = this.state, showFormCD = _a.showFormCD, showFormPD = _a.showFormPD;
        var _b = this.state, payerMobile = _b.payerMobile, clientCode = _b.clientCode, payerName = _b.payerName, payerEmail = _b.payerEmail, amount = _b.amount;
        var emailRegex = /\S+@\S+\.\S+/;
        var disable = (!payerMobile || !clientCode || !payerName || !amount || !emailRegex.test(payerEmail));
        var env = this.props.env;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { id: "sdkPopup" },
                React.createElement("div", { className: "popupHeader" },
                    React.createElement("img", { src: s3Url + "lock.svg", alt: "" }),
                    React.createElement("span", null, "Payment Details"),
                    React.createElement("span", { onClick: this.props.toggle, className: "close cursor-pointer" })),
                React.createElement("div", { className: "popupBody" },
                    React.createElement("form", { id: "pg-form", action: getPaymentUrl(env), method: "post" },
                        React.createElement("div", { className: "activity" },
                            React.createElement(Input$1, { type: "hidden", name: "encData", value: !disable ? this.getEncData() : "", id: "frm1" }),
                            React.createElement(Input$1, { type: "hidden", name: "clientCode", value: clientCode, id: "frm2" }),
                            React.createElement("div", { className: "form " },
                                React.createElement("div", { className: "form-header" },
                                    React.createElement("h3", { className: "form-heading text-blue" }, "Payment Details:"),
                                    React.createElement("img", { src: s3Url + "arrow_drop_down.svg", className: "expandIcon  ".concat((showFormPD) && "down"), alt: "arrow up", onClick: function () {
                                            _this.setState({ showFormPD: !showFormPD });
                                        } })),
                                React.createElement("form", { action: "", className: "form-collapsible form-collapsible-client  ".concat((showFormPD) && "showForm") },
                                    React.createElement("label", null, "Client Code"),
                                    React.createElement("div", { className: "input inputWithIcon" },
                                        React.createElement("span", { className: "inputIcon disabled" },
                                            React.createElement("img", { src: s3Url + "sticky_note.svg", alt: "" })),
                                        React.createElement(Input$1, { disabled: true, value: clientCode, required: true })),
                                    React.createElement("label", null, "Full Name"),
                                    React.createElement("div", { className: "input inputWithIcon" },
                                        React.createElement("span", { className: "inputIcon" },
                                            React.createElement("img", { src: s3Url + "person_pin.svg", alt: "" })),
                                        React.createElement(Input$1, { required: true, value: payerName, name: "payerName", onChange: this.onchangeHandler })),
                                    React.createElement("label", null, "Amount"),
                                    React.createElement("div", { className: "input inputWithIcon" },
                                        React.createElement("span", { className: "inputIcon" },
                                            React.createElement("img", { src: s3Url + "rupee.svg", alt: "" })),
                                        React.createElement(Input$1, { required: true, value: amount, name: "amount", onChange: this.onchangeHandler })))),
                            React.createElement("div", { className: "form " },
                                React.createElement("div", { className: "form-header" },
                                    React.createElement("h3", { className: "form-heading text-blue" }, "Contact Information:"),
                                    React.createElement("img", { src: s3Url + "arrow_drop_down.svg", className: "expandIcon  ".concat((showFormCD) && "down"), alt: "arrow up", onClick: function () {
                                            _this.setState({ showFormCD: !showFormCD });
                                        } })),
                                React.createElement("form", { action: "", className: "form-collapsible form-collapsible-client  ".concat((showFormCD) && "showForm") },
                                    React.createElement("label", null, "Email ID"),
                                    React.createElement("a", { className: "input inputWithIcon" },
                                        React.createElement("span", { className: "inputIcon" },
                                            React.createElement("img", { src: s3Url + "mail.svg", alt: "" })),
                                        React.createElement(Input$1, { required: true, value: payerEmail, type: "email", name: "payerEmail", onChange: this.onchangeHandler })),
                                    React.createElement("label", null, "Phone"),
                                    React.createElement("a", { className: "input inputWithIcon" },
                                        React.createElement("span", { className: "inputIcon" },
                                            React.createElement("img", { src: s3Url + "settings_phone.svg", alt: "" })),
                                        React.createElement(Input$1, { maxLength: 13, required: true, type: 'text', value: payerMobile, name: "payerMobile", onChange: this.onchangeHandler }))))),
                        !disable && React.createElement("button", { type: "submit", className: "primaryButton" }, "Continue")),
                    React.createElement("div", { className: "credits" },
                        React.createElement("div", { className: "text-center flex-center" },
                            React.createElement("img", { src: s3Url + "security.png", alt: "secure" }),
                            React.createElement("img", { src: s3Url + "powered-by-sabpaisa.png", alt: "sabpaisa logo", className: "ml-1 clientlogo" })),
                        React.createElement("div", { className: "partners" },
                            React.createElement("img", { src: s3Url + "rbi.png", alt: "partners", className: 'partner-logo' }),
                            React.createElement("img", { src: s3Url + "master-card.png", alt: "partners", className: 'partner-logo' }),
                            React.createElement("img", { src: s3Url + "pci-dss.png", alt: "partners", className: 'partner-logo' }),
                            React.createElement("img", { src: s3Url + "by-visa.png", alt: "partners", className: 'partner-logo' })))))));
    };
    return ClientDetails;
}(React.Component));

var PgModal = /** @class */ (function (_super) {
    __extends(PgModal, _super);
    function PgModal(props) {
        var _this = this;
        var _a;
        _this = _super.call(this, props) || this;
        _this.state = {
            submitted: false,
            isOpen: (_a = _this.props.isOpen) !== null && _a !== void 0 ? _a : false,
            currentState: 0,
            paymentData: {},
            activeMappings: [],
            errorMessage: '',
            isResponsed: false
        };
        return _this;
    }
    PgModal.prototype.componentDidMount = function () {
        var urlParams = new URLSearchParams(window.location.search);
        var encResponse = urlParams.get('encResponse');
        var _a = this.props, authkey = _a.authkey, authiv = _a.authiv;
        if (authkey && authiv && encResponse) {
            var decData = decAESString(encResponse.replaceAll(' ', '+'), authkey, authiv);
            window.location.search = decData;
        }
    };
    PgModal.prototype.componentDidUpdate = function (prevProps, preState) {
        if (prevProps.isOpen !== this.props.isOpen) {
            this.setState({ isOpen: this.props.isOpen ? true : false });
        }
        if ((typeof (Object.keys(preState.paymentData).length || null) !== typeof Object.keys(this.state.paymentData).length) && (Object.keys(this.state.paymentData).length !== 0)) {
            this.setState({ isResponsed: true });
        }
    };
    PgModal.prototype.render = function () {
        var _a = this.state, isOpen = _a.isOpen, isResponsed = _a.isResponsed;
        var _b = this.props, onToggle = _b.onToggle, additionalClass = _b.additionalClass;
        return (React__default.createElement("div", { id: "pg-sdk" },
            React__default.createElement(Modal$1, { isOpen: isOpen ? true : false, wrapClassName: "sabpaisa-css-utils-classes-version-five", toggle: onToggle, className: additionalClass, id: "pg-sdk" },
                React__default.createElement(ModalBody, { id: "overlay", close: true },
                    React__default.createElement(ClientDetails, __assign({ isResponsed: isResponsed, toggle: onToggle }, this.props))))));
    };
    return PgModal;
}(Component));

export { Button$1 as Button, PgModal as PaymentInitModal };
